export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  Email: any;
  StringInput: any;
  Upload: any;
};

export enum AceFormCompanyType {
  Both = 'Both',
  Commercial = 'Commercial',
  Residential = 'Residential'
}

export type AceFormInput = {
  AttendanceDate: Scalars['String'];
  AttendeeRole: Scalars['String'];
  CompanyIndustry: Scalars['String'];
  CompanyMainProductCategory?: InputMaybe<Scalars['String']>;
  CompanyName: Scalars['String'];
  CompanySize: Scalars['String'];
  CompanySpecialisation?: InputMaybe<Array<Scalars['String']>>;
  CompanyType: AceFormCompanyType;
  CompanyWebsite: Scalars['String'];
  Email: Scalars['Email'];
  FirstName: Scalars['StringInput'];
  LastName: Scalars['StringInput'];
  Phone: Scalars['StringInput'];
  SubmissionType?: InputMaybe<AceFormSubmissionType>;
};

export enum AceFormSubmissionType {
  Exhibitor = 'Exhibitor',
  Professional = 'Professional'
}

export type AiImage = {
  __typename?: 'AIImage';
  fileKey: Scalars['String'];
  height: Scalars['Int'];
  url: Scalars['String'];
  width: Scalars['Int'];
};

export enum AiTone {
  Formal = 'Formal',
  Humorous = 'Humorous',
  Imaginative = 'Imaginative',
  Informal = 'Informal',
  Persuasive = 'Persuasive',
  Playful = 'Playful'
}

export type ApConversionsFilters = {
  EVENT_DATE_HOST__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

/** Information about pagination in a connection. */
export type ApPageInfo = {
  __typename?: 'APPageInfo';
  ID: Scalars['String'];
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  totalCount: Scalars['Int'];
};

export type ArFileData = {
  __typename?: 'ARFileData';
  AndroidFile?: Maybe<Scalars['String']>;
  EnablePan: Scalars['Boolean'];
  EnableShadow: Scalars['Boolean'];
  EnableZoom: Scalars['Boolean'];
  HDRIFile?: Maybe<Scalars['String']>;
  ID: Scalars['Int'];
  MaxDistance: Scalars['Float'];
  MinDistance: Scalars['Float'];
  TargetY: Scalars['Float'];
  WebFile?: Maybe<Scalars['String']>;
  iOSFile?: Maybe<Scalars['String']>;
};

export type AboutModule_MilestonesConnection = {
  __typename?: 'AboutModule_MilestonesConnection';
  edges: Array<AboutModule_MilestonesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type AboutModule_MilestonesConnectionEdge = {
  __typename?: 'AboutModule_MilestonesConnectionEdge';
  /** The node at the end of the collections edge */
  node: Milestone;
};

export type AboutModule_MilestonesSortFields = {
  SortOrder?: InputMaybe<SortDirection>;
};

export type AcceptDesignBoardInvite = {
  __typename?: 'AcceptDesignBoardInvite';
  AlreadyAccepted: Scalars['Boolean'];
  DesignBoard?: Maybe<DesignBoard>;
};

export type AcceptEnquiryConversationInvite = {
  __typename?: 'AcceptEnquiryConversationInvite';
  Accepted?: Maybe<Scalars['Boolean']>;
  AlreadyAccepted: Scalars['Boolean'];
  Link: Scalars['String'];
  Professional: Professional;
};

export type Accordion = {
  __typename?: 'Accordion';
  Content?: Maybe<Scalars['String']>;
  ID: Scalars['ID'];
  Summary?: Maybe<Scalars['String']>;
  Title?: Maybe<Scalars['String']>;
};

export type AccordionModule = ModuleType & {
  __typename?: 'AccordionModule';
  Accordions: Module_AccordionsConnection;
  AnchorTag?: Maybe<Scalars['String']>;
  ExtraClass?: Maybe<Scalars['String']>;
  ID: Scalars['ID'];
  NavigationLabel?: Maybe<Scalars['String']>;
  SpacingBelow?: Maybe<Scalars['String']>;
  SpacingBelowMobile?: Maybe<Scalars['String']>;
  ThemeColour: ThemedElementColourType;
};


export type AccordionModuleAccordionsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Module_AccordionsSortFields>;
};

/** Represents a user's account deletion request with grace period tracking */
export type AccountDeletionRequest = {
  __typename?: 'AccountDeletionRequest';
  /** Number of days remaining in the 30-day grace period */
  DaysRemaining: Scalars['Int'];
  ID: Scalars['Int'];
  MemberID: Scalars['Int'];
  /** The reason for account deletion (nullable) */
  Reason?: Maybe<AccountDeletionRequestReason>;
  /** Timestamp when the deletion was requested */
  RequestedAt: Scalars['String'];
  /** Timestamp when the account was restored (null if still pending) */
  RestoredAt?: Maybe<Scalars['String']>;
};

/** A predefined reason that users can select when requesting account deletion */
export type AccountDeletionRequestReason = DataObject & {
  __typename?: 'AccountDeletionRequestReason';
  ID: Scalars['Int'];
  /** Human-readable reason label */
  Label: Scalars['String'];
  /** Display order for sorting reasons (lower numbers appear first) */
  SortOrder: Scalars['Int'];
  id: Scalars['ID'];
};

export type AccountDeletionRequestResponse = AccountDeletionRequest | NotAuthorizedError | NotFoundError | ServerError | UserError;

/** Archipro-internal conversions. */
export type AdConversions = {
  Downloads: Scalars['Int'];
  EmailReveals: Scalars['Int'];
  Enquiries: Scalars['Int'];
  ID: Scalars['String'];
  LocationReveals: Scalars['Int'];
  PhoneReveals: Scalars['Int'];
  Referrals: Scalars['Int'];
  Saves: Scalars['Int'];
  Shares: Scalars['Int'];
  TotalPageViews: Scalars['Int'];
  TotalTime: Scalars['Int'];
  VideoPlays: Scalars['Int'];
};

export type AdEngagements = {
  ID: Scalars['String'];
};

/** Locations . */
export type AdLocations = {
  ID: Scalars['String'];
  Locations: Array<LocationData>;
};

export type AdPerformance = {
  EngagementRate?: Maybe<Scalars['Float']>;
  ID: Scalars['String'];
  Impressions: Scalars['Int'];
  Reach: Scalars['Int'];
};

/** A CardType string that can be attached to a card. */
export enum AdResultReadyAdType {
  Facebook = 'Facebook',
  FacebookAd = 'FacebookAd',
  Hubspot = 'Hubspot',
  InstagramMedia = 'InstagramMedia'
}

/** The payload for the \"Your ad results are ready\" card. */
export type AdResultsReadyCardPayload = {
  __typename?: 'AdResultsReadyCardPayload';
  /** Identifier of the ad. You should be able to combine this with the the result type to figure out the URL of the report. */
  AdIdentifier: Scalars['String'];
  /** The start time of the ad. */
  AdStartTime?: Maybe<Scalars['String']>;
  /** The title of the ad. */
  AdTitle: Scalars['String'];
  /** The type of ad. */
  AdType: AdResultReadyAdType;
  /** The number of ads in the campaign. */
  CampaignAdCount?: Maybe<Scalars['Int']>;
  /** The UTM title of the campaign. */
  CampaignUTMTitle?: Maybe<Scalars['String']>;
};

export type AddEnquiryConversationMessageInput = {
  /** ID of the conversation you are adding a message to */
  ID: Scalars['ID'];
  Message: FileAttachmentMessageInput;
  /** ID of the professional the member is on */
  ProfessionalID?: InputMaybe<Scalars['Int']>;
};

export type AddFacetOptionInput = {
  /** ID of the facet to add the option too. */
  FacetOptionID: Scalars['Int'];
  URLSegment: Scalars['StringInput'];
};

export type Address = {
  __typename?: 'Address';
  Address1?: Maybe<Scalars['String']>;
  Address2?: Maybe<Scalars['String']>;
  City?: Maybe<Scalars['String']>;
  Company?: Maybe<Scalars['String']>;
  Country?: Maybe<Scalars['String']>;
  Default?: Maybe<Scalars['Boolean']>;
  FirstName?: Maybe<Scalars['String']>;
  ID: Scalars['Int'];
  Phone?: Maybe<Scalars['String']>;
  PostalCode?: Maybe<Scalars['String']>;
  Region?: Maybe<Scalars['String']>;
  State?: Maybe<Scalars['String']>;
  Suburb?: Maybe<Scalars['String']>;
  Surname?: Maybe<Scalars['String']>;
  Title?: Maybe<Scalars['String']>;
};

export type AddressDetailResult = {
  __typename?: 'AddressDetailResult';
  Address1?: Maybe<Scalars['String']>;
  Address2?: Maybe<Scalars['String']>;
  City?: Maybe<Scalars['String']>;
  Country?: Maybe<Scalars['String']>;
  Postcode?: Maybe<Scalars['String']>;
  Region?: Maybe<Scalars['String']>;
  Suburb?: Maybe<Scalars['String']>;
};

export type AddressInput = {
  Address1?: InputMaybe<Scalars['StringInput']>;
  Address2?: InputMaybe<Scalars['StringInput']>;
  City?: InputMaybe<Scalars['StringInput']>;
  Company?: InputMaybe<Scalars['StringInput']>;
  Country?: InputMaybe<Scalars['StringInput']>;
  Default?: InputMaybe<Scalars['Boolean']>;
  FirstName: Scalars['StringInput'];
  Phone?: InputMaybe<Scalars['StringInput']>;
  PostalCode?: InputMaybe<Scalars['StringInput']>;
  State?: InputMaybe<Scalars['StringInput']>;
  Suburb?: InputMaybe<Scalars['StringInput']>;
  Surname: Scalars['StringInput'];
  Title?: InputMaybe<Scalars['StringInput']>;
};

export type AddressResult = {
  __typename?: 'AddressResult';
  Address?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
};

export enum AddressTypeEnum {
  BillingAddress = 'BILLING_ADDRESS',
  DeliveryAddress = 'DELIVERY_ADDRESS'
}

export type AdvertisingEnquireModule = ModuleType & {
  __typename?: 'AdvertisingEnquireModule';
  AnchorTag?: Maybe<Scalars['String']>;
  ExtraClass?: Maybe<Scalars['String']>;
  ID: Scalars['ID'];
  IntroText?: Maybe<Scalars['String']>;
  NavigationLabel?: Maybe<Scalars['String']>;
  SpacingBelow?: Maybe<Scalars['String']>;
  SpacingBelowMobile?: Maybe<Scalars['String']>;
  ThemeColour: ThemedElementColourType;
  Title?: Maybe<Scalars['String']>;
};

export type AdvertisingFormInput = {
  CompanyName: Scalars['StringInput'];
  CompanyWebsite: Scalars['StringInput'];
  Email: Scalars['StringInput'];
  FirstName: Scalars['StringInput'];
  Phone: Scalars['StringInput'];
};

export type AirtableAdSchedule = {
  __typename?: 'AirtableAdSchedule';
  ApproveURL?: Maybe<Scalars['String']>;
  ContentDue?: Maybe<Scalars['String']>;
  FormURLOrPlacementStatus?: Maybe<Scalars['String']>;
  LiveDate: Scalars['String'];
  PlacementDetails: Scalars['String'];
  PlacementNotes?: Maybe<Scalars['String']>;
  Proofs: Array<Proof>;
  RecordURL: Scalars['String'];
  RequestChangesURL?: Maybe<Scalars['String']>;
  ShowProofs?: Maybe<Scalars['Int']>;
  Type: Scalars['String'];
};

export type AirtableAdScheduleModel = {
  __typename?: 'AirtableAdScheduleModel';
  Future: Array<AirtableAdSchedule>;
  Past: Array<AirtableAdSchedule>;
};

export type AlsoFromProductsConnection = {
  __typename?: 'AlsoFromProductsConnection';
  edges: Array<AlsoFromProductsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type AlsoFromProductsConnectionEdge = {
  __typename?: 'AlsoFromProductsConnectionEdge';
  /** The node at the end of the collections edge */
  node: Product;
};

export type AnalyticsCheckoutSession = {
  __typename?: 'AnalyticsCheckoutSession';
  SessionId?: Maybe<Scalars['String']>;
};

export enum AnalyticsStatusEnum {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED',
  Free = 'FREE',
  Scheduled = 'SCHEDULED',
  Visible = 'VISIBLE'
}

export type AnalyticsSubscription = {
  __typename?: 'AnalyticsSubscription';
  Active: Scalars['Boolean'];
  Cancelled: Scalars['Boolean'];
  PeriodEnd: Scalars['String'];
  Status: AnalyticsSubscriptionEnum;
};

export enum AnalyticsSubscriptionEnum {
  Active = 'ACTIVE',
  Failed = 'FAILED',
  Inactive = 'INACTIVE',
  Pending = 'PENDING'
}

export enum AppliedSpecialtyDiscountEnum {
  Member = 'MEMBER',
  Trade = 'TRADE'
}

export type ArcherComment = {
  __typename?: 'ArcherComment';
  ActionData?: Maybe<Scalars['String']>;
  Actioned?: Maybe<Scalars['Boolean']>;
  ActionedBy?: Maybe<Member>;
  ActionedOn?: Maybe<Scalars['String']>;
  Applied?: Maybe<Scalars['Boolean']>;
  Author?: Maybe<Member>;
  CommentLevel?: Maybe<ArcherCommentLevelEnum>;
  CommentType?: Maybe<ArcherCommentTypeEnum>;
  Content: Scalars['String'];
  Created: Scalars['String'];
  Deleted?: Maybe<Scalars['Boolean']>;
  ID: Scalars['Int'];
  Product?: Maybe<Product>;
  Replies: RepliesConnection;
  Section?: Maybe<ArcherHighlightSectionEnum>;
  Title: Scalars['String'];
};


export type ArcherCommentRepliesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export enum ArcherCommentLevelEnum {
  AutomaticUpdate = 'AUTOMATIC_UPDATE',
  Error = 'ERROR',
  ReviewAndAction = 'REVIEW_AND_ACTION',
  UserCreated = 'USER_CREATED'
}

export enum ArcherCommentTypeEnum {
  BulkImprovement = 'BULK_IMPROVEMENT',
  CategoryEnhancement = 'CATEGORY_ENHANCEMENT',
  DescriptionEnhancement = 'DESCRIPTION_ENHANCEMENT',
  SearchTagEnhancement = 'SEARCH_TAG_ENHANCEMENT',
  SeoDescriptionEnhancement = 'SEO_DESCRIPTION_ENHANCEMENT',
  SeoTitleEnhancement = 'SEO_TITLE_ENHANCEMENT',
  SpecificationsExtraction = 'SPECIFICATIONS_EXTRACTION',
  TitleEnhancement = 'TITLE_ENHANCEMENT',
  UserSuggestion = 'USER_SUGGESTION'
}

export type ArcherCommentsConnection = {
  __typename?: 'ArcherCommentsConnection';
  edges: Array<ArcherCommentsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ArcherCommentsConnectionEdge = {
  __typename?: 'ArcherCommentsConnectionEdge';
  /** The node at the end of the collections edge */
  node: ArcherComment;
};

export enum ArcherHighlightSectionEnum {
  PricingAndVariants = 'PRICING_AND_VARIANTS',
  ProductAssets = 'PRODUCT_ASSETS',
  ProductAttributes = 'PRODUCT_ATTRIBUTES',
  ProductDescription = 'PRODUCT_DESCRIPTION',
  ProductDetails = 'PRODUCT_DETAILS',
  ProductDownloads = 'PRODUCT_DOWNLOADS',
  ProductTitle = 'PRODUCT_TITLE',
  SearchTagsAndSeo = 'SEARCH_TAGS_AND_SEO'
}

export type ArcherReply = {
  __typename?: 'ArcherReply';
  Author?: Maybe<Member>;
  Comment?: Maybe<ArcherComment>;
  Content: Scalars['String'];
  Created: Scalars['String'];
  ID: Scalars['Int'];
};

export type Archivable = {
  Archived: Scalars['Boolean'];
  ClassName: Scalars['String'];
  ID: Scalars['Int'];
};

export type Article = ContentBuilder & DesignBoardPinTarget & DirectoryItem & IApprovable & ICreatable & IHasProfessional & IHomePinable & IPublishable & Node & SortableItem & {
  __typename?: 'Article';
  /** Has this page been reviewed and approved by the ArchiPro Content Team? */
  Activated?: Maybe<Scalars['Boolean']>;
  ApprovedByMember?: Maybe<Member>;
  ApprovedDate?: Maybe<Scalars['String']>;
  AssociatedPages: Article_AssociatedPagesConnection;
  Author?: Maybe<Member>;
  AvailabilityZones: Array<Zone>;
  BannerImages: Array<LibraryImage>;
  Banners: LibraryItemBannersConnection;
  ByArchipro?: Maybe<Scalars['Boolean']>;
  Categories: Array<Category>;
  ClassName: Scalars['String'];
  Clones?: Maybe<Array<DirectoryItem>>;
  Content?: Maybe<Scalars['String']>;
  ContentArea: ContentArea;
  ContentBlocks?: Maybe<Array<ContentBlock>>;
  ContentBuilderType: ContentBuilderTypeEnum;
  ContentComment?: Maybe<Scalars['String']>;
  ContentRejectReasons: Array<ContentRejectReasonEnum>;
  ContentStatus?: Maybe<ContentStatusEnum>;
  ContentStatusBy?: Maybe<Member>;
  ContentStatusDate?: Maybe<Scalars['String']>;
  CreatedByMember?: Maybe<Member>;
  CreatedDate?: Maybe<Scalars['String']>;
  CreatedTimestamp: Scalars['Int'];
  DataQualityRating: Scalars['Float'];
  DesignBoardsForCurrentUser?: Maybe<Array<Maybe<DesignBoard>>>;
  Disable: Scalars['Boolean'];
  EmbeddedData?: Maybe<Scalars['String']>;
  Embeddings?: Maybe<Scalars['String']>;
  FacebookPreviewImage?: Maybe<Scalars['String']>;
  FirstPublishedDate?: Maybe<Scalars['String']>;
  HasClones: Scalars['Boolean'];
  HasDownloads: Scalars['Boolean'];
  HasPhotos: Scalars['Boolean'];
  HasProducts: Scalars['Boolean'];
  HasProjects: Scalars['Boolean'];
  HasTags: Scalars['Boolean'];
  HasVideos: Scalars['Boolean'];
  HomePinned: Scalars['Boolean'];
  ID: Scalars['Int'];
  Images: LibraryItemImagesConnection;
  InLibrary?: Maybe<Scalars['Boolean']>;
  IntroText?: Maybe<Scalars['String']>;
  IsCloned: Scalars['Boolean'];
  /** Has this page been reviewed and approved by the client? */
  IsDraft: Scalars['Boolean'];
  IsFeature: Scalars['Boolean'];
  /** True if published and activated */
  IsLive: Scalars['Boolean'];
  IsManufacturer: Scalars['Boolean'];
  IsTemplate: Scalars['Boolean'];
  KPI?: Maybe<LibraryItemKpi>;
  LastEdited?: Maybe<Scalars['String']>;
  LastEditedDate?: Maybe<Scalars['String']>;
  LastEditedTimestamp: Scalars['Int'];
  LegacyLink: Scalars['String'];
  LibraryDownloads: Array<LibraryDownload>;
  LibraryImages: Array<LibraryImage>;
  LibraryLocations: Array<LibraryLocation>;
  LibraryRange?: Maybe<LibraryRange>;
  LibraryTabs: Array<LibraryTab>;
  LibraryThumb?: Maybe<LibraryThumb>;
  LibraryVideos: Array<LibraryVideo>;
  Link: Scalars['String'];
  LiveDateTimestamp?: Maybe<Scalars['Int']>;
  MemberSortOrder: Scalars['Int'];
  Meta?: Maybe<Meta>;
  Networks: Article_NetworksConnection;
  PageMeta?: Maybe<DirectoryPageMeta>;
  PageType: Scalars['String'];
  ParentID: Scalars['Int'];
  /** Same as Categories but with a different return type PrimaryCategory */
  PrimaryCategories: Array<CategoryPage>;
  PrimaryCategory?: Maybe<CategoryPage>;
  ProductsUsed: Array<Product>;
  Professional?: Maybe<Professional>;
  PublicKPI?: Maybe<LibraryItemPublicKpi>;
  /** Has this page been reviewed and approved by the client? */
  Publish: Scalars['Boolean'];
  PublishDate?: Maybe<Scalars['String']>;
  PublishedByMember?: Maybe<Member>;
  RawTileImage?: Maybe<Scalars['String']>;
  ReadingMinutes: Scalars['Int'];
  Recommendations?: Maybe<Array<Maybe<DirectoryItem>>>;
  Review?: Maybe<PageReview>;
  /** Actions that need addressing before this page can be approved */
  ReviewActions?: Maybe<Array<Maybe<ReviewAction>>>;
  SampleAddressPlaceholder?: Maybe<Scalars['String']>;
  SampleMessagePlaceholder?: Maybe<Scalars['String']>;
  SampleSubmitText?: Maybe<Scalars['String']>;
  SampleText?: Maybe<Scalars['String']>;
  SampleTitle?: Maybe<Scalars['String']>;
  SamplesAddressRequired: Scalars['Boolean'];
  SamplesAvailable: Scalars['Boolean'];
  SearchTags?: Maybe<Array<Maybe<SearchTag>>>;
  SelfPublished: Scalars['Boolean'];
  ShowsInElasticSearch: Scalars['Boolean'];
  SortOrder: Scalars['Int'];
  Teaser?: Maybe<Scalars['String']>;
  ThumbnailFile?: Maybe<LibraryImageFile>;
  Title: Scalars['String'];
  TopBanner?: Maybe<LibraryItemBanner>;
  URLSegment: Scalars['String'];
  ViewsCount: Scalars['Int'];
  Visibilities?: Maybe<Array<ArticleVisibility>>;
  Website?: Maybe<Scalars['String']>;
  WebsiteShort?: Maybe<Scalars['String']>;
  WebsiteUntracked: Scalars['String'];
  WordCount: Scalars['Int'];
  deprecated_Awards?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  libraryImageMarkerCount: LibraryImageMarkerCount;
};


export type ArticleApprovedDateArgs = {
  format?: InputMaybe<DateFormatEnum>;
};


export type ArticleAssociatedPagesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type ArticleBannersArgs = {
  filter?: InputMaybe<LibraryItemBannersFilters>;
  filters?: InputMaybe<LibraryItemBannersFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<LibraryItemBannersSortFields>;
};


export type ArticleContentStatusDateArgs = {
  format?: InputMaybe<DateFormatEnum>;
};


export type ArticleCreatedDateArgs = {
  format?: InputMaybe<DateFormatEnum>;
};


export type ArticleFirstPublishedDateArgs = {
  format?: InputMaybe<DateFormatEnum>;
};


export type ArticleImagesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type ArticleLibraryImagesArgs = {
  Limit?: InputMaybe<Scalars['Int']>;
};


export type ArticleLibraryLocationsArgs = {
  showHidden?: InputMaybe<Scalars['Boolean']>;
};


export type ArticleNetworksArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Article_NetworksSortFields>;
};


export type ArticlePublishDateArgs = {
  format?: InputMaybe<DateFormatEnum>;
};


export type ArticleReadingMinutesArgs = {
  WithPageBuilder?: InputMaybe<Scalars['Boolean']>;
};


export type ArticleViewsCountArgs = {
  Range: DirectoryItemViewsCountRange;
};


export type ArticleWordCountArgs = {
  WithPageBuilder?: InputMaybe<Scalars['Boolean']>;
};

export type ArticleAuthor = {
  FirstName: Scalars['String'];
  ID: Scalars['Int'];
  Surname?: Maybe<Scalars['String']>;
};

export type ArticleAuthorsConnection = {
  __typename?: 'ArticleAuthorsConnection';
  edges: Array<ArticleAuthorsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ArticleAuthorsConnectionEdge = {
  __typename?: 'ArticleAuthorsConnectionEdge';
  /** The node at the end of the collections edge */
  node: ArticleAuthor;
};

export type ArticleAuthorsFilters = {
  /** Filter Authors who has posted an article on a given professional */
  HasPosted?: InputMaybe<Scalars['Boolean']>;
};

export type ArticleCategory = ICategory & IHasItems & {
  __typename?: 'ArticleCategory';
  Articles: ArticleCategory_ArticlesConnection;
  CanonicalLink?: Maybe<Scalars['String']>;
  Categories: ArticleCategory_CategoriesConnection;
  ContentTop: Scalars['String'];
  CustomSeoOnFilters?: Maybe<Scalars['Boolean']>;
  ID: Scalars['Int'];
  Image?: Maybe<ResponsiveImage>;
  IsPublished?: Maybe<Scalars['Boolean']>;
  ItemsCount: Scalars['Int'];
  Link: Scalars['String'];
  MenuTitle: Scalars['String'];
  Parent?: Maybe<ArticleCategory>;
  Parents: ArticleCategory_ParentsConnection;
  PrettyTitle: Scalars['String'];
  Thumbnail?: Maybe<ResponsiveImage>;
  Title: Scalars['String'];
  URLSegment: Scalars['String'];
};


export type ArticleCategoryArticlesArgs = {
  filter?: InputMaybe<ArticleCategory_ArticlesFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<ArticleCategory_ArticlesSortFields>;
};


export type ArticleCategoryCategoriesArgs = {
  filter?: InputMaybe<ArticleCategory_CategoriesFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<ArticleCategory_CategoriesSortFields>;
};


export type ArticleCategoryImageArgs = {
  Height?: InputMaybe<Scalars['Int']>;
  Width?: InputMaybe<Scalars['Int']>;
};


export type ArticleCategoryItemsCountArgs = {
  Zone?: InputMaybe<SupportedCountry>;
};


export type ArticleCategoryParentsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type ArticleCategoryThumbnailArgs = {
  Height?: InputMaybe<Scalars['Int']>;
  Width?: InputMaybe<Scalars['Int']>;
};

export type ArticleCategory_ArticlesConnection = {
  __typename?: 'ArticleCategory_ArticlesConnection';
  edges: Array<ArticleCategory_ArticlesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ArticleCategory_ArticlesConnectionEdge = {
  __typename?: 'ArticleCategory_ArticlesConnectionEdge';
  /** The node at the end of the collections edge */
  node: Article;
};

export type ArticleCategory_ArticlesFilters = {
  /** Filters this type when CountryCode is in the provided value */
  CountryCode__in?: InputMaybe<Array<SupportedCountry>>;
  /** Filter categories that have or don`t have items */
  HasItems?: InputMaybe<Scalars['Boolean']>;
  /** Filters this type when ItemID is in the provided value */
  ID__in?: InputMaybe<Array<Scalars['Int']>>;
  /** Filters this type when PublishDate is gt the provided value */
  PublishDate__gt?: InputMaybe<Scalars['String']>;
  /** Filters this type when Visibility is find_in the provided value */
  Visibility__find_in?: InputMaybe<Scalars['String']>;
};

export type ArticleCategory_ArticlesSortFields = {
  Created?: InputMaybe<SortDirection>;
  ID?: InputMaybe<SortDirection>;
  LastEdited?: InputMaybe<SortDirection>;
  Popularity?: InputMaybe<SortDirection>;
  PublishDate?: InputMaybe<SortDirection>;
  SortOrder?: InputMaybe<SortDirection>;
};

export type ArticleCategory_CategoriesConnection = {
  __typename?: 'ArticleCategory_CategoriesConnection';
  edges: Array<ArticleCategory_CategoriesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ArticleCategory_CategoriesConnectionEdge = {
  __typename?: 'ArticleCategory_CategoriesConnectionEdge';
  /** The node at the end of the collections edge */
  node: ArticleCategory;
};

export type ArticleCategory_CategoriesFilters = {
  /** Filter categories that have or don`t have items */
  HasItems?: InputMaybe<Scalars['Boolean']>;
  /** category shows in Archizeen */
  ShowInArchizeen__eq?: InputMaybe<Scalars['Boolean']>;
  /** category shows in Navigation */
  ShowInNavigation__eq?: InputMaybe<Scalars['Boolean']>;
};

export type ArticleCategory_CategoriesSortFields = {
  Sort?: InputMaybe<SortDirection>;
  Title?: InputMaybe<SortDirection>;
};

export type ArticleCategory_ParentsConnection = {
  __typename?: 'ArticleCategory_ParentsConnection';
  edges: Array<ArticleCategory_ParentsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ArticleCategory_ParentsConnectionEdge = {
  __typename?: 'ArticleCategory_ParentsConnectionEdge';
  /** The node at the end of the collections edge */
  node: ArticleCategory;
};

export type ArticlePin = {
  __typename?: 'ArticlePin';
  BoardID: Scalars['Int'];
  BoardURLSegment: Scalars['String'];
  CanDelete: Scalars['Boolean'];
  Comments?: Maybe<Array<Maybe<Comment>>>;
  CommentsCount: Scalars['Int'];
  CreatedBy?: Maybe<Member>;
  HasUnreadComments: Scalars['Boolean'];
  ID: Scalars['Int'];
  LegacyLink?: Maybe<Scalars['String']>;
  LibraryImageID?: Maybe<Scalars['Int']>;
  LibraryThumb?: Maybe<LibraryThumb>;
  Link?: Maybe<Scalars['String']>;
  PageType?: Maybe<Scalars['String']>;
  PageTypeID?: Maybe<Scalars['Int']>;
  Permission: PinPermission;
  PhotoModal?: Maybe<Scalars['String']>;
  PhotoTile?: Maybe<Scalars['String']>;
  ProfessionalID?: Maybe<Scalars['Int']>;
  ProfessionalLink?: Maybe<Scalars['String']>;
  ProfessionalTitle?: Maybe<Scalars['String']>;
  ProfessionalWebsite?: Maybe<Scalars['String']>;
  SubTitle: Scalars['String'];
  Title?: Maybe<Scalars['String']>;
  Type?: Maybe<Scalars['String']>;
};

export enum ArticleVisibility {
  Disabled = 'Disabled',
  Draft = 'Draft',
  InLibrary = 'InLibrary',
  InSearch = 'InSearch',
  NotLive = 'NotLive',
  PendingApproval = 'PendingApproval',
  ProfileOnly = 'ProfileOnly',
  Scheduled = 'Scheduled'
}

export type Article_AssociatedPagesConnection = {
  __typename?: 'Article_AssociatedPagesConnection';
  edges: Array<Article_AssociatedPagesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type Article_AssociatedPagesConnectionEdge = {
  __typename?: 'Article_AssociatedPagesConnectionEdge';
  /** The node at the end of the collections edge */
  node: AssociatedPage;
};

export type Article_NetworksConnection = {
  __typename?: 'Article_NetworksConnection';
  edges: Array<Article_NetworksConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type Article_NetworksConnectionEdge = {
  __typename?: 'Article_NetworksConnectionEdge';
  /** The node at the end of the collections edge */
  node: Network;
};

export type Article_NetworksSortFields = {
  ID?: InputMaybe<SortDirection>;
};

export type ArticlesConnection = {
  __typename?: 'ArticlesConnection';
  ID: Scalars['String'];
  edges: Array<ArticlesConnectionEdge>;
  nodes: Array<Article>;
  pageInfo: ApPageInfo;
};

/** The collections edge */
export type ArticlesConnectionEdge = {
  __typename?: 'ArticlesConnectionEdge';
  /** The node at the end of the collections edge */
  node: Article;
};

export type ArticlesSimpleSortFields = {
  Created?: InputMaybe<SortDirection>;
  DataQualityRating?: InputMaybe<SortDirection>;
  FirstPublishedDate?: InputMaybe<SortDirection>;
  ID?: InputMaybe<SortDirection>;
  LastEdited?: InputMaybe<SortDirection>;
  PublishDate?: InputMaybe<SortDirection>;
  Title?: InputMaybe<SortDirection>;
  WasPublished?: InputMaybe<SortDirection>;
};

export type AssociatedPage = {
  __typename?: 'AssociatedPage';
  Zone: Zone;
  ZonePage?: Maybe<AssociatedZonePage>;
};

export type AssociatedZonePage = {
  __typename?: 'AssociatedZonePage';
  ID: Scalars['Int'];
  Link?: Maybe<Scalars['String']>;
};

export type AssociationsConnection = {
  __typename?: 'AssociationsConnection';
  edges: Array<AssociationsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type AssociationsConnectionEdge = {
  __typename?: 'AssociationsConnectionEdge';
  /** The node at the end of the collections edge */
  node: Professional;
};

export enum AsyncTaskStatus {
  Cancelled = 'Cancelled',
  Failed = 'Failed',
  InFlight = 'InFlight',
  New = 'New',
  Queued = 'Queued',
  Retrying = 'Retrying',
  Running = 'Running',
  Success = 'Success'
}

export type AttendeeListModule = ModuleType & {
  __typename?: 'AttendeeListModule';
  AnchorTag?: Maybe<Scalars['String']>;
  AttendeeList: Array<Scalars['String']>;
  CTA?: Maybe<SiteTreeLink>;
  ExtraClass?: Maybe<Scalars['String']>;
  ID: Scalars['ID'];
  LeadingText?: Maybe<Scalars['String']>;
  NavigationLabel?: Maybe<Scalars['String']>;
  SpacingBelow?: Maybe<Scalars['String']>;
  SpacingBelowMobile?: Maybe<Scalars['String']>;
  ThemeColour: ThemedElementColourType;
  Title?: Maybe<Scalars['String']>;
};

export type Attendees_Connection = {
  __typename?: 'Attendees_Connection';
  edges: Array<Attendees_ConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type Attendees_ConnectionEdge = {
  __typename?: 'Attendees_ConnectionEdge';
  /** The node at the end of the collections edge */
  node: ProfessionalAttendee;
};

export type Attendees_SortFields = {
  SortOrder?: InputMaybe<SortDirection>;
};

export type Attribute = {
  __typename?: 'Attribute';
  ID: Scalars['Int'];
  Name: Scalars['String'];
  Options: AttributeOptionsListConnection;
  Professional?: Maybe<Professional>;
  SortOrder?: Maybe<Scalars['Int']>;
  Title: Scalars['String'];
};


export type AttributeOptionsArgs = {
  ProductID?: InputMaybe<Scalars['Int']>;
  Professional?: InputMaybe<Scalars['StringInput']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type AttributeOption = {
  __typename?: 'AttributeOption';
  Approved: Scalars['Boolean'];
  Attribute: Attribute;
  AttributeID: Scalars['Int'];
  Code: Scalars['String'];
  ColorCategories: ColorCategoriesConnection;
  CommonMaterials: CommonMaterialsConnection;
  /** Deprecated: No longer used, Use ProductColors instead. */
  DominantColor?: Maybe<Scalars['String']>;
  Dot?: Maybe<ResponsiveImage>;
  ID: Scalars['Int'];
  Image?: Maybe<ResponsiveImage>;
  Label: Scalars['String'];
  /** Deprecated: No longer used, Use Label instead */
  Name: Scalars['String'];
  Professional?: Maybe<Professional>;
  Swatch?: Maybe<ProductSwatch>;
};


export type AttributeOptionColorCategoriesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type AttributeOptionCommonMaterialsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type AttributeOptionsConnection = {
  __typename?: 'AttributeOptionsConnection';
  edges: Array<AttributeOptionsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type AttributeOptionsConnectionEdge = {
  __typename?: 'AttributeOptionsConnectionEdge';
  /** The node at the end of the collections edge */
  node: AttributeOption;
};

export type AttributeOptionsListConnection = {
  __typename?: 'AttributeOptionsListConnection';
  edges: Array<AttributeOptionsListConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type AttributeOptionsListConnectionEdge = {
  __typename?: 'AttributeOptionsListConnectionEdge';
  /** The node at the end of the collections edge */
  node: AttributeOption;
};

export type AttributeOptions_MaterialsConnection = {
  __typename?: 'AttributeOptions_MaterialsConnection';
  edges: Array<AttributeOptions_MaterialsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type AttributeOptions_MaterialsConnectionEdge = {
  __typename?: 'AttributeOptions_MaterialsConnectionEdge';
  /** The node at the end of the collections edge */
  node: AttributeOption;
};

export type AudienceAgeGender = {
  __typename?: 'AudienceAgeGender';
  label: Scalars['String'];
  value: AudienceGender;
};

export type AudienceByIndustryBreakdownFilters = {
  EVENT_DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
  USER_INDUSTRY__IN?: InputMaybe<Array<Scalars['String']>>;
};

export type AudienceGender = {
  __typename?: 'AudienceGender';
  female?: Maybe<Scalars['Int']>;
  male?: Maybe<Scalars['Int']>;
  unknown?: Maybe<Scalars['Int']>;
};

export type AudienceIndustriesFilters = {
  EVENT_DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type AudienceLocation = {
  __typename?: 'AudienceLocation';
  label: Scalars['String'];
  value: Scalars['Int'];
};

export type AudiencePlacement = {
  __typename?: 'AudiencePlacement';
  label: Scalars['String'];
  value: Scalars['Int'];
};

export type AudienceTypeBreakdownFilters = {
  EVENT_DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type AuthDebugClaims = {
  __typename?: 'AuthDebugClaims';
  audience: Scalars['String'];
  expiresAt: Scalars['Int'];
  isAdmin?: Maybe<Scalars['Boolean']>;
  issuedAt: Scalars['Int'];
  issuer?: Maybe<Scalars['String']>;
  jti?: Maybe<Scalars['String']>;
  nbf?: Maybe<Scalars['Int']>;
  professional: Scalars['String'];
  rexp?: Maybe<Scalars['Int']>;
  rid?: Maybe<Scalars['Int']>;
  scopes?: Maybe<Array<Scalars['String']>>;
  subject?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['Int']>;
};

export type AuthDebugMetadata = {
  __typename?: 'AuthDebugMetadata';
  expiresAt?: Maybe<Scalars['String']>;
  expiresIn?: Maybe<Scalars['String']>;
  isValid: Scalars['Boolean'];
  issuedAt?: Maybe<Scalars['String']>;
  professional: Scalars['String'];
  tokenType: Scalars['String'];
};

export type AuthDebugResult = {
  __typename?: 'AuthDebugResult';
  claims?: Maybe<AuthDebugClaims>;
  metadata: AuthDebugMetadata;
};

export type AuthenticationException = {
  __typename?: 'AuthenticationException';
  ExpectedMember?: Maybe<PublicMember>;
};

export type AvailableMemberType = {
  __typename?: 'AvailableMemberType';
  email: Scalars['String'];
  memberId: Scalars['Int'];
  name: Scalars['String'];
};

export type Award = SortableItem & {
  __typename?: 'Award';
  AwardedEntities: Award_AwardedEntitiesConnection;
  AwardingInstitutionTitle: Scalars['StringInput'];
  Badge?: Maybe<LibraryImage>;
  ID: Scalars['Int'];
  MemberSortOrder: Scalars['Int'];
  Title: Scalars['StringInput'];
  YearAwarded: Scalars['StringInput'];
};


export type AwardAwardedEntitiesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type Award_AwardedEntitiesConnection = {
  __typename?: 'Award_AwardedEntitiesConnection';
  edges: Array<Award_AwardedEntitiesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type Award_AwardedEntitiesConnectionEdge = {
  __typename?: 'Award_AwardedEntitiesConnectionEdge';
  /** The node at the end of the collections edge */
  node: DirectoryItem;
};

export type BaReports = {
  __typename?: 'BAReports';
  APConversions?: Maybe<TableData>;
  AudienceByIndustryBreakdown: DataCollections;
  AudienceIndustries?: Maybe<TableData>;
  AudienceTypeBreakdown: DataCollections;
  BenchmarkAttentionShare: DataCollections;
  BenchmarkCategoryEngagement: DataCollections;
  BenchmarkCategoryHealth: DataCollections;
  BenchmarkLeadGenerate?: Maybe<RowData>;
  BenchmarkProductHealth?: Maybe<ChartCollection>;
  BenchmarkStats?: Maybe<RowData>;
  BenchmarkTierOnePerformance?: Maybe<TableData>;
  BenchmarkTierTwoPerformance?: Maybe<TableData>;
  CampaignFilter?: Maybe<TableData>;
  CompanyActivities?: Maybe<TableData>;
  CompanyActivityIndustries?: Maybe<TableData>;
  ConversionActivities: DataCollections;
  ConversionActivityOvertime: DataCollections;
  ConversionActivityTable?: Maybe<TableData>;
  ConversionAdsOvertime?: Maybe<ChartCollection>;
  ConversionContentTypes?: Maybe<TableData>;
  ConversionLocationOptions?: Maybe<TableData>;
  ConversionLocations?: Maybe<TableData>;
  ConversionOptions?: Maybe<TableData>;
  ConversionPageNames?: Maybe<TableData>;
  ConversionStats?: Maybe<RowData>;
  ConversionTableData?: Maybe<TableData>;
  ConversionTypes?: Maybe<TableData>;
  ConversionUserTypes?: Maybe<TableData>;
  ConversionsFromTags: DataCollections;
  CustomerLeadActivity?: Maybe<RowData>;
  CustomerLeadCategoryInterest: DataCollections;
  CustomerLeadConversionRate?: Maybe<RowData>;
  CustomerLeadConversions: DataCollections;
  CustomerLeadDetails?: Maybe<RowData>;
  CustomerLeadSummary?: Maybe<RowData>;
  CustomerLeadTopPageViews: DataCollections;
  DemographicLocations: DataCollections;
  DemographicStats?: Maybe<RowData>;
  DemographicUserDevices?: Maybe<RowData>;
  DemographicsAudienceLocation: Array<MapMaker>;
  DemographicsAudienceType: DataCollections;
  DemographicsAudienceTypeOptions?: Maybe<TableData>;
  DemographicsCategories?: Maybe<TableData>;
  DemographicsCategoryInterests: DataCollections;
  DemographicsContentTypeOptions?: Maybe<TableData>;
  DemographicsLocationOptions?: Maybe<TableData>;
  DemographicsProjectStage: DataCollections;
  DemographicsProjectType: DataCollections;
  DemographicsSummary?: Maybe<RowData>;
  DemographicsTotalTimeSpent: DataCollections;
  DemographicsUserEngagementOverTime: DataCollections;
  DigitalPublicationActivity?: Maybe<TableData>;
  DigitalPublicationAttentionShare?: Maybe<RowData>;
  DigitalPublicationAudience: DataCollections;
  DigitalPublicationAudienceRegion: DataCollections;
  DigitalPublicationList?: Maybe<TableData>;
  DigitalPublicationOpenClick?: Maybe<RowData>;
  DigitalPublicationPerformance?: Maybe<RowData>;
  DigitalPublicationPerformanceChartClick: DataCollections;
  DigitalPublicationPerformanceChartOpen: DataCollections;
  DigitalPublicationProfessionalCategory: DataCollections;
  DigitalPublicationProfessionalEngagement: DataCollections;
  DigitalPublicationProfessionalRegion: DataCollections;
  DigitalPublicationProfessionalUser: DataCollections;
  DigitalPublicationProfileConversionChart: DataCollections;
  DigitalPublicationReaderRegion: DataCollections;
  DigitalPublicationRecipient?: Maybe<TableData>;
  DigitalPublicationSingleMeta?: Maybe<TableData>;
  DigitalPublicationSummary?: Maybe<RowData>;
  DigitalPublicationTimespent?: Maybe<RowData>;
  EngagedCompanyStatsByIndustry?: Maybe<TableData>;
  ExposedCompanyStatsByIndustry?: Maybe<TableData>;
  GoogleSEOArchiproIndex?: Maybe<RowData>;
  GoogleSEOBreakdown: DataCollections;
  GoogleSEOPieChart: DataCollections;
  GoogleSEOSummary?: Maybe<RowData>;
  GoogleSEOTopPage?: Maybe<TableData>;
  GoogleSEOTopSearch?: Maybe<TableData>;
  ID: Scalars['Int'];
  LeadFunnel: DataCollections;
  LeadFunnelConversionEvents?: Maybe<TableData>;
  LeadFunnelStats?: Maybe<RowData>;
  LeadFunnelUserScores: DataCollections;
  LeadFunnelUserSessions: DataCollections;
  LeadFunnelUserStatus: DataCollections;
  LeadFunnelUserTime: DataCollections;
  LeadFunnelUsers?: Maybe<TableData>;
  LibraryPageKPI?: Maybe<RowData>;
  LibraryPagePublicKPI?: Maybe<RowData>;
  MetaAdCampaignConversions: DataCollections;
  MetaAdCampaignEngagements: DataCollections;
  MetaAdCampaignProfileStats?: Maybe<RowData>;
  MetaAdCampaignReachLocations: Array<MapMaker>;
  MetaAdCampaignStats?: Maybe<RowData>;
  MetaAdsCampaignTable?: Maybe<TableData>;
  MetaAdsConversionBreakdown: DataCollections;
  MetaAdsEngagementBreakdown: DataCollections;
  MetaAdsStats?: Maybe<RowData>;
  MetaCampaigns?: Maybe<TableData>;
  MetaCampaignsByUTM?: Maybe<TableData>;
  MonthlyUserCount?: Maybe<RowData>;
  NativeDriverAdPerformance?: Maybe<RowData>;
  NativeDriverDevice?: Maybe<RowData>;
  NativeDriverRegion: DataCollections;
  OldConversionTableData?: Maybe<TableData>;
  OldProfileTopPages?: Maybe<TableData>;
  OnsitePlacementBreakdown: DataCollections;
  OnsitePlacementLocationType: DataCollections;
  OnsitePlacementOverview?: Maybe<RowData>;
  OnsitePlacementTable?: Maybe<TableData>;
  OnsitePlacementUserDevices?: Maybe<RowData>;
  OverviewImpression: DataCollections;
  OverviewInteractions?: Maybe<RowData>;
  OverviewNewsletterStats?: Maybe<ChartCollection>;
  OverviewPackage?: Maybe<TableData>;
  OverviewPackageCampaigns?: Maybe<TableData>;
  OverviewPackageCampaignsDetails?: Maybe<TableData>;
  OverviewPackageOtherCampaigns?: Maybe<TableData>;
  OverviewPackageOtherCampaignsDetails?: Maybe<TableData>;
  OverviewPageView: DataCollections;
  OverviewProfilePageStats?: Maybe<ChartCollection>;
  OverviewSocialAdStats?: Maybe<ChartCollection>;
  OverviewStats?: Maybe<RowData>;
  PageNames?: Maybe<TableData>;
  PageOwners?: Maybe<TableData>;
  PinterestBreakdown: DataCollections;
  PinterestCampaigns?: Maybe<TableData>;
  PinterestProfileConversion?: Maybe<RowData>;
  PinterestSummary?: Maybe<RowData>;
  PixelActivityByOrder?: Maybe<TableData>;
  PixelActivityBySession?: Maybe<TableData>;
  PixelActivityByUser?: Maybe<TableData>;
  PixelConversions?: Maybe<TableData>;
  PixelConversionsNonDistinct?: Maybe<TableData>;
  PixelForms?: Maybe<TableData>;
  PixelIndustryBreakdown: DataCollections;
  PixelRegionBreakdown: DataCollections;
  PixelReturningUserBreakdown: DataCollections;
  PixelRuleConversions?: Maybe<TableData>;
  PixelSmokeTest?: Maybe<Datum>;
  PixelStats?: Maybe<RowData>;
  PixelTopLandingPages?: Maybe<TableData>;
  PixelTopReferrals?: Maybe<TableData>;
  ProductNames?: Maybe<TableData>;
  ProductTagStats?: Maybe<RowData>;
  ProductTagTemporalStats?: Maybe<RowData>;
  ProfileCampaignsOverTime?: Maybe<ChartCollection>;
  ProfileConversionBreakdown: DataCollections;
  ProfileConversionTypes?: Maybe<TableData>;
  ProfileImpressionSources: DataCollections;
  ProfileIndustries?: Maybe<TableData>;
  ProfilePageNames?: Maybe<TableData>;
  ProfilePageTypeBreakdown: DataCollections;
  ProfilePageTypes?: Maybe<TableData>;
  ProfileStats?: Maybe<RowData>;
  ProfileStatsOverTime: DataCollections;
  ProfileTopPages?: Maybe<TableData>;
  ProfileTrafficSources: DataCollections;
  SalesConversions?: Maybe<TableData>;
  TaggedProductsByRecord?: Maybe<TableData>;
  TaggedRecords?: Maybe<TableData>;
  TopClickedTags?: Maybe<TableData>;
};


export type BaReportsApConversionsArgs = {
  filters?: InputMaybe<ApConversionsFilters>;
};


export type BaReportsAudienceByIndustryBreakdownArgs = {
  filters?: InputMaybe<AudienceByIndustryBreakdownFilters>;
};


export type BaReportsAudienceIndustriesArgs = {
  filters?: InputMaybe<AudienceIndustriesFilters>;
};


export type BaReportsAudienceTypeBreakdownArgs = {
  filters?: InputMaybe<AudienceTypeBreakdownFilters>;
};


export type BaReportsBenchmarkAttentionShareArgs = {
  filters?: InputMaybe<BenchmarkAttentionShareFilters>;
};


export type BaReportsBenchmarkCategoryEngagementArgs = {
  filters?: InputMaybe<BenchmarkCategoryEngagementFilters>;
};


export type BaReportsBenchmarkCategoryHealthArgs = {
  filters?: InputMaybe<BenchmarkCategoryHealthFilters>;
};


export type BaReportsBenchmarkLeadGenerateArgs = {
  filters?: InputMaybe<BenchmarkLeadGenerateFilters>;
};


export type BaReportsBenchmarkProductHealthArgs = {
  filters?: InputMaybe<BenchmarkProductHealthFilters>;
};


export type BaReportsBenchmarkStatsArgs = {
  filters?: InputMaybe<BenchmarkStatsFilters>;
};


export type BaReportsBenchmarkTierOnePerformanceArgs = {
  filters?: InputMaybe<BenchmarkTierOnePerformanceFilters>;
  sort?: InputMaybe<BenchmarkTierOnePerformanceSort>;
};


export type BaReportsBenchmarkTierTwoPerformanceArgs = {
  filters?: InputMaybe<BenchmarkTierTwoPerformanceFilters>;
};


export type BaReportsCampaignFilterArgs = {
  filters?: InputMaybe<CampaignFilterFilters>;
};


export type BaReportsCompanyActivitiesArgs = {
  filters?: InputMaybe<CompanyActivitiesFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<CompanyActivitiesSort>;
};


export type BaReportsCompanyActivityIndustriesArgs = {
  filters?: InputMaybe<CompanyActivityIndustriesFilters>;
};


export type BaReportsConversionActivitiesArgs = {
  filters?: InputMaybe<ConversionActivitiesFilters>;
};


export type BaReportsConversionActivityOvertimeArgs = {
  filters?: InputMaybe<ConversionActivityOvertimeFilters>;
};


export type BaReportsConversionActivityTableArgs = {
  filters?: InputMaybe<ConversionActivityTableFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<ConversionActivityTableSort>;
};


export type BaReportsConversionAdsOvertimeArgs = {
  filters?: InputMaybe<ConversionAdsOvertimeFilters>;
};


export type BaReportsConversionContentTypesArgs = {
  filters?: InputMaybe<ConversionContentTypesFilters>;
};


export type BaReportsConversionLocationOptionsArgs = {
  filters?: InputMaybe<ConversionLocationOptionsFilters>;
};


export type BaReportsConversionLocationsArgs = {
  filters?: InputMaybe<ConversionLocationsFilters>;
};


export type BaReportsConversionOptionsArgs = {
  filters?: InputMaybe<ConversionOptionsFilters>;
};


export type BaReportsConversionPageNamesArgs = {
  filters?: InputMaybe<ConversionPageNamesFilters>;
};


export type BaReportsConversionStatsArgs = {
  filters?: InputMaybe<ConversionStatsFilters>;
};


export type BaReportsConversionTableDataArgs = {
  filters?: InputMaybe<ConversionTableDataFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type BaReportsConversionUserTypesArgs = {
  filters?: InputMaybe<ConversionUserTypesFilters>;
};


export type BaReportsConversionsFromTagsArgs = {
  filters?: InputMaybe<ConversionsFromTagsFilters>;
};


export type BaReportsCustomerLeadActivityArgs = {
  filters?: InputMaybe<CustomerLeadActivityFilters>;
};


export type BaReportsCustomerLeadCategoryInterestArgs = {
  filters?: InputMaybe<CustomerLeadCategoryInterestFilters>;
};


export type BaReportsCustomerLeadConversionRateArgs = {
  filters?: InputMaybe<CustomerLeadConversionRateFilters>;
};


export type BaReportsCustomerLeadConversionsArgs = {
  filters?: InputMaybe<CustomerLeadConversionsFilters>;
};


export type BaReportsCustomerLeadDetailsArgs = {
  filters?: InputMaybe<CustomerLeadDetailsFilters>;
};


export type BaReportsCustomerLeadSummaryArgs = {
  filters?: InputMaybe<CustomerLeadSummaryFilters>;
};


export type BaReportsCustomerLeadTopPageViewsArgs = {
  filters?: InputMaybe<CustomerLeadTopPageViewsFilters>;
};


export type BaReportsDemographicLocationsArgs = {
  filters?: InputMaybe<DemographicLocationsFilters>;
};


export type BaReportsDemographicStatsArgs = {
  filters?: InputMaybe<DemographicStatsFilters>;
};


export type BaReportsDemographicUserDevicesArgs = {
  filters?: InputMaybe<DemographicUserDevicesFilters>;
};


export type BaReportsDemographicsAudienceLocationArgs = {
  filters?: InputMaybe<DemographicsAudienceLocationFilters>;
};


export type BaReportsDemographicsAudienceTypeArgs = {
  filters?: InputMaybe<DemographicsAudienceTypeFilters>;
};


export type BaReportsDemographicsAudienceTypeOptionsArgs = {
  filters?: InputMaybe<DemographicsAudienceTypeOptionsFilters>;
};


export type BaReportsDemographicsCategoriesArgs = {
  filters?: InputMaybe<DemographicsCategoriesFilters>;
};


export type BaReportsDemographicsCategoryInterestsArgs = {
  filters?: InputMaybe<DemographicsCategoryInterestsFilters>;
};


export type BaReportsDemographicsContentTypeOptionsArgs = {
  filters?: InputMaybe<DemographicsContentTypeOptionsFilters>;
};


export type BaReportsDemographicsLocationOptionsArgs = {
  filters?: InputMaybe<DemographicsLocationOptionsFilters>;
};


export type BaReportsDemographicsProjectStageArgs = {
  filters?: InputMaybe<DemographicsProjectStageFilters>;
};


export type BaReportsDemographicsProjectTypeArgs = {
  filters?: InputMaybe<DemographicsProjectTypeFilters>;
};


export type BaReportsDemographicsSummaryArgs = {
  filters?: InputMaybe<DemographicsSummaryFilters>;
};


export type BaReportsDemographicsTotalTimeSpentArgs = {
  filters?: InputMaybe<DemographicsTotalTimeSpentFilters>;
};


export type BaReportsDemographicsUserEngagementOverTimeArgs = {
  filters?: InputMaybe<DemographicsUserEngagementOverTimeFilters>;
};


export type BaReportsDigitalPublicationActivityArgs = {
  filters?: InputMaybe<DigitalPublicationActivityFilters>;
};


export type BaReportsDigitalPublicationAttentionShareArgs = {
  filters?: InputMaybe<DigitalPublicationAttentionShareFilters>;
};


export type BaReportsDigitalPublicationAudienceArgs = {
  filters?: InputMaybe<DigitalPublicationAudienceFilters>;
};


export type BaReportsDigitalPublicationAudienceRegionArgs = {
  filters?: InputMaybe<DigitalPublicationAudienceRegionFilters>;
};


export type BaReportsDigitalPublicationListArgs = {
  filters?: InputMaybe<DigitalPublicationListFilters>;
};


export type BaReportsDigitalPublicationOpenClickArgs = {
  filters?: InputMaybe<DigitalPublicationOpenClickFilters>;
};


export type BaReportsDigitalPublicationPerformanceArgs = {
  filters?: InputMaybe<DigitalPublicationPerformanceFilters>;
};


export type BaReportsDigitalPublicationPerformanceChartClickArgs = {
  filters?: InputMaybe<DigitalPublicationPerformanceChartClickFilters>;
};


export type BaReportsDigitalPublicationPerformanceChartOpenArgs = {
  filters?: InputMaybe<DigitalPublicationPerformanceChartOpenFilters>;
};


export type BaReportsDigitalPublicationProfessionalCategoryArgs = {
  filters?: InputMaybe<DigitalPublicationProfessionalCategoryFilters>;
};


export type BaReportsDigitalPublicationProfessionalEngagementArgs = {
  filters?: InputMaybe<DigitalPublicationProfessionalEngagementFilters>;
};


export type BaReportsDigitalPublicationProfessionalRegionArgs = {
  filters?: InputMaybe<DigitalPublicationProfessionalRegionFilters>;
};


export type BaReportsDigitalPublicationProfessionalUserArgs = {
  filters?: InputMaybe<DigitalPublicationProfessionalUserFilters>;
};


export type BaReportsDigitalPublicationProfileConversionChartArgs = {
  filters?: InputMaybe<DigitalPublicationProfileConversionChartFilters>;
};


export type BaReportsDigitalPublicationReaderRegionArgs = {
  filters?: InputMaybe<DigitalPublicationReaderRegionFilters>;
};


export type BaReportsDigitalPublicationRecipientArgs = {
  filters?: InputMaybe<DigitalPublicationRecipientFilters>;
};


export type BaReportsDigitalPublicationSingleMetaArgs = {
  filters?: InputMaybe<DigitalPublicationSingleMetaFilters>;
};


export type BaReportsDigitalPublicationSummaryArgs = {
  filters?: InputMaybe<DigitalPublicationSummaryFilters>;
};


export type BaReportsDigitalPublicationTimespentArgs = {
  filters?: InputMaybe<DigitalPublicationTimespentFilters>;
};


export type BaReportsEngagedCompanyStatsByIndustryArgs = {
  filters?: InputMaybe<EngagedCompanyStatsByIndustryFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<EngagedCompanyStatsByIndustrySort>;
};


export type BaReportsExposedCompanyStatsByIndustryArgs = {
  filters?: InputMaybe<ExposedCompanyStatsByIndustryFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<ExposedCompanyStatsByIndustrySort>;
};


export type BaReportsGoogleSeoArchiproIndexArgs = {
  filters?: InputMaybe<GoogleSeoArchiproIndexFilters>;
};


export type BaReportsGoogleSeoBreakdownArgs = {
  filters?: InputMaybe<GoogleSeoBreakdownFilters>;
};


export type BaReportsGoogleSeoPieChartArgs = {
  filters?: InputMaybe<GoogleSeoPieChartFilters>;
};


export type BaReportsGoogleSeoSummaryArgs = {
  filters?: InputMaybe<GoogleSeoSummaryFilters>;
};


export type BaReportsGoogleSeoTopPageArgs = {
  filters?: InputMaybe<GoogleSeoTopPageFilters>;
  sort?: InputMaybe<GoogleSeoTopPageSort>;
};


export type BaReportsGoogleSeoTopSearchArgs = {
  filters?: InputMaybe<GoogleSeoTopSearchFilters>;
  sort?: InputMaybe<GoogleSeoTopSearchSort>;
};


export type BaReportsLeadFunnelArgs = {
  filters?: InputMaybe<LeadFunnelFilters>;
};


export type BaReportsLeadFunnelStatsArgs = {
  filters?: InputMaybe<LeadFunnelStatsFilters>;
};


export type BaReportsLeadFunnelUserScoresArgs = {
  filters?: InputMaybe<LeadFunnelUserScoresFilters>;
};


export type BaReportsLeadFunnelUserSessionsArgs = {
  filters?: InputMaybe<LeadFunnelUserSessionsFilters>;
};


export type BaReportsLeadFunnelUserStatusArgs = {
  filters?: InputMaybe<LeadFunnelUserStatusFilters>;
};


export type BaReportsLeadFunnelUserTimeArgs = {
  filters?: InputMaybe<LeadFunnelUserTimeFilters>;
};


export type BaReportsLeadFunnelUsersArgs = {
  filters?: InputMaybe<LeadFunnelUsersFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<LeadFunnelUsersSort>;
};


export type BaReportsLibraryPageKpiArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type BaReportsLibraryPagePublicKpiArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type BaReportsMetaAdCampaignConversionsArgs = {
  filters?: InputMaybe<MetaAdCampaignConversionsFilters>;
};


export type BaReportsMetaAdCampaignEngagementsArgs = {
  filters?: InputMaybe<MetaAdCampaignEngagementsFilters>;
};


export type BaReportsMetaAdCampaignProfileStatsArgs = {
  filters?: InputMaybe<MetaAdCampaignProfileStatsFilters>;
};


export type BaReportsMetaAdCampaignReachLocationsArgs = {
  filters?: InputMaybe<MetaAdCampaignReachLocationsFilters>;
};


export type BaReportsMetaAdCampaignStatsArgs = {
  filters?: InputMaybe<MetaAdCampaignStatsFilters>;
};


export type BaReportsMetaAdsCampaignTableArgs = {
  filters?: InputMaybe<MetaAdsCampaignTableFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<MetaAdsCampaignTableSort>;
};


export type BaReportsMetaAdsConversionBreakdownArgs = {
  filters?: InputMaybe<MetaAdsConversionBreakdownFilters>;
};


export type BaReportsMetaAdsEngagementBreakdownArgs = {
  filters?: InputMaybe<MetaAdsEngagementBreakdownFilters>;
};


export type BaReportsMetaAdsStatsArgs = {
  filters?: InputMaybe<MetaAdsStatsFilters>;
};


export type BaReportsMetaCampaignsArgs = {
  filters?: InputMaybe<MetaCampaignsFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type BaReportsMetaCampaignsByUtmArgs = {
  filters?: InputMaybe<MetaCampaignsByUtmFilters>;
};


export type BaReportsNativeDriverAdPerformanceArgs = {
  filters?: InputMaybe<NativeDriverAdPerformanceFilters>;
};


export type BaReportsNativeDriverDeviceArgs = {
  filters?: InputMaybe<NativeDriverDeviceFilters>;
};


export type BaReportsNativeDriverRegionArgs = {
  filters?: InputMaybe<NativeDriverRegionFilters>;
};


export type BaReportsOldConversionTableDataArgs = {
  filters?: InputMaybe<OldConversionTableDataFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<OldConversionTableDataSort>;
};


export type BaReportsOldProfileTopPagesArgs = {
  filters?: InputMaybe<OldProfileTopPagesFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<OldProfileTopPagesSort>;
};


export type BaReportsOnsitePlacementBreakdownArgs = {
  filters?: InputMaybe<OnsitePlacementBreakdownFilters>;
};


export type BaReportsOnsitePlacementLocationTypeArgs = {
  filters?: InputMaybe<OnsitePlacementLocationTypeFilters>;
};


export type BaReportsOnsitePlacementOverviewArgs = {
  filters?: InputMaybe<OnsitePlacementOverviewFilters>;
};


export type BaReportsOnsitePlacementTableArgs = {
  filters?: InputMaybe<OnsitePlacementTableFilters>;
};


export type BaReportsOnsitePlacementUserDevicesArgs = {
  filters?: InputMaybe<OnsitePlacementUserDevicesFilters>;
};


export type BaReportsOverviewImpressionArgs = {
  filters?: InputMaybe<OverviewImpressionFilters>;
};


export type BaReportsOverviewInteractionsArgs = {
  filters?: InputMaybe<OverviewInteractionsFilters>;
};


export type BaReportsOverviewNewsletterStatsArgs = {
  filters?: InputMaybe<OverviewNewsletterStatsFilters>;
};


export type BaReportsOverviewPackageArgs = {
  filters?: InputMaybe<OverviewPackageFilters>;
};


export type BaReportsOverviewPackageCampaignsArgs = {
  filters?: InputMaybe<OverviewPackageCampaignsFilters>;
};


export type BaReportsOverviewPackageCampaignsDetailsArgs = {
  filters?: InputMaybe<OverviewPackageCampaignsDetailsFilters>;
};


export type BaReportsOverviewPackageOtherCampaignsArgs = {
  filters?: InputMaybe<OverviewPackageOtherCampaignsFilters>;
};


export type BaReportsOverviewPackageOtherCampaignsDetailsArgs = {
  filters?: InputMaybe<OverviewPackageOtherCampaignsDetailsFilters>;
};


export type BaReportsOverviewPageViewArgs = {
  filters?: InputMaybe<OverviewPageViewFilters>;
};


export type BaReportsOverviewProfilePageStatsArgs = {
  filters?: InputMaybe<OverviewProfilePageStatsFilters>;
};


export type BaReportsOverviewSocialAdStatsArgs = {
  filters?: InputMaybe<OverviewSocialAdStatsFilters>;
};


export type BaReportsOverviewStatsArgs = {
  filters?: InputMaybe<OverviewStatsFilters>;
};


export type BaReportsPinterestBreakdownArgs = {
  filters?: InputMaybe<PinterestBreakdownFilters>;
};


export type BaReportsPinterestCampaignsArgs = {
  filters?: InputMaybe<PinterestCampaignsFilters>;
};


export type BaReportsPinterestSummaryArgs = {
  filters?: InputMaybe<PinterestSummaryFilters>;
};


export type BaReportsPixelActivityByOrderArgs = {
  filters?: InputMaybe<PixelActivityByOrderFilters>;
};


export type BaReportsPixelActivityBySessionArgs = {
  filters?: InputMaybe<PixelActivityBySessionFilters>;
};


export type BaReportsPixelActivityByUserArgs = {
  filters?: InputMaybe<PixelActivityByUserFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type BaReportsPixelConversionsArgs = {
  filters?: InputMaybe<PixelConversionsFilters>;
};


export type BaReportsPixelConversionsNonDistinctArgs = {
  filters?: InputMaybe<PixelConversionsNonDistinctFilters>;
};


export type BaReportsPixelIndustryBreakdownArgs = {
  filters?: InputMaybe<PixelIndustryBreakdownFilters>;
};


export type BaReportsPixelRegionBreakdownArgs = {
  filters?: InputMaybe<PixelRegionBreakdownFilters>;
};


export type BaReportsPixelReturningUserBreakdownArgs = {
  filters?: InputMaybe<PixelReturningUserBreakdownFilters>;
};


export type BaReportsPixelRuleConversionsArgs = {
  filters?: InputMaybe<PixelRuleConversionsFilters>;
};


export type BaReportsPixelSmokeTestArgs = {
  filters?: InputMaybe<PixelSmokeTestFilters>;
};


export type BaReportsPixelStatsArgs = {
  filters?: InputMaybe<PixelStatsFilters>;
};


export type BaReportsPixelTopLandingPagesArgs = {
  filters?: InputMaybe<PixelTopLandingPagesFilters>;
};


export type BaReportsPixelTopReferralsArgs = {
  filters?: InputMaybe<PixelTopReferralsFilters>;
};


export type BaReportsProductTagStatsArgs = {
  filters?: InputMaybe<ProductTagStatsFilters>;
};


export type BaReportsProductTagTemporalStatsArgs = {
  filters?: InputMaybe<ProductTagTemporalStatsFilters>;
};


export type BaReportsProfileCampaignsOverTimeArgs = {
  filters?: InputMaybe<ProfileCampaignsOverTimeFilters>;
};


export type BaReportsProfileConversionBreakdownArgs = {
  filters?: InputMaybe<ProfileConversionBreakdownFilters>;
};


export type BaReportsProfileConversionTypesArgs = {
  filters?: InputMaybe<ProfileConversionTypesFilters>;
};


export type BaReportsProfileImpressionSourcesArgs = {
  filters?: InputMaybe<ProfileImpressionSourcesFilters>;
};


export type BaReportsProfileIndustriesArgs = {
  filters?: InputMaybe<ProfileIndustriesFilters>;
};


export type BaReportsProfilePageNamesArgs = {
  filters?: InputMaybe<ProfilePageNamesFilters>;
};


export type BaReportsProfilePageTypeBreakdownArgs = {
  filters?: InputMaybe<ProfilePageTypeBreakdownFilters>;
};


export type BaReportsProfilePageTypesArgs = {
  filters?: InputMaybe<ProfilePageTypesFilters>;
};


export type BaReportsProfileStatsArgs = {
  filters?: InputMaybe<ProfileStatsFilters>;
};


export type BaReportsProfileStatsOverTimeArgs = {
  filters?: InputMaybe<ProfileStatsOverTimeFilters>;
};


export type BaReportsProfileTopPagesArgs = {
  filters?: InputMaybe<ProfileTopPagesFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<ProfileTopPagesSort>;
};


export type BaReportsProfileTrafficSourcesArgs = {
  filters?: InputMaybe<ProfileTrafficSourcesFilters>;
};


export type BaReportsSalesConversionsArgs = {
  filters?: InputMaybe<SalesConversionsFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type BaReportsTaggedProductsByRecordArgs = {
  filters?: InputMaybe<TaggedProductsByRecordFilters>;
};


export type BaReportsTaggedRecordsArgs = {
  filters?: InputMaybe<TaggedRecordsFilters>;
  sort?: InputMaybe<TaggedRecordsSort>;
};


export type BaReportsTopClickedTagsArgs = {
  filters?: InputMaybe<TopClickedTagsFilters>;
};

export enum BmDateRange {
  Last3Months = 'Last3Months',
  Last6Months = 'Last6Months',
  LastMonth = 'LastMonth',
  LastYear = 'LastYear'
}

export type BackgroundImages_Connection = {
  __typename?: 'BackgroundImages_Connection';
  edges: Array<BackgroundImages_ConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type BackgroundImages_ConnectionEdge = {
  __typename?: 'BackgroundImages_ConnectionEdge';
  /** The node at the end of the collections edge */
  node: LibraryImageFile;
};

export type BackgroundImages_SortFields = {
  SortOrder?: InputMaybe<SortDirection>;
};

export type BannerModule = ModuleType & {
  __typename?: 'BannerModule';
  AnchorTag?: Maybe<Scalars['String']>;
  ExtraClass?: Maybe<Scalars['String']>;
  ID: Scalars['ID'];
  Image?: Maybe<ResponsiveVariantImage>;
  NavigationLabel?: Maybe<Scalars['String']>;
  SpacingBelow?: Maybe<Scalars['String']>;
  SpacingBelowMobile?: Maybe<Scalars['String']>;
  ThemeColour: ThemedElementColourType;
};

export enum BannerSegmentEnum {
  Aboutus = 'ABOUTUS',
  Articles = 'ARTICLES',
  Carousel = 'CAROUSEL',
  Contact = 'CONTACT',
  Network = 'NETWORK',
  Products = 'PRODUCTS',
  Projects = 'PROJECTS',
  Videos = 'VIDEOS'
}

export type BenchmarkAttentionShareFilters = {
  CATEGORY_TYPE__EQUAL?: InputMaybe<Scalars['String']>;
};

export type BenchmarkCategoryEngagementFilters = {
  CATEGORY_TYPE__EQUAL?: InputMaybe<Scalars['String']>;
  MONTH_OF_YEAR__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type BenchmarkCategoryHealthFilters = {
  CATEGORY_TYPE__EQUAL?: InputMaybe<Scalars['String']>;
  MONTH_OF_YEAR__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type BenchmarkLeadGenerateFilters = {
  CATEGORY_TYPE__EQUAL?: InputMaybe<Scalars['String']>;
  LEADS_MONTH__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type BenchmarkProductHealthFilters = {
  CATEGORY_TYPE__EQUAL?: InputMaybe<Scalars['String']>;
};

export type BenchmarkStatsFilters = {
  CATEGORY_TYPE__EQUAL?: InputMaybe<Scalars['String']>;
  MONTH_OF_YEAR__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type BenchmarkTierOnePerformanceFilters = {
  MONTH_OF_YEAR__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type BenchmarkTierOnePerformanceSort = {
  AVG_PRODUCTS_PER_PROFESSIONAL?: InputMaybe<PrioritySort>;
  CATEGORY?: InputMaybe<PrioritySort>;
  TOTAL_PRODUCTS_IN_CATEGORY?: InputMaybe<PrioritySort>;
  YOUR_CATEGORY_HEALTH_SCORE?: InputMaybe<PrioritySort>;
  YOUR_CATEGORY_OWNERSHIP?: InputMaybe<PrioritySort>;
  YOUR_PRODUCT_COUNT?: InputMaybe<PrioritySort>;
  YOUR_SHARE_OF_ATTENTION_TIME?: InputMaybe<PrioritySort>;
  YOUR_SHARE_OF_PAGE_VIEWS?: InputMaybe<PrioritySort>;
};

export type BenchmarkTierTwoPerformanceFilters = {
  MONTH_OF_YEAR__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
  PARENT_CATEGORY__EQUAL?: InputMaybe<Scalars['String']>;
};

export type BlacklistedFields = {
  __typename?: 'BlacklistedFields';
  items?: Maybe<Array<Scalars['String']>>;
};

export type BookCalendarEventInput = {
  /** Company name actually provided by the user (for storage, null if not provided) */
  clientCompany?: InputMaybe<Scalars['String']>;
  /** Email of the client director's connected calendar */
  clientDirectorEmail: Scalars['String'];
  /** Email of the client booking the event */
  clientEmail: Scalars['String'];
  /** Full name of the client booking the event */
  clientName?: InputMaybe<Scalars['String']>;
  /** Name of the company booking the event (for display/event creation, may include fallbacks) */
  company: Scalars['String'];
  /** Detailed description of the event */
  customMessage?: InputMaybe<Scalars['String']>;
  /** Duration of the event in minutes */
  duration: Scalars['Int'];
  /** Name/title of the event (optional - generated from session if not provided) */
  eventName?: InputMaybe<Scalars['String']>;
  /** Location of the event */
  locationString?: InputMaybe<Scalars['String']>;
  /** ID of the organizer professional member */
  organizerId: Scalars['Int'];
  /** Event ID to reschedule (if provided, updates existing event instead of creating new) */
  originalEventId?: InputMaybe<Scalars['String']>;
  /** Array of minutes before the event to send reminders (e.g. [1440, 60, 30] for 1 day, 1 hour, 30 minutes) */
  reminderMinutes?: InputMaybe<Array<Scalars['Int']>>;
  /** Optional ID of the calendar session for this booking */
  sessionId?: InputMaybe<Scalars['Int']>;
  /** Start time of the event in ISO format */
  startTime: Scalars['String'];
  /** Brief summary of the event */
  summary?: InputMaybe<Scalars['String']>;
  /** IANA timezone name for Outlook bookings (e.g. \"Pacific/Auckland\") */
  timezoneName?: InputMaybe<Scalars['String']>;
};

export type BookCalendarEventResult = {
  __typename?: 'BookCalendarEventResult';
  /** Error message if booking failed */
  error?: Maybe<Scalars['String']>;
  /** ID of the created calendar event */
  eventId?: Maybe<Scalars['String']>;
  /** Whether the event was successfully booked */
  success: Scalars['Boolean'];
};

export type BookingByEventId = {
  __typename?: 'BookingByEventId';
  /** Company name of the client */
  clientCompany: Scalars['String'];
  /** Email of the client who booked the event */
  clientEmail: Scalars['String'];
  /** Name of the client who booked the event */
  clientName: Scalars['String'];
  /** Event ID (Google or Outlook) */
  eventId: Scalars['String'];
  /** ID of the organizer member who owns the calendar */
  organizerId?: Maybe<Scalars['Int']>;
  /** ID of the calendar session */
  sessionId?: Maybe<Scalars['Int']>;
};

export type BooleanResult = {
  __typename?: 'BooleanResult';
  Message?: Maybe<Scalars['String']>;
  Success: Scalars['Boolean'];
};

export type BrandImpressionTopPerformer = {
  __typename?: 'BrandImpressionTopPerformer';
  DirectoryItem: DirectoryItem;
  ID: Scalars['String'];
  Link: Scalars['String'];
  Rank: Scalars['String'];
  Title: Scalars['String'];
  TotalImpressions: Scalars['Int'];
};

export type BuildHub = {
  __typename?: 'BuildHub';
  AvailableStages: Array<BuildHubStage>;
  Brief?: Maybe<BuildHubBrief>;
  Budget?: Maybe<BuildHubBudget>;
  BuildStage?: Maybe<Scalars['String']>;
  CanComment: Scalars['Boolean'];
  CanCreate: Scalars['Boolean'];
  CanDelete: Scalars['Boolean'];
  CanEdit: Scalars['Boolean'];
  CanEditCollaborator: Scalars['Boolean'];
  Collaborators: Array<BuildHubCollaborator>;
  Created: Scalars['String'];
  CurrentUserRole?: Maybe<BuildHubRoleEnum>;
  EndDate?: Maybe<Scalars['String']>;
  ID: Scalars['ID'];
  Inspirations: InspirationGroupsConnection;
  IsOwner: Scalars['Boolean'];
  LastEdited: Scalars['String'];
  Link: Scalars['String'];
  Location?: Maybe<Scalars['String']>;
  LocationData?: Maybe<PlaceDetailType>;
  MainDescription?: Maybe<Scalars['String']>;
  Milestones: Array<BuildHubMilestone>;
  Owner: Member;
  ProjectScope?: Maybe<Scalars['String']>;
  ProjectType?: Maybe<BuildHubTypeEnum>;
  StartDate?: Maybe<Scalars['String']>;
  ThumbnailFile?: Maybe<LibraryImageFile>;
  TimelineSettings?: Maybe<BuildHubTimelineSettings>;
  Title: Scalars['String'];
  URLSegment: Scalars['String'];
};


export type BuildHubInspirationsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type BuildHubBrief = {
  __typename?: 'BuildHubBrief';
  HTMLContent?: Maybe<Scalars['String']>;
  RawContent?: Maybe<Scalars['String']>;
};

export type BuildHubBudget = {
  __typename?: 'BuildHubBudget';
  Currency: Scalars['String'];
  Max: Scalars['Float'];
  Min: Scalars['Float'];
};

export type BuildHubBudgetOption = {
  __typename?: 'BuildHubBudgetOption';
  key: Scalars['String'];
  label: Scalars['String'];
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
};

export type BuildHubCollaborator = {
  __typename?: 'BuildHubCollaborator';
  Caption?: Maybe<Scalars['String']>;
  CustomCompanyName?: Maybe<Scalars['String']>;
  Email?: Maybe<Scalars['String']>;
  ID: Scalars['ID'];
  InvitedByMemberID?: Maybe<Scalars['Int']>;
  LastInviteLink?: Maybe<Scalars['String']>;
  LastInviteSent?: Maybe<Scalars['String']>;
  Member?: Maybe<Member>;
  Role?: Maybe<BuildHubRoleEnum>;
  SortOrder: Scalars['Int'];
  TeamMember?: Maybe<TeamMember>;
};

export type BuildHubCollaboratorResponse = BuildHubCollaborator | NotAuthorizedError | NotFoundError | ServerError | UserError;

export type BuildHubComment = {
  __typename?: 'BuildHubComment';
  Author: Member;
  Created: Scalars['String'];
  ID: Scalars['ID'];
  LastEdited: Scalars['String'];
  Link: Scalars['String'];
  LinkedFiles: Array<BuildHubDocument>;
  Mentions: Array<BuildHubCollaborator>;
  Message: Scalars['String'];
  Replies?: Maybe<Array<BuildHubComment>>;
  Target: BuildHubDocument;
  Thread?: Maybe<BuildHubComment>;
};

export type BuildHubCommentResponse = BuildHubComment | NotAuthorizedError | NotFoundError | ServerError | UserError;

export type BuildHubConnection = {
  __typename?: 'BuildHubConnection';
  edges: Array<BuildHubConnectionEdge>;
  nodes: Array<BuildHub>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type BuildHubConnectionEdge = {
  __typename?: 'BuildHubConnectionEdge';
  /** The node at the end of the collections edge */
  node: BuildHub;
};

export type BuildHubDocument = {
  Breadcrumbs: Scalars['String'];
  BuildHub: BuildHub;
  CanComment: Scalars['Boolean'];
  CanCreate: Scalars['Boolean'];
  CanDelete: Scalars['Boolean'];
  CanEdit: Scalars['Boolean'];
  Children: Array<BuildHubDocument>;
  Collaborators: Array<BuildHubDocumentCollaborator>;
  Comments: Array<BuildHubComment>;
  CommentsCount: Scalars['Int'];
  Created: Scalars['String'];
  Description?: Maybe<Scalars['String']>;
  EffectiveAccessMode: Scalars['String'];
  EffectiveAccessRole: Scalars['String'];
  FutureTeamMemberRole: Scalars['String'];
  GeneralAccessMode: Scalars['String'];
  GeneralAccessRole: Scalars['String'];
  ID: Scalars['ID'];
  InheritPermissions: Scalars['Boolean'];
  IsFile: Scalars['Boolean'];
  IsFolder: Scalars['Boolean'];
  LastEdited: Scalars['String'];
  Link: Scalars['String'];
  NegativeReactionsCount: Scalars['Int'];
  Owner: Member;
  Parent?: Maybe<BuildHubDocument>;
  PositiveReactionsCount: Scalars['Int'];
  Private: Scalars['Boolean'];
  Reactions: Array<BuildHubReaction>;
  SortOrder: Scalars['Int'];
  Title: Scalars['String'];
  URLSegment: Scalars['String'];
  UnreadCount: Scalars['Int'];
};

export type BuildHubDocumentAccessInput = {
  FutureTeamMemberRole?: InputMaybe<Scalars['String']>;
  GeneralAccessMode: Scalars['String'];
  GeneralAccessRole: Scalars['String'];
  InheritPermissions?: InputMaybe<Scalars['Boolean']>;
};

export type BuildHubDocumentCollaborator = {
  __typename?: 'BuildHubDocumentCollaborator';
  BuildHubDocument: BuildHubDocument;
  Email: Scalars['String'];
  ID: Scalars['ID'];
  Image?: Maybe<Scalars['String']>;
  Member?: Maybe<Member>;
  Name: Scalars['String'];
  Role: BuildHubDocumentRoleEnum;
  SortOrder: Scalars['Int'];
};

export type BuildHubDocumentCollaboratorInput = {
  Email: Scalars['String'];
  Role: Scalars['String'];
};

export type BuildHubDocumentResponse = InspirationGroup | InspirationItem | NotAuthorizedError | NotFoundError | ServerError | UserError;

/** Roles BuildHub Document Collaborators can take on. */
export enum BuildHubDocumentRoleEnum {
  Commenter = 'Commenter',
  Editor = 'Editor',
  Viewer = 'Viewer'
}

export type BuildHubMilestone = {
  __typename?: 'BuildHubMilestone';
  BuildHubID: Scalars['Int'];
  Date?: Maybe<Scalars['String']>;
  ID: Scalars['ID'];
  IsCompleted: Scalars['Boolean'];
  IsDisabled?: Maybe<Scalars['Boolean']>;
  SortOrder: Scalars['Int'];
  Title: Scalars['String'];
  URLSegment: Scalars['String'];
};

export type BuildHubProjectScope = {
  __typename?: 'BuildHubProjectScope';
  budgetOptions: Array<BuildHubBudgetOption>;
  description: Scalars['String'];
  emoji: Scalars['String'];
  label: Scalars['String'];
  stages: Array<BuildHubStageOption>;
  value: Scalars['String'];
};

export type BuildHubReaction = {
  __typename?: 'BuildHubReaction';
  ByBuildHubOwner: Scalars['Boolean'];
  ByDocumentOwner: Scalars['Boolean'];
  Collaborator?: Maybe<BuildHubCollaborator>;
  Created: Scalars['String'];
  Document: BuildHubDocument;
  ID: Scalars['ID'];
  LastEdited: Scalars['String'];
  Member: Member;
  Polarity: ReactionPolarityEnum;
  Reaction: ReactionTypeEnum;
};

export type BuildHubReactionResponse = BuildHubReaction | NotAuthorizedError | NotFoundError | ServerError | UserError;

export type BuildHubResponse = BuildHub | NotAuthorizedError | NotFoundError | ServerError | UserError;

/** Roles BuildHub Collaborators can take on. */
export enum BuildHubRoleEnum {
  Admin = 'Admin',
  Editor = 'Editor',
  Viewer = 'Viewer'
}

export type BuildHubStage = {
  __typename?: 'BuildHubStage';
  BuildHubID: Scalars['Int'];
  CompletionDate?: Maybe<Scalars['String']>;
  ID: Scalars['ID'];
  IsActive: Scalars['Boolean'];
  IsCompleted: Scalars['Boolean'];
  IsDisabled?: Maybe<Scalars['Boolean']>;
  Progress?: Maybe<Scalars['Int']>;
  SortOrder: Scalars['Int'];
  StartDate?: Maybe<Scalars['String']>;
  Title: Scalars['String'];
  URLSegment: Scalars['String'];
};

export type BuildHubStageConfiguration = {
  __typename?: 'BuildHubStageConfiguration';
  commercial: Array<BuildHubProjectScope>;
  residential: Array<BuildHubProjectScope>;
};

export type BuildHubStageInput = {
  completionDate?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isCompleted?: InputMaybe<Scalars['Boolean']>;
  isDisabled?: InputMaybe<Scalars['Boolean']>;
  progress?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  urlSegment: Scalars['String'];
};

export type BuildHubStageOption = {
  __typename?: 'BuildHubStageOption';
  sortOrder: Scalars['Int'];
  title: Scalars['String'];
  urlSegment: Scalars['String'];
};

export type BuildHubTimelineSettings = {
  __typename?: 'BuildHubTimelineSettings';
  BuildHubID: Scalars['Int'];
  HighlightNonWorkingDays: Scalars['Boolean'];
  ID: Scalars['ID'];
  ShowGridLines: Scalars['Boolean'];
  ShowMinorGridLines: Scalars['Boolean'];
  ShowNonWorkingDays: Scalars['Boolean'];
  ViewMode: Scalars['String'];
  WorkingDays: Scalars['String'];
};

/** The different markets the Build can be targeted at. */
export enum BuildHubTypeEnum {
  Commercial = 'Commercial',
  Residential = 'Residential'
}

export type BuildingGuide = DirectoryItem & IApprovable & ICreatable & IHasProfessional & IHomePinable & IPublishable & Node & SortableItem & {
  __typename?: 'BuildingGuide';
  /** Has this page been reviewed and approved by the ArchiPro Content Team? */
  Activated?: Maybe<Scalars['Boolean']>;
  ApprovedByMember?: Maybe<Member>;
  ApprovedDate?: Maybe<Scalars['String']>;
  AssociatedPages: BuildingGuide_AssociatedPagesConnection;
  Author?: Maybe<Member>;
  AvailabilityZones: Array<Zone>;
  BannerImages: Array<LibraryImage>;
  Banners: LibraryItemBannersConnection;
  ByArchipro?: Maybe<Scalars['Boolean']>;
  CallToActions: Array<CallToAction>;
  CanonicalLink?: Maybe<Scalars['String']>;
  Categories: Array<Category>;
  Clones?: Maybe<Array<DirectoryItem>>;
  Content?: Maybe<Scalars['String']>;
  ContentBlocks?: Maybe<Array<ContentBlock>>;
  ContentComment?: Maybe<Scalars['String']>;
  ContentRejectReasons: Array<ContentRejectReasonEnum>;
  ContentStatus?: Maybe<ContentStatusEnum>;
  ContentStatusBy?: Maybe<Member>;
  ContentStatusDate?: Maybe<Scalars['String']>;
  CreatedByMember?: Maybe<Member>;
  CreatedDate?: Maybe<Scalars['String']>;
  CreatedTimestamp: Scalars['Int'];
  DataQualityRating: Scalars['Float'];
  DesignBoardsForCurrentUser?: Maybe<Array<Maybe<DesignBoard>>>;
  Disable: Scalars['Boolean'];
  FacebookPreviewImage?: Maybe<Scalars['String']>;
  FirstPublishedDate?: Maybe<Scalars['String']>;
  HasClones: Scalars['Boolean'];
  HasDownloads: Scalars['Boolean'];
  HasPhotos: Scalars['Boolean'];
  HasProducts: Scalars['Boolean'];
  HasProjects: Scalars['Boolean'];
  HasTags: Scalars['Boolean'];
  HasVideos: Scalars['Boolean'];
  HomePinned: Scalars['Boolean'];
  ID: Scalars['Int'];
  Images: LibraryItemImagesConnection;
  InLibrary?: Maybe<Scalars['Boolean']>;
  IntroText?: Maybe<Scalars['String']>;
  IsCloned: Scalars['Boolean'];
  /** Has this page been reviewed and approved by the client? */
  IsDraft: Scalars['Boolean'];
  IsFeature: Scalars['Boolean'];
  /** True if published and activated */
  IsLive: Scalars['Boolean'];
  IsManufacturer: Scalars['Boolean'];
  IsTemplate: Scalars['Boolean'];
  LastEditedDate?: Maybe<Scalars['String']>;
  LastEditedTimestamp: Scalars['Int'];
  LibraryDownloads: Array<LibraryDownload>;
  LibraryImages: Array<LibraryImage>;
  LibraryLocations: Array<LibraryLocation>;
  LibraryRange?: Maybe<LibraryRange>;
  LibraryTabs: Array<LibraryTab>;
  LibraryThumb?: Maybe<LibraryThumb>;
  LibraryVideos: Array<LibraryVideo>;
  Link: Scalars['String'];
  LiveDateTimestamp?: Maybe<Scalars['Int']>;
  MemberSortOrder: Scalars['Int'];
  Meta?: Maybe<Meta>;
  Networks: BuildingGuide_NetworksConnection;
  PageMeta?: Maybe<DirectoryPageMeta>;
  PageType: Scalars['String'];
  ParentID: Scalars['Int'];
  /** Same as Categories but with a different return type PrimaryCategory */
  PrimaryCategories: Array<CategoryPage>;
  PrimaryCategory?: Maybe<CategoryPage>;
  ProductsUsed: Array<Product>;
  Professional?: Maybe<Professional>;
  /** Has this page been reviewed and approved by the client? */
  Publish: Scalars['Boolean'];
  PublishDate?: Maybe<Scalars['String']>;
  PublishedByMember?: Maybe<Member>;
  RawTileImage?: Maybe<Scalars['String']>;
  ReadingMinutes: Scalars['Int'];
  Recommendations?: Maybe<Array<Maybe<DirectoryItem>>>;
  /** Actions that need addressing before this page can be approved */
  ReviewActions?: Maybe<Array<Maybe<ReviewAction>>>;
  SampleAddressPlaceholder?: Maybe<Scalars['String']>;
  SampleMessagePlaceholder?: Maybe<Scalars['String']>;
  SampleSubmitText?: Maybe<Scalars['String']>;
  SampleText?: Maybe<Scalars['String']>;
  SampleTitle?: Maybe<Scalars['String']>;
  SamplesAddressRequired: Scalars['Boolean'];
  SamplesAvailable: Scalars['Boolean'];
  SearchTags?: Maybe<Array<Maybe<SearchTag>>>;
  ShowsInElasticSearch: Scalars['Boolean'];
  SortOrder: Scalars['Int'];
  Teaser?: Maybe<Scalars['String']>;
  ThumbnailFile?: Maybe<LibraryImageFile>;
  Title: Scalars['String'];
  TopBanner?: Maybe<LibraryItemBanner>;
  URLSegment: Scalars['String'];
  ViewsCount: Scalars['Int'];
  Website?: Maybe<Scalars['String']>;
  WebsiteShort?: Maybe<Scalars['String']>;
  WebsiteUntracked: Scalars['String'];
  WordCount: Scalars['Int'];
  deprecated_Awards?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};


export type BuildingGuideApprovedDateArgs = {
  format?: InputMaybe<DateFormatEnum>;
};


export type BuildingGuideAssociatedPagesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type BuildingGuideBannersArgs = {
  filter?: InputMaybe<LibraryItemBannersFilters>;
  filters?: InputMaybe<LibraryItemBannersFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<LibraryItemBannersSortFields>;
};


export type BuildingGuideContentStatusDateArgs = {
  format?: InputMaybe<DateFormatEnum>;
};


export type BuildingGuideCreatedDateArgs = {
  format?: InputMaybe<DateFormatEnum>;
};


export type BuildingGuideFirstPublishedDateArgs = {
  format?: InputMaybe<DateFormatEnum>;
};


export type BuildingGuideImagesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type BuildingGuideLibraryImagesArgs = {
  Limit?: InputMaybe<Scalars['Int']>;
};


export type BuildingGuideLibraryLocationsArgs = {
  showHidden?: InputMaybe<Scalars['Boolean']>;
};


export type BuildingGuideNetworksArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<BuildingGuide_NetworksSortFields>;
};


export type BuildingGuidePublishDateArgs = {
  format?: InputMaybe<DateFormatEnum>;
};


export type BuildingGuideReadingMinutesArgs = {
  WithPageBuilder?: InputMaybe<Scalars['Boolean']>;
};


export type BuildingGuideViewsCountArgs = {
  Range: DirectoryItemViewsCountRange;
};


export type BuildingGuideWordCountArgs = {
  WithPageBuilder?: InputMaybe<Scalars['Boolean']>;
};

export type BuildingGuideCategory = ICategory & {
  __typename?: 'BuildingGuideCategory';
  BuildingGuides: BuildingGuideCategory_BuildingGuidesConnection;
  Categories: BuildingGuideCategory_CategoriesConnection;
  CustomSeoOnFilters?: Maybe<Scalars['Boolean']>;
  ID: Scalars['Int'];
  /** Clear cut Image */
  Image?: Maybe<ResponsiveImage>;
  IsPublished?: Maybe<Scalars['Boolean']>;
  Link: Scalars['String'];
  MenuTitle: Scalars['String'];
  Parent?: Maybe<BuildingGuideCategory>;
  Parents: BuildingGuideCategory_ParentsConnection;
  PrettyTitle: Scalars['String'];
  /** Clear cut Image */
  Thumbnail?: Maybe<ResponsiveImage>;
  Title: Scalars['String'];
  URLSegment?: Maybe<Scalars['String']>;
};


export type BuildingGuideCategoryBuildingGuidesArgs = {
  IDs?: InputMaybe<Array<Scalars['Int']>>;
  Visibility?: InputMaybe<BuildingGuideVisibility>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<BuildingGuideCategory_BuildingGuidesSortFields>;
};


export type BuildingGuideCategoryCategoriesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<BuildingGuideCategory_CategoriesSortFields>;
};


export type BuildingGuideCategoryImageArgs = {
  Height?: InputMaybe<Scalars['Int']>;
  Width?: InputMaybe<Scalars['Int']>;
};


export type BuildingGuideCategoryParentsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type BuildingGuideCategoryThumbnailArgs = {
  Height?: InputMaybe<Scalars['Int']>;
  Width?: InputMaybe<Scalars['Int']>;
};

export type BuildingGuideCategory_BuildingGuidesConnection = {
  __typename?: 'BuildingGuideCategory_BuildingGuidesConnection';
  edges: Array<BuildingGuideCategory_BuildingGuidesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type BuildingGuideCategory_BuildingGuidesConnectionEdge = {
  __typename?: 'BuildingGuideCategory_BuildingGuidesConnectionEdge';
  /** The node at the end of the collections edge */
  node: BuildingGuide;
};

export type BuildingGuideCategory_BuildingGuidesSortFields = {
  Created?: InputMaybe<SortDirection>;
  LastEdited?: InputMaybe<SortDirection>;
  SortOrder?: InputMaybe<SortDirection>;
};

export type BuildingGuideCategory_CategoriesConnection = {
  __typename?: 'BuildingGuideCategory_CategoriesConnection';
  edges: Array<BuildingGuideCategory_CategoriesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type BuildingGuideCategory_CategoriesConnectionEdge = {
  __typename?: 'BuildingGuideCategory_CategoriesConnectionEdge';
  /** The node at the end of the collections edge */
  node: BuildingGuideCategory;
};

export type BuildingGuideCategory_CategoriesSortFields = {
  Title?: InputMaybe<SortDirection>;
};

export type BuildingGuideCategory_ParentsConnection = {
  __typename?: 'BuildingGuideCategory_ParentsConnection';
  edges: Array<BuildingGuideCategory_ParentsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type BuildingGuideCategory_ParentsConnectionEdge = {
  __typename?: 'BuildingGuideCategory_ParentsConnectionEdge';
  /** The node at the end of the collections edge */
  node: BuildingGuideCategory;
};

export type BuildingGuideCheckoutSession = {
  __typename?: 'BuildingGuideCheckoutSession';
  SessionId?: Maybe<Scalars['String']>;
};

export type BuildingGuideDownload = {
  __typename?: 'BuildingGuideDownload';
  File: Scalars['String'];
  ID: Scalars['String'];
  Title: Scalars['String'];
};

export type BuildingGuideSection = {
  __typename?: 'BuildingGuideSection';
  CheckList?: Maybe<Array<Array<BuildingGuideDownload>>>;
  Description: Scalars['String'];
  Guides?: Maybe<Array<BuildingGuide>>;
  ID: Scalars['String'];
  Link: Scalars['String'];
  SectionBackground?: Maybe<Scalars['String']>;
  SortOrder: Scalars['Int'];
  Subtitle?: Maybe<Scalars['String']>;
  Title: Scalars['String'];
  URLSegment: Scalars['String'];
};

export type BuildingGuideSubscription = {
  __typename?: 'BuildingGuideSubscription';
  ID: Scalars['String'];
  Name: Scalars['String'];
};

export enum BuildingGuideVisibility {
  Disabled = 'Disabled',
  Draft = 'Draft',
  InLibrary = 'InLibrary',
  InSearch = 'InSearch',
  NotLive = 'NotLive',
  PendingApproval = 'PendingApproval',
  ProfileOnly = 'ProfileOnly'
}

export type BuildingGuide_AssociatedPagesConnection = {
  __typename?: 'BuildingGuide_AssociatedPagesConnection';
  edges: Array<BuildingGuide_AssociatedPagesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type BuildingGuide_AssociatedPagesConnectionEdge = {
  __typename?: 'BuildingGuide_AssociatedPagesConnectionEdge';
  /** The node at the end of the collections edge */
  node: AssociatedPage;
};

export type BuildingGuide_NetworksConnection = {
  __typename?: 'BuildingGuide_NetworksConnection';
  edges: Array<BuildingGuide_NetworksConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type BuildingGuide_NetworksConnectionEdge = {
  __typename?: 'BuildingGuide_NetworksConnectionEdge';
  /** The node at the end of the collections edge */
  node: Network;
};

export type BuildingGuide_NetworksSortFields = {
  ID?: InputMaybe<SortDirection>;
};

export type BulkUploadError = {
  __typename?: 'BulkUploadError';
  code: UploadErrorCodeEnum;
  files: Array<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

export type BulkUploadResult = {
  __typename?: 'BulkUploadResult';
  errors?: Maybe<Array<BulkUploadError>>;
  success?: Maybe<Scalars['Boolean']>;
};

export enum BusinessFocusEnum {
  Commercial = 'Commercial',
  Mixed = 'Mixed',
  Residential = 'Residential',
  Unspecified = 'Unspecified'
}

export enum BusinessManagementActions {
  BmAdvertAdminEdit = 'BM_ADVERT_ADMIN_EDIT',
  BmAnalyticsTrackingLinkShare = 'BM_ANALYTICS_TRACKING_LINK_SHARE',
  BmAnalyticsUpdateSetting = 'BM_ANALYTICS_UPDATE_SETTING',
  BmAnalyticsView = 'BM_ANALYTICS_VIEW',
  BmArticleEdit = 'BM_ARTICLE_EDIT',
  BmCategoryPlacementView = 'BM_CATEGORY_PLACEMENT_VIEW',
  BmContentApprove = 'BM_CONTENT_APPROVE',
  BmContentView = 'BM_CONTENT_VIEW',
  BmEnhancedConversionsView = 'BM_ENHANCED_CONVERSIONS_VIEW',
  BmImageExport = 'BM_IMAGE_EXPORT',
  BmImageImport = 'BM_IMAGE_IMPORT',
  BmInboxReply = 'BM_INBOX_REPLY',
  BmInboxRevealContact = 'BM_INBOX_REVEAL_CONTACT',
  BmInboxShare = 'BM_INBOX_SHARE',
  BmInboxUpdateStatus = 'BM_INBOX_UPDATE_STATUS',
  BmInboxView = 'BM_INBOX_VIEW',
  BmIntegrationsSettings = 'BM_INTEGRATIONS_SETTINGS',
  BmMarketingView = 'BM_MARKETING_VIEW',
  BmOrdersView = 'BM_ORDERS_VIEW',
  BmPageTemplateApply = 'BM_PAGE_TEMPLATE_APPLY',
  BmPageTemplateCreate = 'BM_PAGE_TEMPLATE_CREATE',
  BmPlatformSync = 'BM_PLATFORM_SYNC',
  BmProductsEdit = 'BM_PRODUCTS_EDIT',
  BmProductTaggingApprove = 'BM_PRODUCT_TAGGING_APPROVE',
  BmProductTaggingCreate = 'BM_PRODUCT_TAGGING_CREATE',
  BmProductTaggingDelete = 'BM_PRODUCT_TAGGING_DELETE',
  BmProfessionalCreate = 'BM_PROFESSIONAL_CREATE',
  BmProfileEdit = 'BM_PROFILE_EDIT',
  BmProfileView = 'BM_PROFILE_VIEW',
  BmProjectEdit = 'BM_PROJECT_EDIT',
  BmSettingUpdate = 'BM_SETTING_UPDATE',
  BmStaffView = 'BM_STAFF_VIEW',
  BmSupportView = 'BM_SUPPORT_VIEW'
}

export type BusinessModule = ModuleType & {
  __typename?: 'BusinessModule';
  AnchorTag?: Maybe<Scalars['String']>;
  /** Business support blocks */
  BusinessSupportBlocks: BusinessSupportBlocks_Connection;
  ExtraClass?: Maybe<Scalars['String']>;
  ID: Scalars['ID'];
  IntroText?: Maybe<Scalars['String']>;
  NavigationLabel?: Maybe<Scalars['String']>;
  SpacingBelow?: Maybe<Scalars['String']>;
  SpacingBelowMobile?: Maybe<Scalars['String']>;
  ThemeColour: ThemedElementColourType;
};


export type BusinessModuleBusinessSupportBlocksArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<BusinessSupportBlocks_SortFields>;
};

export type BusinessSupportBlock = ModuleType & {
  __typename?: 'BusinessSupportBlock';
  AnchorTag?: Maybe<Scalars['String']>;
  ExtraClass?: Maybe<Scalars['String']>;
  ID: Scalars['ID'];
  Image?: Maybe<ResponsiveVariantImage>;
  NavigationLabel?: Maybe<Scalars['String']>;
  SpacingBelow?: Maybe<Scalars['String']>;
  SpacingBelowMobile?: Maybe<Scalars['String']>;
  Summary?: Maybe<Scalars['String']>;
  ThemeColour: ThemedElementColourType;
  Title?: Maybe<Scalars['String']>;
};

export type BusinessSupportBlocks_Connection = {
  __typename?: 'BusinessSupportBlocks_Connection';
  edges: Array<BusinessSupportBlocks_ConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type BusinessSupportBlocks_ConnectionEdge = {
  __typename?: 'BusinessSupportBlocks_ConnectionEdge';
  /** The node at the end of the collections edge */
  node: BusinessSupportBlock;
};

export type BusinessSupportBlocks_SortFields = {
  SortOrder?: InputMaybe<SortDirection>;
};

export type BusinessTerms = {
  __typename?: 'BusinessTerms';
  Category?: Maybe<BusinessTermsCategory>;
  Countries: Array<Country>;
  ID: Scalars['ID'];
  LastEdited: Scalars['String'];
  Professional: Professional;
  Terms?: Maybe<TokenisedField>;
  Title: Scalars['String'];
  URLSegment: Scalars['String'];
};

export type BusinessTermsCategory = {
  __typename?: 'BusinessTermsCategory';
  Description?: Maybe<Scalars['String']>;
  ID: Scalars['ID'];
  Tag?: Maybe<Scalars['String']>;
  Title?: Maybe<Scalars['String']>;
};

export type BusinessTermsResponse = BusinessTerms | NotAuthorizedError | NotFoundError | ServerError | UserError;

/** A specific version of BusinessTerms linked to an invoice/quote */
export type BusinessTermsVersion = {
  __typename?: 'BusinessTermsVersion';
  Category?: Maybe<BusinessTermsCategory>;
  ID: Scalars['ID'];
  Terms?: Maybe<TokenisedField>;
  Title: Scalars['String'];
  URL: Scalars['String'];
  Version: Scalars['Int'];
};

export type BusinessType = SortableItem & {
  __typename?: 'BusinessType';
  ID: Scalars['Int'];
  MemberSortOrder: Scalars['Int'];
  Name: Scalars['String'];
  ProfessionalID: Scalars['Int'];
};

export enum BusinessTypeEnum {
  Franchisee = 'franchisee',
  Manufacturer = 'manufacturer',
  ResellerStockist = 'resellerStockist',
  Retailer = 'retailer',
  Wholesaler = 'wholesaler'
}

export type BusinessTypesConnection = {
  __typename?: 'BusinessTypesConnection';
  edges: Array<BusinessTypesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type BusinessTypesConnectionEdge = {
  __typename?: 'BusinessTypesConnectionEdge';
  /** The node at the end of the collections edge */
  node: BusinessType;
};

export type BusinessTypesSortFields = {
  ID?: InputMaybe<SortDirection>;
  MemberSortOrder?: InputMaybe<SortDirection>;
  SortOrder?: InputMaybe<SortDirection>;
};

export type CalendarAttendee = {
  __typename?: 'CalendarAttendee';
  displayName?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  responseStatus?: Maybe<Scalars['String']>;
};

export type CalendarAvailabilityResult = {
  __typename?: 'CalendarAvailabilityResult';
  customMessage?: Maybe<Scalars['String']>;
  durations?: Maybe<Array<CalendarSessionDuration>>;
  emailReminders?: Maybe<Array<CalendarSessionEmailReminder>>;
  freeDaysByDuration: Array<FreeDaysByDurationType>;
  isActive: Scalars['Boolean'];
  locationString?: Maybe<Scalars['String']>;
  locationType: Scalars['String'];
  meetingCover?: Maybe<Scalars['String']>;
  meetingType: Scalars['String'];
  oneOnOneTeamMember?: Maybe<TeamMember>;
  professional: Professional;
  sessionID: Scalars['Int'];
  sessionTitle: Scalars['String'];
  teamMembers: Array<TeamMember>;
  timezone: Scalars['String'];
  urlSegment: Scalars['String'];
};

export type CalendarConnection = {
  __typename?: 'CalendarConnection';
  accessToken?: Maybe<Scalars['String']>;
  connectedAt?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  expiresAt?: Maybe<Scalars['String']>;
  provider: Scalars['String'];
  refreshToken?: Maybe<Scalars['String']>;
};

export type CalendarConnectionSummary = {
  __typename?: 'CalendarConnectionSummary';
  connectedAt?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  expiresAt?: Maybe<Scalars['String']>;
  isExpired: Scalars['Boolean'];
  provider: Scalars['String'];
};

export type CalendarDataType = {
  __typename?: 'CalendarDataType';
  archiproCalendarId?: Maybe<Scalars['String']>;
  connection?: Maybe<CalendarConnection>;
  error?: Maybe<Scalars['String']>;
  events: Array<CalendarEvent>;
  permissions?: Maybe<CalendarPermissions>;
  success: Scalars['Boolean'];
  tokenExpired?: Maybe<Scalars['Boolean']>;
};

export type CalendarEvent = {
  __typename?: 'CalendarEvent';
  attendees: Array<CalendarAttendee>;
  description?: Maybe<Scalars['String']>;
  end?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  /** Whether this event is a public holiday */
  isHoliday?: Maybe<Scalars['Boolean']>;
  location?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
};

export type CalendarPermissions = {
  __typename?: 'CalendarPermissions';
  canCreateCalendars: Scalars['Boolean'];
  canCreateEvents: Scalars['Boolean'];
  grantedScopes: Array<Scalars['String']>;
  hasWriteAccess: Scalars['Boolean'];
};

export type CalendarSession = {
  __typename?: 'CalendarSession';
  Availability?: Maybe<Array<CalendarSessionAvailability>>;
  Created: Scalars['String'];
  CustomMessage?: Maybe<Scalars['String']>;
  Durations?: Maybe<Array<CalendarSessionDuration>>;
  EmailReminders?: Maybe<Array<CalendarSessionEmailReminder>>;
  ID: Scalars['Int'];
  IsActive: Scalars['Boolean'];
  LastEdited: Scalars['String'];
  LocationString?: Maybe<Scalars['String']>;
  LocationType: Scalars['String'];
  MeetingCover?: Maybe<Scalars['String']>;
  MeetingType: Scalars['String'];
  OneOnOneTeamMember?: Maybe<TeamMember>;
  Professional: Professional;
  SessionName: Scalars['String'];
  TeamMembers?: Maybe<Array<TeamMember>>;
  Timezone: Scalars['String'];
  URLSegment: Scalars['String'];
  UnavailableDateRanges?: Maybe<Array<CalendarSessionUnavailableDateRange>>;
};

export type CalendarSessionAvailability = {
  __typename?: 'CalendarSessionAvailability';
  CalendarSession: CalendarSession;
  Created: Scalars['String'];
  Day: Scalars['String'];
  ID: Scalars['Int'];
  IsChecked: Scalars['Boolean'];
  LastEdited: Scalars['String'];
  TimeSlots?: Maybe<Array<CalendarSessionAvailabilitySlot>>;
};

export type CalendarSessionAvailabilityInput = {
  day: Scalars['String'];
  isChecked: Scalars['Boolean'];
  timeSlots: Array<CalendarSessionAvailabilitySlotInput>;
};

export type CalendarSessionAvailabilitySlot = {
  __typename?: 'CalendarSessionAvailabilitySlot';
  Availability: CalendarSessionAvailability;
  Created: Scalars['String'];
  EndTime: Scalars['String'];
  ID: Scalars['Int'];
  LastEdited: Scalars['String'];
  StartTime: Scalars['String'];
};

export type CalendarSessionAvailabilitySlotInput = {
  endTime: Scalars['String'];
  startTime: Scalars['String'];
};

export type CalendarSessionDuration = {
  __typename?: 'CalendarSessionDuration';
  CalendarSession: CalendarSession;
  Checked?: Maybe<Scalars['Boolean']>;
  Created: Scalars['String'];
  Duration: Scalars['Int'];
  ID: Scalars['Int'];
  LastEdited: Scalars['String'];
};

export type CalendarSessionDurationInput = {
  checked?: InputMaybe<Scalars['Boolean']>;
  duration: Scalars['Int'];
};

export type CalendarSessionEmailReminder = {
  __typename?: 'CalendarSessionEmailReminder';
  CalendarSession: CalendarSession;
  Created: Scalars['String'];
  ID: Scalars['Int'];
  LastEdited: Scalars['String'];
  ReminderMinutes: Scalars['Int'];
};

export type CalendarSessionEmailReminderInput = {
  reminderMinutes: Scalars['Int'];
};

export type CalendarSessionUnavailableDateRange = {
  __typename?: 'CalendarSessionUnavailableDateRange';
  CalendarSession: CalendarSession;
  Created: Scalars['String'];
  EndDate: Scalars['String'];
  ID: Scalars['Int'];
  LastEdited: Scalars['String'];
  StartDate: Scalars['String'];
};

export type CalendarSessionUnavailableDateRangeInput = {
  endDate: Scalars['String'];
  startDate: Scalars['String'];
};

export type CalendarSessionsConnection = {
  __typename?: 'CalendarSessionsConnection';
  edges: Array<CalendarSessionsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type CalendarSessionsConnectionEdge = {
  __typename?: 'CalendarSessionsConnectionEdge';
  /** The node at the end of the collections edge */
  node: CalendarSession;
};

export type CalendarSessionsFilters = {
  /** Filter calendar sessions that are active */
  IsActive__in?: InputMaybe<Scalars['Boolean']>;
  /** Filter calendar sessions by meeting type */
  MeetingType__eq?: InputMaybe<Scalars['String']>;
};

export type CalendarSessionsSortFields = {
  Created?: InputMaybe<SortDirection>;
  ID?: InputMaybe<SortDirection>;
  IsActive?: InputMaybe<SortDirection>;
  SessionName?: InputMaybe<SortDirection>;
};

export type CallToAction = {
  __typename?: 'CallToAction';
  ID: Scalars['Int'];
  Link?: Maybe<Scalars['String']>;
  Subtitle: Scalars['String'];
  Thumbnail?: Maybe<ResponsiveImage>;
  Title: Scalars['String'];
};

export type CallToActionModule = ModuleType & {
  __typename?: 'CallToActionModule';
  AnchorTag?: Maybe<Scalars['String']>;
  CTA?: Maybe<EmailLink>;
  DesktopContent?: Maybe<Scalars['String']>;
  ExtraClass?: Maybe<Scalars['String']>;
  ID: Scalars['ID'];
  MobileContent?: Maybe<Scalars['String']>;
  NavigationLabel?: Maybe<Scalars['String']>;
  SpacingBelow?: Maybe<Scalars['String']>;
  SpacingBelowMobile?: Maybe<Scalars['String']>;
  ThemeColour: ThemedElementColourType;
  Title?: Maybe<Scalars['String']>;
};

export type CampaignFilterFilters = {
  CAMPAIGN_SOURCE__EQUAL?: InputMaybe<Scalars['String']>;
};

export type CampaignFormFooterModule = ModuleType & {
  __typename?: 'CampaignFormFooterModule';
  AnchorTag?: Maybe<Scalars['String']>;
  ExtraClass?: Maybe<Scalars['String']>;
  FormEmbedURL?: Maybe<Scalars['String']>;
  FormTitle?: Maybe<Scalars['String']>;
  HeroImage?: Maybe<ResponsiveVariantImage>;
  ID: Scalars['ID'];
  NavigationLabel?: Maybe<Scalars['String']>;
  SpacingBelow?: Maybe<Scalars['String']>;
  SpacingBelowMobile?: Maybe<Scalars['String']>;
  ThemeColour: ThemedElementColourType;
};

export type CampaignHeaderModule = ModuleType & {
  __typename?: 'CampaignHeaderModule';
  AnchorTag?: Maybe<Scalars['String']>;
  ExtraClass?: Maybe<Scalars['String']>;
  FormEmbedURL?: Maybe<Scalars['String']>;
  FormTitle?: Maybe<Scalars['String']>;
  HeroImage?: Maybe<ResponsiveVariantImage>;
  ID: Scalars['ID'];
  LeftImage?: Maybe<ResponsiveVariantImage>;
  NavigationLabel?: Maybe<Scalars['String']>;
  SpacingBelow?: Maybe<Scalars['String']>;
  SpacingBelowMobile?: Maybe<Scalars['String']>;
  ThemeColour: ThemedElementColourType;
};

export type CancelCalendarEventInput = {
  /** Event ID (Google or Outlook event ID) */
  eventId: Scalars['String'];
  /** Optional provider ('google' or 'outlook'). If not provided, will be inferred from booking record. */
  provider?: InputMaybe<Scalars['String']>;
};

export type CancelCalendarEventResult = {
  __typename?: 'CancelCalendarEventResult';
  /** Error message if cancellation failed */
  error?: Maybe<Scalars['String']>;
  /** Whether the event was successfully cancelled */
  success: Scalars['Boolean'];
};

export type CaptionCtaModule = ModuleType & {
  __typename?: 'CaptionCTAModule';
  AnchorTag?: Maybe<Scalars['String']>;
  CTA?: Maybe<SiteTreeLink>;
  ExtraClass?: Maybe<Scalars['String']>;
  ID: Scalars['ID'];
  NavigationLabel?: Maybe<Scalars['String']>;
  SecondaryCTA?: Maybe<SiteTreeLink>;
  SpacingBelow?: Maybe<Scalars['String']>;
  SpacingBelowMobile?: Maybe<Scalars['String']>;
  SubTitle?: Maybe<Scalars['String']>;
  ThemeColour: ThemedElementColourType;
  Title?: Maybe<Scalars['String']>;
};

/** Card attached to a professional informing them of key pieces of information. */
export type Card = {
  __typename?: 'Card';
  CardType: CardType;
  Created: Scalars['String'];
  DismissedAt?: Maybe<Scalars['String']>;
  DismissedBy?: Maybe<TeamMember>;
  Expiry?: Maybe<Scalars['String']>;
  ID: Scalars['ID'];
  LastEdited?: Maybe<Scalars['String']>;
  Payload?: Maybe<CardPayload>;
  Professional: Professional;
  State: CardState;
  ViewedAt?: Maybe<Scalars['String']>;
  ViewedBy?: Maybe<TeamMember>;
};

export type CardConnection = {
  __typename?: 'CardConnection';
  edges: Array<CardConnectionEdge>;
  nodes: Array<Card>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type CardConnectionEdge = {
  __typename?: 'CardConnectionEdge';
  /** The node at the end of the collections edge */
  node: Card;
};

/** The payload for a card varies based on its type. */
export type CardPayload = {
  __typename?: 'CardPayload';
  AdResultsReady?: Maybe<AdResultsReadyCardPayload>;
  Article?: Maybe<Article>;
  Content?: Maybe<Scalars['String']>;
  Enquiry?: Maybe<Enquiry>;
  Product?: Maybe<Product>;
  Professional?: Maybe<Professional>;
  Project?: Maybe<Project>;
  Title: Scalars['String'];
};

/** The result type for a card mutation */
export type CardResult = Card | NotAuthorizedError | NotFoundError | ServerError | UserError;

/** Possible state in which an individual Card can be in. */
export enum CardState {
  Completed = 'Completed',
  Dismissed = 'Dismissed',
  Read = 'Read',
  Unread = 'Unread'
}

/** A Type that can be attached to a card. */
export type CardType = {
  __typename?: 'CardType';
  CardType: CardTypeEnum;
  Category: CardTypeCategory;
  Dismissible: Scalars['Boolean'];
  Priority: Scalars['Int'];
  Status: CardTypeStatus;
};

/** Category for a CardType. Can be use to group card type together. */
export enum CardTypeCategory {
  Analytics = 'Analytics',
  Content = 'Content',
  Leads = 'Leads',
  Milestones = 'Milestones',
  Network = 'Network',
  Profile = 'Profile'
}

/** A CardType string that can be attached to a card. */
export enum CardTypeEnum {
  AddBusinessAboutContentCardType = 'AddBusinessAboutContentCardType',
  AddBusinessEmailCardType = 'AddBusinessEmailCardType',
  AddBusinessFocusCardType = 'AddBusinessFocusCardType',
  AddBusinessHomepageBannerCardType = 'AddBusinessHomepageBannerCardType',
  AddBusinessLocationCardType = 'AddBusinessLocationCardType',
  AddBusinessLogoCardType = 'AddBusinessLogoCardType',
  AddBusinessNetworkCardType = 'AddBusinessNetworkCardType',
  AddBusinessPageBannerCardType = 'AddBusinessPageBannerCardType',
  AddBusinessTeamMemberCardType = 'AddBusinessTeamMemberCardType',
  AddBusinessTypeCardType = 'AddBusinessTypeCardType',
  ArticlePromotedCardType = 'ArticlePromotedCardType',
  CardTypeWithPayloadAnd30DaysExpiry = 'CardTypeWithPayloadAnd30DaysExpiry',
  DigitalPublicationResultsReadyCardType = 'DigitalPublicationResultsReadyCardType',
  FacebookAdResultsReadyCardType = 'FacebookAdResultsReadyCardType',
  FirstDownloadCardType = 'FirstDownloadCardType',
  FirstEnquiryCardType = 'FirstEnquiryCardType',
  ProjectPromotedCardType = 'ProjectPromotedCardType',
  TagClickCardType = 'TagClickCardType',
  TagRequireApprovalCardType = 'TagRequireApprovalCardType',
  YouHaveBeenTaggedCardType = 'YouHaveBeenTaggedCardType'
}

/** Status for a CardType. Used to clarify the purpose of a CardType. */
export enum CardTypeStatus {
  Error = 'Error',
  Info = 'Info',
  Success = 'Success',
  Warning = 'Warning'
}

export type CardsSimpleSortFields = {
  Created?: InputMaybe<SortDirection>;
  Priority?: InputMaybe<SortDirection>;
};

export type CartItem = {
  __typename?: 'CartItem';
  AvailableShippingMethods: Array<ShippingMethod>;
  ClickAndCollect: Scalars['Boolean'];
  ID: Scalars['Int'];
  Price: CurrencyAmount;
  Quantity: Scalars['Int'];
  RetailPrice: CurrencyAmount;
  RetailSubTotal?: Maybe<CurrencyAmount>;
  Sample: Scalars['Boolean'];
  Selected: Scalars['Boolean'];
  ShippingCost: CurrencyAmount;
  ShippingMethod?: Maybe<ShippingMethod>;
  ShippingProvider?: Maybe<ShippingProviderEnum>;
  SpecialtyPriceType?: Maybe<SpecialtyPriceTypeEnum>;
  SubTotal: CurrencyAmount;
  ValidShipping: Scalars['Boolean'];
  Variant: Variant;
};

export type CartSupplier = {
  __typename?: 'CartSupplier';
  AvailablePickupLocations: Array<LibraryLocation>;
  CartItems: Array<CartItem>;
  CartSupplierTotal: CurrencyAmount;
  Comment: Scalars['String'];
  CostToFreeShipping?: Maybe<CurrencyAmount>;
  ID: Scalars['Int'];
  ItemCount: Scalars['Int'];
  ItemTotal: CurrencyAmount;
  LastShippingMethod?: Maybe<ShippingMethod>;
  PickupLocation?: Maybe<LibraryLocation>;
  PickupUsedLast: Scalars['Boolean'];
  Selected: Scalars['Boolean'];
  ShippingCost: CurrencyAmount;
  Supplier: Professional;
};

export type Category = {
  __typename?: 'Category';
  Breadcrumb: Scalars['String'];
  Facets: Array<Facet>;
  ID: Scalars['Int'];
  /** Clear cut Image */
  Image?: Maybe<ResponsiveImage>;
  ItemsCount: Scalars['Int'];
  Link: Scalars['String'];
  Parent?: Maybe<Category>;
  ParentID?: Maybe<Scalars['Int']>;
  Parents?: Maybe<Array<Maybe<Category>>>;
  PrettyTitle: Scalars['String'];
  RecommendedImage?: Maybe<ResponsiveImage>;
  Sort: Scalars['Int'];
  SortOrder?: Maybe<Scalars['String']>;
  /** Clear cut Image */
  Thumbnail?: Maybe<ResponsiveImage>;
  Title: Scalars['String'];
  URLSegment: Scalars['String'];
};


export type CategoryBreadcrumbArgs = {
  Separator?: InputMaybe<Scalars['String']>;
};


export type CategoryImageArgs = {
  Height?: InputMaybe<Scalars['Int']>;
  Width?: InputMaybe<Scalars['Int']>;
};


export type CategoryRecommendedImageArgs = {
  Height?: InputMaybe<Scalars['Int']>;
  Width?: InputMaybe<Scalars['Int']>;
};


export type CategoryThumbnailArgs = {
  Height?: InputMaybe<Scalars['Int']>;
  Width?: InputMaybe<Scalars['Int']>;
};

export type CategoryPage = {
  __typename?: 'CategoryPage';
  ID?: Maybe<Scalars['String']>;
  Link: Scalars['String'];
  Parents: PrimaryCategory_ParentsConnection;
  PrettyTitle?: Maybe<Scalars['String']>;
  Sort?: Maybe<Scalars['Int']>;
  URLSegment?: Maybe<Scalars['String']>;
};


export type CategoryPageParentsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** A network with an owner and children belonging to the owner */
export type CentralisedNetwork = {
  id: Scalars['ID'];
  owner: CentralisedNetworkParticipant;
};

/** A participant of a centralised network */
export type CentralisedNetworkParticipant = {
  id: Scalars['ID'];
  identity: Node;
  network: CentralisedNetwork;
};

export type ChartCollection = {
  __typename?: 'ChartCollection';
  ID: Scalars['String'];
  Name: Scalars['String'];
  Series: Array<ChartSeries>;
};

export type ChartPlot = {
  __typename?: 'ChartPlot';
  ExtraData?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  Name: Scalars['String'];
  X: Scalars['Float'];
  Y: Scalars['Float'];
  Z?: Maybe<Scalars['Float']>;
};

export type ChartSeries = {
  __typename?: 'ChartSeries';
  ID: Scalars['String'];
  Label?: Maybe<Scalars['String']>;
  Values: Array<ChartPlot>;
};

export type ChildRegionsConnection = {
  __typename?: 'ChildRegionsConnection';
  edges: Array<ChildRegionsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ChildRegionsConnectionEdge = {
  __typename?: 'ChildRegionsConnectionEdge';
  /** The node at the end of the collections edge */
  node: Region;
};

export type CloneTask = {
  __typename?: 'CloneTask';
  ClonedProfessional?: Maybe<Professional>;
  CreatedAt: Scalars['Date'];
  ID: Scalars['Int'];
  LastEditedAt: Scalars['Date'];
  Message?: Maybe<Scalars['String']>;
  SourceProfessional?: Maybe<Professional>;
  Status: AsyncTaskStatus;
};

export type Collaborator = {
  __typename?: 'Collaborator';
  AvatarURL?: Maybe<Scalars['String']>;
  CanEdit: Scalars['Boolean'];
  Email: Scalars['String'];
  HasAccepted: Scalars['Boolean'];
  ID: Scalars['String'];
  Name?: Maybe<Scalars['String']>;
  ProfileImageLink?: Maybe<Scalars['String']>;
};

export type ColorCategoriesConnection = {
  __typename?: 'ColorCategoriesConnection';
  edges: Array<ColorCategoriesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ColorCategoriesConnectionEdge = {
  __typename?: 'ColorCategoriesConnectionEdge';
  /** The node at the end of the collections edge */
  node: ProductColor;
};

export type ColumnDimension = {
  __typename?: 'ColumnDimension';
  BuilderHeight: Scalars['Int'];
  BuilderWidth: Scalars['Int'];
  Height: Scalars['Int'];
  ID: Scalars['Int'];
  IsPortrait: Scalars['Boolean'];
  MobileHeight: Scalars['Int'];
  MobileWidth: Scalars['Int'];
  TabletHeight: Scalars['Int'];
  TabletWidth: Scalars['Int'];
  Width: Scalars['Int'];
};

export type ColumnsConnection = {
  __typename?: 'ColumnsConnection';
  edges: Array<ColumnsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ColumnsConnectionEdge = {
  __typename?: 'ColumnsConnectionEdge';
  /** The node at the end of the collections edge */
  node: ModuleColumn;
};

export type ColumnsSortFields = {
  MemberSortOrder?: InputMaybe<SortDirection>;
};

export type CombinedUnreadNotifications = {
  __typename?: 'CombinedUnreadNotifications';
  CompanyInboxes?: Maybe<Array<Inbox>>;
  DesignBoardPinCount: Scalars['Int'];
  UserInbox?: Maybe<Inbox>;
  WebsiteNotificationCount: Scalars['Int'];
};

export type Comment = {
  __typename?: 'Comment';
  Attachments?: Maybe<Array<Maybe<MemberUpload>>>;
  CanDelete: Scalars['Boolean'];
  Content: Scalars['String'];
  Created: Scalars['String'];
  ID: Scalars['Int'];
  IsMember: Scalars['Boolean'];
  Items: Array<DirectoryItem>;
  MadeByTeamMember: Scalars['Boolean'];
  Member: Member;
  ReadStatus: Array<Maybe<ReadStatus>>;
};

export type CommonMaterialsConnection = {
  __typename?: 'CommonMaterialsConnection';
  edges: Array<CommonMaterialsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type CommonMaterialsConnectionEdge = {
  __typename?: 'CommonMaterialsConnectionEdge';
  /** The node at the end of the collections edge */
  node: Material;
};

/** Companies group contacts under a Professional and support custom data fields. */
export type Company = {
  __typename?: 'Company';
  Contacts: CompanyContactsConnection;
  /** Custom arbitrary data that can be saved against a Company and a CustomField that admins can create */
  CustomData?: Maybe<Array<CustomCompanyData>>;
  /** HubSpot URL for the company, if linked to HubSpot */
  HubspotURL?: Maybe<Scalars['String']>;
  ID: Scalars['ID'];
  Name?: Maybe<Scalars['String']>;
  Professional: Professional;
  Website?: Maybe<Scalars['String']>;
};


/** Companies group contacts under a Professional and support custom data fields. */
export type CompanyContactsArgs = {
  filter?: InputMaybe<CompanyContactsFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<CompanyContactsSortFields>;
};

export type CompanyActivitiesFilters = {
  INDUSTRY_CATEGORY__IN?: InputMaybe<Array<Scalars['String']>>;
  IS_ENGAGED__EQUAL?: InputMaybe<Scalars['String']>;
  QUARTER_START_DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type CompanyActivitiesSort = {
  COMPANY_NAME?: InputMaybe<PrioritySort>;
  CONVERSIONS?: InputMaybe<PrioritySort>;
  DOMAIN?: InputMaybe<PrioritySort>;
  INDUSTRIES?: InputMaybe<PrioritySort>;
  LOCATIONS?: InputMaybe<PrioritySort>;
  SESSIONS?: InputMaybe<PrioritySort>;
  USERS?: InputMaybe<PrioritySort>;
};

export type CompanyActivityIndustriesFilters = {
  IS_ENGAGED__EQUAL?: InputMaybe<Scalars['String']>;
  QUARTER_START_DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type CompanyContactsConnection = {
  __typename?: 'CompanyContactsConnection';
  edges: Array<CompanyContactsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type CompanyContactsConnectionEdge = {
  __typename?: 'CompanyContactsConnectionEdge';
  /** The node at the end of the collections edge */
  node: Contact;
};

export type CompanyContactsFilters = {
  EmailContains?: InputMaybe<Scalars['String']>;
  NameStartsWith?: InputMaybe<Scalars['String']>;
};

export type CompanyContactsSortFields = {
  Created?: InputMaybe<SortDirection>;
  FirstName?: InputMaybe<SortDirection>;
  ID?: InputMaybe<SortDirection>;
  Surname?: InputMaybe<SortDirection>;
};

export type CompanyResponse = Company | NotAuthorizedError | NotFoundError | ServerError | UserError;

export type Consignment = {
  __typename?: 'Consignment';
  ConsignmentReference?: Maybe<Scalars['String']>;
  Dispatch?: Maybe<Dispatch>;
  EstimatedDispatch?: Maybe<Scalars['String']>;
  ID: Scalars['Int'];
  LeadTime: Scalars['Int'];
  LeadTimeUnit?: Maybe<LeadTimeUnitEnum>;
  OrderItems: OrderItemsConnection;
  Packages: PackagesConnection;
  PickupLocation?: Maybe<LibraryLocation>;
  ShippingProvider?: Maybe<Scalars['String']>;
  ShippingProviderStatus?: Maybe<Scalars['String']>;
  Status: ConsignmentStatusEnum;
  SupplierOrder: SupplierOrder;
};


export type ConsignmentOrderItemsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type ConsignmentPackagesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type ConsignmentPackage = {
  __typename?: 'ConsignmentPackage';
  Barcode?: Maybe<Scalars['String']>;
  Description?: Maybe<Scalars['String']>;
  Height: Scalars['Int'];
  ID: Scalars['Int'];
  LabelNumber: Scalars['Int'];
  Length: Scalars['Int'];
  PackagingType: Scalars['String'];
  Weight: Scalars['Int'];
  Width: Scalars['Int'];
};

export type ConsignmentPackageInput = {
  Height: Scalars['Int'];
  Length: Scalars['Int'];
  PackageType: Scalars['StringInput'];
  Weight: Scalars['Float'];
  Width: Scalars['Int'];
};

export enum ConsignmentStatusEnum {
  Cancelled = 'CANCELLED',
  Delivered = 'DELIVERED',
  Error = 'ERROR',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Ready = 'READY',
  Transit = 'TRANSIT'
}

export type ConsignmentsConnection = {
  __typename?: 'ConsignmentsConnection';
  edges: Array<ConsignmentsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ConsignmentsConnectionEdge = {
  __typename?: 'ConsignmentsConnectionEdge';
  /** The node at the end of the collections edge */
  node: Consignment;
};

/** Contacts are unique by Email under a specific Professional, it can be imported from CRM or added manually */
export type Contact = {
  __typename?: 'Contact';
  /** Contact address field */
  Address?: Maybe<Scalars['String']>;
  /** Contact city field */
  City?: Maybe<Scalars['String']>;
  Company?: Maybe<Company>;
  /** Custom arbitrary data that can be saved against a Contact and a CustomField that admins can create */
  CustomData?: Maybe<Array<CustomContactData>>;
  Email: Scalars['Email'];
  FirstName?: Maybe<Scalars['String']>;
  HasStripePaymentMethod: Scalars['Boolean'];
  /** HubSpot URL for the contact, if linked to HubSpot */
  HubspotURL?: Maybe<Scalars['String']>;
  ID: Scalars['ID'];
  JobTitle?: Maybe<Scalars['String']>;
  Phone?: Maybe<Scalars['String']>;
  PhotoSrc?: Maybe<Scalars['String']>;
  /** Contact postcode field */
  PostCode?: Maybe<Scalars['String']>;
  Professional: Professional;
  Surname?: Maybe<Scalars['String']>;
};

export type ContactDetails = {
  __typename?: 'ContactDetails';
  AllowsSharing: Scalars['Boolean'];
  Email: Scalars['String'];
  Phone: Scalars['String'];
  Revealed: Scalars['Boolean'];
};

export type ContactResponse = Contact | NotAuthorizedError | NotFoundError | ServerError | UserError;

export type ContactUsMapModule = ModuleType & {
  __typename?: 'ContactUsMapModule';
  AnchorTag?: Maybe<Scalars['String']>;
  ExtraClass?: Maybe<Scalars['String']>;
  ID: Scalars['ID'];
  NavigationLabel?: Maybe<Scalars['String']>;
  SpacingBelow?: Maybe<Scalars['String']>;
  SpacingBelowMobile?: Maybe<Scalars['String']>;
  ThemeColour: ThemedElementColourType;
};

export type ContentArea = {
  __typename?: 'ContentArea';
  BuilderModules: PageBuilderModulesConnection;
  ModuleImages: PageBuilderImagesConnection;
};


export type ContentAreaBuilderModulesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<PageBuilderModulesSortFields>;
};


export type ContentAreaModuleImagesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type ContentBlock = {
  __typename?: 'ContentBlock';
  BlogPostID: Scalars['Int'];
  Content?: Maybe<Scalars['String']>;
  Header?: Maybe<Scalars['String']>;
  ID: Scalars['Int'];
  LibraryImage?: Maybe<LibraryImage>;
  LibraryVideo?: Maybe<LibraryVideo>;
  SortOrder: Scalars['Int'];
  Type?: Maybe<Scalars['String']>;
};

export type ContentBuilder = {
  ClassName: Scalars['String'];
  ContentArea?: Maybe<ContentArea>;
  ContentBuilderType: ContentBuilderTypeEnum;
};

export enum ContentBuilderTypeEnum {
  Article = 'article',
  Email = 'email',
  Invoice = 'invoice',
  Project = 'project',
  Qbr = 'qbr'
}

export enum ContentLockFlexibilityFieldEnum {
  BackOrder = 'BackOrder',
  Categories = 'Categories',
  Colour = 'Colour',
  CustomSections = 'CustomSections',
  CustomVariantOptions = 'CustomVariantOptions',
  Description = 'Description',
  FileDownloads = 'FileDownloads',
  LeadTime = 'LeadTime',
  Link = 'Link',
  Material = 'Material',
  PackageSize = 'PackageSize',
  Price = 'Price',
  ProductImage = 'ProductImage',
  ProductVideos = 'ProductVideos',
  Publish = 'Publish',
  SeoDescription = 'SEODescription',
  SeoTitle = 'SEOTitle',
  SalePrice = 'SalePrice',
  Samples = 'Samples',
  SearchTags = 'SearchTags',
  Size = 'Size',
  Specifications = 'Specifications',
  Stock = 'Stock',
  StockType = 'StockType',
  Title = 'Title',
  VariantImage = 'VariantImage',
  Variants = 'Variants'
}

export enum ContentRejectReasonEnum {
  DataQuality = 'DATA_QUALITY',
  ImgQuality = 'IMG_QUALITY',
  ReqFields = 'REQ_FIELDS',
  SpecChars = 'SPEC_CHARS',
  Url = 'URL'
}

export enum ContentStatusEnum {
  Approved = 'Approved',
  Rejected = 'Rejected'
}

export type ContentStatusUpdateResult = NotAuthenticatedError | NotAuthorizedError | NotFoundError | Product | ServerError | UserError;

export type Conversation = {
  ID: Scalars['ID'];
  /** The participants in the conversation. */
  Participants: Array<Participant>;
  /** The current user has unread messages in this conversation. */
  Unread: Scalars['Boolean'];
  /** The number of the current user's unread messages in this conversation. */
  UnreadMessageCount: Scalars['Int'];
};

export type ConversationConnection = {
  __typename?: 'ConversationConnection';
  edges: Array<ConversationConnectionEdge>;
  nodes: Array<Conversation>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ConversationConnectionEdge = {
  __typename?: 'ConversationConnectionEdge';
  /** The node at the end of the collections edge */
  node: Conversation;
};

/** The available filters to filter conversations by. */
export type ConversationFilters = {
  __typename?: 'ConversationFilters';
  /** The BuildHub projects that can be used to filter conversations. */
  Projects: Array<BuildHub>;
};

/** pixel conversion V3 - Enum for conversion rule trigger types */
export enum ConversionActionEnum {
  ButtonClick = 'ButtonClick',
  FormFill = 'FormFill',
  PageView = 'PageView'
}

export type ConversionActivitiesFilters = {
  CONTENT__EQUAL?: InputMaybe<Scalars['String']>;
  LOCATION__EQUAL?: InputMaybe<Scalars['String']>;
  TIME__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
  USER_TYPE__EQUAL?: InputMaybe<Scalars['String']>;
};

export type ConversionActivityOvertimeFilters = {
  TIME__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type ConversionActivityTableFilters = {
  CONTENT__EQUAL?: InputMaybe<Scalars['String']>;
  CONVERSION__EQUAL?: InputMaybe<Scalars['String']>;
  LOCATION__EQUAL?: InputMaybe<Scalars['String']>;
  SITE__IN?: InputMaybe<Array<Scalars['String']>>;
  TIME__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
  USER_TYPE__EQUAL?: InputMaybe<Scalars['String']>;
};

export type ConversionActivityTableSort = {
  CONTENT?: InputMaybe<PrioritySort>;
  CONVERSION?: InputMaybe<PrioritySort>;
  DETAILS?: InputMaybe<PrioritySort>;
  LOCATION?: InputMaybe<PrioritySort>;
  PAGE_NAME?: InputMaybe<PrioritySort>;
  SITE?: InputMaybe<PrioritySort>;
  STAGE?: InputMaybe<PrioritySort>;
  TIME?: InputMaybe<PrioritySort>;
  USER?: InputMaybe<PrioritySort>;
};

export type ConversionAdsOvertimeFilters = {
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

/** Conversion Category Info. */
export type ConversionCategory = {
  __typename?: 'ConversionCategory';
  Code: Scalars['String'];
  ID: Scalars['ID'];
  Title: Scalars['String'];
};

export type ConversionContentTypesFilters = {
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

/** Enum for grouping conversion configs */
export enum ConversionGroupByEnum {
  Conversion = 'conversion',
  ConversionType = 'conversionType',
  CreatedBy = 'createdBy',
  FunnelStage = 'funnelStage'
}

export type ConversionLocationOptionsFilters = {
  COUNTRY_ABR__EQUAL?: InputMaybe<Scalars['String']>;
};

export type ConversionLocationsFilters = {
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type ConversionOptionsFilters = {
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type ConversionPageNamesFilters = {
  EVENT_TIME__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

/** pixel conversion V3 - Enum for conversion rule pattern matches */
export enum ConversionPatternEnum {
  EndsWith = 'EndsWith',
  ExactMatch = 'ExactMatch',
  PartialMatch = 'PartialMatch',
  StartsWith = 'StartsWith'
}

/** pixel conversion V3 - conversion rule */
export type ConversionRule = {
  __typename?: 'ConversionRule';
  Action: ConversionActionEnum;
  Conversion: ConversionTypeEnum;
  ConversionsPreview?: Maybe<Scalars['Int']>;
  CustomClassification?: Maybe<Scalars['String']>;
  Enabled?: Maybe<Scalars['Boolean']>;
  ID: Scalars['ID'];
  IsDefault?: Maybe<Scalars['Boolean']>;
  Pattern: ConversionPatternEnum;
  ProfessionalID: Scalars['ID'];
  Rule: Scalars['String'];
  SortOrder: Scalars['Int'];
};


/** pixel conversion V3 - conversion rule */
export type ConversionRuleConversionsPreviewArgs = {
  calculate?: InputMaybe<Scalars['Boolean']>;
};

export type ConversionRuleResponse = ConversionRule | NotAuthorizedError | NotFoundError | ServerError | UserError;

export type ConversionStatsFilters = {
  CONTENT__EQUAL?: InputMaybe<Scalars['String']>;
  CONVERSION__EQUAL?: InputMaybe<Scalars['String']>;
  LOCATION__EQUAL?: InputMaybe<Scalars['String']>;
  SITE__EQUAL?: InputMaybe<Scalars['String']>;
  TIME__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
  USER_TYPE__EQUAL?: InputMaybe<Scalars['String']>;
};

export type ConversionTableDataFilters = {
  CONTENT_TYPE__IN?: InputMaybe<Array<Scalars['String']>>;
  CONVERSION_TYPE__IN?: InputMaybe<Array<Scalars['String']>>;
  EVENT_LOCATION__IN?: InputMaybe<Array<Scalars['String']>>;
  EVENT_TIME__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
  PAGE_TITLE__IN?: InputMaybe<Array<Scalars['String']>>;
  USER_CLASS_TYPE__IN?: InputMaybe<Array<Scalars['String']>>;
};

/** Conversion Type Info. */
export type ConversionType = {
  __typename?: 'ConversionType';
  Code: Scalars['String'];
  ID: Scalars['ID'];
  Title: Scalars['String'];
};

/** pixel conversion V3 - Enum for conversion types */
export enum ConversionTypeEnum {
  Custom = 'Custom',
  DirectEnquiry = 'DirectEnquiry',
  Download = 'Download',
  Ecommerce = 'Ecommerce',
  EmailReveal = 'EmailReveal',
  LocationReveal = 'LocationReveal',
  PhoneReveal = 'PhoneReveal',
  Registration = 'Registration',
  SampleRequest = 'SampleRequest',
  Save = 'Save'
}

export type ConversionUserTypesFilters = {
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type ConversionsFromTagsFilters = {
  EVENT_DATE_HOST__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
  INLIBRARY__EQUAL?: InputMaybe<Scalars['Int']>;
  PARENT_NAME__EQUAL?: InputMaybe<Scalars['String']>;
  PARENT_TAG__EQUAL?: InputMaybe<Scalars['String']>;
  PRODUCT_NAME__EQUAL?: InputMaybe<Scalars['String']>;
};

export type Coordinate = {
  __typename?: 'Coordinate';
  Latitude: Scalars['Float'];
  Longitude: Scalars['Float'];
};

export type CoordinateInput = {
  Latitude: Scalars['Float'];
  Longitude: Scalars['Float'];
};

export type Coordinates = {
  __typename?: 'Coordinates';
  Latitude: Scalars['Float'];
  Longitude: Scalars['Float'];
};

export type Countries_Connection = {
  __typename?: 'Countries_Connection';
  edges: Array<Countries_ConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type Countries_ConnectionEdge = {
  __typename?: 'Countries_ConnectionEdge';
  /** The node at the end of the collections edge */
  node: Country;
};

export type Countries_Filters = {
  /** Filter countries that support shipping for ecommerce */
  Dispatchable?: InputMaybe<Scalars['Boolean']>;
  /** Fetch supported countries only, set it true if unsure. */
  Supported__eq?: InputMaybe<Scalars['Boolean']>;
};

export type Countries_SortFields = {
  Code?: InputMaybe<SortDirection>;
  Title?: InputMaybe<SortDirection>;
};

export type Country = {
  __typename?: 'Country';
  Code: Scalars['String'];
  ID: Scalars['Int'];
  RegionLabel: Scalars['String'];
  Regions: Array<Region>;
  Title: Scalars['String'];
};

export type Courier = {
  __typename?: 'Courier';
  Country?: Maybe<Country>;
  HelpText?: Maybe<Scalars['String']>;
  ID: Scalars['Int'];
  JSValidationRegex: Scalars['String'];
  Title: Scalars['String'];
  /** TrackingURLFormat, if it is empty, the tracking code also need to be a URL. */
  TrackingURLFormat?: Maybe<Scalars['String']>;
};

export type CreateCalendarSessionInput = {
  availability: Array<CalendarSessionAvailabilityInput>;
  customMessage?: InputMaybe<Scalars['String']>;
  durations: Array<CalendarSessionDurationInput>;
  emailReminders: Array<CalendarSessionEmailReminderInput>;
  isActive: Scalars['Boolean'];
  locationString?: InputMaybe<Scalars['String']>;
  locationType: Scalars['String'];
  meetingCover?: InputMaybe<Scalars['String']>;
  meetingType: Scalars['String'];
  oneOnOneTeamMemberId?: InputMaybe<Scalars['Int']>;
  professionalUrlSegment: Scalars['String'];
  sessionName: Scalars['String'];
  teamMembers: Array<Scalars['Int']>;
  timezone: Scalars['String'];
  unavailableDateRanges: Array<CalendarSessionUnavailableDateRangeInput>;
};

export type CreateConversationMessageType = FileAttachmentMessage | TextMessage;

export type CreateEnquiry = AuthenticationException | CreateEnquiryResult;

export type CreateEnquiryResult = {
  __typename?: 'CreateEnquiryResult';
  Conversation?: Maybe<EnquiryConversation>;
  Enquiries: Array<Maybe<Enquiry>>;
  GeneratedMember?: Maybe<Me>;
};

export type CreateFacetOptionInput = {
  /** ID of the facet to add the option to. */
  FacetID: Scalars['Int'];
  /** The options name. */
  Name: Scalars['StringInput'];
  /** IDs of the categories to add the option to. */
  ProductCategoryIDs?: InputMaybe<Array<Scalars['Int']>>;
  ProfessionalURLSegment: Scalars['StringInput'];
  URLSegment: Scalars['StringInput'];
};

export type CreateNetworkParticipantCreateData = {
  /** ID of the network to add this new participant to */
  networkId: Scalars['ID'];
  /** Participant meta data depending on which network he's being created against */
  participants: Array<NetworkParticipantMetaData>;
};

export type CreateProfessionalAwardInput = {
  AwardingInstitutionTitle?: InputMaybe<Scalars['StringInput']>;
  File?: InputMaybe<Scalars['Upload']>;
  MemberSortOrder?: InputMaybe<Scalars['Int']>;
  Title: Scalars['StringInput'];
  YearAwarded?: InputMaybe<Scalars['StringInput']>;
};

export type CreateShoppingCartOrderResult = {
  __typename?: 'CreateShoppingCartOrderResult';
  NewMember: Scalars['Boolean'];
  OrderID: Scalars['Int'];
  PartialOrder: Scalars['Boolean'];
};

export type CurrencyAmount = {
  __typename?: 'CurrencyAmount';
  Amount: Scalars['Float'];
  Currency: Scalars['String'];
  LongFormat: Scalars['String'];
  ShortFormat: Scalars['String'];
  Symbol: Scalars['String'];
};

/** Custom arbitrary data on a Company saved from a CustomField */
export type CustomCompanyData = {
  __typename?: 'CustomCompanyData';
  Company: Company;
  CustomField: CustomField;
  ID: Scalars['ID'];
  Value?: Maybe<Scalars['String']>;
};

/** Custom arbitrary data on a Contact saved from a CustomField */
export type CustomContactData = {
  __typename?: 'CustomContactData';
  Contact: Contact;
  CustomField: CustomField;
  ID: Scalars['ID'];
  Value?: Maybe<Scalars['String']>;
};

/** CustomField is generic and is created at the Professional level */
export type CustomField = {
  __typename?: 'CustomField';
  ID: Scalars['ID'];
  Label: Scalars['String'];
  Professional: Professional;
  SortOrder: Scalars['Int'];
  Type: Scalars['String'];
  Visible: Scalars['Boolean'];
};

export type CustomFieldInput = {
  FieldID: Scalars['ID'];
  Value: Scalars['StringInput'];
};

export type CustomFieldResponse = CustomField | NotAuthorizedError | NotFoundError | ServerError | UserError;

export type CustomerLeadActivityFilters = {
  PROFESSIONAL_ID__EQUAL?: InputMaybe<Scalars['Int']>;
  USER_ID__EQUAL?: InputMaybe<Scalars['String']>;
};

export type CustomerLeadCategoryInterestFilters = {
  USER_ID__EQUAL?: InputMaybe<Scalars['String']>;
};

export type CustomerLeadConversionRateFilters = {
  PROFESSIONAL_ID__EQUAL?: InputMaybe<Scalars['Int']>;
  USER_ID__EQUAL?: InputMaybe<Scalars['String']>;
};

export type CustomerLeadConversionsFilters = {
  PROFESSIONAL_ID__EQUAL?: InputMaybe<Scalars['Int']>;
  USER_ID__EQUAL?: InputMaybe<Scalars['String']>;
};

export type CustomerLeadDetailsFilters = {
  USER_ID__EQUAL?: InputMaybe<Scalars['String']>;
};

export type CustomerLeadSummaryFilters = {
  USER_ID__EQUAL?: InputMaybe<Scalars['String']>;
};

export type CustomerLeadTopPageViewsFilters = {
  SOURCE__EQUAL?: InputMaybe<Scalars['String']>;
  USER_ACTIVITY_PROFESSIONAL_ID__EQUAL?: InputMaybe<Scalars['Int']>;
  USER_ID__EQUAL?: InputMaybe<Scalars['String']>;
};

export type CustomerTestimonial = {
  __typename?: 'CustomerTestimonial';
  Author?: Maybe<Scalars['String']>;
  ID: Scalars['ID'];
  Organisation?: Maybe<Scalars['String']>;
  Photo?: Maybe<ResponsiveVariantImage>;
  Testimonial?: Maybe<Scalars['String']>;
};

export type CustomerTestimonials_Connection = {
  __typename?: 'CustomerTestimonials_Connection';
  edges: Array<CustomerTestimonials_ConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type CustomerTestimonials_ConnectionEdge = {
  __typename?: 'CustomerTestimonials_ConnectionEdge';
  /** The node at the end of the collections edge */
  node: CustomerTestimonial;
};

export type CustomerTestimonials_SortFields = {
  SortOrder?: InputMaybe<SortDirection>;
};

export type Do_Not_Use_Hack = {
  __typename?: 'DO_NOT_USE_HACK';
  BuilderModules: PageBuilderModulesConnection;
  FlexibleModule?: Maybe<FlexibleModuleUnion>;
  HtmlColumn?: Maybe<HtmlColumn>;
  ModuleColumEnum?: Maybe<ModuleColumnEnum>;
  ModuleImages: PageBuilderImagesConnection;
  Notifications?: Maybe<WebsiteNotification>;
  SocialAd?: Maybe<SocialAdUnion>;
};


export type Do_Not_Use_HackBuilderModulesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<PageBuilderModulesSortFields>;
};


export type Do_Not_Use_HackModuleImagesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type DashboardAudienceResult = {
  __typename?: 'DashboardAudienceResult';
  AgeGroups: Array<GraphSegment>;
  ID: Scalars['String'];
  InterestedCategories: Array<InterestedCategory>;
  OverviewAudience: OverviewAudience;
  Users: Array<GraphSegment>;
  UsersSummary?: Maybe<UsersSummary>;
};

export type DashboardOverviewResult = {
  __typename?: 'DashboardOverviewResult';
  AvgDailyUsers?: Maybe<Scalars['Int']>;
  AvgInteractionsPerDay: Scalars['Int'];
  CostPerClick: Scalars['Float'];
  CostPerDay: Scalars['Float'];
  CostPerImpression: Scalars['Float'];
  ID: Scalars['String'];
  NewsletterClickSeries: Array<GraphPoint>;
  NewsletterImpressionSeries: Array<GraphPoint>;
  OverviewSummaryNumbers: OverviewSummaryNumbers;
  ProfileClickSeries: Array<GraphPoint>;
  ProfileImpressionSeries: Array<GraphPoint>;
  SocialClickSeries: Array<GraphPoint>;
  SocialImpressionSeries: Array<GraphPoint>;
  SubscriptionCost?: Maybe<Scalars['Float']>;
};

export type DashboardProfilePagesResult = {
  __typename?: 'DashboardProfilePagesResult';
  AgeGroups: Array<GraphSegment>;
  ClickSeries: Array<GraphPoint>;
  ConversionRate: Scalars['Float'];
  EngagementSeries: Array<GraphPoint>;
  EngagementTopPerformers?: Maybe<Array<TopPerformer>>;
  Engagements: Array<GraphSegment>;
  ID: Scalars['String'];
  ImpressionSeries: Array<GraphPoint>;
  ImpressionTopPerformers?: Maybe<Array<TopPerformer>>;
  InterestedCategories: Array<InterestedCategory>;
  PageViewTopPerformers?: Maybe<Array<TopPerformer>>;
  ProfilePagesSummary?: Maybe<ProfilePagesSummary>;
  PromotionalAds?: Maybe<PromotionalStats>;
  Users: Array<GraphSegment>;
  UsersSummary?: Maybe<UsersSummary>;
};

export type DashboardPublicationsResult = {
  __typename?: 'DashboardPublicationsResult';
  ID: Scalars['String'];
  PublicationsSummary: PublicationsSummary;
};

export type DashboardSocialAdsResult = {
  __typename?: 'DashboardSocialAdsResult';
  ID: Scalars['String'];
  SocialAdsSummary: SocialAdsSummary;
};

export type DataCollection = {
  __typename?: 'DataCollection';
  ID: Scalars['String'];
  Name: Scalars['String'];
  Series: Array<DataSeries>;
};

export type DataCollections = {
  __typename?: 'DataCollections';
  Collections: Array<DataCollection>;
  ID: Scalars['String'];
};

/** The common interface shared by all DataObject types */
export type DataObject = {
  id: Scalars['ID'];
};

export type DataSeries = {
  __typename?: 'DataSeries';
  Data: Array<Datum>;
  ID: Scalars['String'];
  Name: Scalars['String'];
};

export enum DateFormatEnum {
  Default = 'Default',
  Iso8601 = 'ISO8601'
}

export type Datum = {
  __typename?: 'Datum';
  ID: Scalars['String'];
  Name: Scalars['String'];
  Subtitle?: Maybe<Scalars['String']>;
  Type: DatumType;
  Value: Scalars['String'];
};

export enum DatumType {
  Date = 'Date',
  Image = 'Image',
  Link = 'Link',
  Number = 'Number',
  Text = 'Text'
}

export type Days_Connection = {
  __typename?: 'Days_Connection';
  edges: Array<Days_ConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type Days_ConnectionEdge = {
  __typename?: 'Days_ConnectionEdge';
  /** The node at the end of the collections edge */
  node: EventDay;
};

export type Days_SortFields = {
  SortOrder?: InputMaybe<SortDirection>;
};

export type DeleteVariantResult = {
  __typename?: 'DeleteVariantResult';
  ID: Scalars['Int'];
  Message: Scalars['String'];
  Success: Scalars['Boolean'];
};

export type DemographicLocationsFilters = {
  COUNTRY_ABR__EQUAL?: InputMaybe<Scalars['String']>;
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type DemographicStatsFilters = {
  COUNTRY_ABR__EQUAL?: InputMaybe<Scalars['String']>;
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type DemographicUserDevicesFilters = {
  COUNTRY_ABR__EQUAL?: InputMaybe<Scalars['String']>;
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type DemographicsAudienceLocationFilters = {
  AUDIENCE_TYPE__EQUAL?: InputMaybe<Scalars['String']>;
  CATEGORY__EQUAL?: InputMaybe<Scalars['String']>;
  CONTENT_TYPE__EQUAL?: InputMaybe<Scalars['String']>;
  COUNTRY_ABR__EQUAL?: InputMaybe<Scalars['String']>;
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
  REGION__EQUAL?: InputMaybe<Scalars['String']>;
};

export type DemographicsAudienceTypeFilters = {
  AUDIENCE_TYPE__EQUAL?: InputMaybe<Scalars['String']>;
  CATEGORY__EQUAL?: InputMaybe<Scalars['String']>;
  CONTENT_TYPE__EQUAL?: InputMaybe<Scalars['String']>;
  COUNTRY_ABR__EQUAL?: InputMaybe<Scalars['String']>;
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
  REGION__EQUAL?: InputMaybe<Scalars['String']>;
};

export type DemographicsAudienceTypeOptionsFilters = {
  CATEGORY__EQUAL?: InputMaybe<Scalars['String']>;
  CONTENT_TYPE__EQUAL?: InputMaybe<Scalars['String']>;
  COUNTRY_ABR__EQUAL?: InputMaybe<Scalars['String']>;
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
  REGION__EQUAL?: InputMaybe<Scalars['String']>;
};

export type DemographicsCategoriesFilters = {
  AUDIENCE_TYPE__EQUAL?: InputMaybe<Scalars['String']>;
  CITY__EQUAL?: InputMaybe<Scalars['String']>;
  CONTENT_TYPE__EQUAL?: InputMaybe<Scalars['String']>;
  COUNTRY_ABR__EQUAL?: InputMaybe<Scalars['String']>;
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
  REGION__EQUAL?: InputMaybe<Scalars['String']>;
};

export type DemographicsCategoryInterestsFilters = {
  AUDIENCE_TYPE__EQUAL?: InputMaybe<Scalars['String']>;
  CATEGORY__EQUAL?: InputMaybe<Scalars['String']>;
  CONTENT_TYPE__EQUAL?: InputMaybe<Scalars['String']>;
  COUNTRY_ABR__EQUAL?: InputMaybe<Scalars['String']>;
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
  REGION__EQUAL?: InputMaybe<Scalars['String']>;
};

export type DemographicsContentTypeOptionsFilters = {
  AUDIENCE_TYPE__EQUAL?: InputMaybe<Scalars['String']>;
  CATEGORY__EQUAL?: InputMaybe<Scalars['String']>;
  CITY__EQUAL?: InputMaybe<Scalars['String']>;
  COUNTRY_ABR__EQUAL?: InputMaybe<Scalars['String']>;
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
  REGION__EQUAL?: InputMaybe<Scalars['String']>;
};

export type DemographicsLocationOptionsFilters = {
  AUDIENCE_TYPE__EQUAL?: InputMaybe<Scalars['String']>;
  CATEGORY__EQUAL?: InputMaybe<Scalars['String']>;
  CONTENT_TYPE__EQUAL?: InputMaybe<Scalars['String']>;
  COUNTRY_ABR__EQUAL?: InputMaybe<Scalars['String']>;
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type DemographicsProjectStageFilters = {
  AUDIENCE_TYPE__EQUAL?: InputMaybe<Scalars['String']>;
  CATEGORY__EQUAL?: InputMaybe<Scalars['String']>;
  CONTENT_TYPE__EQUAL?: InputMaybe<Scalars['String']>;
  COUNTRY_ABR__EQUAL?: InputMaybe<Scalars['String']>;
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
  REGION__EQUAL?: InputMaybe<Scalars['String']>;
};

export type DemographicsProjectTypeFilters = {
  AUDIENCE_TYPE__EQUAL?: InputMaybe<Scalars['String']>;
  CATEGORY__EQUAL?: InputMaybe<Scalars['String']>;
  CONTENT_TYPE__EQUAL?: InputMaybe<Scalars['String']>;
  COUNTRY_ABR__EQUAL?: InputMaybe<Scalars['String']>;
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
  REGION__EQUAL?: InputMaybe<Scalars['String']>;
};

export type DemographicsSummaryFilters = {
  AUDIENCE_TYPE__EQUAL?: InputMaybe<Scalars['String']>;
  CATEGORY__EQUAL?: InputMaybe<Scalars['String']>;
  CONTENT_TYPE__EQUAL?: InputMaybe<Scalars['String']>;
  COUNTRY_ABR__EQUAL?: InputMaybe<Scalars['String']>;
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
  REGION__EQUAL?: InputMaybe<Scalars['String']>;
};

export type DemographicsTotalTimeSpentFilters = {
  AUDIENCE_TYPE__EQUAL?: InputMaybe<Scalars['String']>;
  CATEGORY__EQUAL?: InputMaybe<Scalars['String']>;
  CONTENT_TYPE__EQUAL?: InputMaybe<Scalars['String']>;
  COUNTRY_ABR__EQUAL?: InputMaybe<Scalars['String']>;
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
  REGION__EQUAL?: InputMaybe<Scalars['String']>;
};

export type DemographicsUserEngagementOverTimeFilters = {
  AUDIENCE_TYPE__EQUAL?: InputMaybe<Scalars['String']>;
  CATEGORY__EQUAL?: InputMaybe<Scalars['String']>;
  CONTENT_TYPE__EQUAL?: InputMaybe<Scalars['String']>;
  COUNTRY_ABR__EQUAL?: InputMaybe<Scalars['String']>;
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
  REGION__EQUAL?: InputMaybe<Scalars['String']>;
};

export type DesignBoard = {
  __typename?: 'DesignBoard';
  CanDelete: Scalars['Boolean'];
  CanEdit: Scalars['Boolean'];
  Collaborators: Array<Collaborator>;
  CollaboratorsCount: Scalars['Int'];
  Comments: Array<Comment>;
  CommentsCount: Scalars['Int'];
  Content?: Maybe<Scalars['String']>;
  DesignBoardPins: DesignBoardPinsConnection;
  FollowersCount: Scalars['Int'];
  HasUnreadComments: Scalars['Boolean'];
  ID: Scalars['Int'];
  IsCollaborator: Scalars['Boolean'];
  IsFollower: Scalars['Boolean'];
  IsOwner: Scalars['Boolean'];
  LastEdited: Scalars['String'];
  Owner?: Maybe<Member>;
  Permission: DesignBoardPermission;
  /** Deprecated: Use DesignBoardPins connection instead */
  Pins: Array<Pin>;
  PinsCount: Scalars['Int'];
  Public: Scalars['Boolean'];
  Recommended: Array<DirectoryItem>;
  Title: Scalars['String'];
  URLSegment: Scalars['String'];
};


export type DesignBoardDesignBoardPinsArgs = {
  filter?: InputMaybe<DesignBoardPinsFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type DesignBoardPinsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

export type DesignBoardInvite = {
  __typename?: 'DesignBoardInvite';
  AcceptLink: Scalars['String'];
  CreatedBy?: Maybe<Member>;
  DesignBoardTitle?: Maybe<Scalars['String']>;
  ID: Scalars['Int'];
  InvitedMember?: Maybe<Member>;
};

export type DesignBoardNotification = WebsiteNotificationInterface & {
  __typename?: 'DesignBoardNotification';
  Action: WebsiteNotificationAction;
  Comment?: Maybe<Comment>;
  CreatedAt: Scalars['String'];
  CreatedBy: Member;
  DesignBoard: DesignBoard;
  ID: Scalars['ID'];
  Invite?: Maybe<DesignBoardInvite>;
  IsRead: Scalars['Boolean'];
  LastEdited: Scalars['String'];
  PhotoTileURL?: Maybe<Scalars['String']>;
  Pin?: Maybe<Pin>;
};

export type DesignBoardPermission = {
  __typename?: 'DesignBoardPermission';
  CanAddCollaborators: Scalars['Boolean'];
  CanAddComments: Scalars['Boolean'];
  CanAddPins: Scalars['Boolean'];
  CanUploadFile: Scalars['Boolean'];
  CanViewCollaborators: Scalars['Boolean'];
  CanViewComments: Scalars['Boolean'];
  CanViewPins: Scalars['Boolean'];
  ID: Scalars['Int'];
};

/** A pin on the design board */
export type DesignBoardPin = SortableItem & {
  __typename?: 'DesignBoardPin';
  Comments: Pin_CommentsConnection;
  CreatedBy?: Maybe<Member>;
  /** Design board associated with the pin */
  DesignBoard: DesignBoard;
  ID: Scalars['Int'];
  MemberSortOrder: Scalars['Int'];
  Permission: PinPermission;
  PhotoModal?: Maybe<Scalars['String']>;
  PhotoTile?: Maybe<Scalars['String']>;
  Subtitle: Scalars['String'];
  /** The target of the pin */
  Target?: Maybe<DesignBoardPinTarget>;
  Title: Scalars['String'];
  URLSearchParams?: Maybe<Scalars['String']>;
};


/** A pin on the design board */
export type DesignBoardPinCommentsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** Target for a DesignBoardPin */
export type DesignBoardPinTarget = {
  /** The ID of the target */
  ID: Scalars['Int'];
};

export enum DesignBoardPinTargetType {
  Article = 'article',
  MemberUpload = 'memberUpload',
  Photo = 'photo',
  Product = 'product',
  Professional = 'professional',
  Project = 'project'
}

export type DesignBoardPinsConnection = {
  __typename?: 'DesignBoardPinsConnection';
  ID: Scalars['String'];
  edges: Array<DesignBoardPinsConnectionEdge>;
  nodes: Array<DesignBoardPin>;
  pageInfo: ApPageInfo;
};

/** The collections edge */
export type DesignBoardPinsConnectionEdge = {
  __typename?: 'DesignBoardPinsConnectionEdge';
  /** The node at the end of the collections edge */
  node: DesignBoardPin;
};

export type DesignBoardPinsFilters = {
  /** Filter pins by target type */
  ByTargetType?: InputMaybe<DesignBoardPinTargetType>;
};

export type DesignBoardResult = DesignBoard | NotAuthenticatedError | NotAuthorizedError | NotFoundError;

export enum DesignBoardRole {
  Collaborator = 'collaborator',
  Follower = 'follower',
  Owner = 'owner',
  OwnerOrEditor = 'ownerOrEditor'
}

export type DesignBoardSetting = {
  __typename?: 'DesignBoardSetting';
  EnquiryReminderEmailEnabled: Scalars['Boolean'];
  ID: Scalars['Int'];
  NotifyAllEnabled: Scalars['Boolean'];
  WeeklyEmailEnabled: Scalars['Boolean'];
};

export type DesignBoardsFilters = {
  /** Filter design boards by role */
  ByRole?: InputMaybe<DesignBoardRole>;
};

export type DesignBoardsPinsFilters = {
  /** Filter pins by target type */
  ByTargetType?: InputMaybe<DesignBoardPinTargetType>;
};

export type DesignBoardsPinsSimpleSortFields = {
  SortOrder?: InputMaybe<SortDirection>;
};

export type DesignBoardsSimpleSortFields = {
  SortOrder?: InputMaybe<SortDirection>;
};

export type DeviceData = {
  __typename?: 'DeviceData';
  Device: Scalars['String'];
  ID: Scalars['String'];
  Users: Scalars['String'];
};

export type DiagramImage = SortableItem & {
  __typename?: 'DiagramImage';
  AltText?: Maybe<Scalars['String']>;
  /** Aspect ratio of raw uploaded photo */
  AspectRatio: Scalars['Float'];
  BannerSegment?: Maybe<BannerSegmentEnum>;
  /** Associated caption for this LibraryImage */
  Caption?: Maybe<Scalars['String']>;
  Categories: Array<Category>;
  /** Clickable link for this photo */
  ClickableLink?: Maybe<Scalars['String']>;
  Comments?: Maybe<Array<Maybe<Comment>>>;
  CreatedDate?: Maybe<Scalars['String']>;
  /** Crop Position in x-axis (if applicable) */
  CropPosX: Scalars['Int'];
  /** Crop Position in y-axis (if applicable) */
  CropPosY: Scalars['Int'];
  /** Return any of this user's Design Boards that contain this image */
  DesignBoardsForCurrentUser?: Maybe<Array<Maybe<DesignBoard>>>;
  /** Download link for this photo */
  DownloadLink?: Maybe<Scalars['String']>;
  Format?: Maybe<Scalars['String']>;
  /** Returns true if LibraryImage has tags */
  HasTags: Scalars['Boolean'];
  /** Height of the photo after cropping it */
  HeightAfterCrop: Scalars['Int'];
  /** Height of the photo before cropping it */
  HeightBeforeCrop: Scalars['Int'];
  /** Does a LibraryImage need to hide resene tool */
  HideReseneTool?: Maybe<Scalars['Boolean']>;
  /** The unique identifier of the LibraryImage */
  ID: Scalars['Int'];
  /** Is this image Landscape or Portrait? */
  ImageFormat: Scalars['String'];
  /** If a LibraryImage has active tags */
  Interactive?: Maybe<Scalars['Boolean']>;
  /** Returns true if LibraryImage is clearcut */
  IsClearCut: Scalars['Boolean'];
  /** Returns true if LibraryImage should display as a half-width */
  IsHalfWidth: Scalars['Boolean'];
  /** Returns true if LibraryImage has multiply filter */
  IsMultiplied: Scalars['Boolean'];
  /** is raw image portrait, backend treats square image as portrait */
  IsPortrait: Scalars['Boolean'];
  /** Returns true if LibraryImage is zoomed out */
  IsZoomedOut: Scalars['Boolean'];
  /** LibraryImageFile for this LibraryImage */
  LibraryImageFile?: Maybe<LibraryImageFile>;
  /** SiteTreeID of related LibraryItem */
  LibraryImageFileID?: Maybe<Scalars['Int']>;
  /** Return a list of tags on this photo */
  LibraryImageMarkers: Array<LibraryImageMarker>;
  /** DirectoryItem associated with this LibraryImage */
  LibraryItem?: Maybe<DirectoryItem>;
  /** SiteTreeID of related LibraryItem */
  LibraryItemID?: Maybe<Scalars['Int']>;
  MemberSortOrder: Scalars['Int'];
  MetaDescription?: Maybe<Scalars['String']>;
  PhotoBrickPortrait?: Maybe<Scalars['String']>;
  /** Professional to give Photo Credit for this image */
  PhotoCredit?: Maybe<Professional>;
  /** Name of the photo credit, can be a custom credit without a Professional */
  PhotoCreditName?: Maybe<Scalars['String']>;
  PhotoListing?: Maybe<Scalars['String']>;
  PhotoListingPreload?: Maybe<Scalars['String']>;
  PhotoModal?: Maybe<Scalars['String']>;
  /** Professional associated with this LibraryImage */
  Professional?: Maybe<Professional>;
  ProfessionalID: Scalars['String'];
  ProfessionalWebsite: Scalars['String'];
  ProfessionalWebsiteShort: Scalars['String'];
  /** Scroll Position in x-axis (if applicable) */
  ScrollPosX: Scalars['Int'];
  /** Scroll Position in y-axis (if applicable) */
  ScrollPosY: Scalars['Int'];
  SearchTags: LibraryImageSearchTagsConnection;
  SortOrder: Scalars['Int'];
  Tags?: Maybe<Array<Maybe<LibraryImageMarker>>>;
  Thumbnail: ResponsiveImage;
  /** Title of the LibraryImage (usually internal) */
  Title: Scalars['String'];
  /** Width for this photo */
  Width?: Maybe<Scalars['Int']>;
  /** Width of the photo after cropping it */
  WidthAfterCrop: Scalars['Int'];
  /** Width of the photo before cropping it */
  WidthBeforeCrop: Scalars['Int'];
  /** Zoom percentage of photo (default 100) */
  ZoomFactor: Scalars['Int'];
};


export type DiagramImageSearchTagsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type DigitalPublication = Newsletter | NotFoundError | ServerError | UserError;

export type DigitalPublicationActivityFilters = {
  CAMPAIGN_ID__EQUAL?: InputMaybe<Scalars['String']>;
};

export type DigitalPublicationAttentionShareFilters = {
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type DigitalPublicationAudienceFilters = {
  CAMPAIGN_ID__EQUAL?: InputMaybe<Scalars['String']>;
};

export type DigitalPublicationAudienceRegionFilters = {
  CAMPAIGN_ID__EQUAL?: InputMaybe<Scalars['String']>;
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type DigitalPublicationListFilters = {
  HOST_DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type DigitalPublicationOpenClickFilters = {
  CAMPAIGN_ID__EQUAL?: InputMaybe<Scalars['String']>;
};

export type DigitalPublicationPerformanceChartClickFilters = {
  CAMPAIGN_ID__EQUAL?: InputMaybe<Scalars['String']>;
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type DigitalPublicationPerformanceChartOpenFilters = {
  CAMPAIGN_ID__EQUAL?: InputMaybe<Scalars['String']>;
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type DigitalPublicationPerformanceFilters = {
  CAMPAIGN_ID__EQUAL?: InputMaybe<Scalars['String']>;
};

export type DigitalPublicationProfessionalCategoryFilters = {
  CAMPAIGN_ID__EQUAL?: InputMaybe<Scalars['String']>;
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type DigitalPublicationProfessionalEngagementFilters = {
  CAMPAIGN_ID__EQUAL?: InputMaybe<Scalars['String']>;
};

export type DigitalPublicationProfessionalRegionFilters = {
  CAMPAIGN_ID__EQUAL?: InputMaybe<Scalars['String']>;
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type DigitalPublicationProfessionalUserFilters = {
  CAMPAIGN_ID__EQUAL?: InputMaybe<Scalars['String']>;
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type DigitalPublicationProfileConversionChartFilters = {
  CAMPAIGN_ID__EQUAL?: InputMaybe<Scalars['String']>;
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type DigitalPublicationReaderRegionFilters = {
  CAMPAIGN_ID__EQUAL?: InputMaybe<Scalars['String']>;
};

export type DigitalPublicationRecipientFilters = {
  CAMPAIGN_ID__EQUAL?: InputMaybe<Scalars['String']>;
};

export type DigitalPublicationSingleMetaFilters = {
  ID__EQUAL?: InputMaybe<Scalars['String']>;
};

export type DigitalPublicationSummaryFilters = {
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type DigitalPublicationTimespentFilters = {
  CAMPAIGN_ID__EQUAL?: InputMaybe<Scalars['String']>;
};

export type DigitalPublicationsConnection = {
  __typename?: 'DigitalPublicationsConnection';
  edges: Array<DigitalPublicationsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type DigitalPublicationsConnectionEdge = {
  __typename?: 'DigitalPublicationsConnectionEdge';
  /** The node at the end of the collections edge */
  node: Newsletter;
};

export type DigitalPublicationsFilters = {
  /** Filters this type when ID is in the provided value */
  ID__in?: InputMaybe<Array<Scalars['Int']>>;
  /** Filters this type when Month is eq the provided value */
  Month__eq?: InputMaybe<Scalars['Int']>;
  /** Filters this type when Publish is eq the provided value */
  Publish__eq?: InputMaybe<Scalars['Boolean']>;
  /** Filters this type when Title is eq the provided value */
  Title__eq?: InputMaybe<Scalars['String']>;
  /** Filters this type when Type is eq the provided value */
  Type__eq?: InputMaybe<NewsletterTypeEnum>;
  /** Filters this type when UrlSegment is eq the provided value */
  UrlSegment__eq?: InputMaybe<Scalars['String']>;
  /** Filters this type when Year is eq the provided value */
  Year__eq?: InputMaybe<Scalars['Int']>;
};

export type DigitalPublicationsSortFields = {
  Created?: InputMaybe<SortDirection>;
  Month?: InputMaybe<SortDirection>;
  Title?: InputMaybe<SortDirection>;
  Type?: InputMaybe<SortDirection>;
  Year?: InputMaybe<SortDirection>;
};

export type DirectConversation = Conversation & {
  __typename?: 'DirectConversation';
  /** The BuildHub project associated with this conversation. */
  BuildHub?: Maybe<BuildHub>;
  ID: Scalars['ID'];
  /** This conversation is a group chat. */
  IsGroupChat: Scalars['Boolean'];
  Messages: DirectMessageConnection;
  /** The name of this conversation. */
  Name?: Maybe<Scalars['String']>;
  Participants: Array<MemberParticipant>;
  Unread: Scalars['Boolean'];
  UnreadMessageCount: Scalars['Int'];
};


export type DirectConversationMessagesArgs = {
  BeforeID?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type DirectMessage = FileAttachmentMessage | SystemMessage | TextMessage;

export type DirectMessageConnection = {
  __typename?: 'DirectMessageConnection';
  edges: Array<DirectMessageConnectionEdge>;
  nodes: Array<DirectMessage>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type DirectMessageConnectionEdge = {
  __typename?: 'DirectMessageConnectionEdge';
  /** The node at the end of the collections edge */
  node: DirectMessage;
};

export type Directory = {
  __typename?: 'Directory';
  Article: DirectoryArticle;
  ArticleCategories: Directory_ArticleCategoriesConnection;
  ArticleCategory: DirectoryArticleCategory;
  BuildingGuide: DirectoryBuildingGuide;
  BuildingGuideCategories: Directory_BuildingGuideCategoriesConnection;
  BuildingGuideCategory: DirectoryBuildingGuideCategory;
  DigitalPublication: DigitalPublication;
  DigitalPublications: DigitalPublicationsConnection;
  HomePage: HomePage;
  Items: Directory_ItemsConnection;
  LegacyArticle: LegacyArticle;
  /** AI-generated labels for library images, grouped by LibraryImageID (ordered by AdminScore DESC and ID DESC, returns best label per image) */
  LibraryImageLabel: Directory_LibraryImageLabelConnection;
  Product: DirectoryProduct;
  ProductCategories: Directory_ProductCategoriesConnection;
  ProductCategory: DirectoryProductCategory;
  Professional: DirectoryProfessional;
  ProfessionalCategories: Directory_ProfessionalCategoriesConnection;
  ProfessionalCategory: DirectoryProfessionalCategory;
  Project: DirectoryProject;
  ProjectCategories: Directory_ProductCategoriesConnection;
  ProjectCategory: DirectoryProjectCategory;
  SearchSuggestion: Directory_SearchSuggestionsConnection;
};


export type DirectoryArticleArgs = {
  Link: Scalars['String'];
  LiveOnly?: InputMaybe<Scalars['Boolean']>;
};


export type DirectoryArticleCategoriesArgs = {
  filter?: InputMaybe<Directory_ArticleCategoriesFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Directory_ArticleCategoriesSortFields>;
};


export type DirectoryArticleCategoryArgs = {
  Link: Scalars['String'];
};


export type DirectoryBuildingGuideArgs = {
  Link: Scalars['String'];
};


export type DirectoryBuildingGuideCategoriesArgs = {
  filter?: InputMaybe<Directory_BuildingGuideCategoriesFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Directory_BuildingGuideCategoriesSortFields>;
};


export type DirectoryBuildingGuideCategoryArgs = {
  Link: Scalars['String'];
};


export type DirectoryDigitalPublicationArgs = {
  Link: Scalars['String'];
};


export type DirectoryDigitalPublicationsArgs = {
  filter?: InputMaybe<DigitalPublicationsFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<DigitalPublicationsSortFields>;
};


export type DirectoryItemsArgs = {
  filter?: InputMaybe<Directory_ItemsFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type DirectoryLegacyArticleArgs = {
  Link: Scalars['String'];
};


export type DirectoryLibraryImageLabelArgs = {
  filter?: InputMaybe<LibraryImageLabelFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type DirectoryProductArgs = {
  Link: Scalars['String'];
};


export type DirectoryProductCategoriesArgs = {
  filter?: InputMaybe<Directory_ProductCategoriesFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Directory_ProductCategoriesSortFields>;
};


export type DirectoryProductCategoryArgs = {
  Link: Scalars['String'];
};


export type DirectoryProfessionalArgs = {
  Link: Scalars['String'];
};


export type DirectoryProfessionalCategoriesArgs = {
  filter?: InputMaybe<Directory_ProfessionalCategoriesFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Directory_ProfessionalCategoriesSortFields>;
};


export type DirectoryProfessionalCategoryArgs = {
  Link: Scalars['String'];
};


export type DirectoryProjectArgs = {
  Link: Scalars['String'];
};


export type DirectoryProjectCategoriesArgs = {
  filter?: InputMaybe<Directory_ProductCategoriesFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Directory_ProductCategoriesSortFields>;
};


export type DirectoryProjectCategoryArgs = {
  Link: Scalars['String'];
};


export type DirectorySearchSuggestionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type DirectoryArticle = Article | NotAuthenticatedError | NotAuthorizedError | NotFoundError | Redirect | ServerError | UserError;

export type DirectoryArticleCategory = ArticleCategory | NotAuthenticatedError | NotAuthorizedError | NotFoundError | Redirect | ServerError | UserError;

export type DirectoryBuildingGuide = BuildingGuide | NotAuthenticatedError | NotAuthorizedError | NotFoundError | Redirect | ServerError | UserError;

export type DirectoryBuildingGuideCategory = BuildingGuideCategory | NotAuthenticatedError | NotAuthorizedError | NotFoundError | Redirect | ServerError | UserError;

export type DirectoryHeader = {
  __typename?: 'DirectoryHeader';
  Content?: Maybe<Scalars['String']>;
  ContentAlt?: Maybe<Scalars['String']>;
  /** Teaser text */
  ContentTop?: Maybe<Scalars['String']>;
  ID: Scalars['Int'];
  Title: Scalars['String'];
  TitleAlt?: Maybe<Scalars['String']>;
};


export type DirectoryHeaderContentAltArgs = {
  Filters?: InputMaybe<DirectoryPageMetaFilters>;
};


export type DirectoryHeaderContentTopArgs = {
  Filters?: InputMaybe<DirectoryPageMetaFilters>;
};


export type DirectoryHeaderTitleArgs = {
  Filters?: InputMaybe<DirectoryPageMetaFilters>;
};

export type DirectoryItem = {
  /** Has this page been reviewed and approved by the ArchiPro Content Team? */
  Activated?: Maybe<Scalars['Boolean']>;
  ApprovedByMember?: Maybe<Member>;
  ApprovedDate?: Maybe<Scalars['String']>;
  AvailabilityZones: Array<Zone>;
  /** Deprecated. Use Banners instead */
  BannerImages?: Maybe<Array<LibraryImage>>;
  Categories: Array<Category>;
  Clones?: Maybe<Array<DirectoryItem>>;
  Content?: Maybe<Scalars['String']>;
  CreatedByMember?: Maybe<Member>;
  CreatedDate?: Maybe<Scalars['String']>;
  DesignBoardsForCurrentUser?: Maybe<Array<Maybe<DesignBoard>>>;
  FacebookPreviewImage?: Maybe<Scalars['String']>;
  HasClones: Scalars['Boolean'];
  HasDownloads: Scalars['Boolean'];
  HasPhotos: Scalars['Boolean'];
  HasProducts: Scalars['Boolean'];
  HasProjects: Scalars['Boolean'];
  HomePinned: Scalars['Boolean'];
  ID: Scalars['Int'];
  InLibrary?: Maybe<Scalars['Boolean']>;
  IsCloned: Scalars['Boolean'];
  /** IsDraft will be set to true only until the page is published for the first time. */
  IsDraft: Scalars['Boolean'];
  IsManufacturer: Scalars['Boolean'];
  LibraryImages: Array<LibraryImage>;
  LibraryLocations: Array<LibraryLocation>;
  LibraryThumb?: Maybe<LibraryThumb>;
  LibraryVideos: Array<LibraryVideo>;
  Link: Scalars['String'];
  MemberSortOrder: Scalars['Int'];
  Meta?: Maybe<Meta>;
  PageType: Scalars['String'];
  ParentID: Scalars['Int'];
  ProductsUsed: Array<Product>;
  Professional?: Maybe<Professional>;
  /** Has this page been reviewed and approved by the client? */
  Publish: Scalars['Boolean'];
  PublishDate?: Maybe<Scalars['String']>;
  PublishedByMember?: Maybe<Member>;
  RawTileImage?: Maybe<Scalars['String']>;
  Recommendations?: Maybe<Array<Maybe<DirectoryItem>>>;
  /** Actions that need addressing before this page can be approved */
  ReviewActions?: Maybe<Array<Maybe<ReviewAction>>>;
  SearchTags?: Maybe<Array<Maybe<SearchTag>>>;
  SortOrder: Scalars['Int'];
  Teaser?: Maybe<Scalars['String']>;
  Title: Scalars['String'];
  URLSegment: Scalars['String'];
  Website?: Maybe<Scalars['String']>;
  WebsiteShort?: Maybe<Scalars['String']>;
  WebsiteUntracked?: Maybe<Scalars['String']>;
};


export type DirectoryItemApprovedDateArgs = {
  format?: InputMaybe<DateFormatEnum>;
};


export type DirectoryItemCreatedDateArgs = {
  format?: InputMaybe<DateFormatEnum>;
};


export type DirectoryItemPublishDateArgs = {
  format?: InputMaybe<DateFormatEnum>;
};

export type DirectoryItemClonePageType = Article | NotAuthorizedError | NotFoundError | Product | Project | ServerError;

export enum DirectoryItemEnumType {
  Article = 'article',
  BuildingGuide = 'buildingGuide',
  Magazine = 'magazine',
  Photo = 'photo',
  Product = 'product',
  Professional = 'professional',
  Project = 'project'
}

export enum DirectoryItemStatusEnum {
  Draft = 'Draft',
  InLibrary = 'InLibrary',
  Live = 'Live',
  NotLive = 'NotLive',
  PendingApproval = 'PendingApproval',
  ProfileOnly = 'ProfileOnly',
  Scheduled = 'Scheduled',
  SelfPublished = 'SelfPublished'
}

export type DirectoryItemSyncPageType = Article | NotAuthorizedError | NotFoundError | Product | Project | ServerError;

export type DirectoryItemUpdateUrlResultType = Article | NotAuthorizedError | NotFoundError | Product | Project | ServerError;

export enum DirectoryItemViewsCountRange {
  Annually = 'Annually',
  HalfYearly = 'HalfYearly',
  Monthly = 'Monthly',
  Quarterly = 'Quarterly'
}

export enum DirectoryItemsByCategoryListTypeEnum {
  ProductAlsofrom = 'PRODUCT_ALSOFROM',
  ProductProjects = 'PRODUCT_PROJECTS',
  ProfessionalAllprojects = 'PROFESSIONAL_ALLPROJECTS',
  ProfessionalArticles = 'PROFESSIONAL_ARTICLES',
  ProfessionalProducts = 'PROFESSIONAL_PRODUCTS',
  ProfessionalProjects = 'PROFESSIONAL_PROJECTS',
  ProfessionalRelatedprojects = 'PROFESSIONAL_RELATEDPROJECTS',
  ProjectAlsofrom = 'PROJECT_ALSOFROM',
  ProjectProducts = 'PROJECT_PRODUCTS',
  ProjectProfessionals = 'PROJECT_PROFESSIONALS'
}

export enum DirectoryItemsFilterEnum {
  All = 'All',
  Drafts = 'Drafts',
  InReview = 'InReview',
  IsFeatured = 'IsFeatured',
  Published = 'Published',
  Unpublished = 'Unpublished'
}

export enum DirectoryItemsStatusActions {
  Approve = 'approve',
  InLibrary = 'inLibrary',
  Publish = 'publish'
}

export type DirectoryModule = ModuleType & {
  __typename?: 'DirectoryModule';
  AnchorTag?: Maybe<Scalars['String']>;
  /** Sections in a directory module */
  DirectorySections: DirectorySections_Connection;
  ExtraClass?: Maybe<Scalars['String']>;
  ID: Scalars['ID'];
  NavigationLabel?: Maybe<Scalars['String']>;
  SpacingBelow?: Maybe<Scalars['String']>;
  SpacingBelowMobile?: Maybe<Scalars['String']>;
  ThemeColour: ThemedElementColourType;
  Title?: Maybe<Scalars['String']>;
};


export type DirectoryModuleDirectorySectionsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<DirectorySections_SortFields>;
};

export type DirectoryPageMeta = {
  __typename?: 'DirectoryPageMeta';
  AvailabilityZones?: Maybe<Array<Maybe<Zone>>>;
  Canonical?: Maybe<Scalars['String']>;
  CategoryCrumbs?: Maybe<Array<Maybe<Category>>>;
  /** Bottom CTA paragraph */
  ContentBottom?: Maybe<Scalars['String']>;
  Description?: Maybe<Scalars['String']>;
  DirectoryHeader?: Maybe<DirectoryHeader>;
  FAQSchemas?: Maybe<Array<Maybe<FaqSchema>>>;
  ID: Scalars['Int'];
  MetaKeywords?: Maybe<Scalars['String']>;
  MetaTitle?: Maybe<Scalars['String']>;
  NoIndex?: Maybe<Scalars['Boolean']>;
  Title: Scalars['String'];
};


export type DirectoryPageMetaDescriptionArgs = {
  Filters?: InputMaybe<DirectoryPageMetaFilters>;
};


export type DirectoryPageMetaFaqSchemasArgs = {
  Filters?: InputMaybe<DirectoryPageMetaFilters>;
};


export type DirectoryPageMetaMetaTitleArgs = {
  Filters?: InputMaybe<DirectoryPageMetaFilters>;
};


export type DirectoryPageMetaTitleArgs = {
  Filters?: InputMaybe<DirectoryPageMetaFilters>;
};

export type DirectoryPageMetaFilters = {
  Color?: InputMaybe<Scalars['String']>;
  Location?: InputMaybe<LocationFilterInput>;
  Material?: InputMaybe<Scalars['String']>;
};

export type DirectoryProduct = NotAuthenticatedError | NotAuthorizedError | NotFoundError | Product | Redirect | ServerError | UserError;

export type DirectoryProductCategory = NotAuthenticatedError | NotAuthorizedError | NotFoundError | ProductCategory | Redirect | ServerError | UserError;

export type DirectoryProfessional = NotAuthenticatedError | NotAuthorizedError | NotFoundError | Professional | Redirect | ServerError | UserError;

export type DirectoryProfessionalCategory = NotAuthenticatedError | NotAuthorizedError | NotFoundError | ProfessionalCategory | Redirect | ServerError | UserError;

export type DirectoryProject = NotAuthenticatedError | NotAuthorizedError | NotFoundError | Project | Redirect | ServerError | UserError;

export type DirectoryProjectCategory = NotAuthenticatedError | NotAuthorizedError | NotFoundError | ProjectCategory | Redirect | ServerError | UserError;

export type DirectorySectionBlock = {
  __typename?: 'DirectorySectionBlock';
  AnchorTag?: Maybe<Scalars['String']>;
  ExtraClass?: Maybe<Scalars['String']>;
  ID: Scalars['ID'];
  /** Links in a directory section block */
  Links: DirectorySectionLinks_Connection;
  NavigationLabel?: Maybe<Scalars['String']>;
  SpacingBelow?: Maybe<Scalars['String']>;
  SpacingBelowMobile?: Maybe<Scalars['String']>;
  ThemeColour: ThemedElementColourType;
  Title?: Maybe<Scalars['String']>;
};


export type DirectorySectionBlockLinksArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<DirectorySectionLinks_SortFields>;
};

export type DirectorySectionLinks_Connection = {
  __typename?: 'DirectorySectionLinks_Connection';
  edges: Array<DirectorySectionLinks_ConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type DirectorySectionLinks_ConnectionEdge = {
  __typename?: 'DirectorySectionLinks_ConnectionEdge';
  /** The node at the end of the collections edge */
  node: ExternalLink;
};

export type DirectorySectionLinks_SortFields = {
  SortOrder?: InputMaybe<SortDirection>;
};

export type DirectorySections_Connection = {
  __typename?: 'DirectorySections_Connection';
  edges: Array<DirectorySections_ConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type DirectorySections_ConnectionEdge = {
  __typename?: 'DirectorySections_ConnectionEdge';
  /** The node at the end of the collections edge */
  node: DirectorySectionBlock;
};

export type DirectorySections_SortFields = {
  SortOrder?: InputMaybe<SortDirection>;
};

export type Directory_ArticleCategoriesConnection = {
  __typename?: 'Directory_ArticleCategoriesConnection';
  edges: Array<Directory_ArticleCategoriesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type Directory_ArticleCategoriesConnectionEdge = {
  __typename?: 'Directory_ArticleCategoriesConnectionEdge';
  /** The node at the end of the collections edge */
  node: ArticleCategory;
};

export type Directory_ArticleCategoriesFilters = {
  /** Filter categories that have or don`t have items */
  HasItems?: InputMaybe<Scalars['Boolean']>;
  /** Filters this type when ID is in the provided value */
  ID__in?: InputMaybe<Array<Scalars['Int']>>;
  /** Filters this type when Title is eq the provided value */
  Title__eq?: InputMaybe<Scalars['String']>;
};

export type Directory_ArticleCategoriesSortFields = {
  Title?: InputMaybe<SortDirection>;
};

export type Directory_BuildingGuideCategoriesConnection = {
  __typename?: 'Directory_BuildingGuideCategoriesConnection';
  edges: Array<Directory_BuildingGuideCategoriesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type Directory_BuildingGuideCategoriesConnectionEdge = {
  __typename?: 'Directory_BuildingGuideCategoriesConnectionEdge';
  /** The node at the end of the collections edge */
  node: BuildingGuideCategory;
};

export type Directory_BuildingGuideCategoriesFilters = {
  /** Filter categories that have or don`t have items */
  HasItems?: InputMaybe<Scalars['Boolean']>;
  /** Filters this type when ID is in the provided value */
  ID__in?: InputMaybe<Array<Scalars['Int']>>;
  /** Filters this type when Title is eq the provided value */
  Title__eq?: InputMaybe<Scalars['String']>;
};

export type Directory_BuildingGuideCategoriesSortFields = {
  Title?: InputMaybe<SortDirection>;
};

export type Directory_ItemsConnection = {
  __typename?: 'Directory_ItemsConnection';
  edges: Array<Directory_ItemsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type Directory_ItemsConnectionEdge = {
  __typename?: 'Directory_ItemsConnectionEdge';
  /** The node at the end of the collections edge */
  node: DirectoryItem;
};

export type Directory_ItemsFilters = {
  /** Filters this type when ID is in the provided value */
  ID__in: Array<Scalars['Int']>;
};

export type Directory_LibraryImageLabelConnection = {
  __typename?: 'Directory_LibraryImageLabelConnection';
  edges: Array<Directory_LibraryImageLabelConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type Directory_LibraryImageLabelConnectionEdge = {
  __typename?: 'Directory_LibraryImageLabelConnectionEdge';
  /** The node at the end of the collections edge */
  node: LibraryImageLabel;
};

export type Directory_ProductCategoriesConnection = {
  __typename?: 'Directory_ProductCategoriesConnection';
  edges: Array<Directory_ProductCategoriesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type Directory_ProductCategoriesConnectionEdge = {
  __typename?: 'Directory_ProductCategoriesConnectionEdge';
  /** The node at the end of the collections edge */
  node: ProductCategory;
};

export type Directory_ProductCategoriesFilters = {
  /** Filter categories that have or don`t have items */
  HasItems?: InputMaybe<Scalars['Boolean']>;
  /** Filters this type when ID is in the provided value */
  ID__in?: InputMaybe<Array<Scalars['Int']>>;
  /** Filters this type when Title is eq the provided value */
  Title__eq?: InputMaybe<Scalars['String']>;
};

export type Directory_ProductCategoriesSortFields = {
  Title?: InputMaybe<SortDirection>;
};

export type Directory_ProfessionalCategoriesConnection = {
  __typename?: 'Directory_ProfessionalCategoriesConnection';
  edges: Array<Directory_ProfessionalCategoriesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type Directory_ProfessionalCategoriesConnectionEdge = {
  __typename?: 'Directory_ProfessionalCategoriesConnectionEdge';
  /** The node at the end of the collections edge */
  node: ProfessionalCategory;
};

export type Directory_ProfessionalCategoriesFilters = {
  /** Filter categories that have or don`t have items */
  HasItems?: InputMaybe<Scalars['Boolean']>;
  /** Filters this type when ID is in the provided value */
  ID__in?: InputMaybe<Array<Scalars['Int']>>;
  /** Filters this type when Title is eq the provided value */
  Title__eq?: InputMaybe<Scalars['String']>;
};

export type Directory_ProfessionalCategoriesSortFields = {
  Title?: InputMaybe<SortDirection>;
};

export type Directory_SearchSuggestionsConnection = {
  __typename?: 'Directory_SearchSuggestionsConnection';
  edges: Array<Directory_SearchSuggestionsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type Directory_SearchSuggestionsConnectionEdge = {
  __typename?: 'Directory_SearchSuggestionsConnectionEdge';
  /** The node at the end of the collections edge */
  node: SearchSuggestion;
};

export type Dispatch = {
  __typename?: 'Dispatch';
  Created: Scalars['String'];
  Delivered?: Maybe<Scalars['String']>;
  ID: Scalars['Int'];
  LabelURL?: Maybe<Scalars['String']>;
  OrderItems: Array<OrderItem>;
  ShippingProvider: Scalars['String'];
  ShippingProviderName: Scalars['String'];
  TrackingCode: Scalars['String'];
  TrackingURL: Scalars['String'];
};

export type DownloadableFile = {
  __typename?: 'DownloadableFile';
  ID: Scalars['Int'];
  Link: Scalars['String'];
  Title: Scalars['String'];
};

export type DuoImageModule = FlexibleModule & {
  __typename?: 'DuoImageModule';
  Columns: ColumnsConnection;
  ContentAreaID: Scalars['Int'];
  CreatedFromID?: Maybe<Scalars['Int']>;
  CreatedFromVersion?: Maybe<Scalars['Int']>;
  DetachedFromSavedModule?: Maybe<Scalars['Boolean']>;
  EcommerceEnabled: Scalars['Boolean'];
  ID: Scalars['Int'];
  LibraryItemID: Scalars['Int'];
  MemberSortOrder: Scalars['Int'];
  ModuleGroup?: Maybe<ModuleGroupEnum>;
  PossibleColumnDimensions: Array<ColumnDimension>;
  PresetName: Scalars['String'];
  PresetType: FlexibleModuleEnum;
  SortableColumns: Scalars['Boolean'];
  Swappable: Scalars['Boolean'];
};


export type DuoImageModuleColumnsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<ColumnsSortFields>;
};

export type DuoParagraphModule = FlexibleModule & {
  __typename?: 'DuoParagraphModule';
  Columns: ColumnsConnection;
  ContentAreaID: Scalars['Int'];
  CreatedFromID?: Maybe<Scalars['Int']>;
  CreatedFromVersion?: Maybe<Scalars['Int']>;
  DetachedFromSavedModule?: Maybe<Scalars['Boolean']>;
  EcommerceEnabled: Scalars['Boolean'];
  ID: Scalars['Int'];
  LibraryItemID: Scalars['Int'];
  MemberSortOrder: Scalars['Int'];
  ModuleGroup?: Maybe<ModuleGroupEnum>;
  PossibleColumnDimensions: Array<ColumnDimension>;
  PresetName: Scalars['String'];
  PresetType: FlexibleModuleEnum;
  SortableColumns: Scalars['Boolean'];
  Swappable: Scalars['Boolean'];
};


export type DuoParagraphModuleColumnsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<ColumnsSortFields>;
};

export type EcomCallToActionModule = ModuleType & {
  __typename?: 'EcomCallToActionModule';
  AnchorTag?: Maybe<Scalars['String']>;
  CTA?: Maybe<SiteTreeLink>;
  Content?: Maybe<Scalars['String']>;
  ExtraClass?: Maybe<Scalars['String']>;
  ID: Scalars['ID'];
  NavigationLabel?: Maybe<Scalars['String']>;
  SpacingBelow?: Maybe<Scalars['String']>;
  SpacingBelowMobile?: Maybe<Scalars['String']>;
  ThemeColour: ThemedElementColourType;
};

export type EcomTestimonialModule = ModuleType & {
  __typename?: 'EcomTestimonialModule';
  AnchorTag?: Maybe<Scalars['String']>;
  /** List of testimonials */
  CustomerTestimonials: CustomerTestimonials_Connection;
  ExtraClass?: Maybe<Scalars['String']>;
  ID: Scalars['ID'];
  NavigationLabel?: Maybe<Scalars['String']>;
  SpacingBelow?: Maybe<Scalars['String']>;
  SpacingBelowMobile?: Maybe<Scalars['String']>;
  ThemeColour: ThemedElementColourType;
};


export type EcomTestimonialModuleCustomerTestimonialsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<CustomerTestimonials_SortFields>;
};

export type EcomWelcomeModule = ModuleType & {
  __typename?: 'EcomWelcomeModule';
  AnchorTag?: Maybe<Scalars['String']>;
  CTA?: Maybe<SiteTreeLink>;
  Content?: Maybe<Scalars['String']>;
  ExtraClass?: Maybe<Scalars['String']>;
  ID: Scalars['ID'];
  Image?: Maybe<ResponsiveVariantImage>;
  NavigationLabel?: Maybe<Scalars['String']>;
  SpacingBelow?: Maybe<Scalars['String']>;
  SpacingBelowMobile?: Maybe<Scalars['String']>;
  ThemeColour: ThemedElementColourType;
  Title?: Maybe<Scalars['String']>;
};

export type EditableImage = DiagramImage | LibraryImage;

export type EditorialAuthorsSimpleSortFields = {
  FirstName?: InputMaybe<SortDirection>;
};

export type EditorialAuthors_Connection = {
  __typename?: 'EditorialAuthors_Connection';
  edges: Array<EditorialAuthors_ConnectionEdge>;
  nodes: Array<ArticleAuthor>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type EditorialAuthors_ConnectionEdge = {
  __typename?: 'EditorialAuthors_ConnectionEdge';
  /** The node at the end of the collections edge */
  node: ArticleAuthor;
};

/** Get all shipping products that are eligible for automated shipping */
export type EligibleShippingProducts = {
  __typename?: 'EligibleShippingProducts';
  EligibleCount: Scalars['Int'];
  ProductCount: Scalars['Int'];
};

export type EmailAssetListResponse = NotAuthorizedError | NotFoundError | ProfessionalEmailAssets | ServerError | UserError;

export type EmailAssetResponse = LibraryImage | NotAuthorizedError | NotFoundError | ServerError | UserError;

export type EmailClient = {
  __typename?: 'EmailClient';
  Client: Scalars['String'];
  Count: Scalars['Int'];
  ID: Scalars['String'];
};

export type EmailDataBinding = {
  __typename?: 'EmailDataBinding';
  Created: Scalars['String'];
  ID: Scalars['ID'];
  LastEdited: Scalars['String'];
  SourceClass: Scalars['String'];
  SourceID?: Maybe<Scalars['Int']>;
  Template: EmailTemplate;
};

export type EmailLink = {
  __typename?: 'EmailLink';
  ID: Scalars['ID'];
  Title?: Maybe<Scalars['String']>;
  URL?: Maybe<Scalars['String']>;
};

export type EmailMessage = {
  __typename?: 'EmailMessage';
  BCC?: Maybe<Scalars['String']>;
  Content: Scalars['String'];
  Created: Scalars['String'];
  From: Scalars['String'];
  ID: Scalars['ID'];
  LastEdited: Scalars['String'];
  Owner: Member;
  Preheader?: Maybe<Scalars['String']>;
  Professional: Professional;
  Recipient: Contact;
  ReplyTo?: Maybe<Scalars['String']>;
  Subject: Scalars['String'];
};

export type EmailMessageResponse = EmailMessage | NotAuthorizedError | NotFoundError | ServerError | UserError;

export type EmailTemplate = ContentBuilder & {
  __typename?: 'EmailTemplate';
  BackgroundColor?: Maybe<Scalars['String']>;
  BorderRadius: Scalars['Int'];
  CanCreate: Scalars['Boolean'];
  CanDelete: Scalars['Boolean'];
  CanEdit: Scalars['Boolean'];
  CanSend: Scalars['Boolean'];
  ClassName: Scalars['String'];
  ContainerPadding: Scalars['Int'];
  ContainerWidth: Scalars['String'];
  ContainerWidthValue: Scalars['Int'];
  ContentArea: ContentArea;
  ContentBuilderType: ContentBuilderTypeEnum;
  Created: Scalars['String'];
  CustomFontFamily?: Maybe<Scalars['String']>;
  DataBindings: Array<EmailDataBinding>;
  FontFamily: Scalars['String'];
  FontSize: Scalars['Int'];
  ID: Scalars['Int'];
  InnerBackgroundColor?: Maybe<Scalars['String']>;
  InputConfigs: Array<EmailTemplateInputConfig>;
  LastEdited: Scalars['String'];
  Link: Scalars['String'];
  Owner: Member;
  Preheader?: Maybe<Scalars['String']>;
  Professional: Professional;
  Subject: Scalars['String'];
  TextColor?: Maybe<Scalars['String']>;
  Title: Scalars['String'];
  URLSegment: Scalars['String'];
  UTM?: Maybe<Scalars['String']>;
};

export type EmailTemplateInputConfig = {
  __typename?: 'EmailTemplateInputConfig';
  Alias: Scalars['String'];
  ID: Scalars['ID'];
  InputTypeKey: Scalars['String'];
  IsRequired: Scalars['Boolean'];
  SortOrder: Scalars['Int'];
  Tokens: Array<Scalars['String']>;
  TypeLabel: Scalars['String'];
};

export type EmailTemplateInputConfigResponse = EmailTemplateInputConfig | NotAuthorizedError | NotFoundError | ServerError | UserError;

export type EmailTemplateResponse = EmailTemplate | NotAuthorizedError | NotFoundError | ServerError | UserError;

export type EmbeddedReport = {
  __typename?: 'EmbeddedReport';
  expiration: Scalars['String'];
  id: Scalars['String'];
  reportType: Scalars['String'];
  token: Scalars['String'];
  url: Scalars['String'];
};

export type EngagedCompanyStatsByIndustryFilters = {
  INDUSTRY_CATEGORY__IN?: InputMaybe<Array<Scalars['String']>>;
  QUARTER_START_DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type EngagedCompanyStatsByIndustrySort = {
  AP_CATEGORY?: InputMaybe<PrioritySort>;
  COMPANIES?: InputMaybe<PrioritySort>;
  CONVERSIONS?: InputMaybe<PrioritySort>;
  IMPRESSIONS?: InputMaybe<PrioritySort>;
  PAGE_VIEWS?: InputMaybe<PrioritySort>;
  SESSIONS?: InputMaybe<PrioritySort>;
  USERS?: InputMaybe<PrioritySort>;
};

export type EngagementEvent = {
  __typename?: 'EngagementEvent';
  City?: Maybe<Scalars['String']>;
  Created: Scalars['String'];
  DirectoryItem: DirectoryItem;
  ID: Scalars['Int'];
  Link: Scalars['String'];
  Name: EngagementEventName;
  Title: Scalars['String'];
  UserID: Scalars['Int'];
  UserIcon?: Maybe<Scalars['String']>;
};

export enum EngagementEventName {
  All = 'All',
  Download = 'Download',
  Enquiry = 'Enquiry',
  Lead = 'Lead',
  PageView = 'PageView',
  Reveal = 'Reveal',
  Save = 'Save',
  Share = 'Share',
  VideoPlay = 'VideoPlay'
}

export type EngagementEventSummary = {
  __typename?: 'EngagementEventSummary';
  AverageSecondsOnPage: Scalars['Float'];
  ConversionRate: Scalars['Float'];
  ID: Scalars['String'];
  Months: Scalars['Int'];
  PageViewsCount: Scalars['Int'];
  ProfessionalURL: Scalars['String'];
};

export type EngagementEventsCount = {
  __typename?: 'EngagementEventsCount';
  All: Scalars['Int'];
  Download: Scalars['Int'];
  Enquiry: Scalars['Int'];
  Lead: Scalars['Int'];
  PageView: Scalars['Int'];
  Reveal: Scalars['Int'];
  Save: Scalars['Int'];
  Share: Scalars['Int'];
};

export type EngagementSummary = {
  __typename?: 'EngagementSummary';
  Clicks: Scalars['Int'];
  Impressions: Scalars['Int'];
};

export type EngagementTopPerformer = {
  __typename?: 'EngagementTopPerformer';
  ID: Scalars['String'];
  Link: Scalars['String'];
  PageClicks: Scalars['Int'];
  PhotoTile?: Maybe<Scalars['String']>;
  Rank: Scalars['String'];
  Title: Scalars['String'];
  TotalEngagements: Scalars['Int'];
};

export type EngagementsOverTime = {
  __typename?: 'EngagementsOverTime';
  ClicksOverTime: Array<GraphPoint>;
  ID: Scalars['String'];
  OpensOverTime: Array<GraphPoint>;
};

export type Enquiry = Archivable & {
  __typename?: 'Enquiry';
  Archived: Scalars['Boolean'];
  Branch?: Maybe<Professional>;
  ClassName: Scalars['String'];
  Conversation?: Maybe<EnquiryConversation>;
  Description?: Maybe<Scalars['String']>;
  Email?: Maybe<Scalars['String']>;
  EnquiryType: Scalars['String'];
  HasAttachment: Scalars['Boolean'];
  HasResponse: Scalars['Boolean'];
  HasUnreadComments: Scalars['Boolean'];
  ID: Scalars['Int'];
  Important: Scalars['Boolean'];
  IsTeamMember: Scalars['Boolean'];
  Items: Array<SiteTree>;
  LastComment?: Maybe<Scalars['String']>;
  LastCommentedOn?: Maybe<Scalars['String']>;
  LastEdited: Scalars['String'];
  Member?: Maybe<Member>;
  Name: Scalars['String'];
  Phone?: Maybe<Scalars['String']>;
  Professional: Professional;
  Unread: Scalars['Boolean'];
  UnreadCommentCount: Scalars['Int'];
};

export type EnquiryConversation = Conversation & {
  __typename?: 'EnquiryConversation';
  /** Archived status of the inbox owner */
  Archived: Scalars['Boolean'];
  HasAttachment: Scalars['Boolean'];
  HasProfessionalResponse: Scalars['Boolean'];
  ID: Scalars['ID'];
  /** Important status of the inbox owner */
  Important: Scalars['Boolean'];
  /** The initial enquiry that started this conversation */
  InitialEnquiry: Enquiry;
  LastCommentedOn: Scalars['String'];
  LatestMessage: EnquiryMessage;
  LibraryItems: Array<DirectoryItem>;
  /** Mark as Done status of the inbox owner */
  MarkAsDone: Scalars['Boolean'];
  /** The region of the member who enquiried */
  MemberRegion: Scalars['String'];
  Messages: EnquiryMessageConnection;
  Participants: Array<EnquiryParticipant>;
  Permissions: Array<BusinessManagementActions>;
  Shared: Scalars['Boolean'];
  Unread: Scalars['Boolean'];
  UnreadMessageCount: Scalars['Int'];
};


export type EnquiryConversationMessagesArgs = {
  BeforeID?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export enum EnquiryConversationFilterEnum {
  Archived = 'Archived',
  Branch = 'Branch',
  Important = 'Important',
  MarkAsDone = 'MarkAsDone',
  Unread = 'Unread'
}

export type EnquiryConversationInvite = {
  __typename?: 'EnquiryConversationInvite';
  AcceptLink: Scalars['String'];
  CompanyInboxLink: Scalars['String'];
  CreatedBy: Member;
  ID: Scalars['ID'];
  InvitedMember: Member;
};

export type EnquiryConversationsFilterFieldsType = {
  field: EnquiryConversationFilterEnum;
  operator: EnquiryParticipantStatusOperatorEnum;
  value: Scalars['String'];
};

export type EnquiryInput = {
  Attachments?: InputMaybe<Array<InputMaybe<Scalars['Upload']>>>;
  AutoCreateMember?: InputMaybe<Scalars['Boolean']>;
  /** ProfessionalID of the branch professional */
  Branch?: InputMaybe<Scalars['Int']>;
  BuildHubFieldSelection?: InputMaybe<Scalars['String']>;
  BuildHubID?: InputMaybe<Scalars['Int']>;
  CreatedAt: Scalars['Float'];
  DesignBoardID?: InputMaybe<Scalars['Int']>;
  Email: Scalars['Email'];
  EnquiryReasons?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  Location?: InputMaybe<Scalars['StringInput']>;
  Message?: InputMaybe<Scalars['StringInput']>;
  Name: Scalars['StringInput'];
  Phone?: InputMaybe<Scalars['StringInput']>;
  ShareContactDetails: Scalars['Boolean'];
  SiteTreeIDs: Array<Scalars['Int']>;
  /** Optional list of professional IDs. If provided, all SiteTreeIDs will be sent to each professional in this list. */
  TargetProfessionals?: InputMaybe<Array<Scalars['Int']>>;
  /** The JSON-encoded location object */
  locationResponse?: InputMaybe<Scalars['StringInput']>;
};

export type EnquiryMessage = FileAttachmentMessage | MemberEnquiryMessage | RevealContactDetailsMessage | TextMessage;

export type EnquiryMessageConnection = {
  __typename?: 'EnquiryMessageConnection';
  edges: Array<EnquiryMessageConnectionEdge>;
  nodes: Array<EnquiryMessage>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type EnquiryMessageConnectionEdge = {
  __typename?: 'EnquiryMessageConnectionEdge';
  /** The node at the end of the collections edge */
  node: EnquiryMessage;
};

export type EnquiryNotification = WebsiteNotificationInterface & {
  __typename?: 'EnquiryNotification';
  Action: WebsiteNotificationAction;
  Comment?: Maybe<Comment>;
  ConversationInvite?: Maybe<EnquiryConversationInvite>;
  CreatedAt: Scalars['String'];
  CreatedBy: Member;
  Enquiry: Enquiry;
  ID: Scalars['ID'];
  IsRead: Scalars['Boolean'];
  LastEdited: Scalars['String'];
  PhotoTileURL?: Maybe<Scalars['String']>;
};

export type EnquiryParticipant = Participant & {
  __typename?: 'EnquiryParticipant';
  Archived: Scalars['Boolean'];
  ContactDetails: ContactDetails;
  DisableNotificationAndEmails: Scalars['Boolean'];
  ID: Scalars['ID'];
  Identity: ParticipantIdentity;
  Important: Scalars['Boolean'];
  IsCollaborator: Scalars['Boolean'];
  MarkAsDone: Scalars['Boolean'];
  Unread: Scalars['Boolean'];
};

export enum EnquiryParticipantStatusOperatorEnum {
  Equal = 'Equal',
  Gt = 'Gt',
  NotEqual = 'NotEqual'
}

export type Error = ErrorInterface & {
  __typename?: 'Error';
  Message: Scalars['String'];
};

/** The result type for a CardConnection with error handling */
export type ErrorHandlingCardConnection = CardConnection | NotAuthorizedError | NotFoundError | ServerError | UserError;

export type ErrorInterface = {
  /** Implemented by all error types */
  Message: Scalars['String'];
};

export type ErrorLoadingModule = FlexibleModule & {
  __typename?: 'ErrorLoadingModule';
  Columns: ColumnsConnection;
  ContentAreaID: Scalars['Int'];
  CreatedFromID?: Maybe<Scalars['Int']>;
  CreatedFromVersion?: Maybe<Scalars['Int']>;
  DetachedFromSavedModule?: Maybe<Scalars['Boolean']>;
  EcommerceEnabled: Scalars['Boolean'];
  ID: Scalars['Int'];
  LibraryItemID: Scalars['Int'];
  MemberSortOrder: Scalars['Int'];
  ModuleGroup?: Maybe<ModuleGroupEnum>;
  PossibleColumnDimensions: Array<ColumnDimension>;
  PresetName: Scalars['String'];
  PresetType: FlexibleModuleEnum;
  SortableColumns: Scalars['Boolean'];
  Swappable: Scalars['Boolean'];
};


export type ErrorLoadingModuleColumnsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<ColumnsSortFields>;
};

export type EventDay = {
  __typename?: 'EventDay';
  Date?: Maybe<Scalars['String']>;
  DateTimeDescription?: Maybe<Scalars['String']>;
  FootNotes?: Maybe<Scalars['String']>;
  ID: Scalars['ID'];
  /** List of itineraries in an event day */
  Itineraries: Itineraries_Connection;
  Summary?: Maybe<Scalars['String']>;
};


export type EventDayItinerariesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Itineraries_SortFields>;
};

export type EventDetails = {
  __typename?: 'EventDetails';
  Area?: Maybe<Scalars['String']>;
  DateTimeDescription?: Maybe<Scalars['String']>;
  /** List of days in this event */
  Days: Days_Connection;
  DisplayTitle?: Maybe<Scalars['String']>;
  ID: Scalars['ID'];
  Location?: Maybe<Scalars['String']>;
  PresentedBy?: Maybe<LibraryImageFile>;
  RegistrationFormTitle?: Maybe<Scalars['String']>;
  RegistrationStatus: EventRegistrationStatusEnum;
  Title?: Maybe<Scalars['String']>;
};


export type EventDetailsDaysArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Days_SortFields>;
};

export type EventDetailsModule = ModuleType & {
  __typename?: 'EventDetailsModule';
  AnchorTag?: Maybe<Scalars['String']>;
  Event?: Maybe<EventDetails>;
  ExtraClass?: Maybe<Scalars['String']>;
  ID: Scalars['ID'];
  NavigationLabel?: Maybe<Scalars['String']>;
  SpacingBelow?: Maybe<Scalars['String']>;
  SpacingBelowMobile?: Maybe<Scalars['String']>;
  ThemeColour: ThemedElementColourType;
  Title?: Maybe<Scalars['String']>;
};

export type EventHighlight = {
  __typename?: 'EventHighlight';
  BackgroundDesktop?: Maybe<LibraryImageFile>;
  BackgroundMobile?: Maybe<LibraryImageFile>;
  ID: Scalars['ID'];
  Title?: Maybe<Scalars['String']>;
};

export type EventItinerary = {
  __typename?: 'EventItinerary';
  Content?: Maybe<Scalars['String']>;
  ID: Scalars['ID'];
  /** List of speakers for this itinerary */
  Speakers: EventSpeakerConnection;
  TimeSlot?: Maybe<Scalars['String']>;
  Title?: Maybe<Scalars['String']>;
};


export type EventItinerarySpeakersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SpeakersSimpleSortFields>;
};

export type EventItineraryModule = ModuleType & {
  __typename?: 'EventItineraryModule';
  AnchorTag?: Maybe<Scalars['String']>;
  Event?: Maybe<EventDetails>;
  ExtraClass?: Maybe<Scalars['String']>;
  ID: Scalars['ID'];
  NavigationLabel?: Maybe<Scalars['String']>;
  SpacingBelow?: Maybe<Scalars['String']>;
  SpacingBelowMobile?: Maybe<Scalars['String']>;
  ThemeColour: ThemedElementColourType;
};

export type EventKeynoteSpeaker = {
  __typename?: 'EventKeynoteSpeaker';
  ID: Scalars['ID'];
  Link?: Maybe<Scalars['String']>;
  Name?: Maybe<Scalars['String']>;
  ProfileImage?: Maybe<LibraryImageFile>;
  Role?: Maybe<Scalars['String']>;
};

export type EventRegisterModule = ModuleType & {
  __typename?: 'EventRegisterModule';
  AnchorTag?: Maybe<Scalars['String']>;
  BackgroundDesktop?: Maybe<LibraryImageFile>;
  BackgroundMobile?: Maybe<LibraryImageFile>;
  Events: EventsConnection;
  ExtraClass?: Maybe<Scalars['String']>;
  ID: Scalars['ID'];
  NavigationLabel?: Maybe<Scalars['String']>;
  SpacingBelow?: Maybe<Scalars['String']>;
  SpacingBelowMobile?: Maybe<Scalars['String']>;
  ThemeColour: ThemedElementColourType;
  Title?: Maybe<Scalars['String']>;
};


export type EventRegisterModuleEventsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<EventsSortFields>;
};

export enum EventRegistrationStatusEnum {
  Active = 'active',
  Closed = 'closed',
  Draft = 'draft',
  Finished = 'finished'
}

export type EventSpeaker = {
  __typename?: 'EventSpeaker';
  ID: Scalars['ID'];
  Name?: Maybe<Scalars['String']>;
  Role?: Maybe<Scalars['String']>;
};

export type EventSpeakerConnection = {
  __typename?: 'EventSpeakerConnection';
  ID: Scalars['String'];
  edges: Array<EventSpeakerConnectionEdge>;
  nodes: Array<EventSpeaker>;
  pageInfo: ApPageInfo;
};

/** The collections edge */
export type EventSpeakerConnectionEdge = {
  __typename?: 'EventSpeakerConnectionEdge';
  /** The node at the end of the collections edge */
  node: EventSpeaker;
};

export type EventTestimonial = {
  __typename?: 'EventTestimonial';
  Author?: Maybe<Scalars['String']>;
  ID: Scalars['ID'];
  Organisation?: Maybe<Scalars['String']>;
  Testimonial?: Maybe<Scalars['String']>;
};

export type EventsConnection = {
  __typename?: 'EventsConnection';
  edges: Array<EventsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type EventsConnectionEdge = {
  __typename?: 'EventsConnectionEdge';
  /** The node at the end of the collections edge */
  node: EventDetails;
};

export type EventsSortFields = {
  SortOrder?: InputMaybe<SortDirection>;
};

export type ExceedLimitError = ErrorInterface & {
  __typename?: 'ExceedLimitError';
  Message: Scalars['String'];
};

export type ExcludedPostcodesConnection = {
  __typename?: 'ExcludedPostcodesConnection';
  edges: Array<ExcludedPostcodesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ExcludedPostcodesConnectionEdge = {
  __typename?: 'ExcludedPostcodesConnectionEdge';
  /** The node at the end of the collections edge */
  node: Postcode;
};

export type ExposedCompanyStatsByIndustryFilters = {
  INDUSTRY_CATEGORY__IN?: InputMaybe<Array<Scalars['String']>>;
  QUARTER_START_DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type ExposedCompanyStatsByIndustrySort = {
  AP_CATEGORY?: InputMaybe<PrioritySort>;
  COMPANIES?: InputMaybe<PrioritySort>;
  CONVERSIONS?: InputMaybe<PrioritySort>;
  IMPRESSIONS?: InputMaybe<PrioritySort>;
  PAGE_VIEWS?: InputMaybe<PrioritySort>;
  SESSIONS?: InputMaybe<PrioritySort>;
  USERS?: InputMaybe<PrioritySort>;
};

export type ExternalLink = {
  __typename?: 'ExternalLink';
  ExternalUrl?: Maybe<Scalars['String']>;
  ID: Scalars['ID'];
  OpenInNew?: Maybe<Scalars['Boolean']>;
  Title?: Maybe<Scalars['String']>;
};

/** Scraped content from an external URL for InspirationItems */
export type ExternalUrlContent = {
  __typename?: 'ExternalUrlContent';
  ContentType: Scalars['String'];
  Description?: Maybe<Scalars['String']>;
  Domain: Scalars['String'];
  ErrorMessage?: Maybe<Scalars['String']>;
  ID: Scalars['ID'];
  ImageUrl?: Maybe<Scalars['String']>;
  IsLocked: Scalars['Boolean'];
  LastScrapedAt?: Maybe<Scalars['String']>;
  ProductBrand?: Maybe<Scalars['String']>;
  ProductCurrency?: Maybe<Scalars['String']>;
  ProductPrice?: Maybe<Scalars['Float']>;
  SourceUrl: Scalars['String'];
  Status: Scalars['String'];
  Title: Scalars['String'];
};

export type FaqSchema = {
  __typename?: 'FAQSchema';
  Answer: Scalars['String'];
  AnswerHTML: Scalars['String'];
  ID: Scalars['Int'];
  Question: Scalars['String'];
  QuestionHTML: Scalars['String'];
};

export type FacebookSocialAd = SocialAd & {
  __typename?: 'FacebookSocialAd';
  Audience: FacebookSocialAdAudience;
  BodyText: Scalars['String'];
  Conversions: FacebookSocialAdConversions;
  Date: Scalars['String'];
  DirectoryItem?: Maybe<DirectoryItem>;
  Engagements: FacebookSocialAdEngagements;
  ExternalID: Scalars['String'];
  ID: Scalars['String'];
  Image: Scalars['String'];
  LocationBreakdown: FacebookSocialAdLocations;
  Performance: FacebookSocialAdPerformance;
  Permalink: Scalars['String'];
  PreviewImage: Scalars['String'];
  PreviewShareableLink: Scalars['String'];
  Thumbnail: Scalars['String'];
  Title: Scalars['String'];
  Top10: Scalars['Boolean'];
  Type: Scalars['String'];
};

export type FacebookSocialAdAudience = {
  __typename?: 'FacebookSocialAdAudience';
  AgeGender: Array<AudienceAgeGender>;
  ID: Scalars['String'];
  Locations: Array<AudienceLocation>;
  Placements: Array<AudiencePlacement>;
};

export type FacebookSocialAdConversions = AdConversions & {
  __typename?: 'FacebookSocialAdConversions';
  Downloads: Scalars['Int'];
  EmailReveals: Scalars['Int'];
  Enquiries: Scalars['Int'];
  ID: Scalars['String'];
  LocationReveals: Scalars['Int'];
  PhoneReveals: Scalars['Int'];
  Referrals: Scalars['Int'];
  Saves: Scalars['Int'];
  Shares: Scalars['Int'];
  TotalPageViews: Scalars['Int'];
  TotalTime: Scalars['Int'];
  VideoPlays: Scalars['Int'];
};

export type FacebookSocialAdEngagements = AdEngagements & {
  __typename?: 'FacebookSocialAdEngagements';
  Comments: Scalars['Int'];
  ID: Scalars['String'];
  Likes: Scalars['Int'];
  Shares: Scalars['Int'];
};

export type FacebookSocialAdLocations = AdLocations & {
  __typename?: 'FacebookSocialAdLocations';
  ID: Scalars['String'];
  Locations: Array<LocationData>;
};

export type FacebookSocialAdPerformance = AdPerformance & {
  __typename?: 'FacebookSocialAdPerformance';
  ClickThroughRate?: Maybe<Scalars['Float']>;
  Clicks: Scalars['Int'];
  EngagementRate?: Maybe<Scalars['Float']>;
  ID: Scalars['String'];
  Impressions: Scalars['Int'];
  Reach: Scalars['Int'];
};

export type FacebookSocialCampaign = SocialAd & {
  __typename?: 'FacebookSocialCampaign';
  Audience: FacebookSocialCampaignAudience;
  BodyText: Scalars['String'];
  CampaignAds: Array<Maybe<FacebookSocialAd>>;
  Conversions: FacebookSocialCampaignConversions;
  Date: Scalars['String'];
  Engagements: FacebookSocialCampaignEngagements;
  ExternalID: Scalars['String'];
  ID: Scalars['String'];
  Image: Scalars['String'];
  Performance: FacebookSocialCampaignPerformance;
  PreviewImage: Scalars['String'];
  PreviewShareableLink: Scalars['String'];
  Thumbnail: Scalars['String'];
  Title: Scalars['String'];
  Top10: Scalars['Boolean'];
  Type: Scalars['String'];
};

export type FacebookSocialCampaignAudience = {
  __typename?: 'FacebookSocialCampaignAudience';
  AgeGender: Array<AudienceAgeGender>;
  ID: Scalars['String'];
  Locations: Array<AudienceLocation>;
  Placements: Array<AudiencePlacement>;
};

export type FacebookSocialCampaignConversions = AdConversions & {
  __typename?: 'FacebookSocialCampaignConversions';
  Downloads: Scalars['Int'];
  EmailReveals: Scalars['Int'];
  Enquiries: Scalars['Int'];
  ID: Scalars['String'];
  LocationReveals: Scalars['Int'];
  PhoneReveals: Scalars['Int'];
  Referrals: Scalars['Int'];
  Saves: Scalars['Int'];
  Shares: Scalars['Int'];
  TotalPageViews: Scalars['Int'];
  TotalTime: Scalars['Int'];
  VideoPlays: Scalars['Int'];
};

export type FacebookSocialCampaignEngagements = AdEngagements & {
  __typename?: 'FacebookSocialCampaignEngagements';
  Comments: Scalars['Int'];
  ID: Scalars['String'];
  Likes: Scalars['Int'];
  Shares: Scalars['Int'];
};

export type FacebookSocialCampaignPerformance = AdPerformance & {
  __typename?: 'FacebookSocialCampaignPerformance';
  ClickThroughRate?: Maybe<Scalars['Float']>;
  Clicks: Scalars['Int'];
  EngagementRate?: Maybe<Scalars['Float']>;
  ID: Scalars['String'];
  Impressions: Scalars['Int'];
  Reach: Scalars['Int'];
};

export type Facet = {
  __typename?: 'Facet';
  AllowInput: Scalars['Boolean'];
  GroupName?: Maybe<Scalars['String']>;
  HideByFlag?: Maybe<Scalars['String']>;
  ID: Scalars['Int'];
  IsAiEnabled: Scalars['Boolean'];
  IsDetailPageDisabled: Scalars['Boolean'];
  IsGeneral: Scalars['Boolean'];
  IsHidden: Scalars['Boolean'];
  IsHighAdminOnly: Scalars['Boolean'];
  IsMultiple: Scalars['Boolean'];
  IsSearchUiDisabled: Scalars['Boolean'];
  Label: Scalars['String'];
  Name?: Maybe<Scalars['String']>;
  Options: Array<FacetOption>;
  ShowByFlag?: Maybe<Scalars['String']>;
  SortOrder: Scalars['Int'];
};


export type FacetOptionsArgs = {
  Approved?: InputMaybe<Scalars['Boolean']>;
  ProductCategoryIDs?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  ProfessionalURLSegment?: InputMaybe<Scalars['String']>;
};

export type FacetOption = {
  __typename?: 'FacetOption';
  Approved: Scalars['Boolean'];
  Facet: Facet;
  FacetID: Scalars['Int'];
  ID: Scalars['Int'];
  Name: Scalars['String'];
  Professional?: Maybe<Professional>;
  SortOrder: Scalars['Int'];
};

export type FeatureBooking = {
  __typename?: 'FeatureBooking';
  Description?: Maybe<Scalars['String']>;
  ID: Scalars['Int'];
  Professional?: Maybe<Professional>;
  ScrollPosY: Scalars['Int'];
  SiteTree?: Maybe<DirectoryItem>;
  StartDate: Scalars['String'];
  Thumbnail?: Maybe<Scalars['String']>;
};

export type FeatureFlag = {
  __typename?: 'FeatureFlag';
  CanToggle: Scalars['Boolean'];
  Enabled: Scalars['Boolean'];
  Name: Scalars['String'];
  Title: Scalars['String'];
  ToggleArgs: Scalars['String'];
};

export type FeatureShowcaseModule = ModuleType & {
  __typename?: 'FeatureShowcaseModule';
  AnchorTag?: Maybe<Scalars['String']>;
  CTA?: Maybe<SiteTreeLink>;
  Content?: Maybe<Scalars['String']>;
  ExtraClass?: Maybe<Scalars['String']>;
  ID: Scalars['ID'];
  Image?: Maybe<ResponsiveVariantImage>;
  NavigationLabel?: Maybe<Scalars['String']>;
  SpacingBelow?: Maybe<Scalars['String']>;
  SpacingBelowMobile?: Maybe<Scalars['String']>;
  ThemeColour: ThemedElementColourType;
  Title?: Maybe<Scalars['String']>;
};

export type FeaturedDirectoryItem = Article | Newsletter | Product | Professional | Project;

export enum FeaturedItemContent {
  Archizeen = 'Archizeen',
  Article = 'Article',
  ExternalLink = 'ExternalLink',
  InternalLink = 'InternalLink',
  Product = 'Product',
  ProductDirectory = 'ProductDirectory',
  Professional = 'Professional',
  ProfessionalDirectory = 'ProfessionalDirectory',
  Project = 'Project',
  ProjectDirectory = 'ProjectDirectory'
}

export type FeaturedItemData = {
  __typename?: 'FeaturedItemData';
  AutoPlay?: Maybe<Scalars['Boolean']>;
  CTAText?: Maybe<Scalars['String']>;
  CountryCode?: Maybe<Scalars['String']>;
  Cover?: Maybe<Scalars['String']>;
  DirectoryHeroFullVideo?: Maybe<Scalars['String']>;
  DirectoryHeroVideoID?: Maybe<Scalars['String']>;
  DirectoryHeroVideoPlatform?: Maybe<Scalars['String']>;
  ID: Scalars['ID'];
  Item?: Maybe<DirectoryItem>;
  LinkContent: FeaturedItemContent;
  LinkURL: Scalars['String'];
  ShortDescription?: Maybe<Scalars['String']>;
  Subtitle?: Maybe<Scalars['String']>;
  Title?: Maybe<Scalars['String']>;
  VideoMp4Url?: Maybe<Scalars['String']>;
  VideoWebMUrl?: Maybe<Scalars['String']>;
};


export type FeaturedItemDataAutoPlayArgs = {
  placement: FeaturedItemPlacement;
};


export type FeaturedItemDataCtaTextArgs = {
  placement: FeaturedItemPlacement;
};


export type FeaturedItemDataCoverArgs = {
  placement: FeaturedItemPlacement;
};


export type FeaturedItemDataVideoMp4UrlArgs = {
  placement: FeaturedItemPlacement;
};


export type FeaturedItemDataVideoWebMUrlArgs = {
  placement: FeaturedItemPlacement;
};

export enum FeaturedItemPlacement {
  DirectoryGrid = 'DirectoryGrid',
  DirectoryHero = 'DirectoryHero',
  Homepage = 'Homepage'
}

export type FeaturedProfessionalsConnection = {
  __typename?: 'FeaturedProfessionalsConnection';
  edges: Array<FeaturedProfessionalsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type FeaturedProfessionalsConnectionEdge = {
  __typename?: 'FeaturedProfessionalsConnectionEdge';
  /** The node at the end of the collections edge */
  node: Professional;
};

export type FeaturedProjectsConnection = {
  __typename?: 'FeaturedProjectsConnection';
  edges: Array<FeaturedProjectsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type FeaturedProjectsConnectionEdge = {
  __typename?: 'FeaturedProjectsConnectionEdge';
  /** The node at the end of the collections edge */
  node: Project;
};

export type FeaturesModule = ModuleType & {
  __typename?: 'FeaturesModule';
  AnchorTag?: Maybe<Scalars['String']>;
  ExtraClass?: Maybe<Scalars['String']>;
  /** List of testimonials */
  Features: Features_Connection;
  ID: Scalars['ID'];
  NavigationLabel?: Maybe<Scalars['String']>;
  PrimaryImage?: Maybe<ResponsiveVariantImage>;
  SecondaryImage?: Maybe<ResponsiveVariantImage>;
  SpacingBelow?: Maybe<Scalars['String']>;
  SpacingBelowMobile?: Maybe<Scalars['String']>;
  ThemeColour: ThemedElementColourType;
  Title?: Maybe<Scalars['String']>;
};


export type FeaturesModuleFeaturesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Features_SortFields>;
};

export type Features_Connection = {
  __typename?: 'Features_Connection';
  edges: Array<Features_ConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type Features_ConnectionEdge = {
  __typename?: 'Features_ConnectionEdge';
  /** The node at the end of the collections edge */
  node: ProductFeature;
};

export type Features_SortFields = {
  SortOrder?: InputMaybe<SortDirection>;
};

/** A message with file attachment(s) and optional text content. */
export type FileAttachmentMessage = Message & {
  __typename?: 'FileAttachmentMessage';
  Attachments: Array<MemberUpload>;
  Content: Scalars['String'];
  Created: Scalars['String'];
  CreatedBy: Scalars['String'];
  FirstReadBy: FirstReadBy;
  ID: Scalars['ID'];
  IsHTML: Scalars['Boolean'];
  MemberEnquiryEmail?: Maybe<MemberEnquiryEmail>;
  Participant: Participant;
};

/** The message to create. Must contain at least one of Content or Attachments. */
export type FileAttachmentMessageInput = {
  /** Attachments to include in the message. */
  Attachments?: InputMaybe<Array<Scalars['Upload']>>;
  /** Text content of the message. */
  Content?: InputMaybe<Scalars['String']>;
  /** Whether the content is HTML or plain text. Defaults to `false`. */
  IsHTML?: InputMaybe<Scalars['Boolean']>;
};

export type FileCategoriesConnection = {
  __typename?: 'FileCategoriesConnection';
  edges: Array<FileCategoriesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type FileCategoriesConnectionEdge = {
  __typename?: 'FileCategoriesConnectionEdge';
  /** The node at the end of the collections edge */
  node: FileCategory;
};

export type FileCategoriesSortFields = {
  SortOrder?: InputMaybe<SortDirection>;
};

export type FileCategory = {
  __typename?: 'FileCategory';
  ID: Scalars['Int'];
  SortOrder: Scalars['Int'];
  Title: Scalars['String'];
};

export enum FindPlaceApiProviderEnum {
  Google = 'google',
  Mapbox = 'mapbox',
  ServiceableArea = 'serviceable_area'
}

export enum FindPlaceTypeEnum {
  Address = 'address',
  All = 'all',
  CheckboxTree = 'checkbox_tree',
  City = 'city',
  CityAndSuburb = 'city_and_suburb',
  Country = 'country',
  District = 'district',
  Division = 'division',
  Place = 'place',
  Postcode = 'postcode',
  Region = 'region',
  SearchFilter = 'search_filter',
  State = 'state',
  Suburb = 'suburb',
  SuburbMixed = 'suburb_mixed'
}

export type FirstReadBy = {
  __typename?: 'FirstReadBy';
  Date: Scalars['String'];
  Identity?: Maybe<Member>;
};

export type FlexibleModule = {
  Columns: ColumnsConnection;
  ContentAreaID: Scalars['Int'];
  CreatedFromID?: Maybe<Scalars['Int']>;
  CreatedFromVersion?: Maybe<Scalars['Int']>;
  DetachedFromSavedModule?: Maybe<Scalars['Boolean']>;
  EcommerceEnabled: Scalars['Boolean'];
  ID: Scalars['Int'];
  LibraryItemID: Scalars['Int'];
  MemberSortOrder: Scalars['Int'];
  ModuleGroup?: Maybe<ModuleGroupEnum>;
  PossibleColumnDimensions: Array<ColumnDimension>;
  PresetName: Scalars['String'];
  PresetType: FlexibleModuleEnum;
  SortableColumns: Scalars['Boolean'];
  Swappable: Scalars['Boolean'];
};


export type FlexibleModuleColumnsArgs = {
  sort?: InputMaybe<ColumnsSortFields>;
};

export enum FlexibleModuleEnum {
  DuoImageModule = 'DuoImageModule',
  DuoParagraphModule = 'DuoParagraphModule',
  ErrorLoadingModule = 'ErrorLoadingModule',
  FullPageImageModule = 'FullPageImageModule',
  FullPageImagesSliderModule = 'FullPageImagesSliderModule',
  HeadingModule = 'HeadingModule',
  HtmlModule = 'HtmlModule',
  ImageParagraphModule = 'ImageParagraphModule',
  InvoiceModule = 'InvoiceModule',
  OctaImageModule = 'OctaImageModule',
  QuadImageModule = 'QuadImageModule',
  QuoteModule = 'QuoteModule',
  SingleImageModule = 'SingleImageModule',
  SingleParagraphModule = 'SingleParagraphModule',
  SingleVideoModule = 'SingleVideoModule',
  TrioImageModule = 'TrioImageModule',
  VideoParagraphModule = 'VideoParagraphModule'
}

export type FlexibleModuleUnion = DuoImageModule | DuoParagraphModule | ErrorLoadingModule | FullPageImageModule | FullPageImagesSliderModule | HeadingModule | HtmlModule | ImageParagraphModule | InvoiceModule | MultiColumnModule | OctaImageModule | QuadImageModule | QuoteModule | SingleImageModule | SingleParagraphModule | SingleVideoModule | TrioImageModule | VideoParagraphModule;

export type FooterLink = {
  __typename?: 'FooterLink';
  title: Scalars['String'];
  url: Scalars['String'];
};

export type FramedPictureCarouselModule = ModuleType & {
  __typename?: 'FramedPictureCarouselModule';
  AnchorTag?: Maybe<Scalars['String']>;
  CTA?: Maybe<SiteTreeLink>;
  ExtraClass?: Maybe<Scalars['String']>;
  /** List picture frame items */
  FramedPictureItems: FramedPictureItems_Connection;
  ID: Scalars['ID'];
  NavigationLabel?: Maybe<Scalars['String']>;
  SpacingBelow?: Maybe<Scalars['String']>;
  SpacingBelowMobile?: Maybe<Scalars['String']>;
  ThemeColour: ThemedElementColourType;
};


export type FramedPictureCarouselModuleFramedPictureItemsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<FramedPictureItems_SortFields>;
};

export type FramedPictureContentModule = ModuleType & {
  __typename?: 'FramedPictureContentModule';
  AnchorTag?: Maybe<Scalars['String']>;
  BackgroundImage?: Maybe<ResponsiveVariantImage>;
  CTA?: Maybe<SiteTreeLink>;
  Content?: Maybe<Scalars['String']>;
  ExtraClass?: Maybe<Scalars['String']>;
  ID: Scalars['ID'];
  Image?: Maybe<ResponsiveVariantImage>;
  Milestones: AboutModule_MilestonesConnection;
  NavigationLabel?: Maybe<Scalars['String']>;
  SpacingBelow?: Maybe<Scalars['String']>;
  SpacingBelowMobile?: Maybe<Scalars['String']>;
  ThemeColour: ThemedElementColourType;
  Title?: Maybe<Scalars['String']>;
};


export type FramedPictureContentModuleMilestonesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<AboutModule_MilestonesSortFields>;
};

export type FramedPictureItem = {
  __typename?: 'FramedPictureItem';
  AnchorTag?: Maybe<Scalars['String']>;
  Content?: Maybe<Scalars['String']>;
  ExtraClass?: Maybe<Scalars['String']>;
  ID: Scalars['ID'];
  Image?: Maybe<ResponsiveVariantImage>;
  NavigationLabel?: Maybe<Scalars['String']>;
  SpacingBelow?: Maybe<Scalars['String']>;
  SpacingBelowMobile?: Maybe<Scalars['String']>;
  ThemeColour: ThemedElementColourType;
  Title?: Maybe<Scalars['String']>;
};

export type FramedPictureItems_Connection = {
  __typename?: 'FramedPictureItems_Connection';
  edges: Array<FramedPictureItems_ConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type FramedPictureItems_ConnectionEdge = {
  __typename?: 'FramedPictureItems_ConnectionEdge';
  /** The node at the end of the collections edge */
  node: FramedPictureItem;
};

export type FramedPictureItems_SortFields = {
  SortOrder?: InputMaybe<SortDirection>;
};

export type FreeDayType = {
  __typename?: 'FreeDayType';
  date: Scalars['String'];
  freeSlots: Array<FreeSlotType>;
};

export type FreeDaysByDurationType = {
  __typename?: 'FreeDaysByDurationType';
  duration: Scalars['Int'];
  freeDays: Array<TimezoneFreeDaysType>;
};

export type FreeSlotType = {
  __typename?: 'FreeSlotType';
  availableMembers: Array<AvailableMemberType>;
  label: Scalars['String'];
  timestamp: Scalars['Float'];
};

export type FullPageImageModule = FlexibleModule & {
  __typename?: 'FullPageImageModule';
  Columns: ColumnsConnection;
  ContentAreaID: Scalars['Int'];
  CreatedFromID?: Maybe<Scalars['Int']>;
  CreatedFromVersion?: Maybe<Scalars['Int']>;
  DetachedFromSavedModule?: Maybe<Scalars['Boolean']>;
  EcommerceEnabled: Scalars['Boolean'];
  ID: Scalars['Int'];
  LibraryItemID: Scalars['Int'];
  MemberSortOrder: Scalars['Int'];
  ModuleGroup?: Maybe<ModuleGroupEnum>;
  PossibleColumnDimensions: Array<ColumnDimension>;
  PresetName: Scalars['String'];
  PresetType: FlexibleModuleEnum;
  SortableColumns: Scalars['Boolean'];
  Swappable: Scalars['Boolean'];
};


export type FullPageImageModuleColumnsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<ColumnsSortFields>;
};

export type FullPageImagesSliderModule = FlexibleModule & {
  __typename?: 'FullPageImagesSliderModule';
  Columns: ColumnsConnection;
  ContentAreaID: Scalars['Int'];
  CreatedFromID?: Maybe<Scalars['Int']>;
  CreatedFromVersion?: Maybe<Scalars['Int']>;
  DetachedFromSavedModule?: Maybe<Scalars['Boolean']>;
  EcommerceEnabled: Scalars['Boolean'];
  ID: Scalars['Int'];
  LibraryItemID: Scalars['Int'];
  MemberSortOrder: Scalars['Int'];
  ModuleGroup?: Maybe<ModuleGroupEnum>;
  PossibleColumnDimensions: Array<ColumnDimension>;
  PresetName: Scalars['String'];
  PresetType: FlexibleModuleEnum;
  SortableColumns: Scalars['Boolean'];
  Swappable: Scalars['Boolean'];
};


export type FullPageImagesSliderModuleColumnsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<ColumnsSortFields>;
};

/** Funnel Stage Info. */
export type FunnelStage = {
  __typename?: 'FunnelStage';
  Code: Scalars['String'];
  ID: Scalars['ID'];
  Title: Scalars['String'];
  UserScore: Scalars['Int'];
};

export type GaAgeGroup = {
  __typename?: 'GAAgeGroup';
  From18To24: Scalars['Int'];
  From25To34: Scalars['Int'];
  From35To44: Scalars['Int'];
  From45To54: Scalars['Int'];
  From55To64: Scalars['Int'];
  ID: Scalars['String'];
  Over65: Scalars['Int'];
};

export type GaDailyItem = {
  __typename?: 'GADailyItem';
  Date: Scalars['String'];
  Value: Scalars['Float'];
};

export enum GaDailyItemEnum {
  Clicks = 'Clicks',
  Ctr = 'Ctr',
  Impressions = 'Impressions'
}

export type GaSummary = {
  __typename?: 'GASummary';
  AgeGroup: GaAgeGroup;
  AvgImpressions: Scalars['Float'];
  BucketID: Scalars['String'];
  Clicks: Scalars['Int'];
  Ctr: Scalars['Float'];
  From: Scalars['String'];
  ID: Scalars['String'];
  Impressions: Scalars['Int'];
  IndexedPages: Scalars['Int'];
  Name: Scalars['String'];
  Position: Scalars['Float'];
  ProfessionalID: Scalars['Int'];
  Sessions: Scalars['Int'];
  To: Scalars['String'];
  TopSearchQueries: Array<GaTopQuery>;
};

export type GaTopPerformingItem = {
  __typename?: 'GATopPerformingItem';
  AvgImpressions: Scalars['Float'];
  BucketID: Scalars['String'];
  Clicks: Scalars['Int'];
  Ctr: Scalars['Float'];
  From: Scalars['String'];
  ID: Scalars['String'];
  Impressions: Scalars['Int'];
  Name: Scalars['String'];
  Position: Scalars['Float'];
  ProfessionalID: Scalars['Int'];
  Sessions: Scalars['Int'];
  To: Scalars['String'];
  URL: Scalars['String'];
};

export type GaTopPerformingList = {
  __typename?: 'GATopPerformingList';
  ID: Scalars['String'];
  /** Collection of records */
  nodes: Array<GaTopPerformingItem>;
  pageInfo: ApPageInfo;
};

export enum GaTopPerformingSortBy {
  AvgImpressions = 'AvgImpressions',
  Clicks = 'Clicks',
  Ctr = 'Ctr',
  Impression = 'Impression',
  Sessions = 'Sessions'
}

export type GaTopQuery = {
  __typename?: 'GATopQuery';
  Clicks: Scalars['Int'];
  Impressions: Scalars['Int'];
  Keyword: Scalars['String'];
};

export type GalleryModule = ModuleType & {
  __typename?: 'GalleryModule';
  AnchorTag?: Maybe<Scalars['String']>;
  ExtraClass?: Maybe<Scalars['String']>;
  ID: Scalars['ID'];
  Images: Images_Connection;
  NavigationLabel?: Maybe<Scalars['String']>;
  SpacingBelow?: Maybe<Scalars['String']>;
  SpacingBelowMobile?: Maybe<Scalars['String']>;
  ThemeColour: ThemedElementColourType;
  Thumbnails: Thumbnails_Connection;
  Title?: Maybe<Scalars['String']>;
  UseSliderLayoutOnMobile: Scalars['Boolean'];
};


export type GalleryModuleImagesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Images_SortFields>;
};


export type GalleryModuleThumbnailsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Thumbnails_SortFields>;
};

export type GeneratedExternalLink = {
  __typename?: 'GeneratedExternalLink';
  Suffix: Scalars['String'];
  Url: Scalars['String'];
};

export type GeneratedExternalLinkInput = {
  /** Source external url to be resolvable against the professional */
  URL: Scalars['String'];
  /** Professional to resolve the url to */
  URLSegment: Scalars['String'];
  /** Add UTM campaign */
  UTMCampaign?: InputMaybe<Scalars['String']>;
  /** Add UTM medium */
  UTMMedium?: InputMaybe<Scalars['String']>;
  /** Add UTM source */
  UTMSource?: InputMaybe<Scalars['String']>;
};

export type GenericNotification = WebsiteNotificationInterface & {
  __typename?: 'GenericNotification';
  Action: WebsiteNotificationAction;
  CreatedAt: Scalars['String'];
  CreatedBy: Member;
  ID: Scalars['ID'];
  IsRead: Scalars['Boolean'];
  LastEdited: Scalars['String'];
  Link?: Maybe<Scalars['String']>;
  Message: Scalars['String'];
  PhotoTileURL?: Maybe<Scalars['String']>;
};

export type GetProductInstallersSimpleSortFields = {
  ID?: InputMaybe<SortDirection>;
  URLSegment?: InputMaybe<SortDirection>;
};

export type GetProductInstallers_Connection = {
  __typename?: 'GetProductInstallers_Connection';
  ID: Scalars['String'];
  edges: Array<GetProductInstallers_ConnectionEdge>;
  nodes: Array<Professional>;
  pageInfo: ApPageInfo;
};

/** The collections edge */
export type GetProductInstallers_ConnectionEdge = {
  __typename?: 'GetProductInstallers_ConnectionEdge';
  /** The node at the end of the collections edge */
  node: Professional;
};

export type GetProductsCsvInputType = {
  Filters?: InputMaybe<Array<ListDirectoryItemsFilter>>;
  Professional: Scalars['String'];
  Title?: InputMaybe<Scalars['String']>;
};

export type GoogleAnalytics = {
  __typename?: 'GoogleAnalytics';
  DailyItems: Array<GaDailyItem>;
  Domain: Scalars['String'];
  ID: Scalars['ID'];
  Summary: GaSummary;
  TopPerforming: GaTopPerformingList;
};


export type GoogleAnalyticsDailyItemsArgs = {
  Type: GaDailyItemEnum;
};


export type GoogleAnalyticsTopPerformingArgs = {
  Limit?: InputMaybe<Scalars['Int']>;
  Page?: InputMaybe<Scalars['Int']>;
  SortBy?: InputMaybe<GaTopPerformingSortBy>;
};

export type GoogleSeoArchiproIndexFilters = {
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type GoogleSeoBreakdownFilters = {
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type GoogleSeoPieChartFilters = {
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type GoogleSeoSummaryFilters = {
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type GoogleSeoTopPageFilters = {
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type GoogleSeoTopPageSort = {
  BRAND_IMPRESSIONS?: InputMaybe<PrioritySort>;
  CLICKS?: InputMaybe<PrioritySort>;
  SESSIONS?: InputMaybe<PrioritySort>;
};

export type GoogleSeoTopSearchFilters = {
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type GoogleSeoTopSearchSort = {
  CLICKS?: InputMaybe<PrioritySort>;
  IMPRESSIONS?: InputMaybe<PrioritySort>;
};

export type GraphPoint = {
  __typename?: 'GraphPoint';
  Data: Scalars['Int'];
  Date: Scalars['String'];
  ID: Scalars['String'];
  PromotionalSpikeDetails?: Maybe<PromotionalSpikeDetails>;
};

export type GraphSegment = {
  __typename?: 'GraphSegment';
  Data: Scalars['Int'];
  ID: Scalars['String'];
  Range: Scalars['String'];
};

export type Guest = User & {
  __typename?: 'Guest';
  APID: Scalars['String'];
  DesignBoard: DesignBoardResult;
  DesignBoards: ListDesignBoards_Connection;
  DesignBoardsPins: DesignBoardPinsConnection;
  EcommerceBookingURL: Scalars['String'];
  Enrichment?: Maybe<Scalars['String']>;
  FeatureFlags: Array<FeatureFlag>;
  ID: Scalars['Int'];
  ShoppingCart?: Maybe<ShoppingCart>;
};


export type GuestDesignBoardArgs = {
  Link: Scalars['String'];
};


export type GuestDesignBoardsArgs = {
  filter?: InputMaybe<DesignBoardsFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<DesignBoardsSimpleSortFields>;
};


export type GuestDesignBoardsPinsArgs = {
  filter?: InputMaybe<DesignBoardsPinsFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<DesignBoardsPinsSimpleSortFields>;
};

export type GuestHeroSlide = {
  __typename?: 'GuestHeroSlide';
  BackgroundImage?: Maybe<ResponsiveVariantImage>;
  Content?: Maybe<Scalars['String']>;
  ID: Scalars['ID'];
  MobileScrollingEffect: Scalars['Boolean'];
  PrimaryCTA?: Maybe<SiteTreeLink>;
  SecondaryCTA?: Maybe<SiteTreeLink>;
  Title?: Maybe<Scalars['String']>;
};

export type GuestHomeHeroModule = ModuleType & {
  __typename?: 'GuestHomeHeroModule';
  AnchorTag?: Maybe<Scalars['String']>;
  ExtraClass?: Maybe<Scalars['String']>;
  ID: Scalars['ID'];
  NavigationLabel?: Maybe<Scalars['String']>;
  ShowWelcomeMessage: Scalars['Boolean'];
  Slides: Module_GuestHeroSlidesConnection;
  SpacingBelow?: Maybe<Scalars['String']>;
  SpacingBelowMobile?: Maybe<Scalars['String']>;
  ThemeColour: ThemedElementColourType;
};


export type GuestHomeHeroModuleSlidesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Module_GuestHeroSlidesSortFields>;
};

export type GuestHomePage = {
  __typename?: 'GuestHomePage';
  ID: Scalars['ID'];
  MetaData: Meta;
  Modules: Array<ModuleType>;
  PageBackgroundColor?: Maybe<Scalars['String']>;
  PageTheme: ModulePageThemeEnum;
};

export type HasPaintPartner = {
  PaintPartner?: Maybe<PaintPartner>;
};

export type HeadingModule = FlexibleModule & {
  __typename?: 'HeadingModule';
  Columns: ColumnsConnection;
  ContentAreaID: Scalars['Int'];
  CreatedFromID?: Maybe<Scalars['Int']>;
  CreatedFromVersion?: Maybe<Scalars['Int']>;
  DetachedFromSavedModule?: Maybe<Scalars['Boolean']>;
  EcommerceEnabled: Scalars['Boolean'];
  ID: Scalars['Int'];
  LibraryItemID: Scalars['Int'];
  MemberSortOrder: Scalars['Int'];
  ModuleGroup?: Maybe<ModuleGroupEnum>;
  PossibleColumnDimensions: Array<ColumnDimension>;
  PresetName: Scalars['String'];
  PresetType: FlexibleModuleEnum;
  SortableColumns: Scalars['Boolean'];
  Swappable: Scalars['Boolean'];
};


export type HeadingModuleColumnsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<ColumnsSortFields>;
};

export type HeadingTextModule = ModuleType & {
  __typename?: 'HeadingTextModule';
  AnchorTag?: Maybe<Scalars['String']>;
  ExtraClass?: Maybe<Scalars['String']>;
  HeadingLevel?: Maybe<Scalars['String']>;
  ID: Scalars['ID'];
  NavigationLabel?: Maybe<Scalars['String']>;
  SpacingBelow?: Maybe<Scalars['String']>;
  SpacingBelowMobile?: Maybe<Scalars['String']>;
  ThemeColour: ThemedElementColourType;
  Title?: Maybe<Scalars['String']>;
};

export type HighlightsModule = ModuleType & {
  __typename?: 'HighlightsModule';
  AnchorTag?: Maybe<Scalars['String']>;
  ExtraClass?: Maybe<Scalars['String']>;
  /** List of event highlights */
  Highlights: Highlights_Connection;
  ID: Scalars['ID'];
  NavigationLabel?: Maybe<Scalars['String']>;
  SpacingBelow?: Maybe<Scalars['String']>;
  SpacingBelowMobile?: Maybe<Scalars['String']>;
  ThemeColour: ThemedElementColourType;
};


export type HighlightsModuleHighlightsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Highlights_SortFields>;
};

export type Highlights_Connection = {
  __typename?: 'Highlights_Connection';
  edges: Array<Highlights_ConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type Highlights_ConnectionEdge = {
  __typename?: 'Highlights_ConnectionEdge';
  /** The node at the end of the collections edge */
  node: EventHighlight;
};

export type Highlights_SortFields = {
  SortOrder?: InputMaybe<SortDirection>;
};

/** Call-to-action button configuration with text and link */
export type HomeCtaData = {
  __typename?: 'HomeCTAData';
  /** URL or path that the CTA button links to */
  link?: Maybe<Scalars['String']>;
  /** Text to display on the CTA button */
  text?: Maybe<Scalars['String']>;
};

/** Content for the Essential Guides for your Project section on the homepage */
export type HomeContentCampaign = {
  __typename?: 'HomeContentCampaign';
  /** URL for the section background image */
  backgroundImage?: Maybe<Scalars['String']>;
  /** Call-to-action button configuration */
  cta?: Maybe<HomeCtaData>;
  /** Section description text */
  description: Scalars['String'];
  /** Array of guide items displayed in this section */
  guides?: Maybe<Array<Maybe<MarketingGuideItem>>>;
  /** Section title */
  title: Scalars['String'];
};

/** Content for the homepage hero section, which is the first section of the homepage on the top of the page */
export type HomeHeroData = {
  __typename?: 'HomeHeroData';
  /** 2-letter country code for the hero data (e.g., NZ, AU) */
  countryCode?: Maybe<Scalars['String']>;
  /** Call-to-action button configuration */
  cta?: Maybe<HomeCtaData>;
  /** Additional descriptive text */
  description?: Maybe<Scalars['String']>;
  /** URL for the hero section background image */
  image?: Maybe<Scalars['String']>;
  /** Text displayed before the rotating content */
  prefix: Scalars['String'];
  /** Array of text elements that rotate in the display */
  rotateTexts?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Text displayed after the rotating content */
  suffix?: Maybe<Scalars['String']>;
  /** Video configuration for this section */
  video?: Maybe<HomeVideoData>;
};

/** Content for the homepage introduction section, which is the second section of the homepage on the top of the page */
export type HomeIntroData = {
  __typename?: 'HomeIntroData';
  /** Call-to-action button configuration */
  cta?: Maybe<HomeCtaData>;
  /** Descriptive text content below the title */
  description?: Maybe<Scalars['String']>;
  /** Array of bullet points or list items */
  listItems?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Main title text (HTML supported) */
  title: Scalars['String'];
  /** Video configuration for this section */
  video?: Maybe<HomeVideoData>;
};

/** Content for the homepage media section, which is the third section of the homepage on the top of the page */
export type HomeMediaData = {
  __typename?: 'HomeMediaData';
  /** Call-to-action button configuration */
  cta?: Maybe<HomeCtaData>;
  /** Descriptive text content */
  description?: Maybe<Scalars['String']>;
  /** Main title text (HTML supported) */
  title: Scalars['String'];
  /** Video configuration for this section */
  video?: Maybe<HomeVideoData>;
};

export type HomePage = {
  __typename?: 'HomePage';
  HomePins: HomePinsConnection;
  LastPublishedArticles: Array<Article>;
  ProjectsOfTheMonth: Array<Project>;
  TopProducts: Array<Product>;
  TrendingProfessionals: Array<Professional>;
};


export type HomePageHomePinsArgs = {
  filter?: InputMaybe<HomePinsFilters>;
  filters?: InputMaybe<HomePinsFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<HomePinsSortFields>;
};

export enum HomePinFilter {
  Article = 'Article',
  Product = 'Product',
  Professional = 'Professional',
  Project = 'Project'
}

export type HomePinItem = DataObject & {
  __typename?: 'HomePinItem';
  ID: Scalars['ID'];
  Item: Item;
  id: Scalars['ID'];
};

export type HomePinToggleResultType = Article | ExceedLimitError | NotAuthorizedError | Product | Professional | Project | UserError;

export type HomePinsConnection = {
  __typename?: 'HomePinsConnection';
  edges: Array<HomePinsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type HomePinsConnectionEdge = {
  __typename?: 'HomePinsConnectionEdge';
  /** The node at the end of the collections edge */
  node: HomePinItem;
};

export type HomePinsFilters = {
  /** Filters this type when ItemType is eq the provided value */
  ItemType__eq?: InputMaybe<HomePinFilter>;
};

export type HomePinsSortFields = {
  Created?: InputMaybe<SortDirection>;
};

/** Video configuration data supporting both MP4 and WebM formats, with separate mobile and desktop versions */
export type HomeVideoData = {
  __typename?: 'HomeVideoData';
  /** Whether the video should autoplay */
  autoplay?: Maybe<Scalars['Boolean']>;
  /** Whether the video should loop */
  loop?: Maybe<Scalars['Boolean']>;
  /** URL for the video cover image */
  videoCover?: Maybe<Scalars['String']>;
  /** URL for the MP4 format video */
  videoMp4?: Maybe<Scalars['String']>;
  /** URL for the WebM format video */
  videoWebM?: Maybe<Scalars['String']>;
};

export type HomeownerBudget = DataObject & {
  __typename?: 'HomeownerBudget';
  ID: Scalars['Int'];
  SortOrder: Scalars['Int'];
  Title: Scalars['String'];
  id: Scalars['ID'];
};

export type HomeownerBudgetConnection = {
  __typename?: 'HomeownerBudgetConnection';
  edges: Array<HomeownerBudgetConnectionEdge>;
  nodes: Array<HomeownerBudget>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type HomeownerBudgetConnectionEdge = {
  __typename?: 'HomeownerBudgetConnectionEdge';
  /** The node at the end of the collections edge */
  node: HomeownerBudget;
};

export type HomeownerPurpose = DataObject & {
  __typename?: 'HomeownerPurpose';
  ID: Scalars['Int'];
  SortOrder: Scalars['Int'];
  Title: Scalars['String'];
  id: Scalars['ID'];
};

export type HomeownerPurposeConnection = {
  __typename?: 'HomeownerPurposeConnection';
  edges: Array<HomeownerPurposeConnectionEdge>;
  nodes: Array<HomeownerPurpose>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type HomeownerPurposeConnectionEdge = {
  __typename?: 'HomeownerPurposeConnectionEdge';
  /** The node at the end of the collections edge */
  node: HomeownerPurpose;
};

export type HomeownerStage = DataObject & {
  __typename?: 'HomeownerStage';
  ID: Scalars['Int'];
  SortOrder: Scalars['Int'];
  Title: Scalars['String'];
  id: Scalars['ID'];
};

export type HomeownerStageConnection = {
  __typename?: 'HomeownerStageConnection';
  edges: Array<HomeownerStageConnectionEdge>;
  nodes: Array<HomeownerStage>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type HomeownerStageConnectionEdge = {
  __typename?: 'HomeownerStageConnectionEdge';
  /** The node at the end of the collections edge */
  node: HomeownerStage;
};

export type HostedVideoModule = ModuleType & {
  __typename?: 'HostedVideoModule';
  AnchorTag?: Maybe<Scalars['String']>;
  AutoPlay?: Maybe<Scalars['Boolean']>;
  AutoPlayRedirect?: Maybe<Scalars['String']>;
  AutoPlayRedirectRequireLogin?: Maybe<Scalars['Boolean']>;
  ExtraClass?: Maybe<Scalars['String']>;
  ID: Scalars['ID'];
  NavigationLabel?: Maybe<Scalars['String']>;
  SpacingBelow?: Maybe<Scalars['String']>;
  SpacingBelowMobile?: Maybe<Scalars['String']>;
  ThemeColour: ThemedElementColourType;
  Title?: Maybe<Scalars['String']>;
  VideoCover?: Maybe<ResponsiveVariantImage>;
  VideoMp4Url?: Maybe<Scalars['String']>;
  VideoWebMUrl?: Maybe<Scalars['String']>;
};

export type HtmlColumn = ModuleColumn & SortableItem & {
  __typename?: 'HtmlColumn';
  HtmlContent?: Maybe<Scalars['String']>;
  ID: Scalars['Int'];
  IsEmpty: Scalars['Boolean'];
  MemberSortOrder: Scalars['Int'];
  ModuleID: Scalars['Int'];
  ParsedContent?: Maybe<Scalars['String']>;
  ReadOnly: Scalars['Boolean'];
  WordCount: Scalars['Int'];
};

export type HtmlModule = FlexibleModule & {
  __typename?: 'HtmlModule';
  Columns: ColumnsConnection;
  ContentAreaID: Scalars['Int'];
  CreatedFromID?: Maybe<Scalars['Int']>;
  CreatedFromVersion?: Maybe<Scalars['Int']>;
  DetachedFromSavedModule?: Maybe<Scalars['Boolean']>;
  EcommerceEnabled: Scalars['Boolean'];
  ID: Scalars['Int'];
  LibraryItemID: Scalars['Int'];
  MemberSortOrder: Scalars['Int'];
  ModuleGroup?: Maybe<ModuleGroupEnum>;
  PossibleColumnDimensions: Array<ColumnDimension>;
  PresetName: Scalars['String'];
  PresetType: FlexibleModuleEnum;
  SortableColumns: Scalars['Boolean'];
  Swappable: Scalars['Boolean'];
};


export type HtmlModuleColumnsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<ColumnsSortFields>;
};

export type HubspotCompany = {
  __typename?: 'HubspotCompany';
  HubspotID: Scalars['String'];
  ID: Scalars['String'];
  Name: Scalars['String'];
  Professional?: Maybe<Professional>;
};

export type HubspotContextInput = {
  hutk?: InputMaybe<Scalars['StringInput']>;
  pageName: Scalars['StringInput'];
  pageUri: Scalars['StringInput'];
};

export type IApprovable = {
  ApprovedByMember?: Maybe<Member>;
  ApprovedDate?: Maybe<Scalars['String']>;
};


export type IApprovableApprovedDateArgs = {
  format?: InputMaybe<DateFormatEnum>;
};

export type ICategory = {
  CustomSeoOnFilters?: Maybe<Scalars['Boolean']>;
  ID: Scalars['Int'];
  /** Clear cut Image */
  Image?: Maybe<ResponsiveImage>;
  IsPublished?: Maybe<Scalars['Boolean']>;
  Link: Scalars['String'];
  MenuTitle: Scalars['String'];
  Parent?: Maybe<ICategory>;
  PrettyTitle: Scalars['String'];
  /** Clear cut Image */
  Thumbnail?: Maybe<ResponsiveImage>;
  Title: Scalars['String'];
  URLSegment?: Maybe<Scalars['String']>;
};


export type ICategoryImageArgs = {
  Height?: InputMaybe<Scalars['Int']>;
  Width?: InputMaybe<Scalars['Int']>;
};


export type ICategoryThumbnailArgs = {
  Height?: InputMaybe<Scalars['Int']>;
  Width?: InputMaybe<Scalars['Int']>;
};

export type ICreatable = {
  CreatedByMember?: Maybe<Member>;
  CreatedDate?: Maybe<Scalars['String']>;
};


export type ICreatableCreatedDateArgs = {
  format?: InputMaybe<DateFormatEnum>;
};

export type IFileCategory = {
  FileCategories: FileCategoriesConnection;
};


export type IFileCategoryFileCategoriesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<FileCategoriesSortFields>;
};

export type IHasItems = {
  /** Items count for the given zone */
  ItemsCount: Scalars['Int'];
};


export type IHasItemsItemsCountArgs = {
  Zone?: InputMaybe<SupportedCountry>;
};

export type IHasProfessional = {
  Professional?: Maybe<Professional>;
};

export type IHomePinable = {
  HomePinned: Scalars['Boolean'];
};

export type IPublishable = {
  PublishDate?: Maybe<Scalars['String']>;
  PublishedByMember?: Maybe<Member>;
};


export type IPublishablePublishDateArgs = {
  format?: InputMaybe<DateFormatEnum>;
};

export type IRecentlyViewedTile = {
  RecentlyViewedImage?: Maybe<RecentlyViewedImage>;
};

export type IframeEmbedModule = ModuleType & {
  __typename?: 'IframeEmbedModule';
  AnchorTag?: Maybe<Scalars['String']>;
  EmbedLink?: Maybe<Scalars['String']>;
  ExtraClass?: Maybe<Scalars['String']>;
  FrameHeight?: Maybe<Scalars['Int']>;
  ID: Scalars['ID'];
  NavigationLabel?: Maybe<Scalars['String']>;
  SpacingBelow?: Maybe<Scalars['String']>;
  SpacingBelowMobile?: Maybe<Scalars['String']>;
  ThemeColour: ThemedElementColourType;
  Title?: Maybe<Scalars['String']>;
};

export type ImageBannerModule = ModuleType & {
  __typename?: 'ImageBannerModule';
  AnchorTag?: Maybe<Scalars['String']>;
  BottomBackgroundTheme?: Maybe<Scalars['String']>;
  DesktopImage?: Maybe<LibraryImageFile>;
  ExtraClass?: Maybe<Scalars['String']>;
  ID: Scalars['ID'];
  MobileImage?: Maybe<LibraryImageFile>;
  NavigationLabel?: Maybe<Scalars['String']>;
  Offset?: Maybe<Scalars['String']>;
  SpacingBelow?: Maybe<Scalars['String']>;
  SpacingBelowMobile?: Maybe<Scalars['String']>;
  ThemeColour: ThemedElementColourType;
  Title?: Maybe<Scalars['String']>;
  TopBackgroundTheme?: Maybe<Scalars['String']>;
  UseDesktopForMobile: Scalars['Boolean'];
};

export type ImageCarouselItem = {
  __typename?: 'ImageCarouselItem';
  CaptionOne?: Maybe<Scalars['String']>;
  CaptionTwo?: Maybe<Scalars['String']>;
  ID: Scalars['ID'];
  Image?: Maybe<ResponsiveVariantImage>;
  ImageAspect?: Maybe<Scalars['String']>;
};

export type ImageCenterResultType = AiImage | NotAuthorizedError | ServerError | UserError;

export type ImageColumn = ModuleColumn & SortableItem & {
  __typename?: 'ImageColumn';
  ColumnDimension?: Maybe<ColumnDimension>;
  ID: Scalars['Int'];
  Image?: Maybe<LibraryImage>;
  IsEmpty: Scalars['Boolean'];
  MemberSortOrder: Scalars['Int'];
  ModuleID: Scalars['Int'];
  ProductID?: Maybe<Scalars['Int']>;
  ReadOnly: Scalars['Boolean'];
  ResponsiveImage?: Maybe<ResponsiveImage>;
  WordCount: Scalars['Int'];
};

export type ImageDeletionResult = {
  __typename?: 'ImageDeletionResult';
  ID: Scalars['Int'];
  Success: Scalars['Boolean'];
};

export type ImageDimension = {
  __typename?: 'ImageDimension';
  Height: Scalars['Int'];
  Width: Scalars['Int'];
};

export type ImageExportCreateInputType = {
  DirectoryType: DirectoryItemEnumType;
  Filters?: InputMaybe<Array<ListDirectoryItemsFilter>>;
  Professional: Scalars['StringInput'];
  Title?: InputMaybe<Scalars['StringInput']>;
};

export type ImageExportCreateResult = NotAuthenticatedError | NotAuthorizedError | NotFoundError | ServerError | UserError;

export type ImageParagraphModule = FlexibleModule & {
  __typename?: 'ImageParagraphModule';
  Columns: ColumnsConnection;
  ContentAreaID: Scalars['Int'];
  CreatedFromID?: Maybe<Scalars['Int']>;
  CreatedFromVersion?: Maybe<Scalars['Int']>;
  DetachedFromSavedModule?: Maybe<Scalars['Boolean']>;
  EcommerceEnabled: Scalars['Boolean'];
  ID: Scalars['Int'];
  LibraryItemID: Scalars['Int'];
  MemberSortOrder: Scalars['Int'];
  ModuleGroup?: Maybe<ModuleGroupEnum>;
  PossibleColumnDimensions: Array<ColumnDimension>;
  PresetName: Scalars['String'];
  PresetType: FlexibleModuleEnum;
  SortableColumns: Scalars['Boolean'];
  Swappable: Scalars['Boolean'];
};


export type ImageParagraphModuleColumnsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<ColumnsSortFields>;
};

export type ImageRemoveBackgroundResultType = AiImage | NotAuthorizedError | ServerError | UserError;

export type ImageTextCarouselModule = ModuleType & {
  __typename?: 'ImageTextCarouselModule';
  AnchorTag?: Maybe<Scalars['String']>;
  ExtraClass?: Maybe<Scalars['String']>;
  ID: Scalars['ID'];
  ImageCarouselItems: Module_ImageCarouselItemsConnection;
  NavigationLabel?: Maybe<Scalars['String']>;
  Orientation: Scalars['String'];
  SlimImageColumn: Scalars['Boolean'];
  SpacingBelow?: Maybe<Scalars['String']>;
  SpacingBelowMobile?: Maybe<Scalars['String']>;
  TextCarouselItems: Module_TextCarouselItemsConnection;
  ThemeColour: ThemedElementColourType;
};


export type ImageTextCarouselModuleImageCarouselItemsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Module_ImageCarouselItemsSortFields>;
};


export type ImageTextCarouselModuleTextCarouselItemsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Module_TextCarouselItemsSortFields>;
};

export type ImageUpscaleResultType = AiImage | NotAuthorizedError | ServerError | UserError;

export type Images_Connection = {
  __typename?: 'Images_Connection';
  edges: Array<Images_ConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type Images_ConnectionEdge = {
  __typename?: 'Images_ConnectionEdge';
  /** The node at the end of the collections edge */
  node: LibraryImageFile;
};

export type Images_SortFields = {
  SortOrder?: InputMaybe<SortDirection>;
};

/** A order dispatch to be imported */
export type ImportDispatch = {
  ID: Scalars['StringInput'];
  OrderItems: Array<ImportOrderItem>;
  ShippingProvider?: InputMaybe<Scalars['StringInput']>;
  TrackingURL?: InputMaybe<Scalars['StringInput']>;
};

/** The format of an imported download */
export type ImportDownload = {
  Category?: InputMaybe<Scalars['StringInput']>;
  Title?: InputMaybe<Scalars['StringInput']>;
  Url: Scalars['StringInput'];
};

export type ImportError = {
  __typename?: 'ImportError';
  Error: Scalars['String'];
  Reference?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
  Title?: Maybe<Scalars['String']>;
};

export type ImportMap = {
  __typename?: 'ImportMap';
  Fields: Array<ImportMapField>;
  Professional: Scalars['String'];
};

export type ImportMapField = {
  __typename?: 'ImportMapField';
  Source: Scalars['String'];
  Target: Scalars['String'];
};

export type ImportMapFieldInput = {
  Source: Scalars['String'];
  Target: Scalars['String'];
};

/** A order to be imported */
export type ImportOrder = {
  CancelReason?: InputMaybe<Scalars['StringInput']>;
  Dispatches: Array<ImportDispatch>;
  OrderItems: Array<ImportOrderItem>;
  OrderNumber: Scalars['StringInput'];
};

/** A order item to be imported */
export type ImportOrderItem = {
  Quantity: Scalars['Int'];
  SKU: Scalars['StringInput'];
  Status?: InputMaybe<Scalars['StringInput']>;
  SupplierVariantID?: InputMaybe<Scalars['StringInput']>;
  VariantDescription?: InputMaybe<Scalars['StringInput']>;
};

/** The result of a order import */
export type ImportOrderResult = {
  __typename?: 'ImportOrderResult';
  Error?: Maybe<Scalars['String']>;
  Success: Scalars['Boolean'];
};

/** A product to be imported */
export type ImportProduct = {
  Archived?: InputMaybe<Scalars['StringInput']>;
  Categories?: InputMaybe<Array<InputMaybe<Scalars['StringInput']>>>;
  CustomSectionLabel1?: InputMaybe<Scalars['StringInput']>;
  CustomSectionLabel2?: InputMaybe<Scalars['StringInput']>;
  CustomSectionLabel3?: InputMaybe<Scalars['StringInput']>;
  CustomSectionLabel4?: InputMaybe<Scalars['StringInput']>;
  CustomSectionLabel5?: InputMaybe<Scalars['StringInput']>;
  CustomSectionValue1?: InputMaybe<Scalars['StringInput']>;
  CustomSectionValue2?: InputMaybe<Scalars['StringInput']>;
  CustomSectionValue3?: InputMaybe<Scalars['StringInput']>;
  CustomSectionValue4?: InputMaybe<Scalars['StringInput']>;
  CustomSectionValue5?: InputMaybe<Scalars['StringInput']>;
  Delete?: InputMaybe<Scalars['StringInput']>;
  Description?: InputMaybe<Scalars['StringInput']>;
  Designer?: InputMaybe<Scalars['StringInput']>;
  DimensionDiagrams?: InputMaybe<Array<Scalars['StringInput']>>;
  ExcludeAdvertising?: InputMaybe<Scalars['StringInput']>;
  FileDownloads?: InputMaybe<Array<ImportDownload>>;
  InDirectory?: InputMaybe<Scalars['StringInput']>;
  InternalProductID?: InputMaybe<Scalars['Int']>;
  Link?: InputMaybe<Scalars['StringInput']>;
  ManufacturerBrand?: InputMaybe<Scalars['StringInput']>;
  Performance?: InputMaybe<Scalars['StringInput']>;
  ProductID: Scalars['StringInput'];
  ProductImage?: InputMaybe<Array<Scalars['StringInput']>>;
  ProductVideos?: InputMaybe<Array<ImportVideo>>;
  Publish?: InputMaybe<Scalars['StringInput']>;
  Range?: InputMaybe<Scalars['StringInput']>;
  SEODescription?: InputMaybe<Scalars['StringInput']>;
  SEOTitle?: InputMaybe<Scalars['StringInput']>;
  ScopeOfUse?: InputMaybe<Scalars['StringInput']>;
  SearchTags?: InputMaybe<Array<InputMaybe<Scalars['StringInput']>>>;
  SellOnline?: InputMaybe<Scalars['StringInput']>;
  Specifications?: InputMaybe<Scalars['StringInput']>;
  Status?: InputMaybe<DirectoryItemStatusEnum>;
  Title?: InputMaybe<Scalars['StringInput']>;
  Variants: Array<ImportVariant>;
  Warranty?: InputMaybe<Scalars['StringInput']>;
  Year?: InputMaybe<Scalars['Int']>;
};

/** The result of a product import */
export type ImportResult = {
  __typename?: 'ImportResult';
  Error?: Maybe<Scalars['String']>;
  NewProduct?: Maybe<Scalars['Boolean']>;
  Success: Scalars['Boolean'];
  Warnings: Array<Scalars['String']>;
};

/** A variant to be imported */
export type ImportVariant = {
  BackOrder?: InputMaybe<Scalars['StringInput']>;
  Barcode?: InputMaybe<Scalars['StringInput']>;
  Colour?: InputMaybe<Scalars['StringInput']>;
  ColourHex?: InputMaybe<Scalars['StringInput']>;
  CoverageArea?: InputMaybe<Scalars['StringInput']>;
  Delete?: InputMaybe<Scalars['StringInput']>;
  Depth?: InputMaybe<Scalars['StringInput']>;
  Diameter?: InputMaybe<Scalars['StringInput']>;
  Height?: InputMaybe<Scalars['StringInput']>;
  Indent?: InputMaybe<Scalars['StringInput']>;
  InternalVariantID?: InputMaybe<Scalars['Int']>;
  LeadTime?: InputMaybe<Scalars['StringInput']>;
  Length?: InputMaybe<Scalars['StringInput']>;
  MadeToOrder?: InputMaybe<Scalars['StringInput']>;
  Material?: InputMaybe<Scalars['StringInput']>;
  OnSale?: InputMaybe<Scalars['StringInput']>;
  Option1Label?: InputMaybe<Scalars['StringInput']>;
  Option1Value?: InputMaybe<Scalars['StringInput']>;
  Option2Label?: InputMaybe<Scalars['StringInput']>;
  Option2Value?: InputMaybe<Scalars['StringInput']>;
  Option3Label?: InputMaybe<Scalars['StringInput']>;
  Option3Value?: InputMaybe<Scalars['StringInput']>;
  PackageHeight?: InputMaybe<Scalars['StringInput']>;
  PackageLength?: InputMaybe<Scalars['StringInput']>;
  PackageWeight?: InputMaybe<Scalars['StringInput']>;
  PackageWidth?: InputMaybe<Scalars['StringInput']>;
  Price?: InputMaybe<Scalars['StringInput']>;
  PriceUnit?: InputMaybe<Scalars['StringInput']>;
  QuantityPerUnit?: InputMaybe<Scalars['StringInput']>;
  SKU?: InputMaybe<Scalars['StringInput']>;
  SalePrice?: InputMaybe<Scalars['StringInput']>;
  SampleEnabled?: InputMaybe<Scalars['StringInput']>;
  SamplePrice?: InputMaybe<Scalars['StringInput']>;
  SampleShipping?: InputMaybe<Scalars['StringInput']>;
  SampleStock?: InputMaybe<Scalars['StringInput']>;
  Shipping?: InputMaybe<Scalars['StringInput']>;
  Size?: InputMaybe<Scalars['StringInput']>;
  Stock?: InputMaybe<Scalars['StringInput']>;
  /** The original SKU provided by the supplier, used for platform integrations that auto-generate SKUs */
  SupplierSKU?: InputMaybe<Scalars['StringInput']>;
  /** The suppliers variant ID used in integrations */
  SupplierVariantID?: InputMaybe<Scalars['StringInput']>;
  SwatchImage?: InputMaybe<Scalars['StringInput']>;
  VariantImage?: InputMaybe<Scalars['StringInput']>;
  Volume?: InputMaybe<Scalars['StringInput']>;
  Weight?: InputMaybe<Scalars['StringInput']>;
  Width?: InputMaybe<Scalars['StringInput']>;
};

/** The format of an imported video */
export type ImportVideo = {
  Thumbnail?: InputMaybe<Scalars['StringInput']>;
  Title?: InputMaybe<Scalars['StringInput']>;
  Url: Scalars['StringInput'];
};

export type ImportWarning = {
  __typename?: 'ImportWarning';
  Reference?: Maybe<Scalars['String']>;
  Source: Scalars['String'];
  Title?: Maybe<Scalars['String']>;
  Warnings: Array<Scalars['String']>;
};

export type Inbox = {
  __typename?: 'Inbox';
  ID: Scalars['Int'];
  InboxType: InboxContextTypeEnum;
  Networks: Inbox_NetworksConnection;
  UnreadConversationCount: Scalars['Int'];
};


export type InboxNetworksArgs = {
  filter?: InputMaybe<Inbox_NetworksFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Inbox_NetworksSortFields>;
};

export enum InboxContextTypeEnum {
  CompanyInbox = 'CompanyInbox',
  PersonalInbox = 'PersonalInbox'
}

export type Inbox_NetworksConnection = {
  __typename?: 'Inbox_NetworksConnection';
  edges: Array<Inbox_NetworksConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type Inbox_NetworksConnectionEdge = {
  __typename?: 'Inbox_NetworksConnectionEdge';
  /** The node at the end of the collections edge */
  node: Network;
};

export type Inbox_NetworksFilters = {
  /** Only fetch networks that context is an owner of */
  Owner?: InputMaybe<Scalars['Boolean']>;
};

export type Inbox_NetworksSortFields = {
  ID?: InputMaybe<SortDirection>;
};

/** Information about a pagination in a cursor */
export type Info = {
  __typename?: 'Info';
  ID: Scalars['String'];
  Next?: Maybe<Scalars['String']>;
  Previous?: Maybe<Scalars['String']>;
};

export type InformationModule = ModuleType & {
  __typename?: 'InformationModule';
  AnchorTag?: Maybe<Scalars['String']>;
  CTA?: Maybe<SiteTreeLink>;
  ExtraClass?: Maybe<Scalars['String']>;
  ID: Scalars['ID'];
  MainContent?: Maybe<Scalars['String']>;
  NavigationLabel?: Maybe<Scalars['String']>;
  SpacingBelow?: Maybe<Scalars['String']>;
  SpacingBelowMobile?: Maybe<Scalars['String']>;
  SubContentColumnOne?: Maybe<Scalars['String']>;
  SubContentColumnTwo?: Maybe<Scalars['String']>;
  ThemeColour: ThemedElementColourType;
  Title?: Maybe<Scalars['String']>;
};

/** Information about an available input data type for email templates */
export type InputDataTypeInfo = {
  __typename?: 'InputDataTypeInfo';
  Label: Scalars['String'];
  Tokens: Array<InputDataTypeToken>;
  TypeKey: Scalars['String'];
};

/** A single token available within an input data type */
export type InputDataTypeToken = {
  __typename?: 'InputDataTypeToken';
  Description: Scalars['String'];
  Name: Scalars['String'];
};

export type InspirationGroup = BuildHubDocument & {
  __typename?: 'InspirationGroup';
  Breadcrumbs: Scalars['String'];
  BuildHub: BuildHub;
  CanComment: Scalars['Boolean'];
  CanCreate: Scalars['Boolean'];
  CanDelete: Scalars['Boolean'];
  CanEdit: Scalars['Boolean'];
  Children: Array<BuildHubDocument>;
  Collaborators: Array<BuildHubDocumentCollaborator>;
  CollaboratorsWithAccess: Array<BuildHubDocumentCollaborator>;
  Comments: Array<BuildHubComment>;
  CommentsCount: Scalars['Int'];
  Created: Scalars['String'];
  Description?: Maybe<Scalars['String']>;
  EffectiveAccessMode: Scalars['String'];
  EffectiveAccessRole: Scalars['String'];
  FutureTeamMemberRole: Scalars['String'];
  GeneralAccessMode: Scalars['String'];
  GeneralAccessRole: Scalars['String'];
  ID: Scalars['ID'];
  InheritPermissions: Scalars['Boolean'];
  IsFile: Scalars['Boolean'];
  IsFolder: Scalars['Boolean'];
  Items: InspirationItemsConnection;
  LastEdited: Scalars['String'];
  Link: Scalars['String'];
  NegativeReactionsCount: Scalars['Int'];
  Owner: Member;
  Parent?: Maybe<BuildHubDocument>;
  PositiveReactionsCount: Scalars['Int'];
  Private: Scalars['Boolean'];
  Reactions: Array<BuildHubReaction>;
  SortOrder: Scalars['Int'];
  Source?: Maybe<DesignBoard>;
  Title: Scalars['String'];
  URLSegment: Scalars['String'];
  UnreadCount: Scalars['Int'];
};


export type InspirationGroupItemsArgs = {
  filter?: InputMaybe<ItemsFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type InspirationGroupResponse = InspirationGroup | NotAuthorizedError | NotFoundError | ServerError | UserError;

export type InspirationGroupsConnection = {
  __typename?: 'InspirationGroupsConnection';
  ID: Scalars['String'];
  edges: Array<InspirationGroupsConnectionEdge>;
  nodes: Array<InspirationGroup>;
  pageInfo: ApPageInfo;
};

/** The collections edge */
export type InspirationGroupsConnectionEdge = {
  __typename?: 'InspirationGroupsConnectionEdge';
  /** The node at the end of the collections edge */
  node: InspirationGroup;
};

export type InspirationItem = BuildHubDocument & {
  __typename?: 'InspirationItem';
  Breadcrumbs: Scalars['String'];
  BuildHub: BuildHub;
  CanComment: Scalars['Boolean'];
  CanCreate: Scalars['Boolean'];
  CanDelete: Scalars['Boolean'];
  CanEdit: Scalars['Boolean'];
  Children: Array<BuildHubDocument>;
  Collaborators: Array<BuildHubDocumentCollaborator>;
  Comments: Array<BuildHubComment>;
  CommentsCount: Scalars['Int'];
  ContentType?: Maybe<InspirationTypeEnum>;
  Created: Scalars['String'];
  Description?: Maybe<Scalars['String']>;
  EffectiveAccessMode: Scalars['String'];
  EffectiveAccessRole: Scalars['String'];
  ExternalUrl?: Maybe<ExternalUrlContent>;
  FutureTeamMemberRole: Scalars['String'];
  GeneralAccessMode: Scalars['String'];
  GeneralAccessRole: Scalars['String'];
  ID: Scalars['ID'];
  Image?: Maybe<LibraryImage>;
  InheritPermissions: Scalars['Boolean'];
  IsFile: Scalars['Boolean'];
  IsFolder: Scalars['Boolean'];
  LastEdited: Scalars['String'];
  Link: Scalars['String'];
  NegativeReactionsCount: Scalars['Int'];
  Owner: Member;
  Page?: Maybe<DirectoryItem>;
  Parent?: Maybe<BuildHubDocument>;
  PhotoTile?: Maybe<Scalars['String']>;
  PhotoTileBackground?: Maybe<Scalars['String']>;
  PositiveReactionsCount: Scalars['Int'];
  Private: Scalars['Boolean'];
  Reactions: Array<BuildHubReaction>;
  SortOrder: Scalars['Int'];
  Source?: Maybe<DesignBoardPin>;
  Title: Scalars['String'];
  URLSegment: Scalars['String'];
  UnreadCount: Scalars['Int'];
  Upload?: Maybe<MemberUpload>;
};

export type InspirationItemResponse = InspirationItem | NotAuthorizedError | NotFoundError | ServerError | UserError;

export type InspirationItemsConnection = {
  __typename?: 'InspirationItemsConnection';
  ID: Scalars['String'];
  edges: Array<InspirationItemsConnectionEdge>;
  nodes: Array<InspirationItem>;
  pageInfo: ApPageInfo;
};

/** The collections edge */
export type InspirationItemsConnectionEdge = {
  __typename?: 'InspirationItemsConnectionEdge';
  /** The node at the end of the collections edge */
  node: InspirationItem;
};

/** The type of content associated with a InspirationItem. */
export enum InspirationTypeEnum {
  Article = 'Article',
  ExternalProduct = 'ExternalProduct',
  ExternalUrl = 'ExternalUrl',
  MemberUpload = 'MemberUpload',
  Photo = 'Photo',
  Product = 'Product',
  Professional = 'Professional',
  Project = 'Project'
}

export type InstagramMediaSocialAd = SocialAd & {
  __typename?: 'InstagramMediaSocialAd';
  BodyText: Scalars['String'];
  Date: Scalars['String'];
  Engagements: InstagramMediaSocialAdEngagements;
  ExternalID: Scalars['String'];
  ID: Scalars['String'];
  Image: Scalars['String'];
  Performance: InstagramMediaSocialAdPerformance;
  Permalink: Scalars['String'];
  PreviewImage: Scalars['String'];
  PreviewShareableLink: Scalars['String'];
  Thumbnail: Scalars['String'];
  Title: Scalars['String'];
  Top10: Scalars['Boolean'];
  Type: Scalars['String'];
};

export type InstagramMediaSocialAdEngagements = AdEngagements & {
  __typename?: 'InstagramMediaSocialAdEngagements';
  Comments: Scalars['Int'];
  ID: Scalars['String'];
  Likes: Scalars['Int'];
  Saves: Scalars['Int'];
};

export type InstagramMediaSocialAdPerformance = AdPerformance & {
  __typename?: 'InstagramMediaSocialAdPerformance';
  EngagementRate?: Maybe<Scalars['Float']>;
  ID: Scalars['String'];
  Impressions: Scalars['Int'];
  Reach: Scalars['Int'];
  Saved: Scalars['Int'];
};

export type InstallersType = {
  __typename?: 'InstallersType';
  Categories?: Maybe<Array<Category>>;
  Professionals?: Maybe<Array<Professional>>;
};

export type IntegratedPlatform = {
  __typename?: 'IntegratedPlatform';
  Data?: Maybe<Array<IntegratedPlatformData>>;
  Enabled: Scalars['Boolean'];
  OrdersEnabled?: Maybe<Scalars['Boolean']>;
  Platform: Scalars['String'];
};

export type IntegratedPlatformData = {
  __typename?: 'IntegratedPlatformData';
  Key: Scalars['String'];
  Value?: Maybe<Scalars['String']>;
};

export enum IntegratedPlatformEnum {
  Archipro = 'ARCHIPRO',
  Csv = 'CSV',
  Shopify = 'SHOPIFY',
  ShopifyCsv = 'SHOPIFY_CSV',
  Squarespace = 'SQUARESPACE',
  WooCommerce = 'WOO_COMMERCE',
  WooCommerceCsv = 'WOO_COMMERCE_CSV'
}

export type IntegrationRequest = {
  __typename?: 'IntegrationRequest';
  Created: Scalars['Int'];
  Errors?: Maybe<Array<Scalars['String']>>;
  ErrorsList?: Maybe<Array<ImportError>>;
  Failed?: Maybe<Scalars['Int']>;
  FileName?: Maybe<Scalars['String']>;
  Finished?: Maybe<Scalars['Int']>;
  Format: Scalars['String'];
  ImportType?: Maybe<Scalars['String']>;
  Inserted?: Maybe<Scalars['Int']>;
  IntegrationStatus: Scalars['String'];
  IntegrationType?: Maybe<Scalars['String']>;
  Processed?: Maybe<Scalars['Int']>;
  Professional: Scalars['String'];
  ProfessionalSort: Scalars['Int'];
  RequestID: Scalars['String'];
  Source?: Maybe<Scalars['String']>;
  Started?: Maybe<Scalars['Int']>;
  Total?: Maybe<Scalars['Int']>;
  User?: Maybe<Scalars['String']>;
  WarningsList?: Maybe<Array<ImportWarning>>;
};

export type IntegrationRequestConnection = {
  __typename?: 'IntegrationRequestConnection';
  items?: Maybe<Array<IntegrationRequest>>;
  pageInfo: ListConnectionPageInfo;
};

export type IntegrationSettingsModelInput = {
  ContentLockFlexibilitySettings?: InputMaybe<Array<Scalars['String']>>;
};

export type IntegrationSettingsModelOutput = {
  __typename?: 'IntegrationSettingsModelOutput';
  ContentLockFlexibilitySettings?: Maybe<Array<Scalars['String']>>;
};

export type IntegrationUuidExchangeResponse = IntegrationUuidExchangeSuccess | NotAuthorizedError | NotFoundError | ServerError | UserError;

export type IntegrationUuidExchangeSuccess = {
  __typename?: 'IntegrationUUIDExchangeSuccess';
  /** Refresh token for renewing the JWT token */
  RefreshToken: Scalars['String'];
  /** JWT token for integration service authentication */
  Token: Scalars['String'];
};

export type IntegrationUuidInvalidateResponse = IntegrationUuidInvalidateSuccess | NotAuthenticatedError | NotFoundError | ServerError | UserError;

export type IntegrationUuidInvalidateSuccess = {
  __typename?: 'IntegrationUUIDInvalidateSuccess';
  /** Whether the UUID was successfully invalidated */
  Success: Scalars['Boolean'];
};

export type IntegrationUnpublishProductResult = Error | NotAuthenticatedError | NotAuthorizedError | NotFoundError | ServerError | UserError;

export type InterestedCategory = {
  __typename?: 'InterestedCategory';
  CategoryLabel: Scalars['String'];
  ID: Scalars['String'];
  InterestPercentage: Scalars['Int'];
  URLSegment?: Maybe<Scalars['String']>;
};

export type IntroModule = ModuleType & {
  __typename?: 'IntroModule';
  AnchorTag?: Maybe<Scalars['String']>;
  BackgroundImage?: Maybe<ResponsiveVariantImage>;
  Content?: Maybe<Scalars['String']>;
  ExternalVideoLink?: Maybe<Scalars['String']>;
  ExtraClass?: Maybe<Scalars['String']>;
  ID: Scalars['ID'];
  NavigationLabel?: Maybe<Scalars['String']>;
  PlayInModal: Scalars['Boolean'];
  SpacingBelow?: Maybe<Scalars['String']>;
  SpacingBelowMobile?: Maybe<Scalars['String']>;
  ThemeColour: ThemedElementColourType;
  Title?: Maybe<Scalars['String']>;
  VideoCover?: Maybe<ResponsiveVariantImage>;
};

export type InviteInfo = DesignBoardInvite | EnquiryConversationInvite | NotFoundError | ServerError;

export type Invoice = Invoiceable & ModuleColumn & SortableItem & {
  __typename?: 'Invoice';
  AccountDetails?: Maybe<TokenisedField>;
  BankTransferTerms?: Maybe<TokenisedField>;
  BusinessTermsVersions: Array<BusinessTermsVersion>;
  Contact?: Maybe<Contact>;
  ContactAddress?: Maybe<Scalars['String']>;
  ContactCity?: Maybe<Scalars['String']>;
  ContactEmail?: Maybe<Scalars['String']>;
  ContactFirstName?: Maybe<Scalars['String']>;
  ContactID: Scalars['ID'];
  ContactPhone?: Maybe<Scalars['String']>;
  ContactPostCode?: Maybe<Scalars['String']>;
  ContactSurname?: Maybe<Scalars['String']>;
  Created: Scalars['Date'];
  CreditCardTerms?: Maybe<TokenisedField>;
  Currency: Scalars['String'];
  Description?: Maybe<TokenisedField>;
  Discounts: CurrencyAmount;
  EndDate?: Maybe<Scalars['Date']>;
  ExpiryDate?: Maybe<Scalars['Date']>;
  FooterLinks?: Maybe<Array<FooterLink>>;
  HasProcessingPayment: Scalars['Boolean'];
  HasStripePaymentMethod: Scalars['Boolean'];
  Headline?: Maybe<Scalars['String']>;
  ID: Scalars['Int'];
  InvoiceSentDate?: Maybe<Scalars['Date']>;
  IsEmpty: Scalars['Boolean'];
  LastEdited: Scalars['Date'];
  MemberSortOrder: Scalars['Int'];
  ModuleID: Scalars['Int'];
  Notes?: Maybe<TokenisedField>;
  PONumber?: Maybe<Scalars['String']>;
  PaymentTerms?: Maybe<TokenisedField>;
  Payments: Array<InvoicePayment>;
  PendingResultInvoicePaymentID?: Maybe<Scalars['Int']>;
  Professional?: Maybe<Professional>;
  ReadOnly: Scalars['Boolean'];
  References?: Maybe<TokenisedField>;
  Scope?: Maybe<TokenisedField>;
  SelectedBusinessTermsCategories: Array<BusinessTermsCategory>;
  Services: Array<InvoiceServiceItem>;
  SplitPayment?: Maybe<Scalars['String']>;
  StartDate?: Maybe<Scalars['Date']>;
  StartedProcessingPaymentAt?: Maybe<Scalars['Date']>;
  Status: InvoiceStatusEnum;
  StripeAccount?: Maybe<Scalars['String']>;
  StripeHostedInvoiceUrl?: Maybe<Scalars['String']>;
  SubHeadline?: Maybe<Scalars['String']>;
  SubTotal: CurrencyAmount;
  Tax: CurrencyAmount;
  Title?: Maybe<TokenisedField>;
  Total: CurrencyAmount;
  UUID: Scalars['String'];
  WordCount: Scalars['Int'];
};

/** Response type for invoice payment processing status query */
export type InvoiceHasProcessingPaymentResponse = {
  __typename?: 'InvoiceHasProcessingPaymentResponse';
  HasProcessingPayment: Scalars['Boolean'];
  PendingResultInvoicePaymentID?: Maybe<Scalars['Int']>;
  StartedProcessingPaymentAt?: Maybe<Scalars['Date']>;
};

export type InvoiceModule = FlexibleModule & {
  __typename?: 'InvoiceModule';
  Columns: ColumnsConnection;
  ContentAreaID: Scalars['Int'];
  CreatedFromID?: Maybe<Scalars['Int']>;
  CreatedFromVersion?: Maybe<Scalars['Int']>;
  DetachedFromSavedModule?: Maybe<Scalars['Boolean']>;
  EcommerceEnabled: Scalars['Boolean'];
  ID: Scalars['Int'];
  LibraryItemID: Scalars['Int'];
  MemberSortOrder: Scalars['Int'];
  ModuleGroup?: Maybe<ModuleGroupEnum>;
  PossibleColumnDimensions: Array<ColumnDimension>;
  PresetName: Scalars['String'];
  PresetType: FlexibleModuleEnum;
  SortableColumns: Scalars['Boolean'];
  Swappable: Scalars['Boolean'];
};


export type InvoiceModuleColumnsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<ColumnsSortFields>;
};

export type InvoicePayment = {
  __typename?: 'InvoicePayment';
  Amount: Scalars['Float'];
  AmountOption: InvoicePaymentAmountOptionEnum;
  AmountPercentage?: Maybe<Scalars['Float']>;
  DueDate?: Maybe<Scalars['Date']>;
  DueDaysAfterInvoiceSent?: Maybe<Scalars['Int']>;
  DueFixedDayOfMonth?: Maybe<Scalars['Int']>;
  DueOption: InvoicePaymentDueOptionEnum;
  ID: Scalars['ID'];
  Invoice: Invoice;
  PaymentDate?: Maybe<Scalars['Date']>;
  StartedProcessingPaymentAt?: Maybe<Scalars['Date']>;
  Status: Scalars['String'];
  UUID: Scalars['String'];
};

/** the option user selected for payment amount */
export enum InvoicePaymentAmountOptionEnum {
  CustomAmount = 'CustomAmount',
  EqualPayments = 'EqualPayments',
  Percentage = 'Percentage'
}

/** determines how due date will be resolved, either setup upfront or determined after invoice is sent */
export enum InvoicePaymentDueOptionEnum {
  FixedDate = 'FixedDate',
  FixedDayOfMonth = 'FixedDayOfMonth',
  RelativeInvoiceDate = 'RelativeInvoiceDate'
}

export type InvoicePaymentResponse = InvoicePayment | NotAuthorizedError | NotFoundError | ServerError | UserError;

export type InvoiceServiceItem = {
  __typename?: 'InvoiceServiceItem';
  Description?: Maybe<Scalars['String']>;
  DiscountApplied: Scalars['Boolean'];
  DiscountedAmount?: Maybe<Scalars['Float']>;
  DiscountedUnitPrice: CurrencyAmount;
  ID: Scalars['ID'];
  Invoice: Invoice;
  PhotoSrc?: Maybe<Scalars['String']>;
  Quantity?: Maybe<Scalars['Int']>;
  SKU?: Maybe<Scalars['String']>;
  TaxAmount?: Maybe<Scalars['Float']>;
  TaxRate?: Maybe<Scalars['Float']>;
  /** String */
  Thumbnail?: Maybe<Scalars['String']>;
  Title?: Maybe<Scalars['String']>;
  Total: CurrencyAmount;
  UnitPrice: CurrencyAmount;
};

/** Invoice status */
export enum InvoiceStatusEnum {
  Accepted = 'Accepted',
  Cancelled = 'Cancelled',
  Draft = 'Draft',
  Expired = 'Expired',
  Issued = 'Issued',
  Overdue = 'Overdue',
  Paid = 'Paid',
  PartialPaid = 'PartialPaid',
  Refunded = 'Refunded',
  Sent = 'Sent'
}

/** common fields between invoice and quote template */
export type Invoiceable = {
  AccountDetails?: Maybe<TokenisedField>;
  BankTransferTerms?: Maybe<TokenisedField>;
  BusinessTermsVersions: Array<BusinessTermsVersion>;
  Contact?: Maybe<Contact>;
  Created: Scalars['Date'];
  CreditCardTerms?: Maybe<TokenisedField>;
  Currency: Scalars['String'];
  Description?: Maybe<TokenisedField>;
  Discounts: CurrencyAmount;
  ExpiryDate?: Maybe<Scalars['Date']>;
  ID: Scalars['Int'];
  IsEmpty: Scalars['Boolean'];
  LastEdited: Scalars['Date'];
  MemberSortOrder: Scalars['Int'];
  ModuleID: Scalars['Int'];
  Notes?: Maybe<TokenisedField>;
  PaymentTerms?: Maybe<TokenisedField>;
  Payments: Array<InvoicePayment>;
  Professional?: Maybe<Professional>;
  ReadOnly: Scalars['Boolean'];
  References?: Maybe<TokenisedField>;
  Scope?: Maybe<TokenisedField>;
  SelectedBusinessTermsCategories: Array<BusinessTermsCategory>;
  Services: Array<InvoiceServiceItem>;
  SubTotal: CurrencyAmount;
  Tax: CurrencyAmount;
  Title?: Maybe<TokenisedField>;
  Total: CurrencyAmount;
  WordCount: Scalars['Int'];
};

export type InvoiceableResponse = Invoice | NotAuthorizedError | NotFoundError | QuoteTemplate | ServerError | UserError;

export type Item = Article | Product | Professional | Project;

export type ItemSortOrders = {
  ID: Scalars['Int'];
  MemberSortOrder: Scalars['Int'];
};

export type ItemsFilters = {
  /** Filter inspiration items by content type */
  ByContentType?: InputMaybe<InspirationTypeEnum>;
};

export type Itineraries_Connection = {
  __typename?: 'Itineraries_Connection';
  edges: Array<Itineraries_ConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type Itineraries_ConnectionEdge = {
  __typename?: 'Itineraries_ConnectionEdge';
  /** The node at the end of the collections edge */
  node: EventItinerary;
};

export type Itineraries_SortFields = {
  SortOrder?: InputMaybe<SortDirection>;
};

/** Audience for JWT tokens */
export enum JwtAudience {
  IntegrationServiceBackend = 'IntegrationServiceBackend',
  IntegrationServiceBrowser = 'IntegrationServiceBrowser',
  Mcp = 'MCP',
  MobileApp = 'MobileApp',
  SystemUser = 'SystemUser'
}

export type JwtTokenError = ErrorInterface & {
  __typename?: 'JWTTokenError';
  Message: Scalars['String'];
  Status: JwtTokenErrorStatus;
};

/** JWT token error status */
export enum JwtTokenErrorStatus {
  Dead = 'Dead',
  Expired = 'Expired',
  Invalid = 'Invalid'
}

/** Successful JWT authentication response containing member details and optionally tokens */
export type JwtTokenMember = {
  __typename?: 'JWTTokenMember';
  /** The authenticated member */
  Member: Member;
  /** Refresh token for obtaining new access tokens (long-lived, store securely). Only returned for create/refresh operations. */
  RefreshToken: Scalars['String'];
  /** JWT access token for API authorization (short-lived, use in Bearer header). Only returned for create/refresh operations. */
  Token: Scalars['String'];
};

/** Successful JWT validation response containing only member details */
export type JwtTokenMemberOnly = {
  __typename?: 'JWTTokenMemberOnly';
  /** The authenticated member */
  Member: Member;
};

export type JwtTokenValidResponse = JwtTokenError | JwtTokenMember | NotAuthenticatedError | ServerError | UserError;

/** Response for JWT validation operations that only return member details without issuing new tokens */
export type JwtTokenValidationResponse = JwtTokenError | JwtTokenMemberOnly | NotAuthenticatedError | ServerError | UserError;

/** A scope name controlling which GraphQL operations a JWT can execute. */
export enum JwtScopeEnum {
  /** Allows all GraphQL operations. Avoid using this scope. */
  Everything = 'everything',
  /** Permission to generate AI description with the integration service */
  GenerateAiDescription = 'generateAiDescription',
  /** Administration of integration settings (system user only) */
  IntegrationAdmin = 'integrationAdmin',
  /** Manage supplier orders (system user only) */
  OrderManagement = 'orderManagement',
  /** Manage product imports and unpublishing (system user only) */
  ProductManagement = 'productManagement',
  /** Public scope that do not require authentication */
  Public = 'public',
  /** Permission to access Airtable ad schedule (no GraphQL access) */
  ReadAdSchedule = 'readAdSchedule',
  /** Read information about a user's BuildHub projects */
  ReadBuildHub = 'readBuildHub',
  /** Permission to access import requests */
  ReadImportRequests = 'readImportRequests',
  /** Permission to access integration settings */
  ReadIntegrationSettings = 'readIntegrationSettings',
  /** Read information about the user */
  ReadUser = 'readUser',
  /** Trigger product CSV export for integration */
  TriggerProductExport = 'triggerProductExport',
  /** Trigger product sync in connected platform */
  TriggerProductSync = 'triggerProductSync',
  /** Update information about the user */
  UpdateUser = 'updateUser',
  /** Write information about a user's BuildHub projects */
  WriteBuildHub = 'writeBuildHub'
}

export type KeynoteSpeakers_Connection = {
  __typename?: 'KeynoteSpeakers_Connection';
  edges: Array<KeynoteSpeakers_ConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type KeynoteSpeakers_ConnectionEdge = {
  __typename?: 'KeynoteSpeakers_ConnectionEdge';
  /** The node at the end of the collections edge */
  node: EventKeynoteSpeaker;
};

export type KeynoteSpeakers_SortFields = {
  SortOrder?: InputMaybe<SortDirection>;
};

export type LeadFunnelFilters = {
  CONVERSION__EQUAL?: InputMaybe<Scalars['String']>;
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type LeadFunnelStatsFilters = {
  CONVERSION__EQUAL?: InputMaybe<Scalars['String']>;
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type LeadFunnelUserScoresFilters = {
  CONVERSION__EQUAL?: InputMaybe<Scalars['String']>;
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type LeadFunnelUserSessionsFilters = {
  CONVERSION__EQUAL?: InputMaybe<Scalars['String']>;
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type LeadFunnelUserStatusFilters = {
  CONVERSION__EQUAL?: InputMaybe<Scalars['String']>;
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type LeadFunnelUserTimeFilters = {
  CONVERSION__EQUAL?: InputMaybe<Scalars['String']>;
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type LeadFunnelUsersFilters = {
  CONVERSION__EQUAL?: InputMaybe<Scalars['String']>;
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
  FUNNEL_STAGE__IN?: InputMaybe<Array<Scalars['String']>>;
};

export type LeadFunnelUsersSort = {
  CONVERSIONS?: InputMaybe<PrioritySort>;
  DETAILS?: InputMaybe<PrioritySort>;
  LAST_VISIT?: InputMaybe<PrioritySort>;
  LOCATION?: InputMaybe<PrioritySort>;
  NAME?: InputMaybe<PrioritySort>;
  SESSIONS?: InputMaybe<PrioritySort>;
  STAGE?: InputMaybe<PrioritySort>;
  STATUS?: InputMaybe<PrioritySort>;
  TIME?: InputMaybe<PrioritySort>;
  TYPE?: InputMaybe<PrioritySort>;
  USER_ENGAGEMENT?: InputMaybe<PrioritySort>;
  USER_SCORE?: InputMaybe<PrioritySort>;
  VIEWS?: InputMaybe<PrioritySort>;
};

export enum LeadTimeUnitEnum {
  Day = 'Day',
  Week = 'Week'
}

export type LegacyArticle = NotFoundError | Redirect;

export type LibraryDownload = SortableItem & {
  __typename?: 'LibraryDownload';
  ExternalLink?: Maybe<Scalars['String']>;
  FileCategory?: Maybe<FileCategory>;
  FileID?: Maybe<Scalars['Int']>;
  ID: Scalars['Int'];
  InternalLink?: Maybe<Scalars['String']>;
  LibraryItem?: Maybe<DirectoryItem>;
  MemberSortOrder: Scalars['Int'];
  SortOrder?: Maybe<Scalars['Int']>;
  Thumbnail?: Maybe<ResponsiveImage>;
  Title: Scalars['String'];
};

export type LibraryImage = DesignBoardPinTarget & SortableItem & {
  __typename?: 'LibraryImage';
  AltText?: Maybe<Scalars['String']>;
  /** Aspect ratio of raw uploaded photo */
  AspectRatio: Scalars['Float'];
  BannerSegment?: Maybe<BannerSegmentEnum>;
  /** Associated caption for this LibraryImage */
  Caption?: Maybe<Scalars['String']>;
  Categories: Array<Category>;
  /** Clickable link for this photo */
  ClickableLink?: Maybe<Scalars['String']>;
  Comments?: Maybe<Array<Maybe<Comment>>>;
  CreatedDate?: Maybe<Scalars['String']>;
  /** Crop Position in x-axis (if applicable) */
  CropPosX: Scalars['Int'];
  /** Crop Position in y-axis (if applicable) */
  CropPosY: Scalars['Int'];
  /** Return any of this user's Design Boards that contain this image */
  DesignBoardsForCurrentUser?: Maybe<Array<Maybe<DesignBoard>>>;
  /** Download link for this photo */
  DownloadLink?: Maybe<Scalars['String']>;
  Format?: Maybe<Scalars['String']>;
  FullScreen?: Maybe<Scalars['Boolean']>;
  /** Returns true if LibraryImage has tags */
  HasTags: Scalars['Boolean'];
  /** Height of the photo after cropping it */
  HeightAfterCrop: Scalars['Int'];
  /** Height of the photo before cropping it */
  HeightBeforeCrop: Scalars['Int'];
  /** Does a LibraryImage need to hide resene tool */
  HideReseneTool?: Maybe<Scalars['Boolean']>;
  /** The unique identifier of the LibraryImage */
  ID: Scalars['Int'];
  /** Is this image Landscape or Portrait? */
  ImageFormat: Scalars['String'];
  /** If a LibraryImage has active tags */
  Interactive?: Maybe<Scalars['Boolean']>;
  /** Returns true if LibraryImage is clearcut */
  IsClearCut: Scalars['Boolean'];
  /** Returns true if LibraryImage should display as a half-width */
  IsHalfWidth: Scalars['Boolean'];
  /** Returns true if LibraryImage has multiply filter */
  IsMultiplied: Scalars['Boolean'];
  /** is raw image portrait, backend treats square image as portrait */
  IsPortrait: Scalars['Boolean'];
  /** Returns true if LibraryImage is zoomed out */
  IsZoomedOut: Scalars['Boolean'];
  /** LibraryImageFile for this LibraryImage */
  LibraryImageFile?: Maybe<LibraryImageFile>;
  /** SiteTreeID of related LibraryItem */
  LibraryImageFileID?: Maybe<Scalars['Int']>;
  /** AI-generated label for this image (ordered by AdminScore DESC and ID DESC, limit 1) */
  LibraryImageLabel?: Maybe<LibraryImageLabel>;
  /** Return a list of tags on this photo */
  LibraryImageMarkers: Array<LibraryImageMarker>;
  /** DirectoryItem associated with this LibraryImage */
  LibraryItem?: Maybe<DirectoryItem>;
  /** SiteTreeID of related LibraryItem */
  LibraryItemID?: Maybe<Scalars['Int']>;
  MemberSortOrder: Scalars['Int'];
  MetaDescription?: Maybe<Scalars['String']>;
  /** Show overlay on banner image */
  Overlay?: Maybe<Scalars['Boolean']>;
  PhotoBrickPortrait?: Maybe<Scalars['String']>;
  /** Professional to give Photo Credit for this image */
  PhotoCredit?: Maybe<Professional>;
  /** Name of the photo credit, can be a custom credit without a Professional */
  PhotoCreditName?: Maybe<Scalars['String']>;
  PhotoListing?: Maybe<Scalars['String']>;
  PhotoListingPreload?: Maybe<Scalars['String']>;
  PhotoModal?: Maybe<Scalars['String']>;
  /** Is the image product related */
  ProductRelated?: Maybe<Scalars['Boolean']>;
  /** Professional associated with this LibraryImage */
  Professional?: Maybe<Professional>;
  ProfessionalID: Scalars['String'];
  ProfessionalWebsite: Scalars['String'];
  ProfessionalWebsiteShort: Scalars['String'];
  /** Scroll Position in x-axis (if applicable) */
  ScrollPosX: Scalars['Int'];
  /** Scroll Position in y-axis (if applicable) */
  ScrollPosY: Scalars['Int'];
  SearchTags: LibraryImageSearchTagsConnection;
  SortOrder: Scalars['Int'];
  Tags?: Maybe<Array<Maybe<LibraryImageMarker>>>;
  /** Title of the LibraryImage (usually internal) */
  Title: Scalars['String'];
  /** Width for this photo */
  Width?: Maybe<Scalars['Int']>;
  /** Width of the photo after cropping it */
  WidthAfterCrop: Scalars['Int'];
  /** Width of the photo before cropping it */
  WidthBeforeCrop: Scalars['Int'];
  /** Zoom percentage of photo (default 100) */
  ZoomFactor: Scalars['Int'];
};


export type LibraryImageSearchTagsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type LibraryImageFile = {
  __typename?: 'LibraryImageFile';
  AwardThumb?: Maybe<Scalars['String']>;
  Created: Scalars['String'];
  Cropped48?: Maybe<Scalars['String']>;
  Cropped200?: Maybe<Scalars['String']>;
  DetailBannerEditMode: ResponsiveImage;
  DetailBannerStandard: ResponsiveImage;
  DetailPageEditMode: ResponsiveImage;
  DetailPageLandscape: ResponsiveImage;
  DetailPageSegmentBanner: ResponsiveImage;
  DetailPageSquare: ResponsiveImage;
  DetailPageStandard: ResponsiveImage;
  DirectoryBannerStandard: ResponsiveImage;
  DirectoryFeaturedBannerDesktop?: Maybe<Scalars['String']>;
  DirectoryPageFeatured: ResponsiveImage;
  DirectoryPageLandscape: ResponsiveImage;
  DirectoryPageSquare: ResponsiveImage;
  EmailAsset?: Maybe<Scalars['String']>;
  Filename?: Maybe<Scalars['String']>;
  FlexibleBanner: ResponsiveImage;
  /** Frontend-only detail page image without watermarks - separate from existing watermarked fields */
  FrontendDetailPage: ResponsiveImage;
  ID: Scalars['Int'];
  /** the image background */
  ImageBackgroundColor?: Maybe<Scalars['String']>;
  ImageFilter?: Maybe<Scalars['String']>;
  ImageHeight: Scalars['Int'];
  ImageWidth: Scalars['Int'];
  IsPortrait: Scalars['Boolean'];
  /** the professional logo background of the image owner */
  LogoBackground?: Maybe<Scalars['String']>;
  LogoSearch?: Maybe<Scalars['String']>;
  ModuleImage: ResponsiveImage;
  Name?: Maybe<Scalars['String']>;
  PhotoBrick?: Maybe<Scalars['String']>;
  PhotoBrickLandscape?: Maybe<Scalars['String']>;
  PhotoBrickPortrait?: Maybe<Scalars['String']>;
  PhotoEnquiryThumb?: Maybe<Scalars['String']>;
  PhotoModal?: Maybe<Scalars['String']>;
  PhotoTile?: Maybe<Scalars['String']>;
  PhotoTileDraggable?: Maybe<Scalars['String']>;
  PhotoViewer: ResponsiveImage;
  PositionedImage?: Maybe<Scalars['String']>;
  ProfessionalLogo?: Maybe<Scalars['String']>;
  RecommendedSlider: ResponsiveImage;
  RelatedArticle: ResponsiveImage;
  SimpleFlexibleThumb: ResponsiveImage;
  SliderThumb: ResponsiveImage;
  ThumbCategory?: Maybe<Scalars['String']>;
  ThumbLandscapeDesktop?: Maybe<Scalars['String']>;
  ThumbLandscapeMobile?: Maybe<Scalars['String']>;
  ThumbPortrait?: Maybe<Scalars['String']>;
  ThumbTiny?: Maybe<Scalars['String']>;
  ThumbnailBM?: Maybe<Scalars['String']>;
  ThumbnailBM90?: Maybe<Scalars['String']>;
  ThumbnailBM180?: Maybe<Scalars['String']>;
  ThumbnailBMTable?: Maybe<Scalars['String']>;
  ThumbnailDirectoryTile?: Maybe<Scalars['String']>;
  VideoCover: ResponsiveImage;
  aiEdited: Scalars['Boolean'];
  isBanner: Scalars['Boolean'];
};


export type LibraryImageFileDetailPageEditModeArgs = {
  remix?: InputMaybe<Scalars['Boolean']>;
};


export type LibraryImageFileDetailPageSquareArgs = {
  remix?: InputMaybe<Scalars['Boolean']>;
};


export type LibraryImageFileDetailPageStandardArgs = {
  remix?: InputMaybe<Scalars['Boolean']>;
};


export type LibraryImageFileFlexibleBannerArgs = {
  desktopHeight?: InputMaybe<Scalars['Int']>;
  desktopWidth?: InputMaybe<Scalars['Int']>;
  mobileHeight?: InputMaybe<Scalars['Int']>;
  mobileWidth?: InputMaybe<Scalars['Int']>;
};


export type LibraryImageFileFrontendDetailPageArgs = {
  remix?: InputMaybe<Scalars['Boolean']>;
};


export type LibraryImageFileModuleImageArgs = {
  identifier: Scalars['String'];
};


export type LibraryImageFilePhotoTileDraggableArgs = {
  remix?: InputMaybe<Scalars['Boolean']>;
};


export type LibraryImageFilePositionedImageArgs = {
  height?: InputMaybe<Scalars['Int']>;
  width?: InputMaybe<Scalars['Int']>;
};


export type LibraryImageFileSimpleFlexibleThumbArgs = {
  desktopHeight?: InputMaybe<Scalars['Int']>;
  desktopWidth?: InputMaybe<Scalars['Int']>;
  exactCrop?: InputMaybe<Scalars['Boolean']>;
  mobileHeight?: InputMaybe<Scalars['Int']>;
  mobileWidth?: InputMaybe<Scalars['Int']>;
};


export type LibraryImageFileThumbCategoryArgs = {
  WithWatermark?: InputMaybe<Scalars['Boolean']>;
};

export type LibraryImageLabel = {
  __typename?: 'LibraryImageLabel';
  /** Admin score for the result (0-100) */
  AdminScore?: Maybe<Scalars['Int']>;
  /** Estimated Cost per 1K images */
  AiCost1K?: Maybe<Scalars['Float']>;
  /** Execution time in seconds */
  AiExecSecond?: Maybe<Scalars['Int']>;
  /** URL of the image sent to AI */
  AiImageUrl?: Maybe<Scalars['String']>;
  /** AI model used for the analysis */
  AiModel?: Maybe<Scalars['String']>;
  /** Raw JSON response from the AI API */
  AiRawResult?: Maybe<Scalars['String']>;
  /** Number of input tokens used */
  AiTokenInput?: Maybe<Scalars['Int']>;
  /** Number of output tokens used */
  AiTokenOutput?: Maybe<Scalars['Int']>;
  /** JSON array of architectural styles */
  ArchitecturalStyle?: Maybe<Scalars['String']>;
  /** JSON object with primary_families, accent_families, tone, contrast, brightness */
  ColorPalette?: Maybe<Scalars['String']>;
  /** JSON object with confidence scores per field */
  ConfidenceScores?: Maybe<Scalars['String']>;
  /** Description of the image */
  Description?: Maybe<Scalars['String']>;
  /** JSON array of emotional tags */
  EmotionalTags?: Maybe<Scalars['String']>;
  /** The unique identifier of the LibraryImageLabel */
  ID: Scalars['Int'];
  /** JSON array of interior styles */
  InteriorStyle?: Maybe<Scalars['String']>;
  /** ID of the associated item */
  ItemID?: Maybe<Scalars['Int']>;
  /** Type of the associated item (e.g., \"project\", \"product\", \"article\", \"professional\") */
  ItemType?: Maybe<DirectoryItemEnumType>;
  /** The library image this label is associated with */
  LibraryImage?: Maybe<LibraryImage>;
  /** Foreign key to the library image */
  LibraryImageID: Scalars['Int'];
  /** JSON array of material objects with category, material, finish, colour_family, confidence */
  Materials?: Maybe<Scalars['String']>;
  /** Additional notes about the label */
  Note?: Maybe<Scalars['String']>;
  /** Primary room type (e.g., \"kitchen\", \"bathroom\") */
  RoomTypePrimary?: Maybe<Scalars['String']>;
  /** JSON array of secondary room types */
  RoomTypeSecondary?: Maybe<Scalars['String']>;
  /** JSON array of semantic tag objects with tag and confidence */
  SemanticTags?: Maybe<Scalars['String']>;
  /** JSON object with room_size, ceiling_height, scale_cues, confidence */
  SizeScale?: Maybe<Scalars['String']>;
};

export type LibraryImageLabelFilters = {
  /** Filter by array of IDs, compatible with ID__in filter for search index */
  ID__in?: InputMaybe<Array<Scalars['Int']>>;
  /** Filter by LibraryImageID */
  LibraryImageID?: InputMaybe<Scalars['Int']>;
  /** Filter by LibraryItemID (directory item like Project/Product) */
  LibraryItemID?: InputMaybe<Scalars['Int']>;
  /** Filter by ProfessionalID */
  ProfessionalID?: InputMaybe<Scalars['Int']>;
};

export type LibraryImageMarker = {
  __typename?: 'LibraryImageMarker';
  /** Has this tag been approved by an ArchiPro admin? */
  Approved: Scalars['Boolean'];
  /** The unique identifier of the LibraryImage */
  ID: Scalars['Int'];
  /** Indicate if this tag is created by Staff/High admin */
  IsArchiPro: Scalars['Boolean'];
  /** Page that this tag is placed on */
  LibraryItem?: Maybe<DirectoryItem>;
  /** Member who created this tag */
  Member?: Maybe<Member>;
  /** Position in x-axis */
  PositionX: Scalars['Float'];
  /** Position in y-axis */
  PositionY: Scalars['Float'];
  /** Product tagged in this photo */
  Product?: Maybe<Product>;
  /** [Fallback] The professional has been tagged - we should find the correct product. */
  ProfessionalForUnknownProduct?: Maybe<Professional>;
  /** [Fallback] The name of the professional has been given - we should add them to our platform */
  TitleForUnknownProfessional?: Maybe<Scalars['String']>;
};

export type LibraryImageMarkerCount = {
  __typename?: 'LibraryImageMarkerCount';
  pendingProductCount: Scalars['Int'];
  pendingProfessionalCount: Scalars['Int'];
  totalProductCount: Scalars['Int'];
  totalProfessionalCount: Scalars['Int'];
  uniquePendingProductCount: Scalars['Int'];
  uniqueProductCount: Scalars['Int'];
};

export type LibraryImageSearchTagsConnection = {
  __typename?: 'LibraryImageSearchTagsConnection';
  edges: Array<LibraryImageSearchTagsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type LibraryImageSearchTagsConnectionEdge = {
  __typename?: 'LibraryImageSearchTagsConnectionEdge';
  /** The node at the end of the collections edge */
  node: SearchTag;
};

export type LibraryImagesInput = {
  ID: Scalars['Int'];
  SortOrder: Scalars['Int'];
};

export type LibraryItemBanner = {
  __typename?: 'LibraryItemBanner';
  BannerImage: LibraryImage;
  BannerVideoUrl?: Maybe<Scalars['String']>;
  IsVideoBanner: Scalars['Boolean'];
  Overlay?: Maybe<Scalars['Boolean']>;
};

export type LibraryItemBannersConnection = {
  __typename?: 'LibraryItemBannersConnection';
  edges: Array<LibraryItemBannersConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type LibraryItemBannersConnectionEdge = {
  __typename?: 'LibraryItemBannersConnectionEdge';
  /** The node at the end of the collections edge */
  node: LibraryImage;
};

export type LibraryItemBannersFilters = {
  /** Filters this type when BannerSegment is eq the provided value */
  BannerSegment__eq?: InputMaybe<Scalars['Boolean']>;
  BannerSegment__in?: InputMaybe<BannerSegmentEnum>;
  BannerSegment__is_nil?: InputMaybe<Scalars['Boolean']>;
};

export type LibraryItemBannersSortFields = {
  ID?: InputMaybe<SortDirection>;
  MemberSortOrder?: InputMaybe<SortDirection>;
  Professional__Title?: InputMaybe<SortDirection>;
};

export type LibraryItemImagesConnection = {
  __typename?: 'LibraryItemImagesConnection';
  edges: Array<LibraryItemImagesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type LibraryItemImagesConnectionEdge = {
  __typename?: 'LibraryItemImagesConnectionEdge';
  /** The node at the end of the collections edge */
  node: LibraryImage;
};

export type LibraryItemKpi = {
  __typename?: 'LibraryItemKPI';
  ClientType: Scalars['String'];
  ID: Scalars['Int'];
  ItemType: Scalars['String'];
  PeriodClientProjected12MonthEnquiries?: Maybe<Scalars['Int']>;
  PeriodClientProjected12MonthPageViews?: Maybe<Scalars['Int']>;
  PeriodClientProjected12MonthReferrals?: Maybe<Scalars['Int']>;
  PeriodClientProjected12MonthSaves?: Maybe<Scalars['Int']>;
  PeriodClientTotalEnquiries?: Maybe<Scalars['Int']>;
  PeriodClientTotalPageViews?: Maybe<Scalars['Int']>;
  PeriodClientTotalReferrals?: Maybe<Scalars['Int']>;
  PeriodClientTotalSaves?: Maybe<Scalars['Int']>;
  PeriodItemEnquiries?: Maybe<Scalars['Int']>;
  PeriodItemPageViews?: Maybe<Scalars['Int']>;
  PeriodItemReferrals?: Maybe<Scalars['Int']>;
  PeriodItemSaves?: Maybe<Scalars['Int']>;
  PeriodStart?: Maybe<Scalars['String']>;
  PredictedWinRate?: Maybe<Scalars['Float']>;
  SubscriptionAmount?: Maybe<Scalars['Float']>;
};

export type LibraryItemPublicKpi = {
  __typename?: 'LibraryItemPublicKPI';
  ID: Scalars['Int'];
  ItemEnquiries?: Maybe<Scalars['Int']>;
  ItemImpressions?: Maybe<Scalars['Int']>;
  ItemPageViews?: Maybe<Scalars['Int']>;
  ItemReferrals?: Maybe<Scalars['Int']>;
  ItemSaves?: Maybe<Scalars['Int']>;
  ItemTimeSpent?: Maybe<Scalars['Int']>;
};

export enum LibraryItemRelationshipEnumType {
  Installers = 'Installers',
  Partner = 'Partner',
  ProductsUsed = 'ProductsUsed',
  ProductsWeRetail = 'ProductsWeRetail',
  ProfessionalsUsed = 'ProfessionalsUsed'
}

export type LibraryLocation = SortableItem & {
  __typename?: 'LibraryLocation';
  Address1?: Maybe<Scalars['String']>;
  Address2?: Maybe<Scalars['String']>;
  AllowsDispatch?: Maybe<Scalars['Boolean']>;
  AllowsPickup: Scalars['Boolean'];
  City?: Maybe<Scalars['String']>;
  Country?: Maybe<Scalars['String']>;
  DispatchEstimate: MinMax;
  District?: Maybe<Scalars['String']>;
  FormattedAddress: Scalars['String'];
  ID: Scalars['Int'];
  LocationHidden: Scalars['Boolean'];
  MapAddress?: Maybe<Scalars['String']>;
  MapCoordinates: Coordinate;
  MemberSortOrder: Scalars['Int'];
  Phone?: Maybe<Scalars['String']>;
  PickupEstimate: MinMax;
  PickupEstimateText: Scalars['String'];
  PostCode?: Maybe<Scalars['String']>;
  Region?: Maybe<Scalars['String']>;
  RegionType?: Maybe<Region>;
  State?: Maybe<Scalars['String']>;
  Suburb?: Maybe<Scalars['String']>;
  Title: Scalars['String'];
  Type: Scalars['String'];
  ZoomLevel?: Maybe<Scalars['Int']>;
};

export type LibraryLocationUpdatesList = {
  Address1?: InputMaybe<Scalars['StringInput']>;
  Address2?: InputMaybe<Scalars['StringInput']>;
  AllowsDispatch?: InputMaybe<Scalars['Boolean']>;
  AllowsPickup?: InputMaybe<Scalars['Boolean']>;
  City?: InputMaybe<Scalars['StringInput']>;
  Country?: InputMaybe<Scalars['StringInput']>;
  DispatchEstimate?: InputMaybe<MinMaxInput>;
  ID: Scalars['Int'];
  LocationHidden?: InputMaybe<Scalars['Boolean']>;
  MapAddress?: InputMaybe<Scalars['StringInput']>;
  MapCoordinates?: InputMaybe<CoordinateInput>;
  MemberSortOrder?: InputMaybe<Scalars['Int']>;
  Phone?: InputMaybe<Scalars['StringInput']>;
  PickupEstimate?: InputMaybe<MinMaxInput>;
  PickupEstimateText?: InputMaybe<Scalars['StringInput']>;
  PostCode?: InputMaybe<Scalars['StringInput']>;
  Region?: InputMaybe<Scalars['StringInput']>;
  SortOrder?: InputMaybe<Scalars['Int']>;
  Suburb?: InputMaybe<Scalars['StringInput']>;
  Title?: InputMaybe<Scalars['StringInput']>;
  Type?: InputMaybe<Scalars['StringInput']>;
  ZoomLevel?: InputMaybe<Scalars['Int']>;
};

export type LibraryPageVersion = DataObject & {
  __typename?: 'LibraryPageVersion';
  author?: Maybe<Member>;
  deleted?: Maybe<Scalars['Boolean']>;
  draft?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  latestDraftVersion?: Maybe<Scalars['Boolean']>;
  liveVersion?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  publisher?: Maybe<Member>;
  version?: Maybe<Scalars['Int']>;
};

export type LibraryPageVersionConnection = {
  __typename?: 'LibraryPageVersionConnection';
  edges: Array<LibraryPageVersionConnectionEdge>;
  nodes?: Maybe<Array<Maybe<LibraryPageVersion>>>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type LibraryPageVersionConnectionEdge = {
  __typename?: 'LibraryPageVersionConnectionEdge';
  /** The node at the end of the collections edge */
  node: LibraryPageVersion;
};

export type LibraryPinUpdateResultType = Article | NotAuthorizedError | Product | Professional | Project | UserError;

export type LibraryRange = {
  __typename?: 'LibraryRange';
  Categories: Array<Category>;
  HasPublicItems: Scalars['Boolean'];
  ID: Scalars['Int'];
  Professional?: Maybe<Professional>;
  SortOrder: Scalars['Int'];
  Title: Scalars['String'];
  URLSlug: Scalars['String'];
};

export type LibraryTab = {
  __typename?: 'LibraryTab';
  Content?: Maybe<Scalars['String']>;
  ID: Scalars['Int'];
  MemberSortOrder: Scalars['Int'];
  Title: Scalars['String'];
};

export type LibraryTabUpdate = {
  Content?: InputMaybe<Scalars['StringInput']>;
  /** ID of the library tab */
  ID: Scalars['Int'];
  MemberSortOrder?: InputMaybe<Scalars['Int']>;
  Title?: InputMaybe<Scalars['StringInput']>;
};

/**
 * Deprecated - use the `ThumbnailFile` field with the PositionedImage(width, height) resolver instead.
 * DOC: https://archipro.atlassian.net/wiki/x/B4CXag
 *
 */
export type LibraryThumb = {
  __typename?: 'LibraryThumb';
  /** Aspect ratio of raw uploaded photo */
  AspectRatio: Scalars['Float'];
  ID: Scalars['Int'];
  IsClearCut: Scalars['Boolean'];
  IsMultiplied: Scalars['Boolean'];
  /** is raw image portrait, backend treats square image as portrait */
  IsPortrait: Scalars['Boolean'];
  /**
   * Deprecated - use the `ThumbnailFile` field with the PositionedImage(width, height) resolver instead.
   * DOC: https://archipro.atlassian.net/wiki/x/B4CXag
   *
   */
  LibraryImage?: Maybe<LibraryImage>;
  ScrollPosX: Scalars['Int'];
  ScrollPosY: Scalars['Int'];
  /**
   * Deprecated - use the `ThumbnailFile` field with the PositionedImage(width, height) resolver instead.
   * DOC: https://archipro.atlassian.net/wiki/x/B4CXag
   *
   */
  ThumbImageFile?: Maybe<LibraryImageFile>;
  ZoomLevel: Scalars['Int'];
};

export type LibraryVideo = SortableItem & {
  __typename?: 'LibraryVideo';
  CreatedDate?: Maybe<Scalars['String']>;
  ID: Scalars['Int'];
  /** The LibraryImage to use as this video's thumbnail */
  LibraryImage?: Maybe<LibraryImage>;
  /** DirectoryItem associated with this LibraryImage */
  LibraryItem?: Maybe<DirectoryItem>;
  MemberSortOrder: Scalars['Int'];
  SortOrder: Scalars['Int'];
  /** The thumbnail image URL - either from an uploaded LibraryImage or pulled from YouTube */
  ThumbnailImageQuick?: Maybe<Scalars['String']>;
  /** The thumbnail URL from Youtube or Vimeo, to be used as a fallback if LibraryImage isn't set. */
  ThumbnailOfficial?: Maybe<Scalars['String']>;
  Title?: Maybe<Scalars['String']>;
  /** Is this a YouTube or Vimeo video? */
  Type: Scalars['String'];
  VideoID: Scalars['String'];
  /** Full video url constructed using base url depending on video type and video id. */
  VideoLink?: Maybe<Scalars['String']>;
};

export type LinkAwardToEntityMutationType = Award | NotAuthorizedError | NotFoundError;

export type ListArticlesFilter = {
  eq: Scalars['String'];
  field: ListArticlesFilterFields;
};

export enum ListArticlesFilterFields {
  AuthorId = 'AuthorID',
  Category = 'Category',
  DataScoreMax = 'DataScoreMax',
  DataScoreMin = 'DataScoreMin',
  InLibraryOnly = 'InLibraryOnly',
  InProfileOnly = 'InProfileOnly',
  IsTemplate = 'IsTemplate',
  Keyword = 'Keyword',
  PendingTag = 'PendingTag',
  Professional = 'Professional',
  ProfessionalAuthorId = 'ProfessionalAuthorID',
  ProfessionalId = 'ProfessionalID',
  PublishDateMax = 'PublishDateMax',
  PublishDateMin = 'PublishDateMin',
  StaffAuthors = 'StaffAuthors',
  Status = 'Status'
}

export type ListClickEngagementEvents_Cursor = {
  __typename?: 'ListClickEngagementEvents_Cursor';
  ID: Scalars['String'];
  /** Cursor information */
  Info: Info;
  /** Collection of records */
  Rows: Array<EngagementEvent>;
};

export type ListConnectionPageInfo = {
  __typename?: 'ListConnectionPageInfo';
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  totalCount: Scalars['Int'];
};

export type ListDesignBoardsSimpleSortFields = {
  LastEdited?: InputMaybe<SortDirection>;
};

export type ListDesignBoards_Connection = {
  __typename?: 'ListDesignBoards_Connection';
  ID: Scalars['String'];
  edges: Array<ListDesignBoards_ConnectionEdge>;
  nodes: Array<DesignBoard>;
  pageInfo: ApPageInfo;
};

/** The collections edge */
export type ListDesignBoards_ConnectionEdge = {
  __typename?: 'ListDesignBoards_ConnectionEdge';
  /** The node at the end of the collections edge */
  node: DesignBoard;
};

export type ListDigitalPublicationRecipientClicksConnection = {
  __typename?: 'ListDigitalPublicationRecipientClicksConnection';
  ID: Scalars['String'];
  edges: Array<ListDigitalPublicationRecipientClicksConnectionEdge>;
  nodes: Array<PublicationRecipientEvent>;
  pageInfo: ApPageInfo;
};

/** The collections edge */
export type ListDigitalPublicationRecipientClicksConnectionEdge = {
  __typename?: 'ListDigitalPublicationRecipientClicksConnectionEdge';
  /** The node at the end of the collections edge */
  node: PublicationRecipientEvent;
};

export type ListDirectoryItemsByCategorySimpleSortFields = {
  Activated?: InputMaybe<SortDirection>;
  ID?: InputMaybe<SortDirection>;
  InLibrary?: InputMaybe<SortDirection>;
  MemberSortOrder?: InputMaybe<SortDirection>;
  Price?: InputMaybe<SortDirection>;
  Publish?: InputMaybe<SortDirection>;
  SortOrder?: InputMaybe<SortDirection>;
  Title?: InputMaybe<SortDirection>;
  URLSegment?: InputMaybe<SortDirection>;
  Website?: InputMaybe<SortDirection>;
};

export type ListDirectoryItemsFilter = {
  eq: Scalars['String'];
  field: ListDirectoryItemsFilterFields;
};

export enum ListDirectoryItemsFilterFields {
  Archived = 'Archived',
  Category = 'Category',
  ContentLocked = 'ContentLocked',
  ContentStatus = 'ContentStatus',
  DataScore = 'DataScore',
  DataSource = 'DataSource',
  Deleted = 'Deleted',
  ECommerce = 'ECommerce',
  ExcludeAdvertising = 'ExcludeAdvertising',
  ExcludedFromSpecialtyRates = 'ExcludedFromSpecialtyRates',
  HasSupplierProductId = 'HasSupplierProductID',
  IsFeatured = 'IsFeatured',
  LastExternalUpdateMax = 'LastExternalUpdateMax',
  LastExternalUpdateMin = 'LastExternalUpdateMin',
  MissingCategory = 'MissingCategory',
  MissingPackageSize = 'MissingPackageSize',
  Pricing = 'Pricing',
  PublishDateMax = 'PublishDateMax',
  PublishDateMin = 'PublishDateMin',
  Purchasable = 'Purchasable',
  Range = 'Range',
  Sample = 'Sample',
  Status = 'Status'
}

export type ListDirectoryItemsSimpleSortFields = {
  Activated?: InputMaybe<SortDirection>;
  ID?: InputMaybe<SortDirection>;
  InLibrary?: InputMaybe<SortDirection>;
  Price?: InputMaybe<SortDirection>;
  Publish?: InputMaybe<SortDirection>;
  Title?: InputMaybe<SortDirection>;
  URLSegment?: InputMaybe<SortDirection>;
  Website?: InputMaybe<SortDirection>;
};

export type ListEngagementEvents_Cursor = {
  __typename?: 'ListEngagementEvents_Cursor';
  ID: Scalars['String'];
  /** Cursor information */
  Info: Info;
  /** Collection of records */
  Rows: Array<EngagementEvent>;
};

export type ListEnquiryConversationsSimpleSortFields = {
  LastCommentedOn?: InputMaybe<SortDirection>;
};

export type ListEnquiryConversations_Connection = {
  __typename?: 'ListEnquiryConversations_Connection';
  ID: Scalars['String'];
  nodes: Array<EnquiryConversation>;
  pageInfo: ApPageInfo;
};

export type ListLibraryImagesSimpleSortFields = {
  Activated?: InputMaybe<SortDirection>;
  ID?: InputMaybe<SortDirection>;
  InLibrary?: InputMaybe<SortDirection>;
  Price?: InputMaybe<SortDirection>;
  Publish?: InputMaybe<SortDirection>;
  Title?: InputMaybe<SortDirection>;
  URLSegment?: InputMaybe<SortDirection>;
  Website?: InputMaybe<SortDirection>;
};

export type ListLibraryImages_Connection = {
  __typename?: 'ListLibraryImages_Connection';
  ID: Scalars['String'];
  edges: Array<ListLibraryImages_ConnectionEdge>;
  nodes: Array<LibraryImage>;
  pageInfo: ApPageInfo;
};

/** The collections edge */
export type ListLibraryImages_ConnectionEdge = {
  __typename?: 'ListLibraryImages_ConnectionEdge';
  /** The node at the end of the collections edge */
  node: LibraryImage;
};

export type ListLibraryRangeItemsSimpleSortFields = {
  Activated?: InputMaybe<SortDirection>;
  ID?: InputMaybe<SortDirection>;
  InLibrary?: InputMaybe<SortDirection>;
  Price?: InputMaybe<SortDirection>;
  Publish?: InputMaybe<SortDirection>;
  Title?: InputMaybe<SortDirection>;
  URLSegment?: InputMaybe<SortDirection>;
  Website?: InputMaybe<SortDirection>;
};

export type ListLibraryRangeItems_Connection = {
  __typename?: 'ListLibraryRangeItems_Connection';
  ID: Scalars['String'];
  edges: Array<ListLibraryRangeItems_ConnectionEdge>;
  nodes: Array<DirectoryItem>;
  pageInfo: ApPageInfo;
};

/** The collections edge */
export type ListLibraryRangeItems_ConnectionEdge = {
  __typename?: 'ListLibraryRangeItems_ConnectionEdge';
  /** The node at the end of the collections edge */
  node: DirectoryItem;
};

export type ListPinsConnection = {
  __typename?: 'ListPinsConnection';
  ID: Scalars['String'];
  edges: Array<ListPinsConnectionEdge>;
  nodes: Array<Pin>;
  pageInfo: ApPageInfo;
};

/** The collections edge */
export type ListPinsConnectionEdge = {
  __typename?: 'ListPinsConnectionEdge';
  /** The node at the end of the collections edge */
  node: Pin;
};

export type ListProfessionalNetworkSuggestionsInputType = {
  /** Only return professionals that are in any of the given categories. */
  CategoryURLSegments?: InputMaybe<Array<Scalars['String']>>;
  /** If true, will only return professionals local to the region. */
  LimitToRegion?: InputMaybe<Scalars['Boolean']>;
  ShowChildCategories?: InputMaybe<Scalars['Boolean']>;
};

export type ListProfessionalPartnersFilterType = {
  excludeDisabled?: InputMaybe<Scalars['Boolean']>;
  keyword?: InputMaybe<Scalars['String']>;
  professionalCategories?: InputMaybe<Array<Scalars['String']>>;
  sortBy?: InputMaybe<Scalars['String']>;
};

export type ListProfessionalProjectsSimpleSortFields = {
  ID?: InputMaybe<SortDirection>;
  Title?: InputMaybe<SortDirection>;
};

export type ListProfessionalProjects_Connection = {
  __typename?: 'ListProfessionalProjects_Connection';
  ID: Scalars['String'];
  edges: Array<ListProfessionalProjects_ConnectionEdge>;
  nodes: Array<Project>;
  pageInfo: ApPageInfo;
};

/** The collections edge */
export type ListProfessionalProjects_ConnectionEdge = {
  __typename?: 'ListProfessionalProjects_ConnectionEdge';
  /** The node at the end of the collections edge */
  node: Project;
};

export type ListProjectsFilter = {
  eq: Scalars['String'];
  field: ListProjectsFilterFields;
};

export enum ListProjectsFilterFields {
  Category = 'Category',
  DataScoreMax = 'DataScoreMax',
  DataScoreMin = 'DataScoreMin',
  IsFeatured = 'IsFeatured',
  IsTemplate = 'IsTemplate',
  Keyword = 'Keyword',
  PendingTag = 'PendingTag',
  Professional = 'Professional',
  ProfessionalCategory = 'ProfessionalCategory',
  PublishDateMax = 'PublishDateMax',
  PublishDateMin = 'PublishDateMin',
  Status = 'Status'
}

export type ListPublicationOpenedRecipientsConnection = {
  __typename?: 'ListPublicationOpenedRecipientsConnection';
  ID: Scalars['String'];
  edges: Array<ListPublicationOpenedRecipientsConnectionEdge>;
  nodes: Array<PublicationRecipient>;
  pageInfo: ApPageInfo;
};

/** The collections edge */
export type ListPublicationOpenedRecipientsConnectionEdge = {
  __typename?: 'ListPublicationOpenedRecipientsConnectionEdge';
  /** The node at the end of the collections edge */
  node: PublicationRecipient;
};

export type ListPublications_Cursor = {
  __typename?: 'ListPublications_Cursor';
  ID: Scalars['String'];
  /** Cursor information */
  Info: Info;
  /** Collection of records */
  Rows: Array<PromotionalStat>;
};

export type ListSocialAds_Cursor = {
  __typename?: 'ListSocialAds_Cursor';
  ID: Scalars['String'];
  /** Cursor information */
  Info: Info;
  /** Collection of records */
  Rows: Array<PromotionalStat>;
};

export type ListTeamMembersByUrlSegmentConnection = {
  __typename?: 'ListTeamMembersByURLSegmentConnection';
  edges: Array<ListTeamMembersByUrlSegmentConnectionEdge>;
  nodes: Array<TeamMember>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ListTeamMembersByUrlSegmentConnectionEdge = {
  __typename?: 'ListTeamMembersByURLSegmentConnectionEdge';
  /** The node at the end of the collections edge */
  node: TeamMember;
};

export type ListTeamMembersByUrlSegmentFilters = {
  Approved__eq?: InputMaybe<Scalars['Boolean']>;
  IsPublic__eq?: InputMaybe<Scalars['Boolean']>;
  Name__contains?: InputMaybe<Scalars['String']>;
};

export type ListTeamMembersByUrlSegmentSimpleSortFields = {
  MemberSortOrder?: InputMaybe<SortDirection>;
  Name?: InputMaybe<SortDirection>;
};

export type ListWebsiteNotifications_Connection = {
  __typename?: 'ListWebsiteNotifications_Connection';
  ID: Scalars['String'];
  edges: Array<ListWebsiteNotifications_ConnectionEdge>;
  nodes: Array<WebsiteNotificationInterface>;
  pageInfo: ApPageInfo;
};

/** The collections edge */
export type ListWebsiteNotifications_ConnectionEdge = {
  __typename?: 'ListWebsiteNotifications_ConnectionEdge';
  /** The node at the end of the collections edge */
  node: WebsiteNotificationInterface;
};

export type LocalitiesSimpleSortFields = {
  Title?: InputMaybe<SortDirection>;
};

export type Locality = {
  __typename?: 'Locality';
  GeoPostcode?: Maybe<Scalars['String']>;
  GeoRegion?: Maybe<Scalars['String']>;
  GeoStreetName?: Maybe<Scalars['String']>;
  GeoStreetNumber?: Maybe<Scalars['String']>;
  GeoSuburb?: Maybe<Scalars['String']>;
  GeoTownCity?: Maybe<Scalars['String']>;
  ID: Scalars['Int'];
  Latitude?: Maybe<Scalars['String']>;
  Longitude?: Maybe<Scalars['String']>;
  Postcode: Scalars['String'];
  Region: Region;
  Title: Scalars['String'];
};

export type LocalityConnection = {
  __typename?: 'LocalityConnection';
  ID: Scalars['String'];
  edges: Array<LocalityConnectionEdge>;
  nodes: Array<Locality>;
  pageInfo: ApPageInfo;
};

/** The collections edge */
export type LocalityConnectionEdge = {
  __typename?: 'LocalityConnectionEdge';
  /** The node at the end of the collections edge */
  node: Locality;
};

export type LocationData = {
  __typename?: 'LocationData';
  ID: Scalars['String'];
  Location: Scalars['String'];
  Percentage: Scalars['Float'];
  Users: Scalars['String'];
};

export type LocationFilterInput = {
  City?: InputMaybe<Scalars['String']>;
  Country?: InputMaybe<Scalars['String']>;
  District?: InputMaybe<Scalars['String']>;
  Region?: InputMaybe<Scalars['String']>;
  State?: InputMaybe<Scalars['String']>;
  Suburb?: InputMaybe<Scalars['String']>;
};

export type LocationsConnection = {
  __typename?: 'LocationsConnection';
  edges: Array<LocationsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type LocationsConnectionEdge = {
  __typename?: 'LocationsConnectionEdge';
  /** The node at the end of the collections edge */
  node: LibraryLocation;
};

export type LoginInput = {
  Email: Scalars['Email'];
  Password: Scalars['StringInput'];
  RememberMe?: InputMaybe<Scalars['Boolean']>;
};

export type LoginResult = {
  __typename?: 'LoginResult';
  Member: Me;
  RequiresMfa: Scalars['Boolean'];
  ServerToken: Scalars['String'];
};

export type LogoCarouselModule = ModuleType & {
  __typename?: 'LogoCarouselModule';
  AnchorTag?: Maybe<Scalars['String']>;
  ExtraClass?: Maybe<Scalars['String']>;
  ID: Scalars['ID'];
  /** logo images */
  Logos: Logos_Connection;
  NavigationLabel?: Maybe<Scalars['String']>;
  SmallPrint?: Maybe<Scalars['String']>;
  SpacingBelow?: Maybe<Scalars['String']>;
  SpacingBelowMobile?: Maybe<Scalars['String']>;
  ThemeColour: ThemedElementColourType;
};


export type LogoCarouselModuleLogosArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Logos_SortFields>;
};

export type Logos_Connection = {
  __typename?: 'Logos_Connection';
  edges: Array<Logos_ConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type Logos_ConnectionEdge = {
  __typename?: 'Logos_ConnectionEdge';
  /** The node at the end of the collections edge */
  node: ResponsiveSingleImage;
};

export type Logos_SortFields = {
  SortOrder?: InputMaybe<SortDirection>;
};

export type MgeFormInput = {
  ApplicationType: MgeFormTypeEnum;
  BringingGuest?: InputMaybe<Scalars['Boolean']>;
  CompanyName?: InputMaybe<Scalars['String']>;
  CompanyType?: InputMaybe<Scalars['String']>;
  CompanyWebsite?: InputMaybe<Scalars['String']>;
  Email?: InputMaybe<Scalars['String']>;
  EventIDs: Array<InputMaybe<Scalars['Int']>>;
  FirstName?: InputMaybe<Scalars['String']>;
  GuestEmail?: InputMaybe<Scalars['String']>;
  GuestFirstName?: InputMaybe<Scalars['String']>;
  GuestLastName?: InputMaybe<Scalars['String']>;
  GuestPhone?: InputMaybe<Scalars['String']>;
  HDEOtherPleaseSpecify?: InputMaybe<Scalars['String']>;
  HearAboutMGE?: InputMaybe<Scalars['String']>;
  LastName?: InputMaybe<Scalars['String']>;
  Phone?: InputMaybe<Scalars['String']>;
  ProjectArchitect?: InputMaybe<Scalars['String']>;
  ProjectAttendanceReason?: InputMaybe<Scalars['String']>;
  ProjectBudget?: InputMaybe<Scalars['String']>;
  ProjectLending?: InputMaybe<Scalars['String']>;
  ProjectLocation?: InputMaybe<Scalars['String']>;
  ProjectLocationPostcode?: InputMaybe<Scalars['String']>;
  ProjectProductInterest?: InputMaybe<Scalars['String']>;
  ProjectStage?: InputMaybe<Scalars['String']>;
  ProjectType?: InputMaybe<Scalars['String']>;
  PropertyOwned?: InputMaybe<Scalars['Boolean']>;
  PropertySize?: InputMaybe<Scalars['String']>;
  TimeSlot?: InputMaybe<Scalars['String']>;
};

export enum MgeFormTypeEnum {
  Exhibitor = 'Exhibitor',
  Homeowner = 'Homeowner',
  Professional = 'Professional'
}

export type MapMaker = {
  __typename?: 'MapMaker';
  City?: Maybe<Scalars['String']>;
  Coordinates?: Maybe<Coordinates>;
  Country: Scalars['String'];
  ID: Scalars['String'];
  Region?: Maybe<Scalars['String']>;
  Value: Scalars['Int'];
};

/** Individual marketing guide item with step number, description, link and image */
export type MarketingGuideItem = {
  __typename?: 'MarketingGuideItem';
  /** Descriptive text for this guide */
  description: Scalars['String'];
  /** URL for the guide image */
  image: Scalars['String'];
  /** URL or path to the guide details */
  link: Scalars['String'];
  /** Name of the guide PDF */
  pdfName?: Maybe<Scalars['String']>;
  /** URL for the guide PDF */
  pdfUrl?: Maybe<Scalars['String']>;
  /** The step number for this guide */
  step: Scalars['Int'];
};

export type Material = {
  __typename?: 'Material';
  ID: Scalars['Int'];
  Label: Scalars['String'];
  Name: Scalars['String'];
};

export type Me = User & {
  __typename?: 'Me';
  APID: Scalars['String'];
  AgeGroup?: Maybe<Scalars['String']>;
  ArchiproProfilePage: Scalars['String'];
  AuthToken?: Maybe<Scalars['String']>;
  Budget?: Maybe<Scalars['String']>;
  BuildStatus?: Maybe<Scalars['String']>;
  Company: Scalars['String'];
  DesignBoard: DesignBoardResult;
  DesignBoards: ListDesignBoards_Connection;
  DesignBoardsPins: DesignBoardPinsConnection;
  EcommerceBookingURL: Scalars['String'];
  Email: Scalars['String'];
  Enrichment?: Maybe<Scalars['String']>;
  FeatureFlags: Array<FeatureFlag>;
  FirstName: Scalars['String'];
  HashedEmail: Scalars['String'];
  HomeownerPurpose?: Maybe<HomeownerPurpose>;
  HomeownerStage?: Maybe<HomeownerStage>;
  ID: Scalars['Int'];
  Industry?: Maybe<Scalars['String']>;
  Initials?: Maybe<Scalars['String']>;
  IntercomHash: Scalars['String'];
  IsActive: Scalars['Boolean'];
  IsArchiproStaff: Scalars['Boolean'];
  IsEditorialTeam: Scalars['Boolean'];
  IsHighAdmin: Scalars['Boolean'];
  IsLeadershipTeam: Scalars['Boolean'];
  IsSalesAdmin: Scalars['Boolean'];
  IsStaffAdmin: Scalars['Boolean'];
  JobTitle?: Maybe<Scalars['String']>;
  LastName: Scalars['String'];
  MemberImage?: Maybe<MemberImage>;
  MemberOAuths?: Maybe<Array<MemberOAuth>>;
  MfaType?: Maybe<MfaConfigEnumType>;
  ModalAds: Array<Scalars['String']>;
  Name: Scalars['String'];
  OrderNotificationCount: Scalars['Int'];
  Orders: Array<Order>;
  OwnedBuildHubs: Array<BuildHub>;
  PasswordLastChanged?: Maybe<Scalars['String']>;
  /** Active account deletion request if one exists (where RestoredAt IS NULL) */
  PendingDeletionRequest?: Maybe<AccountDeletionRequest>;
  Permissions: Array<PermissionEnum>;
  Phone: Scalars['String'];
  PostSignupQuestionnaireSeen: Scalars['Boolean'];
  ProfessionalCategory?: Maybe<ProfessionalCategory>;
  ProfessionalCategoryUpdatedAt?: Maybe<Scalars['String']>;
  ProfessionalLisitingInterest?: Maybe<Scalars['Boolean']>;
  ProfessionalTargetMarket?: Maybe<ProfessionalTargetMarketType>;
  ProfessionalType: Scalars['String'];
  ProfessionalTypeIsUserSelected: Scalars['Boolean'];
  Professionals: Array<MemberProfessional>;
  ProfileImage: Scalars['String'];
  ProfileImageComments: Scalars['String'];
  ProfileImageLink?: Maybe<Scalars['String']>;
  Region: Scalars['String'];
  RegionCoordinates?: Maybe<Coordinate>;
  RegisteredPushDevices: Array<UserPushDevice>;
  Section?: Maybe<Scalars['Boolean']>;
  ShoppingCart?: Maybe<ShoppingCart>;
  Style?: Maybe<Scalars['String']>;
  Surname?: Maybe<Scalars['String']>;
  TaggedProducts: Array<Product>;
  TaggedProfessionals: Array<Professional>;
  TeamMembers: Array<TeamMember>;
  TempPassword: Scalars['Boolean'];
  TrackedGuest?: Maybe<Guest>;
  UserClassification?: Maybe<UserClassificationType>;
  UserClassificationUpdatedAt?: Maybe<Scalars['String']>;
  UserType: Scalars['String'];
  Website: Scalars['String'];
  When?: Maybe<Scalars['String']>;
  Where?: Maybe<Scalars['String']>;
  calendarConnection: Array<CalendarConnectionSummary>;
};


export type MeDesignBoardArgs = {
  Link: Scalars['String'];
};


export type MeDesignBoardsArgs = {
  filter?: InputMaybe<DesignBoardsFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<DesignBoardsSimpleSortFields>;
};


export type MeDesignBoardsPinsArgs = {
  filter?: InputMaybe<DesignBoardsPinsFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<DesignBoardsPinsSimpleSortFields>;
};


export type MeTaggedProductsArgs = {
  Limit?: InputMaybe<Scalars['Int']>;
};


export type MeTaggedProfessionalsArgs = {
  Limit?: InputMaybe<Scalars['Int']>;
};

export type Member = ArticleAuthor & DataObject & ParticipantIdentity & PermissionInterface & {
  __typename?: 'Member';
  ArchiProEditorial: Scalars['Boolean'];
  Email?: Maybe<Scalars['String']>;
  FirstName: Scalars['String'];
  ID: Scalars['Int'];
  Initials?: Maybe<Scalars['String']>;
  IsEditorialTeam: Scalars['Boolean'];
  LastName: Scalars['String'];
  MemberImage?: Maybe<MemberImage>;
  Name: Scalars['String'];
  Permissions: Array<PermissionEnum>;
  Phone: Scalars['String'];
  ProfessionalCategory?: Maybe<ProfessionalCategory>;
  ProfessionalTypeIsUserSelected: Scalars['Boolean'];
  Professionals: Array<MemberProfessional>;
  ProfileImageLink?: Maybe<Scalars['String']>;
  Region?: Maybe<Scalars['String']>;
  Surname?: Maybe<Scalars['String']>;
  UserType: Scalars['String'];
  id: Scalars['ID'];
};

export type MemberCalendarOAuth = {
  __typename?: 'MemberCalendarOAuth';
  AccessToken?: Maybe<Scalars['String']>;
  ConnectedAt?: Maybe<Scalars['String']>;
  DisplayName?: Maybe<Scalars['String']>;
  Email?: Maybe<Scalars['String']>;
  ExpiresAt?: Maybe<Scalars['String']>;
  ID: Scalars['Int'];
  IsTokenExpired?: Maybe<Scalars['Boolean']>;
  IsValid?: Maybe<Scalars['Boolean']>;
  LastSyncAt?: Maybe<Scalars['String']>;
  MemberID?: Maybe<Scalars['Int']>;
  Provider?: Maybe<Scalars['String']>;
  RefreshToken?: Maybe<Scalars['String']>;
};

export type MemberConnection = {
  __typename?: 'MemberConnection';
  edges: Array<MemberConnectionEdge>;
  nodes: Array<Member>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type MemberConnectionEdge = {
  __typename?: 'MemberConnectionEdge';
  /** The node at the end of the collections edge */
  node: Member;
};

export type MemberEnquiryEmail = {
  __typename?: 'MemberEnquiryEmail';
  CommentID?: Maybe<Scalars['Int']>;
  EmailMsgID?: Maybe<Scalars['String']>;
  EmailThreadID?: Maybe<Scalars['String']>;
  EmailTime?: Maybe<Scalars['String']>;
  EnquiryConversationID: Scalars['Int'];
  EnquiryID: Scalars['Int'];
  FromEmail?: Maybe<Scalars['String']>;
  ID: Scalars['Int'];
  InReplyTo?: Maybe<Scalars['String']>;
  IsFromSentBox: Scalars['Boolean'];
  MemberID: Scalars['Int'];
  MemberOAuthID: Scalars['Int'];
  MessageID?: Maybe<Scalars['Int']>;
  ProfessionalID: Scalars['Int'];
  Provider?: Maybe<Scalars['String']>;
  RawEmail?: Maybe<Scalars['String']>;
  Subject?: Maybe<Scalars['String']>;
  ToEmail?: Maybe<Scalars['String']>;
  UniqueBody?: Maybe<Scalars['String']>;
};

/** Message sent when a user sends an enquiry to a professional. */
export type MemberEnquiryMessage = Message & {
  __typename?: 'MemberEnquiryMessage';
  Attachments: Array<MemberUpload>;
  BuildHub?: Maybe<BuildHub>;
  BuildHubFieldSelection?: Maybe<Scalars['String']>;
  Content: Scalars['String'];
  Created: Scalars['String'];
  CreatedBy: Scalars['String'];
  FirstReadBy: FirstReadBy;
  ID: Scalars['ID'];
  LibraryItems: Array<DirectoryItem>;
  MemberEnquiryEmail?: Maybe<MemberEnquiryEmail>;
  Participant: Participant;
};

export type MemberImage = {
  __typename?: 'MemberImage';
  Avatar?: Maybe<Scalars['String']>;
  DetailsPage?: Maybe<Scalars['String']>;
  FileName?: Maybe<Scalars['String']>;
  ID: Scalars['Int'];
  LargeAvatar?: Maybe<Scalars['String']>;
  Logo?: Maybe<Scalars['String']>;
  TeamMemberDisplay?: Maybe<Scalars['String']>;
};


export type MemberImageAvatarArgs = {
  Height: Scalars['Int'];
  Width: Scalars['Int'];
};

export type MemberOAuth = {
  __typename?: 'MemberOAuth';
  AccessToken?: Maybe<Scalars['String']>;
  Disabled?: Maybe<Scalars['Boolean']>;
  ExpiresAt?: Maybe<Scalars['String']>;
  From?: Maybe<Scalars['String']>;
  ID: Scalars['Int'];
  MemberID?: Maybe<Scalars['Int']>;
  OAuthEmail?: Maybe<Scalars['String']>;
  Provider?: Maybe<Scalars['String']>;
  RefreshToken?: Maybe<Scalars['String']>;
  Scope?: Maybe<Scalars['String']>;
  SyncedAt?: Maybe<Scalars['String']>;
};

export type MemberOrdersSimpleSortFields = {
  Created?: InputMaybe<SortDirection>;
  OrderNumber?: InputMaybe<SortDirection>;
};

export type MemberParticipant = Participant & {
  __typename?: 'MemberParticipant';
  ID: Scalars['ID'];
  Identity: ParticipantIdentity;
  Member: Member;
};

export type MemberProfessional = {
  __typename?: 'MemberProfessional';
  AnalyticsEnabled: Scalars['Boolean'];
  AnalyticsStatus: AnalyticsStatusEnum;
  BusinessFocus: Scalars['String'];
  CanEdit: Scalars['Boolean'];
  CompanyLogo: Scalars['String'];
  CompanyLogo48Resized?: Maybe<Scalars['String']>;
  CompanyLogo96Resized?: Maybe<Scalars['String']>;
  Country: Scalars['String'];
  EcommerceEnabled: Scalars['Boolean'];
  HasClones: Scalars['Boolean'];
  HasEcommerceEmail: Scalars['Boolean'];
  HasInboxAccess: Scalars['Boolean'];
  ID: Scalars['Int'];
  IsCloned: Scalars['Boolean'];
  IsCollaborator: Scalars['Boolean'];
  IsManufacturer: Scalars['Boolean'];
  IsTeamMember: Scalars['Boolean'];
  LibraryLocationsCount: Scalars['Int'];
  Link: Scalars['String'];
  LogoBackgroundColor?: Maybe<Scalars['String']>;
  MetaData: ProfessionalMetaData;
  PrimaryDomain: Scalars['String'];
  ServiceableAreasCount: Scalars['Int'];
  StripeAccountEnabled: Scalars['Boolean'];
  Title: Scalars['String'];
  TradePricing: Array<SpecialtyRateCategories>;
  URLSegment: Scalars['String'];
  Website: Scalars['String'];
};

export type MemberUpload = DesignBoardPinTarget & {
  __typename?: 'MemberUpload';
  Created: Scalars['String'];
  FileName?: Maybe<Scalars['String']>;
  ID: Scalars['Int'];
  Link: Scalars['String'];
  PhotoTile?: Maybe<Scalars['String']>;
  Title: Scalars['String'];
};

export type MemberUploadPin = {
  __typename?: 'MemberUploadPin';
  BoardID: Scalars['Int'];
  BoardURLSegment: Scalars['String'];
  CanDelete: Scalars['Boolean'];
  Caption?: Maybe<Scalars['String']>;
  Comments?: Maybe<Array<Maybe<Comment>>>;
  CommentsCount: Scalars['Int'];
  CreatedBy?: Maybe<Member>;
  Filename?: Maybe<Scalars['String']>;
  HasUnreadComments: Scalars['Boolean'];
  ID: Scalars['Int'];
  Permission: PinPermission;
  PhotoModal?: Maybe<Scalars['String']>;
  PhotoTile?: Maybe<Scalars['String']>;
  Title?: Maybe<Scalars['String']>;
  TypeID: Scalars['Int'];
  UploadedBy?: Maybe<Member>;
};

export type Message = {
  Created: Scalars['String'];
  CreatedBy: Scalars['String'];
  FirstReadBy: FirstReadBy;
  ID: Scalars['ID'];
  MemberEnquiryEmail?: Maybe<MemberEnquiryEmail>;
  Participant: Participant;
};

export type Meta = {
  __typename?: 'Meta';
  Canonical?: Maybe<Scalars['String']>;
  ExtraMeta: Scalars['String'];
  ID: Scalars['Int'];
  MetaDescription: Scalars['String'];
  MetaKeywords: Scalars['String'];
  SearchTags: Array<SearchTag>;
  SocialDescription: Scalars['String'];
  SocialPreviewImage?: Maybe<Scalars['String']>;
  SocialTitle: Scalars['String'];
  Title: Scalars['String'];
};

export type MetaAdCampaignConversionsFilters = {
  EXTERNAL_FACEBOOKCAMPAIGNID__EQUAL?: InputMaybe<Scalars['String']>;
};

export type MetaAdCampaignEngagementsFilters = {
  EXTERNAL_FACEBOOKCAMPAIGNID__EQUAL?: InputMaybe<Scalars['String']>;
};

export type MetaAdCampaignProfileStatsFilters = {
  EXTERNAL_FACEBOOKCAMPAIGNID__EQUAL?: InputMaybe<Scalars['String']>;
};

export type MetaAdCampaignReachLocationsFilters = {
  EXTERNAL_FACEBOOKCAMPAIGNID__EQUAL?: InputMaybe<Scalars['String']>;
};

export type MetaAdCampaignStatsFilters = {
  EXTERNAL_FACEBOOKCAMPAIGNID__EQUAL?: InputMaybe<Scalars['String']>;
};

export type MetaAdsCampaignTableFilters = {
  START_DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type MetaAdsCampaignTableSort = {
  CAMPAIGN_NAME?: InputMaybe<PrioritySort>;
  CLICK_THROUGH_RATE?: InputMaybe<PrioritySort>;
  CONVERSIONS?: InputMaybe<PrioritySort>;
  CONVERSION_RATE?: InputMaybe<PrioritySort>;
  DURATION?: InputMaybe<PrioritySort>;
  ENGAGEMENTS?: InputMaybe<PrioritySort>;
  IMPRESSIONS?: InputMaybe<PrioritySort>;
  PAGE_VIEWS?: InputMaybe<PrioritySort>;
  REACH?: InputMaybe<PrioritySort>;
  START_DATE?: InputMaybe<PrioritySort>;
};

export type MetaAdsConversionBreakdownFilters = {
  START_DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type MetaAdsEngagementBreakdownFilters = {
  START_DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type MetaAdsStatsFilters = {
  START_DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type MetaCampaignsByUtmFilters = {
  CLEAN_CAMPAIGN_NAME__EQUAL?: InputMaybe<Scalars['String']>;
};

export type MetaCampaignsFilters = {
  CLEAN_CAMPAIGN_NAME__EQUAL?: InputMaybe<Scalars['String']>;
  START_DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export enum MfaConfigEnumType {
  App = 'App',
  Disabled = 'Disabled',
  Email = 'Email',
  Pending = 'Pending',
  Sms = 'SMS'
}

export type MfaConfirmLoginInput = {
  /** Auth token. */
  AuthToken: Scalars['String'];
  /** Remember the the login after session close. */
  RememberMe: Scalars['Boolean'];
  /** Server token. */
  ServerToken: Scalars['String'];
  /** Type of MFA being confirmed. */
  Type: MfaConfirmTypeEnum;
};

export type MfaConfirmSetupInput = {
  /** Auth token. */
  AuthToken: Scalars['String'];
  /** Password to validate session. */
  Password: Scalars['String'];
  /** Server token. */
  ServerToken: Scalars['String'];
  /** Type of MFA being confirmed. */
  Type: MfaConfirmTypeEnum;
};

export enum MfaConfirmTypeEnum {
  App = 'App',
  Sms = 'SMS'
}

export type MfaDisableSetupInput = {
  /** Password to validate session. */
  Password: Scalars['String'];
  /** Server token. */
  ServerToken: Scalars['String'];
};

export type MfaPasswordReset = {
  __typename?: 'MfaPasswordReset';
  Email: Scalars['String'];
};

export type MfaPasswordResetInput = {
  /** Confirmation of email to use. */
  Email: Scalars['String'];
};

export type MfaRequest = {
  __typename?: 'MfaRequest';
  Email?: Maybe<Scalars['String']>;
  Phone?: Maybe<Scalars['String']>;
  QrCode?: Maybe<Scalars['String']>;
  Secret?: Maybe<Scalars['String']>;
  ServerToken: Scalars['String'];
  Type: MfaRequestTypeEnum;
};

export type MfaRequestInput = {
  /** Server token. */
  ServerToken: Scalars['String'];
  /** Type of MFA being requested. */
  Type: MfaRequestTypeEnum;
};

export enum MfaRequestTypeEnum {
  App = 'App',
  Email = 'Email',
  Sms = 'SMS'
}

export type MfaSetup = {
  __typename?: 'MfaSetup';
  ID: Scalars['Int'];
  MfaType: Scalars['String'];
  PasswordResetEmail?: Maybe<Scalars['String']>;
  ServerToken: Scalars['String'];
};

export type MfaSetupInput = {
  /** If setup is an enable or disable. */
  Enabled: Scalars['Boolean'];
};

export type Milestone = {
  __typename?: 'Milestone';
  Content?: Maybe<Scalars['String']>;
  ID: Scalars['ID'];
  Title?: Maybe<Scalars['String']>;
};

export type MilestoneModule = ModuleType & {
  __typename?: 'MilestoneModule';
  AnchorTag?: Maybe<Scalars['String']>;
  ExtraClass?: Maybe<Scalars['String']>;
  ID: Scalars['ID'];
  Milestones: AboutModule_MilestonesConnection;
  NavigationLabel?: Maybe<Scalars['String']>;
  SpacingBelow?: Maybe<Scalars['String']>;
  SpacingBelowMobile?: Maybe<Scalars['String']>;
  ThemeColour: ThemedElementColourType;
  Title?: Maybe<Scalars['String']>;
};


export type MilestoneModuleMilestonesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<AboutModule_MilestonesSortFields>;
};

export type MinMax = {
  __typename?: 'MinMax';
  Max: Scalars['Int'];
  Min: Scalars['Int'];
};

export type MinMaxInput = {
  Max: Scalars['Int'];
  Min: Scalars['Int'];
};

/** Union type for reports (can be ModerationContentReport or ModerationUserReport) */
export type Moderation = {
  __typename?: 'Moderation';
  /** Timestamp when the report was created */
  Created: Scalars['Date'];
  ID: Scalars['ID'];
  /** The selected moderation reason */
  ModerationReason: ModerationReason;
  /** Optional additional details from the reporter */
  Note?: Maybe<Scalars['String']>;
  /** The member who submitted the report */
  Reporter: Member;
};

/** Minimal response when content report is created successfully */
export type ModerationContentReportCreated = {
  __typename?: 'ModerationContentReportCreated';
  /** The ID of the created content report */
  ID: Scalars['ID'];
};

/** Entity types that can be flagged for moderation (DirectoryItem or User). */
export enum ModerationEntityTypeEnum {
  DirectoryItem = 'DirectoryItem',
  User = 'User'
}

/** A predefined reason for reporting content or users for moderation */
export type ModerationReason = {
  __typename?: 'ModerationReason';
  /** Child reasons if this is a parent reason */
  Children: Array<ModerationReason>;
  /** Array of entity types this reason applies to (DirectoryItem, User, or both) */
  EntityTypes: Array<ModerationEntityTypeEnum>;
  ID: Scalars['ID'];
  /** Human-readable reason label */
  Label: Scalars['String'];
  /** Parent reason if this is a nested reason */
  Parent?: Maybe<ModerationReason>;
  /** ID of parent reason for hierarchical structure (null for top-level) */
  ParentID?: Maybe<Scalars['Int']>;
  /** Display order for sorting reasons (lower numbers appear first) */
  SortOrder?: Maybe<Scalars['Int']>;
};

/** Minimal response when user report is created successfully */
export type ModerationUserReportCreated = {
  __typename?: 'ModerationUserReportCreated';
  /** The ID of the created user report */
  ID: Scalars['ID'];
};

export type Module = AccordionModule | AdvertisingEnquireModule | AttendeeListModule | BannerModule | BusinessModule | BusinessSupportBlock | CallToActionModule | CampaignFormFooterModule | CampaignHeaderModule | CaptionCtaModule | ContactUsMapModule | DirectoryModule | EcomCallToActionModule | EcomTestimonialModule | EcomWelcomeModule | EventDetailsModule | EventItineraryModule | EventRegisterModule | FeatureShowcaseModule | FeaturesModule | FramedPictureCarouselModule | FramedPictureContentModule | GalleryModule | GuestHomeHeroModule | HeadingTextModule | HighlightsModule | HostedVideoModule | IframeEmbedModule | ImageBannerModule | ImageColumn | ImageTextCarouselModule | InformationModule | IntroModule | LogoCarouselModule | MilestoneModule | PhotoCollageModule | PlaceholderModule | PlainTextModule | ProductFeature | ProfessionalAttendeeModule | ProfessionalMembersModule | ProjectFeaturesModule | RecommendationModule | RichTextModule | SpeakerLineupModule | StaticGalleryModule | TestimonialModule | TextColumn | VideoColumn | VideoModule | WelcomeModule;

export type ModuleColumn = {
  ID: Scalars['Int'];
  IsEmpty: Scalars['Boolean'];
  MemberSortOrder: Scalars['Int'];
  ModuleID: Scalars['Int'];
  ReadOnly: Scalars['Boolean'];
  WordCount: Scalars['Int'];
};

export enum ModuleColumnEnum {
  HtmlColumn = 'HtmlColumn',
  ImageColumn = 'ImageColumn',
  Invoice = 'Invoice',
  TextColumn = 'TextColumn',
  VideoColumn = 'VideoColumn'
}

export type ModuleColumnInput = {
  Caption?: InputMaybe<Scalars['String']>;
  Content?: InputMaybe<Scalars['String']>;
  File?: InputMaybe<Scalars['Upload']>;
  ID?: InputMaybe<Scalars['Int']>;
  MemberSortOrder?: InputMaybe<Scalars['Int']>;
  ProductID?: InputMaybe<Scalars['Int']>;
  ReadOnly?: InputMaybe<Scalars['Boolean']>;
  TextType?: InputMaybe<TextTypeEnum>;
  UpdateDimensionID?: InputMaybe<Scalars['Int']>;
  VideoLink?: InputMaybe<Scalars['String']>;
};

export enum ModuleGroupEnum {
  Gallery = 'Gallery',
  Photos = 'Photos',
  Plans = 'Plans',
  Products = 'Products',
  Text = 'Text',
  Videos = 'Videos'
}

export type ModulePage = {
  __typename?: 'ModulePage';
  ID: Scalars['ID'];
  MetaData: Meta;
  Modules: Array<ModuleType>;
  PageBackgroundColor?: Maybe<Scalars['String']>;
  PageTheme: ModulePageThemeEnum;
};

export enum ModulePageThemeEnum {
  About = 'about',
  Ace = 'ace',
  Home = 'home',
  Mge = 'mge'
}

export type ModulePreset = FlexibleModule & SortableItem & {
  __typename?: 'ModulePreset';
  Columns: ColumnsConnection;
  ContentAreaID: Scalars['Int'];
  CreatedFromID?: Maybe<Scalars['Int']>;
  CreatedFromVersion?: Maybe<Scalars['Int']>;
  DetachedFromSavedModule?: Maybe<Scalars['Boolean']>;
  EcommerceEnabled: Scalars['Boolean'];
  ID: Scalars['Int'];
  LibraryItemID: Scalars['Int'];
  MemberSortOrder: Scalars['Int'];
  ModuleGroup: ModuleGroupEnum;
  PossibleColumnDimensions: Array<ColumnDimension>;
  PresetName: Scalars['String'];
  PresetType: FlexibleModuleEnum;
  PreviewImage?: Maybe<ResponsiveImage>;
  SortableColumns: Scalars['Boolean'];
  Swappable: Scalars['Boolean'];
};


export type ModulePresetColumnsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<ColumnsSortFields>;
};

export type ModuleType = {
  AnchorTag?: Maybe<Scalars['String']>;
  ExtraClass?: Maybe<Scalars['String']>;
  ID: Scalars['ID'];
  NavigationLabel?: Maybe<Scalars['String']>;
  SpacingBelow?: Maybe<Scalars['String']>;
  SpacingBelowMobile?: Maybe<Scalars['String']>;
  ThemeColour: ThemedElementColourType;
};

export type Module_AccordionsConnection = {
  __typename?: 'Module_AccordionsConnection';
  edges: Array<Module_AccordionsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type Module_AccordionsConnectionEdge = {
  __typename?: 'Module_AccordionsConnectionEdge';
  /** The node at the end of the collections edge */
  node: Accordion;
};

export type Module_AccordionsSortFields = {
  SortOrder?: InputMaybe<SortDirection>;
};

export type Module_FeatureBlocksConnection = {
  __typename?: 'Module_FeatureBlocksConnection';
  edges: Array<Module_FeatureBlocksConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type Module_FeatureBlocksConnectionEdge = {
  __typename?: 'Module_FeatureBlocksConnectionEdge';
  /** The node at the end of the collections edge */
  node: ProjectFeatureBlock;
};

export type Module_FeatureBlocksSortFields = {
  SortOrder?: InputMaybe<SortDirection>;
};

export type Module_GuestHeroSlidesConnection = {
  __typename?: 'Module_GuestHeroSlidesConnection';
  edges: Array<Module_GuestHeroSlidesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type Module_GuestHeroSlidesConnectionEdge = {
  __typename?: 'Module_GuestHeroSlidesConnectionEdge';
  /** The node at the end of the collections edge */
  node: GuestHeroSlide;
};

export type Module_GuestHeroSlidesSortFields = {
  SortOrder?: InputMaybe<SortDirection>;
};

export type Module_ImageCarouselItemsConnection = {
  __typename?: 'Module_ImageCarouselItemsConnection';
  edges: Array<Module_ImageCarouselItemsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type Module_ImageCarouselItemsConnectionEdge = {
  __typename?: 'Module_ImageCarouselItemsConnectionEdge';
  /** The node at the end of the collections edge */
  node: ImageCarouselItem;
};

export type Module_ImageCarouselItemsSortFields = {
  SortOrder?: InputMaybe<SortDirection>;
};

export type Module_TeamMembersConnection = {
  __typename?: 'Module_TeamMembersConnection';
  edges: Array<Module_TeamMembersConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type Module_TeamMembersConnectionEdge = {
  __typename?: 'Module_TeamMembersConnectionEdge';
  /** The node at the end of the collections edge */
  node: TeamMember;
};

export type Module_TeamMembersSortFields = {
  ModuleSort?: InputMaybe<SortDirection>;
};

export type Module_TextCarouselItemsConnection = {
  __typename?: 'Module_TextCarouselItemsConnection';
  edges: Array<Module_TextCarouselItemsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type Module_TextCarouselItemsConnectionEdge = {
  __typename?: 'Module_TextCarouselItemsConnectionEdge';
  /** The node at the end of the collections edge */
  node: TextCarouselItem;
};

export type Module_TextCarouselItemsSortFields = {
  SortOrder?: InputMaybe<SortDirection>;
};

export type MonthlyUserCount = {
  __typename?: 'MonthlyUserCount';
  CountryCode: Scalars['String'];
  Created: Scalars['String'];
  DataLastUpdatedInclusive: Scalars['String'];
  ID: Scalars['Int'];
  LastEdited: Scalars['String'];
  UniqueUsers: Scalars['Int'];
};

export type MoodBoardSavedIDs = {
  __typename?: 'MoodBoardSavedIDs';
  imageIDs: Array<Scalars['Int']>;
  pageIDs: Array<Scalars['Int']>;
};

export type MultiColumnModule = FlexibleModule & SortableItem & {
  __typename?: 'MultiColumnModule';
  Columns: ColumnsConnection;
  ContentAreaID: Scalars['Int'];
  CreatedFromID?: Maybe<Scalars['Int']>;
  CreatedFromVersion?: Maybe<Scalars['Int']>;
  DetachedFromSavedModule?: Maybe<Scalars['Boolean']>;
  EcommerceEnabled: Scalars['Boolean'];
  ID: Scalars['Int'];
  LibraryItemID: Scalars['Int'];
  MemberSortOrder: Scalars['Int'];
  ModuleGroup?: Maybe<ModuleGroupEnum>;
  PossibleColumnDimensions: Array<ColumnDimension>;
  PresetName: Scalars['String'];
  PresetType: FlexibleModuleEnum;
  SortableColumns: Scalars['Boolean'];
  Swappable: Scalars['Boolean'];
};


export type MultiColumnModuleColumnsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<ColumnsSortFields>;
};

export type Mutation = {
  __typename?: 'Mutation';
  ArcherCommentAction: ArcherComment;
  ArcherCommentDelete: Scalars['Int'];
  ArcherCommentReply: ArcherReply;
  /** Links an Award to an Entity. */
  AwardLinkToEntity?: Maybe<LinkAwardToEntityMutationType>;
  /** UnLinks an Award from an Entity. */
  AwardUnlinkFromEntity?: Maybe<UnlinkAwardFromEntityMutationType>;
  BulkUploadAndRearrange: BulkUploadResult;
  /** Invalidates the cache of Integration Settings used for Content Lock Flexibility etc. */
  CachedIntegrationSettingsInvalidate: Scalars['Boolean'];
  CancelSync: BooleanResult;
  ConsignmentPickupRequest: Consignment;
  ConsignmentSync: Consignment;
  /** Updates the content teams status for a library item */
  ContentStatusUpdate?: Maybe<ContentStatusUpdateResult>;
  DeleteQBRByID: Scalars['Boolean'];
  EnrichProductWithAi?: Maybe<ProductEnrichmentResult>;
  HomePinToggle?: Maybe<HomePinToggleResultType>;
  ImageExportCreate?: Maybe<ImageExportCreateResult>;
  /** Takes an image from the import bucket and replaces the related original website image */
  ImageImport?: Maybe<ImageExportCreateResult>;
  IntegrationRequestReportResult: Scalars['Boolean'];
  IntegrationSettingsUpdate: BooleanResult;
  /**
   * TEMPORARY MIGRATION ENDPOINT - DO NOT USE FOR NEW INTEGRATIONS. Exchanges a valid UUID token for a JWT token. This endpoint does not require authentication but validates the UUID directly. Part of Phase 1, Card 2 of JWT migration (SEC-24). Reference: https://archipro.atlassian.net/browse/SEC-24
   *
   */
  IntegrationUUIDExchange?: Maybe<IntegrationUuidExchangeResponse>;
  /**
   * TEMPORARY MIGRATION ENDPOINT - DO NOT USE FOR NEW INTEGRATIONS. Invalidates a UUID token after migration to JWT. Requires JWT authentication. Part of Phase 1, Card 2 of JWT migration (SEC-24). Reference: https://archipro.atlassian.net/browse/SEC-24
   *
   */
  IntegrationUUIDInvalidate?: Maybe<IntegrationUuidInvalidateResponse>;
  /** Handles the unlink of an integration. It will set linked products to Not Live when an integration is unlinked. */
  IntegrationUnlink: Scalars['Boolean'];
  /** Handles when products are deleted from and integration. It will set the given product to not live */
  IntegrationUnpublishProduct?: Maybe<IntegrationUnpublishProductResult>;
  /** Creates a JWT token for a valid user */
  JWTTokenCreate?: Maybe<JwtTokenValidResponse>;
  /** Refreshes a JWT using a refresh token (secure token rotation pattern) */
  JWTTokenRefresh?: Maybe<JwtTokenValidResponse>;
  LibraryPinUpdate?: Maybe<LibraryPinUpdateResultType>;
  /** Processes an order import from the integration service. */
  OrderImport: ImportOrderResult;
  /** Connects a professional profile to an ecommerce store. Only use for WooCommerce at this point. */
  PlatformConnect?: Maybe<Scalars['String']>;
  PlatformDisconnect: BooleanResult;
  /** Handlings invalidating the field blacklist cache when it has been changed on the integration service. */
  ProductImportFieldBlacklistInvalidate: Scalars['Boolean'];
  /** Initiates a product import task. Returns the the TaskRunner job identifier or null on failure. */
  ProductImportProcess?: Maybe<Scalars['String']>;
  ProductImprovementCreateTask?: Maybe<ProductImprovementTaskStatus>;
  /** Sends an Enquiry to a Professional */
  SampleEnquiryCreate: Scalars['Boolean'];
  /** Update an existing shipping provider */
  ShippingProviderUpdate: ShippingProvider;
  /** Creates a new shipping zone */
  ShippingZoneCreate?: Maybe<ShippingZoneCreateResult>;
  /** Deletes a professionals shipping zone */
  ShippingZoneDelete: ShippingZoneDeleteResult;
  /** Updates an existing shipping zone */
  ShippingZoneUpdate?: Maybe<ShippingZoneUpdateResult>;
  SpecialtyRatesUpdate?: Maybe<Professional>;
  /** User submission of the MGE form */
  SubmitMGEForm: Scalars['Boolean'];
  /** Update a SupplierOrder by OrderNumber from an external source i.e. the Intergration Service */
  SupplierOrderExternalUpdate: Scalars['Boolean'];
  SyncFilteredProducts: BooleanResult;
  SyncProducts: BooleanResult;
  ToggleAutomatedSync: BooleanResult;
  ToggleOrderSyncing: BooleanResult;
  UpdateAllowedTags: BooleanResult;
  UpdateMemberOAuth?: Maybe<Scalars['Boolean']>;
  UpdateSettings: BooleanResult;
  UpsertQBR: Qbr;
  VariantImageUnlink: Variant;
  VariantOptionModify?: Maybe<AttributeOption>;
  WebsiteEventCreate?: Maybe<Scalars['Boolean']>;
  WooCommerceCancelSync: BooleanResult;
  WooCommerceDisconnect: BooleanResult;
  WooCommerceToggleOrderSyncing: BooleanResult;
  WooCommerceToggleWebhooks: BooleanResult;
  WooCommerceUpdateAllowedTags: BooleanResult;
  WooCommerceUpdateSettings: BooleanResult;
  /** Accepts and invite */
  acceptDesignBoardInvite?: Maybe<AcceptDesignBoardInvite>;
  /** Accepts enquiry conversation invite */
  acceptEnquiryConversationInvite?: Maybe<AcceptEnquiryConversationInvite>;
  /** Accepts and invite to be part of Team */
  acceptTeamMemberInvite: Scalars['String'];
  addPermission?: Maybe<PermissionInterface>;
  addProductFacetOption: Product;
  addSupplierOrderNote: OrderEvent;
  /** Adds a variant to the cart */
  addToShoppingCart: ShoppingCart;
  /** Apply a saved template to a page. */
  applyPageTemplate?: Maybe<DirectoryItem>;
  /** sync page with associated page in another zone */
  associatedPageSync?: Maybe<DirectoryItemSyncPageType>;
  /** Book a calendar event with a client director */
  bookCalendarEvent?: Maybe<BookCalendarEventResult>;
  /** Shares a BuildHub with user by email */
  buildHubCollaboratorAdd: BuildHubResponse;
  /** Removes a BuildHub collaborator */
  buildHubCollaboratorRemove: BuildHubCollaboratorResponse;
  /** Reorder collaborators for a BuildHub */
  buildHubCollaboratorReorder: BuildHubResponse;
  /** Update a BuildHub collaborator */
  buildHubCollaboratorUpdate: BuildHubCollaboratorResponse;
  /** Soft deletes a BuildHub */
  buildHubDelete: BuildHubResponse;
  /** Update a document's access mode and role settings */
  buildHubDocumentAccessUpdate: BuildHubDocument;
  /** Add collaborators with specific roles to a BuildHub document */
  buildHubDocumentCollaboratorAdd: BuildHubDocument;
  /** Remove a collaborator from a document */
  buildHubDocumentCollaboratorRemove: BuildHubDocumentCollaborator;
  /** Update a document collaborator's role */
  buildHubDocumentCollaboratorUpdate: BuildHubDocumentCollaborator;
  /** Member accepting a BuildHub invite */
  buildHubInviteAccept: BuildHubCollaboratorResponse;
  /** triggers a resend on a previously created invite */
  buildHubInviteResend: BuildHubCollaboratorResponse;
  /** leaves the BuildHub project */
  buildHubLeaveProject: BuildHubCollaboratorResponse;
  /** Update or create a BuildHub */
  buildHubUpsert: BuildHubResponse;
  /** Cancel a calendar event */
  cancelCalendarEvent?: Maybe<CancelCalendarEventResult>;
  cancelRequest?: Maybe<IntegrationRequest>;
  /** Cancels a supplier order. When the supplier is unable to processing it. */
  cancelSupplierOrder: Scalars['Boolean'];
  /** Dismiss a card */
  cardDismiss?: Maybe<CardResult>;
  /** Mark a card as viewed */
  cardMarkAsViewed?: Maybe<CardResult>;
  /** Clone a professional */
  cloneProfessional: CloneTask;
  /** Mark a document's comments as read for the current user */
  commentMarkAsRead: BuildHubDocumentResponse;
  /** Mark a document's comments as unread for the current user from a specific comment onwards */
  commentMarkAsUnread: BuildHubDocumentResponse;
  commentSubmit: BuildHubCommentResponse;
  /** Confirms the shopping cart is ready to be paid for a finalised. */
  confirmShoppingCartState: Scalars['Boolean'];
  confirmStripeAccount: Professional;
  /** Confirms a supplier order. When the supplier commits to processing it. */
  confirmSupplierOrder: Scalars['Boolean'];
  connectStripeAccount: Scalars['String'];
  /** Archive a Pixel Conversion config */
  conversionConfigArchive?: Maybe<ProfessionalPixelTrackerConversionStatus>;
  /** Create a Pixel Conversion under a Professional. */
  conversionConfigCreate?: Maybe<PixelTrackerConversionConfig>;
  /** Delete a Pixel Conversion config */
  conversionConfigDelete?: Maybe<Scalars['Boolean']>;
  /** Unarchive a Pixel Conversion config */
  conversionConfigUnarchive?: Maybe<ProfessionalPixelTrackerConversionStatus>;
  /** Update a Pixel Conversion config */
  conversionConfigUpdate?: Maybe<PixelTrackerConversionConfig>;
  /** Soft deletes a conversion rule */
  conversionRuleDelete: Scalars['Boolean'];
  /** Reorders conversion rule, updating SortOrder on the rule and shifting all ensuing rules */
  conversionRuleOrder: ConversionRuleResponse;
  /** Toggle enable or disable a conversion rule */
  conversionRuleToggle: ConversionRuleResponse;
  /** Update or create a conversion rule for a Professional. */
  conversionRuleUpsert: ConversionRuleResponse;
  /** Copy a Pin */
  copyPin: Array<Maybe<DesignBoard>>;
  /** Creates a checkout session for purchasing analytics */
  createAnalyticsCheckoutSession?: Maybe<AnalyticsCheckoutSession>;
  createAndUpdateFacetOption: Product;
  /** Create an article */
  createArticle?: Maybe<DirectoryItem>;
  createAttribute: Attribute;
  createAttributeAndOptions: Attribute;
  createAttributeOption: AttributeOption;
  /** Creates a banner LibraryImage and associates it to a LibraryItem. */
  createBannerImage?: Maybe<Array<LibraryImage>>;
  /** Creates a checkout session for building guide */
  createBuildingGuideCheckoutSession?: Maybe<BuildingGuideCheckoutSession>;
  createCalendarSession: CalendarSession;
  createCompany: CompanyResponse;
  createContact: ContactResponse;
  createContentBlock?: Maybe<ContentBlock>;
  /** Create a new conversation with the given participants and send a first message. If the conversation already exists, the message is sent to it instead. */
  createConversation: DirectConversation;
  /** Create a new message in a conversation. At least one of Text or Attachments must be provided. */
  createConversationMessage: CreateConversationMessageType;
  /** Create a Conversion under a Professional. */
  createConversionConfig?: Maybe<PixelTrackerConversionConfig>;
  /** Creates a DesignBoard for the loggedIn Member or the current Tracked user */
  createDesignBoard?: Maybe<DesignBoard>;
  /** Creates comment for a design board */
  createDesignBoardComment?: Maybe<Comment>;
  /** Creates DiagramImages from file uploads and associates them with a  */
  createDiagramImages: Array<Maybe<DiagramImage>>;
  /** Sends an Enquiry to a Professional */
  createEnquiry?: Maybe<CreateEnquiry>;
  /** Create a Comment on an Enquiry */
  createEnquiryComment?: Maybe<Comment>;
  /** Adds a message to an enquiry conversation */
  createEnquiryConversationMessage?: Maybe<CreateConversationMessageType>;
  createFacetOption: FacetOption;
  /** Creates a banner LibraryImage and associates it to a LibraryItem. Supports both image and video banners. */
  createItemTopBanner: LibraryItemBanner;
  createLibraryDownload?: Maybe<Array<Maybe<LibraryDownload>>>;
  /** Creates LibraryImages from file uploads and associates them with a nominated LibraryItem/LibraryVideo/ContentBlock. */
  createLibraryImage: Array<Maybe<LibraryImage>>;
  /** Place a tag on a photo. */
  createLibraryImageMarker?: Maybe<LibraryImageMarker>;
  /**
   * Creates a LibraryLocation and associates it to a
   *                 LibraryItem (Currently only Professionals).
   */
  createLibraryLocation?: Maybe<LibraryLocation>;
  createLibraryRange: LibraryRange;
  createLibraryTab?: Maybe<Array<LibraryTab>>;
  createLibraryVideo?: Maybe<LibraryVideo>;
  /** Creates a Member Upload Pin for given designboard. */
  createMemberUploadPin?: Maybe<Pin>;
  /** Create a network participant and adds him to the network */
  createNetworkParticipant: Array<NetworkParticipant>;
  createOrUpdateMasterVariant: Variant;
  createOrderReturn: SupplierOrder;
  /** Initializes a new organization network */
  createOrganizationNetwork: OrganizationNetwork;
  /** Create an template from a page to be reused later. */
  createPageTemplate?: Maybe<DirectoryItem>;
  /** Creates a Pin */
  createPin?: Maybe<Pin>;
  /** Creates comment for a Pin */
  createPinComment?: Maybe<Comment>;
  createPins: Array<Maybe<Pin>>;
  /** Create a product */
  createProduct: Product;
  createProductSize: ProductSize;
  /** Create one or more product swatches */
  createProductSwatches?: Maybe<Array<ProductSwatch>>;
  createProductVariants: Product;
  /** Create a professional */
  createProfessional: DirectoryItem;
  /** Creates a ProfessionalAward for a given professional */
  createProfessionalAward?: Maybe<ProfessionalAwardMutationCreateResultType>;
  /** Creates a ProfessionalServiceArea and associates it to a professional. */
  createProfessionalServiceArea?: Maybe<ProfessionalServiceArea>;
  /** Create a project */
  createProject: DirectoryItem;
  createReviewAction?: Maybe<ReviewAction>;
  createSavedModule: SavedModule;
  createSearchTag: SearchTag;
  createServiceOffering: ServiceOfferingResponse;
  /** Creates a new shipping method */
  createShippingMethod: ShippingMethod;
  /** Creates a new shipping profile */
  createShippingProfile?: Maybe<ShippingProfile>;
  /** Creates a new address on the shopping cart */
  createShoppingCartAddress: ShoppingCart;
  /** Creates an order from a shopping cart */
  createShoppingCartOrder: CreateShoppingCartOrderResult;
  /** create a new team member */
  createTeamMember: TeamMember;
  /** Creates a testimonial and associates it to given ID */
  createTestimonial?: Maybe<Testimonial>;
  createVariant: Variant;
  createVariantImage: LibraryImage;
  /** Delete an article */
  deleteArticle: Scalars['Int'];
  deleteAttributeOption: Scalars['Boolean'];
  deleteBusinessTermsByID: Scalars['Boolean'];
  deleteCalendarSession: Scalars['Boolean'];
  /** Deletes a comment */
  deleteComment: Scalars['Int'];
  deleteCompany: CompanyResponse;
  deleteContact: ContactResponse;
  deleteContentBlock: Scalars['Int'];
  deleteConversionConfig?: Maybe<Scalars['Boolean']>;
  /** Deletes a DesignBoard */
  deleteDesignBoard: Scalars['Int'];
  /** Delete a Directory Item */
  deleteDirectoryItem?: Maybe<Scalars['Boolean']>;
  deleteEmailTemplateByID: Scalars['Boolean'];
  deleteEmailTemplateInputConfig: Scalars['Boolean'];
  deleteLibraryDownload: Scalars['Boolean'];
  deleteLibraryImage?: Maybe<Scalars['Boolean']>;
  deleteLibraryImageMarker?: Maybe<Scalars['Boolean']>;
  deleteLibraryImages: Array<ImageDeletionResult>;
  deleteLibraryLocation?: Maybe<Scalars['Boolean']>;
  deleteLibraryRange?: Maybe<Scalars['Boolean']>;
  deleteLibraryTab: Scalars['Boolean'];
  deleteLibraryVideo: Scalars['Boolean'];
  deleteLibraryVideoThumbnail?: Maybe<Scalars['Boolean']>;
  deleteModule: Scalars['Boolean'];
  deleteModuleColumn: FlexibleModule;
  /** Deletes a Pin */
  deletePin?: Maybe<DesignBoard>;
  /** Deletes a Pin */
  deletePinsByPage?: Maybe<DesignBoard>;
  deleteProductSwatch: Scalars['Boolean'];
  /** Delete a ProfessionalAward with the given IDs */
  deleteProfessionalAward?: Maybe<ProfessionalAwardMutationDeleteResultType>;
  /** Delete Badge image with the given award ID */
  deleteProfessionalAwardBadge?: Maybe<ProfessionalAwardBadgeDeleteResultType>;
  deleteProfessionalCompanyField: CustomFieldResponse;
  deleteProfessionalContactField: CustomFieldResponse;
  /** Deletes a ProfessionalServiceArea by ID. */
  deleteProfessionalServiceArea?: Maybe<Scalars['Boolean']>;
  deleteQuoteContentByID: Scalars['Boolean'];
  deleteQuotePayment: InvoiceableResponse;
  deleteQuoteServiceItem: InvoiceableResponse;
  deleteReviewAction?: Maybe<Scalars['Boolean']>;
  deleteSavedModule: Scalars['Boolean'];
  deleteSearchTag: Scalars['Boolean'];
  deleteServiceOffering: ServiceOfferingResponse;
  /** Deletes a shipping method */
  deleteShippingMethod?: Maybe<Scalars['Boolean']>;
  /** Deletes a shipping profile */
  deleteShippingProfile?: Maybe<Scalars['Int']>;
  /** Removes the shipping rate */
  deleteShippingRate?: Maybe<Scalars['Boolean']>;
  deleteSupplierOrderNote: Scalars['Boolean'];
  /** Deletes TeamMember with given ID */
  deleteTeamMember: Scalars['Boolean'];
  deleteTestimonial?: Maybe<Scalars['Boolean']>;
  deleteUnusedOptions: Array<Scalars['Int']>;
  deleteVariant?: Maybe<DeleteVariantResult>;
  deleteVariantImage: Scalars['Boolean'];
  deleteVariants: Array<DeleteVariantResult>;
  /** Bulk update visibility of directory items */
  directoryItemBulkUpdateVisibility: Scalars['Boolean'];
  /** Disconnect calendar OAuth integration */
  disconnectCalendar: Scalars['Boolean'];
  /** Dispatches order items or marks them ready for pickup */
  dispatchSupplierOrder: SupplierOrder;
  emailAssetRename: EmailAssetResponse;
  emailAssetUpload: EmailAssetListResponse;
  emailDataBindingUpdate: EmailTemplateResponse;
  /** Updates a collaborator permission */
  followDesignBoard?: Maybe<DesignBoard>;
  /** Accept the AI Image and replace the original LibraryImage */
  imageAccept: EditableImage;
  /** Center the image with AI Service */
  imageCenter?: Maybe<ImageCenterResultType>;
  /** Remove the image background with AI Service */
  imageRemoveBackground?: Maybe<ImageRemoveBackgroundResultType>;
  /** Revert the AI Image and replace the original LibraryImage */
  imageRevert: EditableImage;
  /** Upscale the image with AI Service */
  imageUpscale?: Maybe<ImageUpscaleResultType>;
  /** Purchases a single product through the ApplePay/GPay button */
  instantPurchase: CreateShoppingCartOrderResult;
  /** Invites one or more Collaborators */
  inviteCollaborators?: Maybe<DesignBoard>;
  /** Send an invite to be part of Team */
  inviteTeamMember: TeamMember;
  /** bulk invite team members to the professional */
  inviteTeamMembers: Scalars['Boolean'];
  invoicePaymentSetProcessingPayment: InvoicePaymentResponse;
  /** Updates a collaborator permission */
  leaveDesignBoard?: Maybe<DesignBoard>;
  /** Create a relationship of some kind between two pages */
  linkLibraryItem: DirectoryItem;
  /** Log JavaScript error */
  logError?: Maybe<Scalars['Boolean']>;
  /** Attempts to login a user. */
  login: LoginResult;
  /** Logs out the current user */
  logout?: Maybe<Scalars['Boolean']>;
  /** Mark all messages in a Conversation as read for the current user. */
  markConversationRead: Conversation;
  /** Marks one notification as read */
  markWebsiteNotificationsAsRead: Array<WebsiteNotificationInterface>;
  /** Marks a member read record */
  memberReadRecordSet: Scalars['Boolean'];
  mfaConfirmLogin: Me;
  mfaConfirmSetup: Me;
  mfaDisableSetup: Me;
  mfaPasswordReset: MfaPasswordReset;
  mfaRequest: MfaRequest;
  mfaSetup: MfaSetup;
  moduleSwitch: Scalars['Boolean'];
  moodBoardPinUpload: InspirationItemResponse;
  moodBoardPinsAdd: InspirationGroupResponse;
  moodBoardPinsCopy: InspirationGroupResponse;
  moodBoardPinsMove: InspirationGroupResponse;
  moodBoardPinsRemove: InspirationGroupResponse;
  /** remove mood board pins by page ids */
  moodBoardPinsRemoveByPage: InspirationGroupResponse;
  /** Moves a Pin */
  movePin: Array<Maybe<DesignBoard>>;
  /** bulk clone page to target zone */
  pageBulkClone: PageBulkCloneJob;
  pageClone: DirectoryItemClonePageType;
  pageURLSegmentUpdate?: Maybe<DirectoryItemUpdateUrlResultType>;
  paymentIntentCreate: PaymentIntentResponse;
  processOrderDecline: SupplierOrder;
  processOrderReturn: SupplierOrder;
  /** Process the PaymentResponse data from the Stripe Payment Request Button */
  processPaymentResponse: Scalars['Boolean'];
  /** Processes a product import from the integration service. (deprecated) */
  processProductImport: ImportResult;
  /** Restore a soft deleted product */
  productRestore: Array<Product>;
  /** soft deletes a existing inspiration group */
  projectInspirationGroupRemove: InspirationGroupResponse;
  /** soft deletes a existing inspiration group by its migrated source */
  projectInspirationGroupRemoveBySource: InspirationGroupResponse;
  /** create a new inspiration group */
  projectInspirationGroupUpsert: InspirationGroupResponse;
  /** creates a new inspiration group by migrating from an IdeaBook and its items */
  projectInspirationIdeaBookMigrate: InspirationGroupResponse;
  /** Import an external URL as an inspiration item */
  projectInspirationItemImportUrl: InspirationItemResponse;
  /** Update title and/or description of an inspiration item */
  projectInspirationItemUpdate: InspirationItemResponse;
  /** Link a team member to a project */
  projectTeamMemberCreate: ProjectTeamMember;
  /** Unlink a team member from a project */
  projectTeamMemberDelete: ProjectTeamMember;
  quoteAcceptOrDecline: InvoiceableResponse;
  /** Move a selection of item to a starting position and arrange consecutively */
  rearrangeSortOrders: Array<SortableItem>;
  registerExpoPushDevice: UserPushDevicesResponse;
  /** register an email address to the newsletter */
  registerForNewsLetter?: Maybe<Scalars['Boolean']>;
  /** Removes an existing collaborator */
  removeCollaborator?: Maybe<DesignBoard>;
  /** Removes the participant from the given network type */
  removeNetworkParticipant: Scalars['Boolean'];
  removePermission?: Maybe<PermissionInterface>;
  removeProductFacetOption: Product;
  /** Removes a reaction for the current user on a document. */
  removeReaction: BuildHubReactionResponse;
  renameSavedModule: SavedModule;
  reorderQuoteServiceItem: InvoiceableResponse;
  /** Reports a DirectoryItem (Product, Project, Professional, Article) for moderation review */
  reportDirectoryItem: ReportDirectoryItemResponse;
  /** Reports a User/Member for moderation review */
  reportUser: ReportUserResponse;
  /** Request account deletion. Creates a deletion request and begins a 30-day grace period. Account remains active during this time. A scheduled task will disable the account after 30 days if not restored. */
  requestAccountDeletion: AccountDeletionRequestResponse;
  /** Resend an invite to a collaborator */
  resendCollaboratorInvite: DesignBoard;
  /** Resend an invitation to the teammate */
  resendTeamMemberInvitation: Scalars['Boolean'];
  resetModuleColumn: FlexibleModule;
  /** Resets SupplierOrder.NotifyCustomer. */
  resetOrderNotification: SupplierOrder;
  /** Cancel a pending account deletion request. Cancels the deletion and the account remains active. */
  restoreAccount: AccountDeletionRequestResponse;
  reuseVariantImage: LibraryImage;
  /** Adds a message to an enquiry conversation */
  revealContactDetails: EnquiryConversation;
  reviewPage?: Maybe<PageReviewType>;
  /** Saves a team member and send invitation if the email has changed or is a new record */
  saveAndInviteTeamMember: TeamMember;
  saveImportMap?: Maybe<Scalars['Boolean']>;
  /** User reacts to a document in BuildHub */
  saveReaction: BuildHubReactionResponse;
  sendEmailTemplate: EmailMessageResponse;
  sendHubspotMarketingPreferencesEmail: SendHubspotMarketingPreferencesEmailResultType;
  /** Send pixel code to developer email */
  sendPixelCode?: Maybe<Scalars['Boolean']>;
  sendPushNotification: Scalars['Boolean'];
  sendQuote: SavedQuoteResponse;
  /** Marks comments for board as read */
  setBoardCommentsAsRead?: Maybe<DesignBoard>;
  /** Sets the enquiries archive status. Changes are propagated to all related enquiries. */
  setEnquiryArchived: Array<Enquiry>;
  /** Marks comments for enquiry as read */
  setEnquiryCommentsAsRead?: Maybe<Enquiry>;
  /** Set an Enquiry as important */
  setEnquiryImportantStatus?: Maybe<Enquiry>;
  /** set enquiry to unread */
  setEnquiryReadStatus?: Maybe<Enquiry>;
  setLibraryItemCategories?: Maybe<DirectoryItem>;
  setLibraryRange: LibraryRange;
  /** Set a LibraryThumb */
  setLibraryThumb?: Maybe<LibraryThumb>;
  /** set an objects archived flag. */
  setObjectArchived?: Maybe<Archivable>;
  /** Marks comments for pin as read */
  setPinCommentsAsRead?: Maybe<DesignBoard>;
  /** Set the custom team member order for a project */
  setProjectTeamOrder: Project;
  /** Sets the charges for one or more shipping rates */
  setShippingRates?: Maybe<Array<Maybe<ShippingRate>>>;
  /** Configures an address type on the shopping cart */
  setShoppingCartAddress: ShoppingCart;
  setSupplierSurveyStatus: Scalars['Boolean'];
  setupIntentCreate: SetupIntentResponse;
  setupSplitPayments: SavedQuoteResponse;
  /** Share en enquiry conversation to other invitees */
  shareEnquiryConversation?: Maybe<ShareEnquiryConversationResult>;
  /** Share an item. */
  shareItem?: Maybe<Scalars['Boolean']>;
  /** Attempts to login a user via social login (Google, Facebook, LinkedIn). */
  socialLogin: LoginResult;
  sortContentBlocks?: Maybe<Array<Maybe<ContentBlock>>>;
  /** User submission of the ACE form */
  submitACEForm: Scalars['Boolean'];
  /** User submission of the Advertising form */
  submitAdvertisingForm: Scalars['Boolean'];
  /** Updates site subscription using payment provider data */
  syncAnalyticsSubscription?: Maybe<AnalyticsSubscription>;
  syncSavedModule: FlexibleModule;
  /** Remove a relationship of some kind between two pages */
  unlinkLibraryItem?: Maybe<DirectoryItem>;
  unregisterExpoPushDevice: UserPushDevicesResponse;
  unsetLibraryRange: Product;
  unsetVariantOptions: Array<Scalars['Int']>;
  unsetVariantSize: Scalars['Boolean'];
  /** Updates an analytics subscription */
  updateAnalyticsSubscription?: Maybe<Scalars['Boolean']>;
  /** Update/edit an article */
  updateArticle?: Maybe<DirectoryItem>;
  updateAttributeOption: AttributeOption;
  updateAttributeOptionSortOrders: Array<ProductAttributeOption>;
  /** Update timeline view settings for a BuildHub */
  updateBuildHubTimelineSettings: BuildHubTimelineSettings;
  updateBusinessTermsDataBinding: BusinessTermsResponse;
  updateCalendarSession: CalendarSession;
  /** Updates a collaborator permission */
  updateCollaboratorPermission: DesignBoard;
  updateCompany: CompanyResponse;
  updateContact: ContactResponse;
  updateContentBlock?: Maybe<ContentBlock>;
  /** Update one or more settings of a (direct) conversation. Fields that are `nullish` are ignored and won't be updated. */
  updateConversation: UpdateConversationPayload;
  /** Update the participants of a (direct) conversation. At least 1 original participant must remain and at least 2 participants must remain after the update. */
  updateConversationParticipants: UpdateConversationPayload;
  /** Update a Conversion of the Professional. */
  updateConversionConfig?: Maybe<PixelTrackerConversionConfig>;
  /** Creates a DesignBoard for the loggedIn Member or the current Tracked user */
  updateDesignBoard?: Maybe<DesignBoard>;
  /** Updates a user's DesignBoardSetting */
  updateDesignBoardSetting?: Maybe<DesignBoardSetting>;
  updateFeatureBooking?: Maybe<FeatureBooking>;
  /** Update or Create a flexible module based on preset name */
  updateFlexibleModule: FlexibleModule;
  /** Items status change is used by admin button on item tiles. It allows us to change the publish/approval/inLibrary status of product/project. Staff admin and company admin users are allowed to use this mutation. */
  updateItemStatusByAdmin?: Maybe<DirectoryItem>;
  updateLibraryDownload?: Maybe<Array<Maybe<LibraryDownload>>>;
  updateLibraryImage?: Maybe<LibraryImage>;
  /** Update a tag */
  updateLibraryImageMarker?: Maybe<LibraryImageMarker>;
  updateLibraryImages: Array<LibraryImage>;
  updateLibraryImagesSortOrder?: Maybe<Array<LibraryImage>>;
  updateLibraryLocations: Array<LibraryLocation>;
  updateLibraryRange: LibraryRange;
  updateLibraryTabs?: Maybe<Array<LibraryTab>>;
  /** Update a LibraryThumb */
  updateLibraryThumb?: Maybe<LibraryThumb>;
  updateLibraryVideo?: Maybe<LibraryVideo>;
  updateMe?: Maybe<Me>;
  updateMeta: Meta;
  /** Updates the participants meta */
  updateOrganizationNetworkParticipant: OrganizationNetworkParticipant;
  /** Toggles the status of a participant (Unread, archived, important) */
  updateParticipantStatus?: Maybe<UpdateEnquiryParticipantStatusResult>;
  updatePassword?: Maybe<Me>;
  /** Update/edit a product */
  updateProduct: Product;
  updateProductFacetOptions: Product;
  updateProductPricing: ProductPricing;
  updateProductSize: ProductSize;
  updateProductSizeSortOrders: Array<ProductSize>;
  /** Updates one or more product swatches */
  updateProductSwatches: Array<ProductSwatch>;
  /** Update/edit a professional */
  updateProfessional?: Maybe<Professional>;
  /** Update a ProfessionalAward with the given ID */
  updateProfessionalAward?: Maybe<ProfessionalAwardMutationUpdateResultType>;
  /** Updates ProfessionalServiceAreas of a professional. */
  updateProfessionalServiceArea?: Maybe<Array<ProfessionalServiceArea>>;
  /** Update/edit a project */
  updateProject?: Maybe<DirectoryItem>;
  updateQuoteDataBinding: InvoiceableResponse;
  updateQuoteMetaData: InvoiceableResponse;
  updateReviewAction?: Maybe<ReviewAction>;
  updateSavedModule: SavedModule;
  updateSearchTags: Array<SearchTag>;
  updateServiceOffering: ServiceOfferingResponse;
  /** Updates a shipping method */
  updateShippingMethod?: Maybe<ShippingMethod>;
  /** Update an existing shipping profile */
  updateShippingProfile?: Maybe<ShippingProfile>;
  /** Updates data on the shopping cart */
  updateShoppingCart: ShoppingCart;
  /** Updates an address on the shopping cart */
  updateShoppingCartAddress: ShoppingCart;
  /** Updates or removes an item on the cart */
  updateShoppingCartItem: ShoppingCart;
  /** Updates data on the CartSupplier on the shopping cart */
  updateShoppingCartSupplier: ShoppingCart;
  /** Update the sort orders of a list of directoryItems of a certain type */
  updateSortOrders: Array<SortableItem>;
  updateSupplierOrderNote: OrderEvent;
  updateSupplierOrderShipping: SupplierOrder;
  /** Updates a team member */
  updateTeamMember: Array<TeamMember>;
  /** Batch updates testimonials */
  updateTestimonials?: Maybe<Array<Maybe<Testimonial>>>;
  updateVariant: Variant;
  updateVariantOption: AttributeOption;
  updateVariantSize: ProductSize;
  updateVariants: Array<Maybe<Variant>>;
  /** Creates a Member UploadDesignBoardPin for given design board. */
  uploadDesignBoardPin?: Maybe<DesignBoardPin>;
  /** Uploads a LibraryImage and updates the Professional logo */
  uploadLogoImage?: Maybe<LibraryImageFile>;
  upsertBusinessTerms: BusinessTermsResponse;
  upsertEmailTemplate: EmailTemplateResponse;
  upsertEmailTemplateInputConfig: EmailTemplateInputConfigResponse;
  upsertProfessionalCompanyField: CustomFieldResponse;
  upsertProfessionalContactField: CustomFieldResponse;
  upsertQuoteContact: InvoiceableResponse;
  upsertQuoteContent: SavedQuoteResponse;
  upsertQuotePayment: InvoiceableResponse;
  upsertQuoteServiceItem: InvoiceableResponse;
  useQuoteTemplate: SavedQuoteResponse;
};


export type MutationArcherCommentActionArgs = {
  Action: Scalars['Boolean'];
  CommentID: Scalars['Int'];
  Content?: InputMaybe<Scalars['StringInput']>;
  Level?: InputMaybe<ArcherCommentLevelEnum>;
  ProductID?: InputMaybe<Scalars['Int']>;
  Section?: InputMaybe<ArcherHighlightSectionEnum>;
  Title?: InputMaybe<Scalars['StringInput']>;
};


export type MutationArcherCommentDeleteArgs = {
  CommentID?: InputMaybe<Scalars['Int']>;
  ReplyID?: InputMaybe<Scalars['Int']>;
};


export type MutationArcherCommentReplyArgs = {
  CommentID: Scalars['Int'];
  Content: Scalars['StringInput'];
  ReplyID?: InputMaybe<Scalars['Int']>;
};


export type MutationAwardLinkToEntityArgs = {
  AwardID: Scalars['Int'];
  AwardedEntityLink?: InputMaybe<Scalars['StringInput']>;
};


export type MutationAwardUnlinkFromEntityArgs = {
  AwardID: Scalars['Int'];
  AwardedEntityLink?: InputMaybe<Scalars['StringInput']>;
};


export type MutationBulkUploadAndRearrangeArgs = {
  Images: Array<Scalars['Upload']>;
  ParentClass: Scalars['String'];
  ParentID: Scalars['Int'];
};


export type MutationCachedIntegrationSettingsInvalidateArgs = {
  Platform: IntegratedPlatformEnum;
  Professional: Scalars['String'];
};


export type MutationCancelSyncArgs = {
  Platform: IntegratedPlatformEnum;
  Professional: Scalars['String'];
};


export type MutationConsignmentPickupRequestArgs = {
  Consignment: Scalars['Int'];
  Packages: Array<ConsignmentPackageInput>;
};


export type MutationConsignmentSyncArgs = {
  Consignment: Scalars['Int'];
};


export type MutationContentStatusUpdateArgs = {
  Comment?: InputMaybe<Scalars['StringInput']>;
  LibraryItemID: Scalars['Int'];
  RejectionReasons?: InputMaybe<Array<InputMaybe<ContentRejectReasonEnum>>>;
  Status?: InputMaybe<ContentStatusEnum>;
};


export type MutationDeleteQbrByIdArgs = {
  ID: Scalars['Int'];
};


export type MutationEnrichProductWithAiArgs = {
  AiModel?: InputMaybe<Scalars['String']>;
  ClearExisting?: InputMaybe<Scalars['Boolean']>;
  ProductID: Scalars['Int'];
  PromptVersion?: InputMaybe<Scalars['Int']>;
  Temperature?: InputMaybe<Scalars['Float']>;
};


export type MutationHomePinToggleArgs = {
  ItemID: Scalars['Int'];
  Pin: Scalars['Boolean'];
};


export type MutationImageExportCreateArgs = {
  input?: InputMaybe<ImageExportCreateInputType>;
};


export type MutationImageImportArgs = {
  ImageKey: Scalars['StringInput'];
};


export type MutationIntegrationRequestReportResultArgs = {
  Error?: InputMaybe<Scalars['String']>;
  NewProduct?: InputMaybe<Scalars['Boolean']>;
  ProductData?: InputMaybe<ProductResultData>;
  Professional: Scalars['String'];
  Reference?: InputMaybe<Scalars['String']>;
  RequestID: Scalars['String'];
  Success: Scalars['Boolean'];
  Warnings?: InputMaybe<Array<Scalars['String']>>;
};


export type MutationIntegrationSettingsUpdateArgs = {
  Platform: IntegratedPlatformEnum;
  Professional: Scalars['String'];
  Settings: IntegrationSettingsModelInput;
};


export type MutationIntegrationUuidExchangeArgs = {
  Professional: Scalars['String'];
  UUID: Scalars['String'];
};


export type MutationIntegrationUuidInvalidateArgs = {
  UUID: Scalars['String'];
};


export type MutationIntegrationUnlinkArgs = {
  DataSource: IntegratedPlatformEnum;
  Professional: Scalars['String'];
};


export type MutationIntegrationUnpublishProductArgs = {
  Professional: Scalars['String'];
  SupplierProductID: Scalars['String'];
};


export type MutationJwtTokenCreateArgs = {
  audience: JwtAudience;
  deviceName: Scalars['String'];
  professional?: InputMaybe<Scalars['String']>;
  scopes: Array<JwtScopeEnum>;
  ttl?: InputMaybe<Scalars['Int']>;
};


export type MutationJwtTokenRefreshArgs = {
  refreshToken: Scalars['String'];
};


export type MutationLibraryPinUpdateArgs = {
  CategoryID: Scalars['Int'];
  ItemID: Scalars['Int'];
  Pin: Scalars['Boolean'];
};


export type MutationOrderImportArgs = {
  DataSource: IntegratedPlatformEnum;
  Order: ImportOrder;
  Professional: Scalars['String'];
};


export type MutationPlatformConnectArgs = {
  ConnectHash: Scalars['StringInput'];
  CountryCode: Scalars['String'];
  Link: Scalars['StringInput'];
  Platform: IntegratedPlatformEnum;
  Shop: Scalars['StringInput'];
};


export type MutationPlatformDisconnectArgs = {
  Platform: IntegratedPlatformEnum;
  Professional: Scalars['String'];
};


export type MutationProductImportFieldBlacklistInvalidateArgs = {
  Professional: Scalars['String'];
};


export type MutationProductImportProcessArgs = {
  DataSource?: InputMaybe<IntegratedPlatformEnum>;
  Overwrite?: InputMaybe<Scalars['Boolean']>;
  Product: ImportProduct;
  Professional: Scalars['String'];
  RequestID: Scalars['String'];
  Synchronous?: InputMaybe<Scalars['Boolean']>;
  ignoreMe?: InputMaybe<ContentLockFlexibilityFieldEnum>;
};


export type MutationProductImprovementCreateTaskArgs = {
  CommentID?: InputMaybe<Scalars['Int']>;
  IsUndo?: InputMaybe<Scalars['Boolean']>;
  ProductID: Scalars['Int'];
};


export type MutationSampleEnquiryCreateArgs = {
  FormData: SampleEnquiryInput;
  ProductID: Scalars['Int'];
  ProfessionalID: Scalars['Int'];
};


export type MutationShippingProviderUpdateArgs = {
  AccountID?: InputMaybe<Scalars['StringInput']>;
  AccountSecret?: InputMaybe<Scalars['StringInput']>;
  Enabled?: InputMaybe<Scalars['Boolean']>;
  FreeThresholdEnabled?: InputMaybe<Scalars['Boolean']>;
  Locations?: InputMaybe<Array<ShippingProviderLocationInput>>;
  ProfessionalID: Scalars['Int'];
  ShippingProvider: ShippingProviderEnum;
};


export type MutationShippingZoneCreateArgs = {
  ProfessionalID: Scalars['Int'];
  ShippingZone: ShippingZoneInput;
};


export type MutationShippingZoneDeleteArgs = {
  ID: Scalars['Int'];
};


export type MutationShippingZoneUpdateArgs = {
  ID: Scalars['Int'];
  ShippingZone: ShippingZoneInput;
};


export type MutationSpecialtyRatesUpdateArgs = {
  Categories: Array<SpecialtyRateCategoriesInput>;
  ProfessionalID: Scalars['Int'];
  SpecialtyRatesOnSalePrices?: InputMaybe<Scalars['Boolean']>;
};


export type MutationSubmitMgeFormArgs = {
  Input: MgeFormInput;
};


export type MutationSupplierOrderExternalUpdateArgs = {
  ExternalOrderReference: Scalars['StringInput'];
  OrderNumber: Scalars['Int'];
};


export type MutationSyncFilteredProductsArgs = {
  Filters: Array<ListDirectoryItemsFilter>;
  Platform: IntegratedPlatformEnum;
  Professional: Scalars['String'];
  Title?: InputMaybe<Scalars['String']>;
};


export type MutationSyncProductsArgs = {
  Platform: IntegratedPlatformEnum;
  Professional: Scalars['String'];
};


export type MutationToggleAutomatedSyncArgs = {
  Platform: IntegratedPlatformEnum;
  Professional: Scalars['String'];
};


export type MutationToggleOrderSyncingArgs = {
  Platform: IntegratedPlatformEnum;
  Professional: Scalars['String'];
};


export type MutationUpdateAllowedTagsArgs = {
  AllowedTags: Array<Scalars['String']>;
  Platform: IntegratedPlatformEnum;
  Professional: Scalars['String'];
};


export type MutationUpdateMemberOAuthArgs = {
  Action: Scalars['String'];
  OAuthID: Scalars['Int'];
};


export type MutationUpdateSettingsArgs = {
  DisabledSettings?: InputMaybe<Array<Scalars['String']>>;
  Platform: IntegratedPlatformEnum;
  Professional: Scalars['String'];
};


export type MutationUpsertQbrArgs = {
  ID?: InputMaybe<Scalars['Int']>;
  ProfessionalID: Scalars['Int'];
  Title: Scalars['StringInput'];
};


export type MutationVariantImageUnlinkArgs = {
  VariantID: Scalars['Int'];
};


export type MutationVariantOptionModifyArgs = {
  AttributeID: Scalars['Int'];
  Code?: InputMaybe<Scalars['StringInput']>;
  Label?: InputMaybe<Scalars['StringInput']>;
  ProfessionalID: Scalars['Int'];
  VariantID: Scalars['Int'];
};


export type MutationWebsiteEventCreateArgs = {
  Event: WebsiteEvent;
  Professional: Scalars['String'];
};


export type MutationWooCommerceCancelSyncArgs = {
  Professional: Scalars['String'];
};


export type MutationWooCommerceDisconnectArgs = {
  Professional: Scalars['String'];
};


export type MutationWooCommerceToggleOrderSyncingArgs = {
  Professional: Scalars['String'];
};


export type MutationWooCommerceToggleWebhooksArgs = {
  Professional: Scalars['String'];
};


export type MutationWooCommerceUpdateAllowedTagsArgs = {
  Professional: Scalars['String'];
  Tags: Array<Scalars['Int']>;
};


export type MutationWooCommerceUpdateSettingsArgs = {
  DisabledSettings?: InputMaybe<Array<Scalars['String']>>;
  Professional: Scalars['String'];
};


export type MutationAcceptDesignBoardInviteArgs = {
  InviteHash: Scalars['StringInput'];
};


export type MutationAcceptEnquiryConversationInviteArgs = {
  InviteHash: Scalars['String'];
};


export type MutationAcceptTeamMemberInviteArgs = {
  InviteHash: Scalars['StringInput'];
};


export type MutationAddPermissionArgs = {
  Permission: PermissionGroupEnum;
  Resource: PermissionResource;
};


export type MutationAddProductFacetOptionArgs = {
  Input?: InputMaybe<AddFacetOptionInput>;
};


export type MutationAddSupplierOrderNoteArgs = {
  Note: Scalars['StringInput'];
  SupplierOrder: Scalars['Int'];
};


export type MutationAddToShoppingCartArgs = {
  PickupLocation?: InputMaybe<Scalars['Int']>;
  Quantity?: InputMaybe<Scalars['Int']>;
  Region?: InputMaybe<Scalars['Int']>;
  Sample?: InputMaybe<Scalars['Boolean']>;
  ShippingMethod?: InputMaybe<Scalars['Int']>;
  ShippingProvider?: InputMaybe<ShippingProviderEnum>;
  Variant: Scalars['Int'];
};


export type MutationApplyPageTemplateArgs = {
  DirectoryType: DirectoryItemEnumType;
  ID: Scalars['Int'];
  TemplateID: Scalars['Int'];
};


export type MutationAssociatedPageSyncArgs = {
  AssociatedPageID: Scalars['Int'];
  ID: Scalars['Int'];
  PageType: Scalars['String'];
};


export type MutationBookCalendarEventArgs = {
  input: BookCalendarEventInput;
};


export type MutationBuildHubCollaboratorAddArgs = {
  BuildHubID: Scalars['ID'];
  Emails: Array<Scalars['Email']>;
  Message?: InputMaybe<Scalars['StringInput']>;
  Role?: InputMaybe<Scalars['StringInput']>;
  TeamMemberID?: InputMaybe<Scalars['Int']>;
};


export type MutationBuildHubCollaboratorRemoveArgs = {
  BuildHubID: Scalars['ID'];
  CollaboratorID: Scalars['ID'];
};


export type MutationBuildHubCollaboratorReorderArgs = {
  BuildHubID: Scalars['ID'];
  CollaboratorIDs: Array<Scalars['ID']>;
};


export type MutationBuildHubCollaboratorUpdateArgs = {
  BuildHubID: Scalars['ID'];
  Caption?: InputMaybe<Scalars['StringInput']>;
  CollaboratorID: Scalars['ID'];
  CustomCompanyName?: InputMaybe<Scalars['StringInput']>;
  Role: Scalars['StringInput'];
};


export type MutationBuildHubDeleteArgs = {
  BuildHubID: Scalars['ID'];
};


export type MutationBuildHubDocumentAccessUpdateArgs = {
  AccessSettings: BuildHubDocumentAccessInput;
  BuildHubDocumentID: Scalars['ID'];
};


export type MutationBuildHubDocumentCollaboratorAddArgs = {
  BuildHubDocumentID: Scalars['ID'];
  Collaborators: Array<BuildHubDocumentCollaboratorInput>;
};


export type MutationBuildHubDocumentCollaboratorRemoveArgs = {
  CollaboratorID: Scalars['ID'];
};


export type MutationBuildHubDocumentCollaboratorUpdateArgs = {
  CollaboratorID: Scalars['ID'];
  Role: Scalars['String'];
};


export type MutationBuildHubInviteAcceptArgs = {
  InviteHash: Scalars['String'];
};


export type MutationBuildHubInviteResendArgs = {
  CollaboratorID: Scalars['ID'];
};


export type MutationBuildHubLeaveProjectArgs = {
  BuildHubID: Scalars['ID'];
};


export type MutationBuildHubUpsertArgs = {
  ActiveStageURLSegment?: InputMaybe<Scalars['StringInput']>;
  BudgetMax?: InputMaybe<Scalars['Float']>;
  BudgetMin?: InputMaybe<Scalars['Float']>;
  BuildHubID?: InputMaybe<Scalars['ID']>;
  EndDate?: InputMaybe<Scalars['StringInput']>;
  Location?: InputMaybe<Scalars['StringInput']>;
  LocationData?: InputMaybe<PlaceDetailTypeInput>;
  MainDescription?: InputMaybe<Scalars['StringInput']>;
  OwnerCustomCompanyName?: InputMaybe<Scalars['StringInput']>;
  OwnerTeamMemberID?: InputMaybe<Scalars['Int']>;
  ProjectScope?: InputMaybe<Scalars['StringInput']>;
  ProjectType?: InputMaybe<BuildHubTypeEnum>;
  RemoveThumbnail?: InputMaybe<Scalars['Boolean']>;
  Stages?: InputMaybe<Array<InputMaybe<BuildHubStageInput>>>;
  StartDate?: InputMaybe<Scalars['StringInput']>;
  ThumbnailFile?: InputMaybe<Scalars['Upload']>;
  Title?: InputMaybe<Scalars['StringInput']>;
};


export type MutationCancelCalendarEventArgs = {
  input: CancelCalendarEventInput;
};


export type MutationCancelRequestArgs = {
  RequestID: Scalars['String'];
};


export type MutationCancelSupplierOrderArgs = {
  ID: Scalars['Int'];
  Message?: InputMaybe<Scalars['StringInput']>;
  Reason: Scalars['StringInput'];
};


export type MutationCardDismissArgs = {
  ID: Scalars['ID'];
};


export type MutationCardMarkAsViewedArgs = {
  ID: Scalars['ID'];
};


export type MutationCloneProfessionalArgs = {
  Options?: InputMaybe<Array<Scalars['StringInput']>>;
  URLSegment: Scalars['StringInput'];
};


export type MutationCommentMarkAsReadArgs = {
  DocumentID: Scalars['ID'];
};


export type MutationCommentMarkAsUnreadArgs = {
  CommentID?: InputMaybe<Scalars['ID']>;
  DocumentID: Scalars['ID'];
};


export type MutationCommentSubmitArgs = {
  CommentTargetID: Scalars['ID'];
  Files?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  Mentions?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  Message: Scalars['StringInput'];
};


export type MutationConfirmStripeAccountArgs = {
  URLSegment: Scalars['StringInput'];
};


export type MutationConfirmSupplierOrderArgs = {
  ID: Scalars['Int'];
};


export type MutationConnectStripeAccountArgs = {
  URLSegment: Scalars['StringInput'];
};


export type MutationConversionConfigArchiveArgs = {
  id: Scalars['Int'];
};


export type MutationConversionConfigCreateArgs = {
  categoryID: Scalars['StringInput'];
  eventType: PixelTrackerConversionConfigEventType;
  extraInfo: Scalars['StringInput'];
  funnelID: Scalars['StringInput'];
  professionalID: Scalars['Int'];
  title: Scalars['StringInput'];
};


export type MutationConversionConfigDeleteArgs = {
  id: Scalars['Int'];
};


export type MutationConversionConfigUnarchiveArgs = {
  id: Scalars['Int'];
};


export type MutationConversionConfigUpdateArgs = {
  conversionCategoryID: Scalars['Int'];
  funnelID: Scalars['Int'];
  id: Scalars['Int'];
  title: Scalars['StringInput'];
};


export type MutationConversionRuleDeleteArgs = {
  ID: Scalars['ID'];
  ProfessionalID: Scalars['ID'];
};


export type MutationConversionRuleOrderArgs = {
  ID: Scalars['ID'];
  ProfessionalID: Scalars['ID'];
  SortOrder: Scalars['Int'];
};


export type MutationConversionRuleToggleArgs = {
  Enabled: Scalars['Boolean'];
  ID: Scalars['ID'];
  ProfessionalID: Scalars['ID'];
};


export type MutationConversionRuleUpsertArgs = {
  Action: ConversionActionEnum;
  Conversion: ConversionTypeEnum;
  CustomClassification?: InputMaybe<Scalars['StringInput']>;
  ID?: InputMaybe<Scalars['ID']>;
  Pattern: ConversionPatternEnum;
  ProfessionalID: Scalars['ID'];
  Rule: Scalars['StringInput'];
};


export type MutationCopyPinArgs = {
  DestinationBoardID: Scalars['Int'];
  IDs: Array<Scalars['Int']>;
  SourceBoardID: Scalars['Int'];
};


export type MutationCreateAnalyticsCheckoutSessionArgs = {
  URLSegment: Scalars['StringInput'];
};


export type MutationCreateAndUpdateFacetOptionArgs = {
  Input?: InputMaybe<CreateFacetOptionInput>;
};


export type MutationCreateArticleArgs = {
  Title?: InputMaybe<Scalars['StringInput']>;
  URLSegment: Scalars['StringInput'];
};


export type MutationCreateAttributeArgs = {
  Name: Scalars['StringInput'];
  ProfessionalURLSegment: Scalars['StringInput'];
  SortOrder?: InputMaybe<Scalars['Int']>;
  Title?: InputMaybe<Scalars['StringInput']>;
};


export type MutationCreateAttributeAndOptionsArgs = {
  Name: Scalars['StringInput'];
  Options: Array<Scalars['StringInput']>;
  ProfessionalURLSegment: Scalars['StringInput'];
  ReplaceAttributeID?: InputMaybe<Scalars['Int']>;
};


export type MutationCreateAttributeOptionArgs = {
  AttributeID: Scalars['Int'];
  Code?: InputMaybe<Scalars['StringInput']>;
  Label: Scalars['StringInput'];
  ProfessionalURLSegment: Scalars['StringInput'];
  SortOrder?: InputMaybe<Scalars['Int']>;
};


export type MutationCreateBannerImageArgs = {
  BannerSegment?: InputMaybe<BannerSegmentEnum>;
  File: Scalars['Upload'];
  LibraryItemID: Scalars['Int'];
  Overlay?: InputMaybe<Scalars['Boolean']>;
  ReplaceExistingBanner?: InputMaybe<Scalars['Boolean']>;
  UnfilteredImage?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateBuildingGuideCheckoutSessionArgs = {
  Name: Scalars['StringInput'];
};


export type MutationCreateCalendarSessionArgs = {
  input: CreateCalendarSessionInput;
};


export type MutationCreateCompanyArgs = {
  CustomFields?: InputMaybe<Array<CustomFieldInput>>;
  Name: Scalars['StringInput'];
  ProfessionalID: Scalars['ID'];
  Website?: InputMaybe<Scalars['StringInput']>;
};


export type MutationCreateContactArgs = {
  CustomFields?: InputMaybe<Array<CustomFieldInput>>;
  Email: Scalars['Email'];
  FirstName?: InputMaybe<Scalars['StringInput']>;
  JobTitle?: InputMaybe<Scalars['StringInput']>;
  Phone?: InputMaybe<Scalars['StringInput']>;
  Photo?: InputMaybe<Scalars['Upload']>;
  ProfessionalID: Scalars['ID'];
  Surname?: InputMaybe<Scalars['StringInput']>;
};


export type MutationCreateContentBlockArgs = {
  BlogPostID: Scalars['Int'];
  Content?: InputMaybe<Scalars['StringInput']>;
  File?: InputMaybe<Scalars['Upload']>;
  Header?: InputMaybe<Scalars['StringInput']>;
  LibraryImageFileID?: InputMaybe<Scalars['Int']>;
  Type?: InputMaybe<Scalars['StringInput']>;
  VideoURL?: InputMaybe<Scalars['StringInput']>;
};


export type MutationCreateConversationArgs = {
  Attachments?: InputMaybe<Array<Scalars['Upload']>>;
  MemberIDs: Array<Scalars['Int']>;
  Text?: InputMaybe<Scalars['String']>;
};


export type MutationCreateConversationMessageArgs = {
  Attachments?: InputMaybe<Array<Scalars['Upload']>>;
  ConversationID: Scalars['Int'];
  Text?: InputMaybe<Scalars['String']>;
};


export type MutationCreateConversionConfigArgs = {
  EventType: PixelTrackerConversionConfigEventType;
  ExtraInfo: Scalars['StringInput'];
  Title: Scalars['StringInput'];
  URLSegment: Scalars['StringInput'];
};


export type MutationCreateDesignBoardArgs = {
  Content: Scalars['StringInput'];
  Public?: InputMaybe<Scalars['Boolean']>;
  Title: Scalars['StringInput'];
};


export type MutationCreateDesignBoardCommentArgs = {
  Content: Scalars['StringInput'];
  DesignBoardID: Scalars['Int'];
};


export type MutationCreateDiagramImagesArgs = {
  Files: Array<InputMaybe<Scalars['Upload']>>;
  LibraryItemID: Scalars['Int'];
};


export type MutationCreateEnquiryArgs = {
  HubspotContext?: InputMaybe<HubspotContextInput>;
  Input: EnquiryInput;
};


export type MutationCreateEnquiryCommentArgs = {
  Content: Scalars['StringInput'];
  EnquiryID: Scalars['Int'];
  Files?: InputMaybe<Array<InputMaybe<Scalars['Upload']>>>;
};


export type MutationCreateEnquiryConversationMessageArgs = {
  Input: AddEnquiryConversationMessageInput;
};


export type MutationCreateFacetOptionArgs = {
  FacetID: Scalars['Int'];
  Name: Scalars['StringInput'];
  ProfessionalURLSegment: Scalars['StringInput'];
};


export type MutationCreateItemTopBannerArgs = {
  BannerSegment?: InputMaybe<BannerSegmentEnum>;
  BannerVideoUrl?: InputMaybe<Scalars['String']>;
  CoverImageFile?: InputMaybe<Scalars['Upload']>;
  LibraryItemID: Scalars['Int'];
  Overlay?: InputMaybe<Scalars['Boolean']>;
  ReplaceExistingBanner?: InputMaybe<Scalars['Boolean']>;
  UnfilteredImage?: InputMaybe<Scalars['Boolean']>;
  VideoFile?: InputMaybe<Scalars['Upload']>;
};


export type MutationCreateLibraryDownloadArgs = {
  ExternalLink?: InputMaybe<Scalars['StringInput']>;
  FileCategoryID?: InputMaybe<Scalars['Int']>;
  Files?: InputMaybe<Array<InputMaybe<Scalars['Upload']>>>;
  Titles?: InputMaybe<Array<InputMaybe<Scalars['StringInput']>>>;
  URLSegment: Scalars['StringInput'];
};


export type MutationCreateLibraryImageArgs = {
  ContentBlockID?: InputMaybe<Scalars['Int']>;
  Files: Array<InputMaybe<Scalars['Upload']>>;
  IsBanner?: InputMaybe<Scalars['Int']>;
  LibraryItemID: Scalars['Int'];
  LibraryVideoID?: InputMaybe<Scalars['Int']>;
};


export type MutationCreateLibraryImageMarkerArgs = {
  LibraryImageID: Scalars['Int'];
  PositionX: Scalars['Float'];
  PositionY: Scalars['Float'];
  ProfessionalName?: InputMaybe<Scalars['StringInput']>;
  TargetID?: InputMaybe<Scalars['Int']>;
};


export type MutationCreateLibraryLocationArgs = {
  Address1: Scalars['StringInput'];
  Address2?: InputMaybe<Scalars['StringInput']>;
  AllowsDispatch?: InputMaybe<Scalars['Boolean']>;
  AllowsPickup?: InputMaybe<Scalars['Boolean']>;
  City?: InputMaybe<Scalars['StringInput']>;
  Country?: InputMaybe<Scalars['StringInput']>;
  DispatchEstimate?: InputMaybe<MinMaxInput>;
  LocationHidden?: InputMaybe<Scalars['Boolean']>;
  MapCoordinates?: InputMaybe<CoordinateInput>;
  Phone: Scalars['StringInput'];
  PickupEstimate?: InputMaybe<MinMaxInput>;
  PostCode?: InputMaybe<Scalars['StringInput']>;
  Region: Scalars['StringInput'];
  Suburb?: InputMaybe<Scalars['StringInput']>;
  Title: Scalars['StringInput'];
  Type: Scalars['StringInput'];
  URLSegment: Scalars['StringInput'];
};


export type MutationCreateLibraryRangeArgs = {
  Title: Scalars['StringInput'];
  URLSegment: Scalars['StringInput'];
};


export type MutationCreateLibraryTabArgs = {
  Content?: InputMaybe<Scalars['StringInput']>;
  Title: Scalars['StringInput'];
  URLSegment: Scalars['StringInput'];
};


export type MutationCreateLibraryVideoArgs = {
  Title?: InputMaybe<Scalars['StringInput']>;
  URLSegment: Scalars['StringInput'];
  Url: Scalars['StringInput'];
};


export type MutationCreateMemberUploadPinArgs = {
  DesignBoardID: Scalars['Int'];
  File?: InputMaybe<Scalars['Upload']>;
};


export type MutationCreateNetworkParticipantArgs = {
  input: CreateNetworkParticipantCreateData;
};


export type MutationCreateOrUpdateMasterVariantArgs = {
  Input?: InputMaybe<VariantInput>;
  ProductID: Scalars['Int'];
};


export type MutationCreateOrderReturnArgs = {
  ReturnItems: Array<OrderReturnItemInput>;
  SupplierOrder: Scalars['Int'];
};


export type MutationCreateOrganizationNetworkArgs = {
  input?: InputMaybe<OrganizationCreateData>;
};


export type MutationCreatePageTemplateArgs = {
  DirectoryType: DirectoryItemEnumType;
  ID?: InputMaybe<Scalars['Int']>;
  Title: Scalars['StringInput'];
};


export type MutationCreatePinArgs = {
  Input: PinInput;
};


export type MutationCreatePinCommentArgs = {
  Content: Scalars['StringInput'];
  PinID: Scalars['Int'];
};


export type MutationCreatePinsArgs = {
  Input: Array<InputMaybe<PinInput>>;
};


export type MutationCreateProductArgs = {
  CategoryIDs?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  PricingType?: InputMaybe<ProductPricingTypeEnum>;
  RangeID?: InputMaybe<Scalars['Int']>;
  RangeText?: InputMaybe<Scalars['StringInput']>;
  Title?: InputMaybe<Scalars['StringInput']>;
  URLSegment: Scalars['StringInput'];
};


export type MutationCreateProductSizeArgs = {
  Input: ProductSizeInput;
  ProductID: Scalars['Int'];
};


export type MutationCreateProductSwatchesArgs = {
  Files: Array<InputMaybe<Scalars['Upload']>>;
  URLSegment: Scalars['StringInput'];
};


export type MutationCreateProductVariantsArgs = {
  ColourImages?: InputMaybe<Array<Scalars['Int']>>;
  Excludes?: InputMaybe<Array<Scalars['StringInput']>>;
  ProductURLSegment: Scalars['StringInput'];
  Sizes?: InputMaybe<Array<Scalars['Int']>>;
  VariantOptions: Array<VariantOptionGroupInput>;
};


export type MutationCreateProfessionalArgs = {
  CategoryIDs?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  Title: Scalars['StringInput'];
};


export type MutationCreateProfessionalAwardArgs = {
  AwardDetails: CreateProfessionalAwardInput;
  AwardedEntityLinkList?: InputMaybe<Array<InputMaybe<Scalars['StringInput']>>>;
  ProfessionalID: Scalars['Int'];
};


export type MutationCreateProfessionalServiceAreaArgs = {
  Place: ServiceAreaInput;
  URLSegment: Scalars['StringInput'];
};


export type MutationCreateProjectArgs = {
  CategoryIDs?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  ProjectHeroTitle?: InputMaybe<Scalars['StringInput']>;
  Title?: InputMaybe<Scalars['StringInput']>;
  URLSegment: Scalars['StringInput'];
};


export type MutationCreateReviewActionArgs = {
  LibraryItemID: Scalars['Int'];
  Task: Scalars['StringInput'];
};


export type MutationCreateSavedModuleArgs = {
  ContentBuilderType?: InputMaybe<ContentBuilderTypeEnum>;
  ModuleID: Scalars['Int'];
  Name: Scalars['String'];
  ProfessionalID: Scalars['Int'];
};


export type MutationCreateSearchTagArgs = {
  LibraryItemID: Scalars['Int'];
  Text: Scalars['StringInput'];
};


export type MutationCreateServiceOfferingArgs = {
  Description?: InputMaybe<Scalars['StringInput']>;
  Photo?: InputMaybe<Scalars['Upload']>;
  ProfessionalID: Scalars['ID'];
  Quantity?: InputMaybe<Scalars['Int']>;
  SKU: Scalars['StringInput'];
  Title: Scalars['StringInput'];
  Unit?: InputMaybe<Scalars['StringInput']>;
  UnitPriceAmount?: InputMaybe<Scalars['Float']>;
};


export type MutationCreateShippingMethodArgs = {
  DeliveryEstimate?: InputMaybe<MinMaxInput>;
  Professional: Scalars['StringInput'];
  Title: Scalars['StringInput'];
};


export type MutationCreateShippingProfileArgs = {
  Professional: Scalars['StringInput'];
  Title: Scalars['StringInput'];
};


export type MutationCreateShoppingCartAddressArgs = {
  Address: AddressInput;
  AddressType: AddressTypeEnum;
};


export type MutationCreateShoppingCartOrderArgs = {
  PaymentMethod?: InputMaybe<Scalars['StringInput']>;
};


export type MutationCreateTeamMemberArgs = {
  Input: TeamMemberInput;
  URLSegment: Scalars['StringInput'];
};


export type MutationCreateTestimonialArgs = {
  Content: Scalars['StringInput'];
  ID?: InputMaybe<Scalars['Int']>;
  Location?: InputMaybe<Scalars['StringInput']>;
  Rating?: InputMaybe<Scalars['Int']>;
  SortOrder?: InputMaybe<Scalars['Int']>;
  Source?: InputMaybe<Scalars['StringInput']>;
  URLSegment?: InputMaybe<Scalars['StringInput']>;
};


export type MutationCreateVariantArgs = {
  AttributeOptionIDs: Array<Scalars['Int']>;
  Barcode?: InputMaybe<Scalars['StringInput']>;
  IsOnSale?: InputMaybe<Scalars['Boolean']>;
  Name?: InputMaybe<Scalars['StringInput']>;
  Price?: InputMaybe<Scalars['Int']>;
  ProductURLSegment: Scalars['StringInput'];
  SKU?: InputMaybe<Scalars['StringInput']>;
  SaleFinish?: InputMaybe<Scalars['StringInput']>;
  SalePrice?: InputMaybe<Scalars['Int']>;
  SaleStart?: InputMaybe<Scalars['StringInput']>;
  SortOrder?: InputMaybe<Scalars['Int']>;
  TradePrice?: InputMaybe<Scalars['Int']>;
};


export type MutationCreateVariantImageArgs = {
  Files: Array<InputMaybe<Scalars['Upload']>>;
  VariantID: Scalars['Int'];
};


export type MutationDeleteArticleArgs = {
  ID: Scalars['Int'];
};


export type MutationDeleteAttributeOptionArgs = {
  ID: Scalars['Int'];
};


export type MutationDeleteBusinessTermsByIdArgs = {
  ID: Scalars['Int'];
};


export type MutationDeleteCalendarSessionArgs = {
  ID: Scalars['Int'];
};


export type MutationDeleteCommentArgs = {
  ID: Scalars['Int'];
};


export type MutationDeleteCompanyArgs = {
  CompanyID: Scalars['ID'];
  ProfessionalID: Scalars['ID'];
};


export type MutationDeleteContactArgs = {
  Email: Scalars['Email'];
  ProfessionalID: Scalars['ID'];
};


export type MutationDeleteContentBlockArgs = {
  ID: Scalars['Int'];
};


export type MutationDeleteConversionConfigArgs = {
  ID: Scalars['ID'];
};


export type MutationDeleteDesignBoardArgs = {
  ID: Scalars['Int'];
};


export type MutationDeleteDirectoryItemArgs = {
  DirectoryItemID: Scalars['Int'];
};


export type MutationDeleteEmailTemplateByIdArgs = {
  ID: Scalars['Int'];
};


export type MutationDeleteEmailTemplateInputConfigArgs = {
  ID: Scalars['ID'];
};


export type MutationDeleteLibraryDownloadArgs = {
  ID: Scalars['Int'];
};


export type MutationDeleteLibraryImageArgs = {
  LibraryImageID: Scalars['Int'];
};


export type MutationDeleteLibraryImageMarkerArgs = {
  LibraryImageMarkerID: Scalars['Int'];
};


export type MutationDeleteLibraryImagesArgs = {
  ImageIds: Array<Scalars['Int']>;
};


export type MutationDeleteLibraryLocationArgs = {
  ID: Scalars['Int'];
};


export type MutationDeleteLibraryRangeArgs = {
  ID: Scalars['Int'];
};


export type MutationDeleteLibraryTabArgs = {
  ID: Scalars['Int'];
  URLSegment: Scalars['StringInput'];
};


export type MutationDeleteLibraryVideoArgs = {
  ID: Scalars['Int'];
};


export type MutationDeleteLibraryVideoThumbnailArgs = {
  LibraryVideoID: Scalars['Int'];
};


export type MutationDeleteModuleArgs = {
  ID: Scalars['Int'];
  ParentClass: Scalars['String'];
  ParentID: Scalars['Int'];
};


export type MutationDeleteModuleColumnArgs = {
  ColumnID: Scalars['Int'];
  ModuleID: Scalars['Int'];
  ParentClass: Scalars['String'];
  ParentID: Scalars['Int'];
};


export type MutationDeletePinArgs = {
  IDs: Array<Scalars['Int']>;
};


export type MutationDeletePinsByPageArgs = {
  BoardID?: InputMaybe<Scalars['Int']>;
  LibraryItemIDs: Array<Scalars['Int']>;
};


export type MutationDeleteProductSwatchArgs = {
  ID: Scalars['Int'];
};


export type MutationDeleteProfessionalAwardArgs = {
  AwardID: Scalars['Int'];
};


export type MutationDeleteProfessionalAwardBadgeArgs = {
  AwardID: Scalars['Int'];
  BadgeID: Scalars['Int'];
};


export type MutationDeleteProfessionalCompanyFieldArgs = {
  FieldID: Scalars['ID'];
  ProfessionalID: Scalars['ID'];
};


export type MutationDeleteProfessionalContactFieldArgs = {
  FieldID: Scalars['ID'];
  ProfessionalID: Scalars['ID'];
};


export type MutationDeleteProfessionalServiceAreaArgs = {
  ID: Scalars['Int'];
};


export type MutationDeleteQuoteContentByIdArgs = {
  ID: Scalars['Int'];
};


export type MutationDeleteQuotePaymentArgs = {
  IsTemplate: Scalars['Boolean'];
  PaymentID: Scalars['ID'];
  ProfessionalID: Scalars['ID'];
  QuoteID: Scalars['ID'];
};


export type MutationDeleteQuoteServiceItemArgs = {
  IsTemplate: Scalars['Boolean'];
  ProfessionalID: Scalars['ID'];
  QuoteID: Scalars['ID'];
  ServiceID: Scalars['ID'];
};


export type MutationDeleteReviewActionArgs = {
  ReviewActionID: Scalars['Int'];
};


export type MutationDeleteSavedModuleArgs = {
  ID: Scalars['Int'];
};


export type MutationDeleteSearchTagArgs = {
  ID: Scalars['Int'];
};


export type MutationDeleteServiceOfferingArgs = {
  ProfessionalID: Scalars['ID'];
  SKU: Scalars['StringInput'];
};


export type MutationDeleteShippingMethodArgs = {
  ID: Scalars['Int'];
};


export type MutationDeleteShippingProfileArgs = {
  ShippingProfileID: Scalars['Int'];
};


export type MutationDeleteShippingRateArgs = {
  ID: Scalars['Int'];
};


export type MutationDeleteSupplierOrderNoteArgs = {
  OrderEventID: Scalars['Int'];
};


export type MutationDeleteTeamMemberArgs = {
  ID: Scalars['Int'];
};


export type MutationDeleteTestimonialArgs = {
  ID?: InputMaybe<Scalars['Int']>;
};


export type MutationDeleteUnusedOptionsArgs = {
  AttributeID: Scalars['Int'];
  ProfessionalURLSegment: Scalars['String'];
};


export type MutationDeleteVariantArgs = {
  ID: Scalars['Int'];
};


export type MutationDeleteVariantImageArgs = {
  VariantImageID: Scalars['Int'];
};


export type MutationDeleteVariantsArgs = {
  IDs: Array<Scalars['Int']>;
};


export type MutationDirectoryItemBulkUpdateVisibilityArgs = {
  inLibrary: Scalars['Boolean'];
  pageIds: Array<Scalars['Int']>;
  professionalId: Scalars['Int'];
  type: DirectoryItemEnumType;
};


export type MutationDisconnectCalendarArgs = {
  provider: Scalars['String'];
};


export type MutationDispatchSupplierOrderArgs = {
  Courier?: InputMaybe<Scalars['Int']>;
  OrderItems: Array<Scalars['Int']>;
  ShippingProvider?: InputMaybe<Scalars['StringInput']>;
  SupplierOrder: Scalars['Int'];
  TrackingCode?: InputMaybe<Scalars['StringInput']>;
};


export type MutationEmailAssetRenameArgs = {
  LibraryImageID: Scalars['ID'];
  Title: Scalars['StringInput'];
};


export type MutationEmailAssetUploadArgs = {
  ProfessionalID: Scalars['ID'];
  Uploads: Array<Scalars['Upload']>;
};


export type MutationEmailDataBindingUpdateArgs = {
  EmailTemplateID: Scalars['ID'];
  SourceClass: Scalars['String'];
  SourceID?: InputMaybe<Scalars['ID']>;
};


export type MutationFollowDesignBoardArgs = {
  DesignBoardID: Scalars['ID'];
};


export type MutationImageAcceptArgs = {
  fileKey: Scalars['String'];
  keepReposition?: InputMaybe<Scalars['Boolean']>;
  libraryImageID: Scalars['Int'];
};


export type MutationImageCenterArgs = {
  libraryImageID: Scalars['Int'];
};


export type MutationImageRemoveBackgroundArgs = {
  libraryImageID: Scalars['Int'];
};


export type MutationImageRevertArgs = {
  libraryImageID: Scalars['Int'];
  originalImageUrl?: InputMaybe<Scalars['String']>;
};


export type MutationImageUpscaleArgs = {
  libraryImageID: Scalars['Int'];
};


export type MutationInstantPurchaseArgs = {
  Data: Scalars['StringInput'];
  PickupLocation?: InputMaybe<Scalars['Int']>;
  Quantity: Scalars['Int'];
  ShippingMethod?: InputMaybe<Scalars['Int']>;
  TotalCheck: Scalars['Int'];
  Variant: Scalars['Int'];
};


export type MutationInviteCollaboratorsArgs = {
  CanEdit: Scalars['Boolean'];
  DesignBoardID: Scalars['ID'];
  Emails: Scalars['StringInput'];
  Message?: InputMaybe<Scalars['StringInput']>;
};


export type MutationInviteTeamMemberArgs = {
  BypassEmail?: InputMaybe<Scalars['Boolean']>;
  Email: Scalars['Email'];
  Message?: InputMaybe<Scalars['StringInput']>;
  Name: Scalars['StringInput'];
  Phone?: InputMaybe<Scalars['StringInput']>;
  Position?: InputMaybe<Scalars['StringInput']>;
  URLSegment: Scalars['StringInput'];
};


export type MutationInviteTeamMembersArgs = {
  EmailAndNames: Array<TeamMemberInput>;
  Message?: InputMaybe<Scalars['StringInput']>;
  ProfessionalID: Scalars['Int'];
};


export type MutationInvoicePaymentSetProcessingPaymentArgs = {
  InvoicePaymentId: Scalars['Int'];
};


export type MutationLeaveDesignBoardArgs = {
  DesignBoardID: Scalars['ID'];
};


export type MutationLinkLibraryItemArgs = {
  ChildID: Scalars['Int'];
  ParentID: Scalars['Int'];
  Relationship: LibraryItemRelationshipEnumType;
};


export type MutationLogErrorArgs = {
  Error: Scalars['StringInput'];
  JsUrl?: InputMaybe<Scalars['StringInput']>;
  PageUrl?: InputMaybe<Scalars['StringInput']>;
  StackTrace: Scalars['StringInput'];
  UserAgent?: InputMaybe<Scalars['StringInput']>;
};


export type MutationLoginArgs = {
  Input: LoginInput;
};


export type MutationMarkConversationReadArgs = {
  ConversationID: Scalars['Int'];
};


export type MutationMarkWebsiteNotificationsAsReadArgs = {
  IDS?: InputMaybe<Array<Scalars['Int']>>;
};


export type MutationMemberReadRecordSetArgs = {
  Group: Scalars['String'];
  Name: Scalars['String'];
  hasRead: Scalars['Boolean'];
};


export type MutationMfaConfirmLoginArgs = {
  Input?: InputMaybe<MfaConfirmLoginInput>;
};


export type MutationMfaConfirmSetupArgs = {
  Input?: InputMaybe<MfaConfirmSetupInput>;
};


export type MutationMfaDisableSetupArgs = {
  Input?: InputMaybe<MfaDisableSetupInput>;
};


export type MutationMfaPasswordResetArgs = {
  Input?: InputMaybe<MfaPasswordResetInput>;
};


export type MutationMfaRequestArgs = {
  Input?: InputMaybe<MfaRequestInput>;
};


export type MutationMfaSetupArgs = {
  Input?: InputMaybe<MfaSetupInput>;
};


export type MutationModuleSwitchArgs = {
  ModuleID: Scalars['Int'];
  ParentClass: Scalars['String'];
  ParentID: Scalars['Int'];
  PresetID: Scalars['Int'];
};


export type MutationMoodBoardPinUploadArgs = {
  BoardID: Scalars['ID'];
  BuildHubID: Scalars['ID'];
  File: Scalars['Upload'];
};


export type MutationMoodBoardPinsAddArgs = {
  BoardID: Scalars['ID'];
  Pins: Array<InputMaybe<PinInput>>;
};


export type MutationMoodBoardPinsCopyArgs = {
  BuildHubUrl: Scalars['String'];
  FromBoardID: Scalars['Int'];
  Pins: Array<Scalars['String']>;
  ToBoardID: Scalars['Int'];
};


export type MutationMoodBoardPinsMoveArgs = {
  BuildHubUrl: Scalars['String'];
  FromBoardID: Scalars['Int'];
  Pins: Array<Scalars['String']>;
  ToBoardID: Scalars['Int'];
};


export type MutationMoodBoardPinsRemoveArgs = {
  BoardID: Scalars['ID'];
  Pins: Array<Scalars['ID']>;
};


export type MutationMoodBoardPinsRemoveByPageArgs = {
  BoardID: Scalars['ID'];
  LibraryItemIDs: Array<Scalars['ID']>;
};


export type MutationMovePinArgs = {
  DestinationBoardID: Scalars['Int'];
  IDs: Array<Scalars['Int']>;
  SourceBoardID: Scalars['Int'];
};


export type MutationPageBulkCloneArgs = {
  CountryCode: SupportedCountry;
  PageIDs: Array<Scalars['Int']>;
  PageType: Scalars['String'];
};


export type MutationPageCloneArgs = {
  ID: Scalars['Int'];
  PageType: Scalars['String'];
  ProfessionalID: Scalars['Int'];
};


export type MutationPageUrlSegmentUpdateArgs = {
  PageID: Scalars['Int'];
  PageType: Scalars['String'];
  URLSegment: Scalars['StringInput'];
};


export type MutationPaymentIntentCreateArgs = {
  InvoicePaymentID: Scalars['ID'];
};


export type MutationProcessOrderDeclineArgs = {
  DeclineItems: Array<OrderDeclineItemInput>;
  DeclineReason?: InputMaybe<Scalars['StringInput']>;
  SupplierOrder: Scalars['Int'];
};


export type MutationProcessOrderReturnArgs = {
  ReturnItems: Array<OrderReturnItemInput>;
  ReturnReason?: InputMaybe<Scalars['StringInput']>;
  ShippingRefund: Scalars['Int'];
  SupplierOrder: Scalars['Int'];
};


export type MutationProcessPaymentResponseArgs = {
  Data: Scalars['StringInput'];
};


export type MutationProcessProductImportArgs = {
  DataSource?: InputMaybe<IntegratedPlatformEnum>;
  Overwrite?: InputMaybe<Scalars['Boolean']>;
  Product: ImportProduct;
  Professional: Scalars['String'];
};


export type MutationProductRestoreArgs = {
  products?: InputMaybe<Array<Scalars['Int']>>;
};


export type MutationProjectInspirationGroupRemoveArgs = {
  BuildHubID: Scalars['ID'];
  InspirationGroupID: Scalars['ID'];
};


export type MutationProjectInspirationGroupRemoveBySourceArgs = {
  BuildHubID: Scalars['ID'];
  IdeaBookID: Scalars['ID'];
};


export type MutationProjectInspirationGroupUpsertArgs = {
  BuildHubID: Scalars['ID'];
  Description?: InputMaybe<Scalars['StringInput']>;
  GeneralAccessMode?: InputMaybe<Scalars['String']>;
  GeneralAccessRole?: InputMaybe<Scalars['String']>;
  InheritPermissions?: InputMaybe<Scalars['Boolean']>;
  InspirationGroupID?: InputMaybe<Scalars['ID']>;
  ParentID?: InputMaybe<Scalars['Int']>;
  Private?: InputMaybe<Scalars['Boolean']>;
  SortOrder?: InputMaybe<Scalars['Int']>;
  Title?: InputMaybe<Scalars['StringInput']>;
};


export type MutationProjectInspirationIdeaBookMigrateArgs = {
  BuildHubID: Scalars['ID'];
  IdeaBookID: Scalars['ID'];
  ParentID?: InputMaybe<Scalars['Int']>;
};


export type MutationProjectInspirationItemImportUrlArgs = {
  BuildHubID: Scalars['ID'];
  InspirationGroupID: Scalars['ID'];
  URL: Scalars['String'];
};


export type MutationProjectInspirationItemUpdateArgs = {
  Description?: InputMaybe<Scalars['StringInput']>;
  InspirationItemID: Scalars['ID'];
  Title?: InputMaybe<Scalars['StringInput']>;
};


export type MutationProjectTeamMemberCreateArgs = {
  Category: Scalars['String'];
  ProjectID: Scalars['ID'];
  TeamMemberID: Scalars['ID'];
};


export type MutationProjectTeamMemberDeleteArgs = {
  Category: Scalars['String'];
  ProjectID: Scalars['ID'];
  TeamMemberID: Scalars['ID'];
};


export type MutationQuoteAcceptOrDeclineArgs = {
  Decision: QuoteDecisionEnum;
  Email?: InputMaybe<Scalars['Email']>;
  FullName?: InputMaybe<Scalars['StringInput']>;
  SignatureDataUrl?: InputMaybe<Scalars['StringInput']>;
  UrlSegment: Scalars['StringInput'];
};


export type MutationRearrangeSortOrdersArgs = {
  ItemType: SortableItemEnum;
  Items?: InputMaybe<Array<RearrangeItems>>;
  PageNumber: Scalars['Int'];
  PageSize: Scalars['Int'];
  ProfessionalID: Scalars['Int'];
};


export type MutationRegisterExpoPushDeviceArgs = {
  Devices: Array<PushDeviceInfo>;
};


export type MutationRegisterForNewsLetterArgs = {
  Email: Scalars['Email'];
};


export type MutationRemoveCollaboratorArgs = {
  DesignBoardID: Scalars['ID'];
  Email: Scalars['Email'];
  HasAccepted: Scalars['Boolean'];
};


export type MutationRemoveNetworkParticipantArgs = {
  input: RemoveNetworkParticipantCreateData;
};


export type MutationRemovePermissionArgs = {
  Permission: PermissionGroupEnum;
  Resource: PermissionResource;
};


export type MutationRemoveProductFacetOptionArgs = {
  Input?: InputMaybe<RemoveFacetOptionInput>;
};


export type MutationRemoveReactionArgs = {
  DocumentID: Scalars['ID'];
  Reaction: ReactionTypeEnum;
};


export type MutationRenameSavedModuleArgs = {
  ID: Scalars['Int'];
  Name: Scalars['String'];
};


export type MutationReorderQuoteServiceItemArgs = {
  IsTemplate: Scalars['Boolean'];
  ProfessionalID: Scalars['ID'];
  QuoteID: Scalars['ID'];
  ServiceID: Scalars['ID'];
  SortOrder: Scalars['Int'];
};


export type MutationReportDirectoryItemArgs = {
  Link: Scalars['String'];
  ModerationReasonID: Scalars['Int'];
  Note?: InputMaybe<Scalars['String']>;
};


export type MutationReportUserArgs = {
  ModerationReasonID: Scalars['Int'];
  Note?: InputMaybe<Scalars['String']>;
  UserID: Scalars['Int'];
};


export type MutationRequestAccountDeletionArgs = {
  ReasonID?: InputMaybe<Scalars['Int']>;
};


export type MutationResendCollaboratorInviteArgs = {
  DesignBoardID: Scalars['ID'];
  Email: Scalars['Email'];
};


export type MutationResendTeamMemberInvitationArgs = {
  ID: Scalars['Int'];
};


export type MutationResetModuleColumnArgs = {
  ColumnID: Scalars['Int'];
  ModuleID: Scalars['Int'];
};


export type MutationResetOrderNotificationArgs = {
  OrderNumber: Scalars['String'];
};


export type MutationReuseVariantImageArgs = {
  VariantID: Scalars['Int'];
  VariantImageID: Scalars['Int'];
};


export type MutationRevealContactDetailsArgs = {
  ParticipantID: Scalars['Int'];
};


export type MutationReviewPageArgs = {
  Approved: Scalars['Boolean'];
  LibraryItemID: Scalars['Int'];
};


export type MutationSaveAndInviteTeamMemberArgs = {
  Email?: InputMaybe<Scalars['Email']>;
  ID?: InputMaybe<Scalars['Int']>;
  Image?: InputMaybe<Scalars['Upload']>;
  JobTitle?: InputMaybe<Scalars['StringInput']>;
  LinkedInLink?: InputMaybe<Scalars['StringInput']>;
  Name: Scalars['StringInput'];
  ProfessionalID: Scalars['Int'];
};


export type MutationSaveImportMapArgs = {
  Fields?: InputMaybe<Array<InputMaybe<ImportMapFieldInput>>>;
  Professional: Scalars['String'];
};


export type MutationSaveReactionArgs = {
  DocumentID: Scalars['ID'];
  Reaction: ReactionTypeEnum;
  UniqueReaction?: InputMaybe<Scalars['Boolean']>;
};


export type MutationSendEmailTemplateArgs = {
  BCC?: InputMaybe<Scalars['StringInput']>;
  EmailTemplateID: Scalars['ID'];
  ReplyTo?: InputMaybe<Scalars['Email']>;
  To: Scalars['Email'];
  ToFirstName: Scalars['StringInput'];
  ToSurname: Scalars['StringInput'];
};


export type MutationSendHubspotMarketingPreferencesEmailArgs = {
  input: SendHubspotMarketingPreferencesEmailInputType;
};


export type MutationSendPixelCodeArgs = {
  Email: Scalars['Email'];
  Message: Scalars['StringInput'];
  ProfessionalID: Scalars['Int'];
  ReceiverName?: InputMaybe<Scalars['StringInput']>;
  RecordStartedAt?: InputMaybe<Scalars['StringInput']>;
  RecordStoppedAt?: InputMaybe<Scalars['StringInput']>;
  SenderName?: InputMaybe<Scalars['StringInput']>;
};


export type MutationSendPushNotificationArgs = {
  Message: Scalars['StringInput'];
  Recipients: Array<PushNotificationRecipient>;
  Title: Scalars['StringInput'];
};


export type MutationSendQuoteArgs = {
  ProfessionalID: Scalars['ID'];
  QuoteContentID: Scalars['ID'];
  To?: InputMaybe<Scalars['Email']>;
  ToFirstName?: InputMaybe<Scalars['StringInput']>;
  ToSurname?: InputMaybe<Scalars['StringInput']>;
};


export type MutationSetBoardCommentsAsReadArgs = {
  ID: Scalars['Int'];
};


export type MutationSetEnquiryArchivedArgs = {
  Archived: Scalars['Boolean'];
  ID: Scalars['Int'];
};


export type MutationSetEnquiryCommentsAsReadArgs = {
  ID: Scalars['Int'];
};


export type MutationSetEnquiryImportantStatusArgs = {
  EnquiryID: Scalars['Int'];
  Important: Scalars['Boolean'];
};


export type MutationSetEnquiryReadStatusArgs = {
  EnquiryID: Scalars['Int'];
  Read: Scalars['Boolean'];
};


export type MutationSetLibraryItemCategoriesArgs = {
  CategoryIDs: Array<InputMaybe<Scalars['Int']>>;
  DirectoryItemType?: InputMaybe<DirectoryItemEnumType>;
  LibraryItemID: Scalars['Int'];
};


export type MutationSetLibraryRangeArgs = {
  ID: Scalars['Int'];
  URLSegment: Scalars['StringInput'];
};


export type MutationSetLibraryThumbArgs = {
  LibraryImageFileID: Scalars['Int'];
  LibraryItemID: Scalars['Int'];
};


export type MutationSetObjectArchivedArgs = {
  Archived: Scalars['Boolean'];
  ObjectID: Scalars['Int'];
  ObjectType: Scalars['StringInput'];
};


export type MutationSetPinCommentsAsReadArgs = {
  ID: Scalars['Int'];
};


export type MutationSetProjectTeamOrderArgs = {
  ProjectID: Scalars['Int'];
  TeamMemberIDs: Array<Scalars['Int']>;
};


export type MutationSetShippingRatesArgs = {
  ShippingProfileID: Scalars['Int'];
  ShippingRates: Array<ShippingRateInput>;
};


export type MutationSetShoppingCartAddressArgs = {
  AddressID: Scalars['Int'];
  AddressType: AddressTypeEnum;
};


export type MutationSetSupplierSurveyStatusArgs = {
  URLSegment: Scalars['StringInput'];
};


export type MutationSetupIntentCreateArgs = {
  ContactID: Scalars['ID'];
  InvoicePaymentID?: InputMaybe<Scalars['ID']>;
};


export type MutationSetupSplitPaymentsArgs = {
  DueDayOfMonth: Scalars['Int'];
  NumberOfPayments: Scalars['Int'];
  ProfessionalID: Scalars['ID'];
  QuoteContentID: Scalars['ID'];
};


export type MutationShareEnquiryConversationArgs = {
  Input?: InputMaybe<ShareEnquiryConversationInput>;
};


export type MutationShareItemArgs = {
  ItemID: Scalars['Int'];
  ItemType: ShareItemType;
  Message?: InputMaybe<Scalars['StringInput']>;
  ShareType: ShareType;
  To?: InputMaybe<Array<Scalars['StringInput']>>;
};


export type MutationSocialLoginArgs = {
  Input: SocialLoginInput;
};


export type MutationSortContentBlocksArgs = {
  BlogPostID: Scalars['Int'];
  ContentBlockIDs: Array<InputMaybe<Scalars['Int']>>;
};


export type MutationSubmitAceFormArgs = {
  Input: AceFormInput;
};


export type MutationSubmitAdvertisingFormArgs = {
  Input: AdvertisingFormInput;
};


export type MutationSyncAnalyticsSubscriptionArgs = {
  URLSegment: Scalars['StringInput'];
};


export type MutationSyncSavedModuleArgs = {
  ModuleID: Scalars['Int'];
};


export type MutationUnlinkLibraryItemArgs = {
  ChildID: Scalars['Int'];
  ParentID: Scalars['Int'];
  Relationship: LibraryItemRelationshipEnumType;
};


export type MutationUnregisterExpoPushDeviceArgs = {
  DeviceID: Scalars['String'];
};


export type MutationUnsetLibraryRangeArgs = {
  URLSegment: Scalars['StringInput'];
};


export type MutationUnsetVariantOptionsArgs = {
  Options: Array<Scalars['Int']>;
  VariantID: Scalars['Int'];
};


export type MutationUnsetVariantSizeArgs = {
  VariantID: Scalars['Int'];
};


export type MutationUpdateAnalyticsSubscriptionArgs = {
  Cancel: Scalars['Boolean'];
  URLSegment: Scalars['StringInput'];
};


export type MutationUpdateArticleArgs = {
  Activated?: InputMaybe<Scalars['Boolean']>;
  AuthorID?: InputMaybe<Scalars['Int']>;
  BulkPhotoCreditID?: InputMaybe<Scalars['Int']>;
  ByArchipro?: InputMaybe<Scalars['Boolean']>;
  CategoryIDs?: InputMaybe<Array<Scalars['Int']>>;
  Content?: InputMaybe<Scalars['StringInput']>;
  DirectoryItemID: Scalars['Int'];
  InLibrary?: InputMaybe<Scalars['Boolean']>;
  IntroText?: InputMaybe<Scalars['StringInput']>;
  ProfessionalID?: InputMaybe<Scalars['Int']>;
  Publish?: InputMaybe<Scalars['Boolean']>;
  PublishDate?: InputMaybe<Scalars['StringInput']>;
  SelfPublished?: InputMaybe<Scalars['Boolean']>;
  Title?: InputMaybe<Scalars['StringInput']>;
};


export type MutationUpdateAttributeOptionArgs = {
  Code?: InputMaybe<Scalars['StringInput']>;
  ID: Scalars['Int'];
  Label?: InputMaybe<Scalars['StringInput']>;
  Name?: InputMaybe<Scalars['StringInput']>;
  SortOrder?: InputMaybe<Scalars['Int']>;
};


export type MutationUpdateAttributeOptionSortOrdersArgs = {
  Input: Array<SortOrderInput>;
  ProductID: Scalars['Int'];
};


export type MutationUpdateBuildHubTimelineSettingsArgs = {
  BuildHubID: Scalars['ID'];
  HighlightNonWorkingDays?: InputMaybe<Scalars['Boolean']>;
  ShowGridLines?: InputMaybe<Scalars['Boolean']>;
  ShowMinorGridLines?: InputMaybe<Scalars['Boolean']>;
  ShowNonWorkingDays?: InputMaybe<Scalars['Boolean']>;
  ViewMode?: InputMaybe<Scalars['StringInput']>;
  WorkingDays?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateBusinessTermsDataBindingArgs = {
  BusinessTermsID: Scalars['ID'];
  SourceClass: Scalars['String'];
  SourceID?: InputMaybe<Scalars['ID']>;
};


export type MutationUpdateCalendarSessionArgs = {
  ID: Scalars['Int'];
  input: UpdateCalendarSessionInput;
};


export type MutationUpdateCollaboratorPermissionArgs = {
  CanEdit: Scalars['Boolean'];
  DesignBoardID: Scalars['ID'];
  Email: Scalars['Email'];
  HasAccepted: Scalars['Boolean'];
};


export type MutationUpdateCompanyArgs = {
  CompanyID: Scalars['ID'];
  CustomFields?: InputMaybe<Array<CustomFieldInput>>;
  Name?: InputMaybe<Scalars['StringInput']>;
  ProfessionalID: Scalars['ID'];
  Website?: InputMaybe<Scalars['StringInput']>;
};


export type MutationUpdateContactArgs = {
  CustomFields?: InputMaybe<Array<CustomFieldInput>>;
  Email: Scalars['Email'];
  FirstName?: InputMaybe<Scalars['StringInput']>;
  JobTitle?: InputMaybe<Scalars['StringInput']>;
  Phone?: InputMaybe<Scalars['StringInput']>;
  Photo?: InputMaybe<Scalars['Upload']>;
  ProfessionalID: Scalars['ID'];
  Surname?: InputMaybe<Scalars['StringInput']>;
};


export type MutationUpdateContentBlockArgs = {
  Content?: InputMaybe<Scalars['StringInput']>;
  Header?: InputMaybe<Scalars['StringInput']>;
  ID: Scalars['Int'];
  Type?: InputMaybe<Scalars['StringInput']>;
  VideoURL?: InputMaybe<Scalars['StringInput']>;
};


export type MutationUpdateConversationArgs = {
  BuildHubID?: InputMaybe<Scalars['Int']>;
  ConversationID: Scalars['Int'];
  Name?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateConversationParticipantsArgs = {
  AddMemberIDs?: InputMaybe<Array<Scalars['Int']>>;
  ConversationID: Scalars['Int'];
  RemoveMemberIDs?: InputMaybe<Array<Scalars['Int']>>;
};


export type MutationUpdateConversionConfigArgs = {
  ID: Scalars['ID'];
  Title: Scalars['StringInput'];
};


export type MutationUpdateDesignBoardArgs = {
  Content?: InputMaybe<Scalars['StringInput']>;
  DesignBoardID: Scalars['Int'];
  Public?: InputMaybe<Scalars['Boolean']>;
  Title?: InputMaybe<Scalars['StringInput']>;
};


export type MutationUpdateDesignBoardSettingArgs = {
  EnquiryReminderEmailEnabled: Scalars['Boolean'];
  NotifyAllEnabled: Scalars['Boolean'];
  WeeklyEmailEnabled: Scalars['Boolean'];
};


export type MutationUpdateFeatureBookingArgs = {
  ID: Scalars['Int'];
  ScrollPosY: Scalars['Int'];
};


export type MutationUpdateFlexibleModuleArgs = {
  Columns?: InputMaybe<Array<ModuleColumnInput>>;
  ID?: InputMaybe<Scalars['Int']>;
  MemberSortOrder?: InputMaybe<Scalars['Int']>;
  ParentClass: Scalars['String'];
  ParentID: Scalars['Int'];
  PresetID?: InputMaybe<Scalars['Int']>;
};


export type MutationUpdateItemStatusByAdminArgs = {
  Field: DirectoryItemsStatusActions;
  ID: Scalars['Int'];
  Value: Scalars['Boolean'];
};


export type MutationUpdateLibraryDownloadArgs = {
  FileCategoryID?: InputMaybe<Scalars['Int']>;
  ID: Scalars['Int'];
  Title?: InputMaybe<Scalars['StringInput']>;
};


export type MutationUpdateLibraryImageArgs = {
  AltText?: InputMaybe<Scalars['StringInput']>;
  Caption?: InputMaybe<Scalars['StringInput']>;
  ClickableLink?: InputMaybe<Scalars['StringInput']>;
  FileName?: InputMaybe<Scalars['StringInput']>;
  FullScreen?: InputMaybe<Scalars['Boolean']>;
  ImageFilter?: InputMaybe<Scalars['StringInput']>;
  IsHalfWidth?: InputMaybe<Scalars['Boolean']>;
  IsMultiplied?: InputMaybe<Scalars['Boolean']>;
  LibraryImageID: Scalars['Int'];
  MetaDescription?: InputMaybe<Scalars['StringInput']>;
  Overlay?: InputMaybe<Scalars['Boolean']>;
  PhotoCreditID?: InputMaybe<Scalars['Int']>;
  PhotoCreditName?: InputMaybe<Scalars['StringInput']>;
  Regenerate?: InputMaybe<Scalars['Boolean']>;
  ScrollPosX?: InputMaybe<Scalars['Float']>;
  ScrollPosY?: InputMaybe<Scalars['Float']>;
  SearchTags?: InputMaybe<Array<Scalars['StringInput']>>;
  Title?: InputMaybe<Scalars['StringInput']>;
  ZoomFactor?: InputMaybe<Scalars['Float']>;
};


export type MutationUpdateLibraryImageMarkerArgs = {
  Approved?: InputMaybe<Scalars['Boolean']>;
  LibraryImageMarkerID: Scalars['Int'];
};


export type MutationUpdateLibraryImagesArgs = {
  Input: Array<UpdateLibraryImageInput>;
};


export type MutationUpdateLibraryImagesSortOrderArgs = {
  LibraryImages?: InputMaybe<Array<LibraryImagesInput>>;
};


export type MutationUpdateLibraryLocationsArgs = {
  LibraryLocations: Array<InputMaybe<LibraryLocationUpdatesList>>;
};


export type MutationUpdateLibraryRangeArgs = {
  ID: Scalars['Int'];
  Title: Scalars['StringInput'];
};


export type MutationUpdateLibraryTabsArgs = {
  LibraryTabs: Array<LibraryTabUpdate>;
  URLSegment: Scalars['StringInput'];
};


export type MutationUpdateLibraryThumbArgs = {
  LibraryImageID?: InputMaybe<Scalars['Int']>;
  LibraryItemID?: InputMaybe<Scalars['Int']>;
  ScrollPosX?: InputMaybe<Scalars['Float']>;
  ScrollPosY?: InputMaybe<Scalars['Float']>;
  ZoomLevel?: InputMaybe<Scalars['Int']>;
};


export type MutationUpdateLibraryVideoArgs = {
  ID: Scalars['Int'];
  Title?: InputMaybe<Scalars['StringInput']>;
  Url?: InputMaybe<Scalars['StringInput']>;
};


export type MutationUpdateMeArgs = {
  Input: UpdateMeInput;
};


export type MutationUpdateMetaArgs = {
  Input: UpdateMetaInput;
  URLSegment: Scalars['StringInput'];
};


export type MutationUpdateOrganizationNetworkParticipantArgs = {
  input: UpdateOrganizationNetworkParticipantData;
};


export type MutationUpdateParticipantStatusArgs = {
  Input: SetParticipantStatusInput;
};


export type MutationUpdatePasswordArgs = {
  Input: UpdatePasswordInput;
};


export type MutationUpdateProductArgs = {
  Activated?: InputMaybe<Scalars['Boolean']>;
  AllowFastQuote?: InputMaybe<Scalars['Boolean']>;
  Brand?: InputMaybe<Scalars['StringInput']>;
  BulkPhotoCreditID?: InputMaybe<Scalars['Int']>;
  CategoryIDs?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  Content?: InputMaybe<Scalars['StringInput']>;
  ContentLocked?: InputMaybe<Scalars['Boolean']>;
  Designer?: InputMaybe<Scalars['StringInput']>;
  DirectoryItemID: Scalars['Int'];
  ExcludeAdvertising?: InputMaybe<Scalars['Boolean']>;
  ExcludedFromSpecialtyRates?: InputMaybe<Scalars['Boolean']>;
  InLibrary?: InputMaybe<Scalars['Boolean']>;
  IsBasePrice?: InputMaybe<Scalars['Boolean']>;
  IsDraft?: InputMaybe<Scalars['Boolean']>;
  IsFeatured?: InputMaybe<Scalars['Boolean']>;
  LeadTime?: InputMaybe<Scalars['StringInput']>;
  PerformanceDescription?: InputMaybe<Scalars['StringInput']>;
  Price?: InputMaybe<Scalars['Float']>;
  ProfessionalID?: InputMaybe<Scalars['Int']>;
  Publish?: InputMaybe<Scalars['Boolean']>;
  PublishDate?: InputMaybe<Scalars['StringInput']>;
  ScopeOfUseDescription?: InputMaybe<Scalars['StringInput']>;
  Title?: InputMaybe<Scalars['StringInput']>;
  WarrantyDuration?: InputMaybe<Scalars['StringInput']>;
  Website?: InputMaybe<Scalars['StringInput']>;
  Year?: InputMaybe<Scalars['StringInput']>;
};


export type MutationUpdateProductFacetOptionsArgs = {
  FacetOptionIDs: Array<Scalars['Int']>;
  URLSegment: Scalars['StringInput'];
};


export type MutationUpdateProductPricingArgs = {
  Input: UpdateProductPricingInput;
};


export type MutationUpdateProductSizeArgs = {
  ID: Scalars['Int'];
  Input: ProductSizeInput;
};


export type MutationUpdateProductSizeSortOrdersArgs = {
  Input: Array<SortOrderInput>;
  ProductID: Scalars['Int'];
};


export type MutationUpdateProductSwatchesArgs = {
  ProductSwatches: Array<ProductSwatchUpdate>;
  URLSegment: Scalars['StringInput'];
};


export type MutationUpdateProfessionalArgs = {
  APConnect?: InputMaybe<Scalars['Boolean']>;
  Activated?: InputMaybe<Scalars['Boolean']>;
  AllowBooking?: InputMaybe<Scalars['Boolean']>;
  AllowCRMIntegration?: InputMaybe<Scalars['Boolean']>;
  AllowEmailBuilder?: InputMaybe<Scalars['Boolean']>;
  AllowInvoicing?: InputMaybe<Scalars['Boolean']>;
  AnalyticsStatus?: InputMaybe<AnalyticsStatusEnum>;
  AutoConfirmOrders?: InputMaybe<Scalars['Boolean']>;
  AvailableForWork?: InputMaybe<Scalars['Boolean']>;
  Awards?: InputMaybe<Scalars['StringInput']>;
  BlockSummary?: InputMaybe<Scalars['StringInput']>;
  BulkPhotoCreditID?: InputMaybe<Scalars['Int']>;
  BusinessFocus?: InputMaybe<BusinessFocusEnum>;
  BusinessTypes?: InputMaybe<Array<BusinessTypeEnum>>;
  CategoryIDs?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  Content?: InputMaybe<Scalars['StringInput']>;
  ContentNotificationEmailAddresses?: InputMaybe<Array<Scalars['StringInput']>>;
  CustomEnquiryMessage?: InputMaybe<Scalars['StringInput']>;
  DirectoryItemID: Scalars['Int'];
  Disable?: InputMaybe<Scalars['Boolean']>;
  EcommerceEmailAddresses?: InputMaybe<Array<Scalars['StringInput']>>;
  Email?: InputMaybe<Scalars['Email']>;
  EngagementNotificationEmailAddresses?: InputMaybe<Array<Scalars['StringInput']>>;
  EnquiryEmailAddresses?: InputMaybe<Array<Scalars['StringInput']>>;
  FreeShippingThreshold?: InputMaybe<Scalars['Int']>;
  FreeShippingThresholdEnabled?: InputMaybe<Scalars['Boolean']>;
  HubspotID?: InputMaybe<Scalars['String']>;
  InLibrary?: InputMaybe<Scalars['Boolean']>;
  Mobile?: InputMaybe<Scalars['StringInput']>;
  NoticePeriod?: InputMaybe<Scalars['Int']>;
  NoticePeriodUnit?: InputMaybe<ProfessionalNoticePeriodUnitEnum>;
  Phone?: InputMaybe<Scalars['StringInput']>;
  Phone2?: InputMaybe<Scalars['StringInput']>;
  PhoneTracking?: InputMaybe<Scalars['StringInput']>;
  PhoneTrackingPlayMessage?: InputMaybe<Scalars['StringInput']>;
  PixelNotGated?: InputMaybe<Scalars['Boolean']>;
  PriceRanges?: InputMaybe<Array<Scalars['Int']>>;
  PrimaryCTA?: InputMaybe<PrimaryCtaEnum>;
  ProductCTA?: InputMaybe<ProductCtaEnum>;
  PublicFacebookLink?: InputMaybe<Scalars['StringInput']>;
  PublicInstagramLink?: InputMaybe<Scalars['StringInput']>;
  PublicLinkedinLink?: InputMaybe<Scalars['StringInput']>;
  PublicPinterestLink?: InputMaybe<Scalars['StringInput']>;
  PublicTikTokLink?: InputMaybe<Scalars['StringInput']>;
  PublicTwitterLink?: InputMaybe<Scalars['StringInput']>;
  PublicYoutubeLink?: InputMaybe<Scalars['StringInput']>;
  Publish?: InputMaybe<Scalars['Boolean']>;
  PublishDate?: InputMaybe<Scalars['StringInput']>;
  Services?: InputMaybe<Array<Scalars['StringInput']>>;
  StatsReportEmailAddresses?: InputMaybe<Array<Scalars['StringInput']>>;
  Title?: InputMaybe<Scalars['StringInput']>;
  Website?: InputMaybe<Scalars['StringInput']>;
  YearFounded?: InputMaybe<Scalars['StringInput']>;
};


export type MutationUpdateProfessionalAwardArgs = {
  AwardDetails: UpdateProfessionalAwardInput;
  AwardID: Scalars['Int'];
  AwardedEntityLinkList?: InputMaybe<Array<InputMaybe<Scalars['StringInput']>>>;
};


export type MutationUpdateProfessionalServiceAreaArgs = {
  Places: Array<InputMaybe<ServiceAreaInput>>;
  URLSegment: Scalars['StringInput'];
};


export type MutationUpdateProjectArgs = {
  Activated?: InputMaybe<Scalars['Boolean']>;
  BuildingStyle?: InputMaybe<Scalars['StringInput']>;
  BulkPhotoCreditID?: InputMaybe<Scalars['Int']>;
  CategoryIDs?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  Client?: InputMaybe<Scalars['StringInput']>;
  Content?: InputMaybe<Scalars['StringInput']>;
  DirectoryItemID: Scalars['Int'];
  InLibrary?: InputMaybe<Scalars['Boolean']>;
  IsDraft?: InputMaybe<Scalars['Boolean']>;
  IsFeatured?: InputMaybe<Scalars['Boolean']>;
  PriceRangeID?: InputMaybe<Scalars['Int']>;
  ProjectHeroTitle?: InputMaybe<Scalars['StringInput']>;
  Publish?: InputMaybe<Scalars['Boolean']>;
  PublishDate?: InputMaybe<Scalars['StringInput']>;
  SelfPublished?: InputMaybe<Scalars['Boolean']>;
  Subheading?: InputMaybe<Scalars['StringInput']>;
  TeamMemberOrder?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  Title?: InputMaybe<Scalars['StringInput']>;
  YearOfCompletion?: InputMaybe<Scalars['Int']>;
};


export type MutationUpdateQuoteDataBindingArgs = {
  IsTemplate: Scalars['Boolean'];
  ProfessionalID: Scalars['ID'];
  QuoteID: Scalars['ID'];
  SourceClass: Scalars['String'];
  SourceID?: InputMaybe<Scalars['ID']>;
};


export type MutationUpdateQuoteMetaDataArgs = {
  AccountDetails?: InputMaybe<Scalars['StringInput']>;
  BankTransferTerms?: InputMaybe<Scalars['StringInput']>;
  CreditCardTerms?: InputMaybe<Scalars['StringInput']>;
  Description?: InputMaybe<Scalars['StringInput']>;
  ExpiryDate?: InputMaybe<Scalars['StringInput']>;
  IsTemplate: Scalars['Boolean'];
  Notes?: InputMaybe<Scalars['StringInput']>;
  PaymentTerms?: InputMaybe<Scalars['StringInput']>;
  ProfessionalID: Scalars['ID'];
  QuoteID: Scalars['ID'];
  References?: InputMaybe<Scalars['StringInput']>;
  Scope?: InputMaybe<Scalars['StringInput']>;
  SelectedBusinessTermsCategoryIDs?: InputMaybe<Array<Scalars['ID']>>;
  Title?: InputMaybe<Scalars['StringInput']>;
};


export type MutationUpdateReviewActionArgs = {
  IsDone?: InputMaybe<Scalars['Boolean']>;
  ReviewActionID: Scalars['Int'];
  Task?: InputMaybe<Scalars['StringInput']>;
};


export type MutationUpdateSavedModuleArgs = {
  ID: Scalars['Int'];
  ModuleID: Scalars['Int'];
  Name?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateSearchTagsArgs = {
  LibraryItemID: Scalars['Int'];
  SearchTags: Array<Scalars['StringInput']>;
};


export type MutationUpdateServiceOfferingArgs = {
  Description?: InputMaybe<Scalars['StringInput']>;
  Photo?: InputMaybe<Scalars['Upload']>;
  ProfessionalID: Scalars['ID'];
  Quantity?: InputMaybe<Scalars['Int']>;
  SKU: Scalars['StringInput'];
  Title: Scalars['StringInput'];
  Unit?: InputMaybe<Scalars['StringInput']>;
  UnitPriceAmount?: InputMaybe<Scalars['Float']>;
};


export type MutationUpdateShippingMethodArgs = {
  DeliveryEstimate?: InputMaybe<MinMaxInput>;
  ID: Scalars['Int'];
  Title: Scalars['StringInput'];
};


export type MutationUpdateShippingProfileArgs = {
  ApplyRatePerItem?: InputMaybe<Scalars['Boolean']>;
  Default?: InputMaybe<Scalars['Boolean']>;
  ExcludePromotions?: InputMaybe<Scalars['Boolean']>;
  ID: Scalars['Int'];
  ShippingMethods?: InputMaybe<Array<ShippingMethodInput>>;
  Title?: InputMaybe<Scalars['StringInput']>;
};


export type MutationUpdateShoppingCartArgs = {
  Email?: InputMaybe<Scalars['Email']>;
  Locality?: InputMaybe<Scalars['Int']>;
  Region?: InputMaybe<Scalars['Int']>;
  ResetModified?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUpdateShoppingCartAddressArgs = {
  Address: AddressInput;
  AddressType: AddressTypeEnum;
};


export type MutationUpdateShoppingCartItemArgs = {
  CartItemID: Scalars['Int'];
  ClickAndCollect?: InputMaybe<Scalars['Boolean']>;
  PickupLocation?: InputMaybe<Scalars['Int']>;
  Quantity?: InputMaybe<Scalars['Int']>;
  Region?: InputMaybe<Scalars['Int']>;
  Selected?: InputMaybe<Scalars['Boolean']>;
  ShippingMethod?: InputMaybe<Scalars['Int']>;
  ShippingProvider?: InputMaybe<ShippingProviderEnum>;
};


export type MutationUpdateShoppingCartSupplierArgs = {
  Comment?: InputMaybe<Scalars['StringInput']>;
  PickupLocation?: InputMaybe<Scalars['Int']>;
  Selected?: InputMaybe<Scalars['Boolean']>;
  SupplierID: Scalars['Int'];
};


export type MutationUpdateSortOrdersArgs = {
  ItemType: SortableItemEnum;
  SortOrders?: InputMaybe<Array<ItemSortOrders>>;
};


export type MutationUpdateSupplierOrderNoteArgs = {
  Note: Scalars['StringInput'];
  OrderEventID: Scalars['Int'];
};


export type MutationUpdateSupplierOrderShippingArgs = {
  DeliveryAddressID?: InputMaybe<Scalars['Int']>;
  ID: Scalars['Int'];
  PickupLocationID?: InputMaybe<Scalars['Int']>;
  ShippingMethodID?: InputMaybe<Scalars['Int']>;
};


export type MutationUpdateTeamMemberArgs = {
  Approved?: InputMaybe<Scalars['Int']>;
  Email?: InputMaybe<Scalars['Email']>;
  HasInboxAccess?: InputMaybe<Scalars['Boolean']>;
  HideEmail?: InputMaybe<Scalars['Boolean']>;
  HideJobTitle?: InputMaybe<Scalars['Boolean']>;
  HideLinkedInLink?: InputMaybe<Scalars['Boolean']>;
  HidePhone?: InputMaybe<Scalars['Boolean']>;
  ID: Scalars['Int'];
  Image?: InputMaybe<Scalars['Upload']>;
  IsOwner?: InputMaybe<Scalars['Int']>;
  IsPublic?: InputMaybe<Scalars['Int']>;
  JobTitle?: InputMaybe<Scalars['StringInput']>;
  LicenseNumber?: InputMaybe<Scalars['StringInput']>;
  LinkedInLink?: InputMaybe<Scalars['StringInput']>;
  MemberImage?: InputMaybe<Scalars['Upload']>;
  Message?: InputMaybe<Scalars['StringInput']>;
  Name?: InputMaybe<Scalars['StringInput']>;
  Phone?: InputMaybe<Scalars['StringInput']>;
  SortOrder?: InputMaybe<Scalars['Int']>;
  Summary?: InputMaybe<Scalars['StringInput']>;
};


export type MutationUpdateTestimonialsArgs = {
  ID?: InputMaybe<Scalars['Int']>;
  Testimonials: Array<InputMaybe<TestimonialsList>>;
  URLSegment?: InputMaybe<Scalars['StringInput']>;
};


export type MutationUpdateVariantArgs = {
  Input: VariantInput;
};


export type MutationUpdateVariantOptionArgs = {
  OptionID: Scalars['Int'];
  SwatchID?: InputMaybe<Scalars['Int']>;
  VariantID: Scalars['Int'];
};


export type MutationUpdateVariantSizeArgs = {
  ProductSizeID: Scalars['Int'];
  VariantID: Scalars['Int'];
};


export type MutationUpdateVariantsArgs = {
  Input: Array<VariantInput>;
};


export type MutationUploadDesignBoardPinArgs = {
  DesignBoardID: Scalars['Int'];
  File?: InputMaybe<Scalars['Upload']>;
};


export type MutationUploadLogoImageArgs = {
  File?: InputMaybe<Scalars['Upload']>;
  LibraryItemID: Scalars['Int'];
};


export type MutationUpsertBusinessTermsArgs = {
  CategoryID?: InputMaybe<Scalars['Int']>;
  CountryIDs?: InputMaybe<Array<Scalars['Int']>>;
  ID?: InputMaybe<Scalars['Int']>;
  ProfessionalID: Scalars['Int'];
  Terms?: InputMaybe<Scalars['String']>;
  Title: Scalars['String'];
};


export type MutationUpsertEmailTemplateArgs = {
  BackgroundColor?: InputMaybe<Scalars['String']>;
  BorderRadius?: InputMaybe<Scalars['Int']>;
  ContainerPadding?: InputMaybe<Scalars['Int']>;
  ContainerWidth?: InputMaybe<Scalars['String']>;
  ContainerWidthValue?: InputMaybe<Scalars['Int']>;
  CustomFontFamily?: InputMaybe<Scalars['String']>;
  FontFamily?: InputMaybe<Scalars['String']>;
  FontSize?: InputMaybe<Scalars['Int']>;
  ID?: InputMaybe<Scalars['Int']>;
  InnerBackgroundColor?: InputMaybe<Scalars['String']>;
  ProfessionalID: Scalars['Int'];
  Subject: Scalars['StringInput'];
  TextColor?: InputMaybe<Scalars['String']>;
};


export type MutationUpsertEmailTemplateInputConfigArgs = {
  Alias: Scalars['StringInput'];
  EmailTemplateID: Scalars['ID'];
  ID?: InputMaybe<Scalars['ID']>;
  InputTypeKey: Scalars['String'];
};


export type MutationUpsertProfessionalCompanyFieldArgs = {
  FieldID?: InputMaybe<Scalars['ID']>;
  Label: Scalars['StringInput'];
  ProfessionalID: Scalars['ID'];
  SortOrder?: InputMaybe<Scalars['Int']>;
  Type?: InputMaybe<Scalars['StringInput']>;
  Visible?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUpsertProfessionalContactFieldArgs = {
  FieldID?: InputMaybe<Scalars['ID']>;
  Label: Scalars['StringInput'];
  ProfessionalID: Scalars['ID'];
  SortOrder?: InputMaybe<Scalars['Int']>;
  Type?: InputMaybe<Scalars['StringInput']>;
  Visible?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUpsertQuoteContactArgs = {
  Address?: InputMaybe<Scalars['StringInput']>;
  City?: InputMaybe<Scalars['StringInput']>;
  Email: Scalars['Email'];
  FirstName: Scalars['StringInput'];
  IsTemplate: Scalars['Boolean'];
  JobTitle?: InputMaybe<Scalars['StringInput']>;
  Phone?: InputMaybe<Scalars['StringInput']>;
  Photo?: InputMaybe<Scalars['Upload']>;
  PostCode?: InputMaybe<Scalars['StringInput']>;
  ProfessionalID: Scalars['ID'];
  QuoteID: Scalars['ID'];
  Surname: Scalars['StringInput'];
};


export type MutationUpsertQuoteContentArgs = {
  CreateInvoice?: InputMaybe<Scalars['Boolean']>;
  ID?: InputMaybe<Scalars['Int']>;
  IsTemplate?: InputMaybe<Scalars['Boolean']>;
  ProfessionalID: Scalars['Int'];
  Title: Scalars['StringInput'];
};


export type MutationUpsertQuotePaymentArgs = {
  Amount?: InputMaybe<Scalars['Float']>;
  AmountOption: InvoicePaymentAmountOptionEnum;
  AmountPercentage?: InputMaybe<Scalars['Float']>;
  DueDate?: InputMaybe<Scalars['StringInput']>;
  DueDaysAfterInvoiceSent?: InputMaybe<Scalars['Int']>;
  DueFixedDayOfMonth?: InputMaybe<Scalars['Int']>;
  DueOption: InvoicePaymentDueOptionEnum;
  IsTemplate: Scalars['Boolean'];
  PaymentID?: InputMaybe<Scalars['ID']>;
  ProfessionalID: Scalars['ID'];
  QuoteID: Scalars['ID'];
};


export type MutationUpsertQuoteServiceItemArgs = {
  Description?: InputMaybe<Scalars['StringInput']>;
  DiscountApplied?: InputMaybe<Scalars['Boolean']>;
  DiscountedUnitPriceAmount?: InputMaybe<Scalars['Float']>;
  IsTemplate: Scalars['Boolean'];
  Photo?: InputMaybe<Scalars['Upload']>;
  ProfessionalID: Scalars['ID'];
  Quantity?: InputMaybe<Scalars['Int']>;
  QuoteID: Scalars['ID'];
  ServiceID?: InputMaybe<Scalars['ID']>;
  Title: Scalars['StringInput'];
  UnitPriceAmount: Scalars['Float'];
};


export type MutationUseQuoteTemplateArgs = {
  ProfessionalID: Scalars['ID'];
  QuoteContentID: Scalars['ID'];
};

/** list of all registered devices on the current user. */
export type MyPushDevices = {
  __typename?: 'MyPushDevices';
  RegisteredDevices: Array<UserPushDevice>;
};

export type NativeDriverAdPerformanceFilters = {
  START_DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type NativeDriverDeviceFilters = {
  START_DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type NativeDriverRegionFilters = {
  START_DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

/** A network */
export type Network = {
  id: Scalars['ID'];
};

export enum NetworkEnum {
  OrganizationNetwork = 'OrganizationNetwork'
}

/** A participant of a network */
export type NetworkParticipant = {
  id: Scalars['ID'];
  identity: Node;
  network: Network;
};

export enum NetworkParticipantEnum {
  Franchise = 'franchise'
}

export type NetworkParticipantMetaData = {
  /** ID of the libraryitem that the participant is being created against */
  identity: Scalars['Int'];
  type: NetworkParticipantEnum;
};

export type Newsletter = {
  __typename?: 'Newsletter';
  BannerPhoto: Scalars['String'];
  BannerPhotoLarge: Scalars['String'];
  Created: Scalars['String'];
  FormattedDate: Scalars['String'];
  FrameStyle: NewsletterTileFrameEnum;
  ID: Scalars['Int'];
  Link: Scalars['String'];
  Month: Scalars['Int'];
  Subtitle?: Maybe<Scalars['String']>;
  Title: Scalars['String'];
  Type: Scalars['String'];
  URL: Scalars['String'];
  URLSegment: Scalars['String'];
  Year: Scalars['Int'];
};

export enum NewsletterTileFrameEnum {
  Framed = 'Framed',
  Frameless = 'Frameless'
}

export enum NewsletterTypeEnum {
  ArchiPros = 'ArchiPros',
  Build = 'Build',
  CommercialEdit = 'CommercialEdit',
  CuratedCollection = 'CuratedCollection',
  DedicatedEdm = 'DedicatedEDM',
  Misc = 'Misc',
  ProjectFeature = 'ProjectFeature',
  ProjectPortfolio = 'ProjectPortfolio'
}

/** A node can be anything with an ID */
export type Node = {
  id: Scalars['ID'];
};

export type NotAuthenticatedError = ErrorInterface & {
  __typename?: 'NotAuthenticatedError';
  Message: Scalars['String'];
};

export type NotAuthorizedError = ErrorInterface & {
  __typename?: 'NotAuthorizedError';
  Message: Scalars['String'];
};

export type NotFoundError = ErrorInterface & {
  __typename?: 'NotFoundError';
  Message: Scalars['String'];
};

export type OctaImageModule = FlexibleModule & {
  __typename?: 'OctaImageModule';
  Columns: ColumnsConnection;
  ContentAreaID: Scalars['Int'];
  CreatedFromID?: Maybe<Scalars['Int']>;
  CreatedFromVersion?: Maybe<Scalars['Int']>;
  DetachedFromSavedModule?: Maybe<Scalars['Boolean']>;
  EcommerceEnabled: Scalars['Boolean'];
  ID: Scalars['Int'];
  LibraryItemID: Scalars['Int'];
  MemberSortOrder: Scalars['Int'];
  ModuleGroup?: Maybe<ModuleGroupEnum>;
  PossibleColumnDimensions: Array<ColumnDimension>;
  PresetName: Scalars['String'];
  PresetType: FlexibleModuleEnum;
  SortableColumns: Scalars['Boolean'];
  Swappable: Scalars['Boolean'];
};


export type OctaImageModuleColumnsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<ColumnsSortFields>;
};

export type OldConversionTableDataFilters = {
  CONTENT_TYPE__IN?: InputMaybe<Array<Scalars['String']>>;
  CONVERSION__IN?: InputMaybe<Array<Scalars['String']>>;
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
  EVENT_LOCATION_DATA__IN?: InputMaybe<Array<Scalars['String']>>;
  TITLE__IN?: InputMaybe<Array<Scalars['String']>>;
  USER_CLASS_TYPE__IN?: InputMaybe<Array<Scalars['String']>>;
};

export type OldConversionTableDataSort = {
  CONTENT?: InputMaybe<PrioritySort>;
  CONVERSION?: InputMaybe<PrioritySort>;
  DESCRIPTION?: InputMaybe<PrioritySort>;
  INDUSTRY?: InputMaybe<PrioritySort>;
  LOCATION?: InputMaybe<PrioritySort>;
  PAGE?: InputMaybe<PrioritySort>;
  TIME?: InputMaybe<PrioritySort>;
  USER?: InputMaybe<PrioritySort>;
};

export type OldProfileTopPagesFilters = {
  CONVERSION_TYPE__IN?: InputMaybe<Array<Scalars['String']>>;
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
  INDUSTRY_CATEGORY__IN?: InputMaybe<Array<Scalars['String']>>;
  LIBRARY_ITEM_TYPE__IN?: InputMaybe<Array<Scalars['String']>>;
  TITLE__IN?: InputMaybe<Array<Scalars['String']>>;
};

export type OldProfileTopPagesSort = {
  AVG_TIME_ON_PAGE?: InputMaybe<PrioritySort>;
  CONVERSIONS?: InputMaybe<PrioritySort>;
  CONVERSION_RATE?: InputMaybe<PrioritySort>;
  IMPRESSIONS?: InputMaybe<PrioritySort>;
  PAGE?: InputMaybe<PrioritySort>;
  PAGE_VIEWS?: InputMaybe<PrioritySort>;
  TYPE?: InputMaybe<PrioritySort>;
};

export type OnboardingProfessionalCategory = {
  __typename?: 'OnboardingProfessionalCategory';
  ID: Scalars['Int'];
  Title: Scalars['String'];
};

export type OnboardingProfessionalCategoryConnection = {
  __typename?: 'OnboardingProfessionalCategoryConnection';
  edges: Array<OnboardingProfessionalCategoryConnectionEdge>;
  nodes: Array<OnboardingProfessionalCategory>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type OnboardingProfessionalCategoryConnectionEdge = {
  __typename?: 'OnboardingProfessionalCategoryConnectionEdge';
  /** The node at the end of the collections edge */
  node: OnboardingProfessionalCategory;
};

export type OnsitePlacementBreakdownFilters = {
  DATE_CREATED__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type OnsitePlacementLocationTypeFilters = {
  DATE_CREATED__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type OnsitePlacementOverviewFilters = {
  DATE_CREATED__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type OnsitePlacementTableFilters = {
  DATE_CREATED__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type OnsitePlacementUserDevicesFilters = {
  DATE_CREATED__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type OpenClickRates = {
  __typename?: 'OpenClickRates';
  Delivered: Scalars['Int'];
  ID: Scalars['String'];
  TotalAllClicks: Scalars['Int'];
  TotalClicks: Scalars['Int'];
  TotalOpens: Scalars['Int'];
  UniqueClicks: Scalars['Int'];
  UniqueOpens: Scalars['Int'];
};

export type Option = {
  __typename?: 'Option';
  ID: Scalars['String'];
  Label: Scalars['String'];
  Name: Scalars['String'];
};

export type Order = {
  __typename?: 'Order';
  Company: Scalars['String'];
  Created: Scalars['String'];
  Email: Scalars['String'];
  FirstName: Scalars['String'];
  ID: Scalars['Int'];
  ItemTotal?: Maybe<CurrencyAmount>;
  Member: Member;
  OrderTotal?: Maybe<CurrencyAmount>;
  Phone: Scalars['String'];
  ShippingTotal?: Maybe<CurrencyAmount>;
  Status: Scalars['String'];
  SupplierOrders: Array<SupplierOrder>;
  Surname: Scalars['String'];
  TaxSystem: Scalars['String'];
  TaxTotal?: Maybe<CurrencyAmount>;
};


export type OrderSupplierOrdersArgs = {
  SupplierID?: InputMaybe<Scalars['Int']>;
};

export type OrderDeclineItemInput = {
  OrderReturnItem: Scalars['Int'];
  Quantity: Scalars['Int'];
};

export type OrderEvent = {
  __typename?: 'OrderEvent';
  ByMember?: Maybe<Member>;
  Created: Scalars['String'];
  Event?: Maybe<Scalars['String']>;
  EventSource: Scalars['String'];
  ID: Scalars['Int'];
  UpdateType?: Maybe<OrderEventUpdateTypeEnum>;
};

export enum OrderEventUpdateTypeEnum {
  Note = 'Note'
}

export type OrderItem = {
  __typename?: 'OrderItem';
  BusinessFullShippingMethodLabel: Scalars['String'];
  ClickAndCollect: Scalars['Boolean'];
  Consignment?: Maybe<Consignment>;
  DeliveryEstimate?: Maybe<Scalars['String']>;
  Dispatch?: Maybe<Dispatch>;
  ID: Scalars['Int'];
  Image?: Maybe<ResponsiveImage>;
  LastEdited: Scalars['String'];
  LeadTime: Scalars['Int'];
  LeadTimeUnit?: Maybe<LeadTimeUnitEnum>;
  Price: CurrencyAmount;
  Product: Scalars['String'];
  Quantity: Scalars['Int'];
  RetailPrice: CurrencyAmount;
  RetailSubTotal?: Maybe<CurrencyAmount>;
  ReturnReason?: Maybe<Scalars['String']>;
  Returns: Array<OrderReturnItem>;
  SKU: Scalars['String'];
  Sample: Scalars['Boolean'];
  ShippingCost: CurrencyAmount;
  ShippingMethod?: Maybe<ShippingMethod>;
  ShippingMethodLabel: Scalars['String'];
  Status: OrderStatusEnum;
  SubTotal: CurrencyAmount;
  SupplierSKU?: Maybe<Scalars['String']>;
  TaxPerItem: CurrencyAmount;
  TaxTotal: CurrencyAmount;
  Variant: Variant;
  VariantDescription: Scalars['String'];
};

export type OrderItemsConnection = {
  __typename?: 'OrderItemsConnection';
  edges: Array<OrderItemsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type OrderItemsConnectionEdge = {
  __typename?: 'OrderItemsConnectionEdge';
  /** The node at the end of the collections edge */
  node: OrderItem;
};

export type OrderReturnItem = {
  __typename?: 'OrderReturnItem';
  Archived: Scalars['Boolean'];
  Created: Scalars['String'];
  DeclineReason?: Maybe<Scalars['String']>;
  ID: Scalars['Int'];
  Photo?: Maybe<Scalars['String']>;
  Quantity: Scalars['Int'];
  Reason: Scalars['String'];
  ReasonGroup: Scalars['String'];
  Status: OrderReturnItemStatusEnum;
  SubTotal: CurrencyAmount;
};

export type OrderReturnItemInput = {
  OrderItem: Scalars['Int'];
  OrderReturnItemID?: InputMaybe<Scalars['Int']>;
  Photo?: InputMaybe<Scalars['Upload']>;
  Quantity: Scalars['Int'];
  Reason?: InputMaybe<Scalars['StringInput']>;
  ReasonGroup?: InputMaybe<Scalars['StringInput']>;
};

export enum OrderReturnItemStatusEnum {
  Approved = 'APPROVED',
  Declined = 'DECLINED',
  Pending = 'PENDING'
}

export enum OrderStatusEnum {
  Cancelled = 'CANCELLED',
  Confirmed = 'CONFIRMED',
  Dispatched = 'DISPATCHED',
  Fulfilled = 'FULFILLED',
  Pending = 'PENDING',
  Returned = 'RETURNED'
}

export type OrganizationCreateData = {
  /** URLSegment of the professional that is creating this network */
  owner: Scalars['String'];
};

export type OrganizationNetwork = CentralisedNetwork & Network & {
  __typename?: 'OrganizationNetwork';
  id: Scalars['ID'];
  owner: OrganizationNetworkParticipant;
  participants: OrganizationNetworkParticipantsConnection;
};


export type OrganizationNetworkParticipantsArgs = {
  filter?: InputMaybe<OrganizationNetworkParticipantsFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<OrganizationNetworkParticipantsSortFields>;
};

export type OrganizationNetworkOwner = {
  __typename?: 'OrganizationNetworkOwner';
  ID: Scalars['Int'];
  Title: Scalars['String'];
};

export type OrganizationNetworkParticipant = CentralisedNetworkParticipant & NetworkParticipant & {
  __typename?: 'OrganizationNetworkParticipant';
  directEnquiry: Scalars['Boolean'];
  id: Scalars['ID'];
  identity: Professional;
  network: OrganizationNetwork;
  productSharing: Scalars['Boolean'];
};

export type OrganizationNetworkParticipantUpdateData = {
  /** Enables direct enquiry for this participant */
  directEnquiry?: InputMaybe<Scalars['Boolean']>;
  /** Enables product sharing for this participant */
  productSharing?: InputMaybe<Scalars['Boolean']>;
};

export type OrganizationNetworkParticipantsConnection = {
  __typename?: 'OrganizationNetworkParticipantsConnection';
  edges: Array<OrganizationNetworkParticipantsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type OrganizationNetworkParticipantsConnectionEdge = {
  __typename?: 'OrganizationNetworkParticipantsConnectionEdge';
  /** The node at the end of the collections edge */
  node: NetworkParticipant;
};

export type OrganizationNetworkParticipantsFilters = {
  /** Filters this type when DirectEnquiry is eq the provided value */
  DirectEnquiry__eq?: InputMaybe<Scalars['Boolean']>;
  /** Filters this type when ProductSharing is eq the provided value */
  ProductSharing__eq?: InputMaybe<Scalars['Boolean']>;
};

export type OrganizationNetworkParticipantsSortFields = {
  ID?: InputMaybe<SortDirection>;
  Professional__Title?: InputMaybe<SortDirection>;
};

export type OtherRangeProductsConnection = {
  __typename?: 'OtherRangeProductsConnection';
  edges: Array<OtherRangeProductsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type OtherRangeProductsConnectionEdge = {
  __typename?: 'OtherRangeProductsConnectionEdge';
  /** The node at the end of the collections edge */
  node: Product;
};

export type OverviewAudience = {
  __typename?: 'OverviewAudience';
  AgeGroups: Array<GraphSegment>;
  DeviceBreakdown: Array<Maybe<DeviceData>>;
  ID: Scalars['String'];
  LocationBreakdown: Array<Maybe<LocationData>>;
};

export type OverviewImpressionFilters = {
  START_DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type OverviewInteractionsFilters = {
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type OverviewNewsletterStatsFilters = {
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type OverviewPackageCampaignsDetailsFilters = {
  START_DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type OverviewPackageCampaignsFilters = {
  START_DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type OverviewPackageFilters = {
  START_DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type OverviewPackageOtherCampaignsDetailsFilters = {
  START_DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type OverviewPackageOtherCampaignsFilters = {
  START_DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type OverviewPageViewFilters = {
  START_DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type OverviewProfilePageStatsFilters = {
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type OverviewSocialAdStatsFilters = {
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type OverviewStatsFilters = {
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type OverviewSummaryNumbers = {
  __typename?: 'OverviewSummaryNumbers';
  Clicks: Scalars['Int'];
  Conversions: Scalars['Int'];
  ID: Scalars['String'];
  Impressions: Scalars['Int'];
  NewsletterSummary: EngagementSummary;
  ProfileSummary: EngagementSummary;
  SocialSummary: EngagementSummary;
  TotalTimeSpent: Scalars['String'];
};

export type PotmData = {
  __typename?: 'POTMData';
  AutoPlay?: Maybe<Scalars['Boolean']>;
  DesktopCover?: Maybe<Scalars['String']>;
  DirectoryGridAutoPlay?: Maybe<Scalars['Boolean']>;
  DirectoryGridDesktopCover?: Maybe<Scalars['String']>;
  DirectoryGridMobileCover?: Maybe<Scalars['String']>;
  DirectoryGridVideoMp4Url?: Maybe<Scalars['String']>;
  DirectoryGridVideoWebMUrl?: Maybe<Scalars['String']>;
  DirectoryHeroAutoPlay?: Maybe<Scalars['Boolean']>;
  DirectoryHeroDesktopCover?: Maybe<Scalars['String']>;
  DirectoryHeroFullVideo?: Maybe<Scalars['String']>;
  DirectoryHeroMobileCover?: Maybe<Scalars['String']>;
  DirectoryHeroPrimaryCTAText: Scalars['String'];
  DirectoryHeroVideoID?: Maybe<Scalars['String']>;
  DirectoryHeroVideoMp4MobileUrl?: Maybe<Scalars['String']>;
  DirectoryHeroVideoMp4Url?: Maybe<Scalars['String']>;
  DirectoryHeroVideoPlatform?: Maybe<Scalars['String']>;
  DirectoryHeroVideoWebMMobileUrl?: Maybe<Scalars['String']>;
  DirectoryHeroVideoWebMUrl?: Maybe<Scalars['String']>;
  ID: Scalars['ID'];
  MobileCover?: Maybe<Scalars['String']>;
  OverrideURL?: Maybe<Scalars['String']>;
  PrimaryCTAText: Scalars['String'];
  Project?: Maybe<Project>;
  ProjectArticle?: Maybe<Article>;
  ShortDescription?: Maybe<Scalars['String']>;
  Subtitle?: Maybe<Scalars['String']>;
  Title?: Maybe<Scalars['String']>;
  VideoMp4Url?: Maybe<Scalars['String']>;
  VideoWebMUrl?: Maybe<Scalars['String']>;
};

export enum PotmPlacement {
  DirectoryGrid = 'DirectoryGrid',
  DirectoryHero = 'DirectoryHero',
  Homepage = 'Homepage'
}

export type PackagesConnection = {
  __typename?: 'PackagesConnection';
  edges: Array<PackagesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type PackagesConnectionEdge = {
  __typename?: 'PackagesConnectionEdge';
  /** The node at the end of the collections edge */
  node: ConsignmentPackage;
};

export type PageBuilderImagesConnection = {
  __typename?: 'PageBuilderImagesConnection';
  edges: Array<PageBuilderImagesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type PageBuilderImagesConnectionEdge = {
  __typename?: 'PageBuilderImagesConnectionEdge';
  /** The node at the end of the collections edge */
  node: LibraryImage;
};

export type PageBuilderModulesConnection = {
  __typename?: 'PageBuilderModulesConnection';
  edges: Array<PageBuilderModulesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type PageBuilderModulesConnectionEdge = {
  __typename?: 'PageBuilderModulesConnectionEdge';
  /** The node at the end of the collections edge */
  node: FlexibleModule;
};

export type PageBuilderModulesSortFields = {
  MemberSortOrder?: InputMaybe<SortDirection>;
};

export type PageBulkCloneJob = {
  __typename?: 'PageBulkCloneJob';
  ClonedCount: Scalars['Int'];
  CreatedAt: Scalars['Date'];
  /** The ID of the underlying TaskDetails object */
  ID: Scalars['Int'];
  /** The ID of the underlying PageBulkCloneJob object */
  JobID: Scalars['Int'];
  LastEditedAt: Scalars['Date'];
  Message?: Maybe<Scalars['String']>;
  SourceCount: Scalars['Int'];
  Status: AsyncTaskStatus;
};

export type PageContent = {
  __typename?: 'PageContent';
  Content: Scalars['String'];
  ID: Scalars['Int'];
};

export type PageEmbedding = {
  __typename?: 'PageEmbedding';
  EmbeddedData?: Maybe<Scalars['String']>;
  Embeddings?: Maybe<Scalars['String']>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  totalCount: Scalars['Int'];
};

export type PagePin = {
  __typename?: 'PagePin';
  ID: Scalars['Int'];
  PageType?: Maybe<Scalars['String']>;
  PageTypeID?: Maybe<Scalars['Int']>;
};

export type PageReview = {
  __typename?: 'PageReview';
  Approved: Scalars['Boolean'];
  ID: Scalars['Int'];
  ReviewDateTime: Scalars['String'];
  Reviewer: Member;
};

export type PageReviewType = NotAuthorizedError | NotFoundError | PageReview | UserError;

export type PageSeoSchema = {
  __typename?: 'PageSEOSchema';
  FAQSchemas?: Maybe<Array<Maybe<FaqSchema>>>;
  ID: Scalars['Int'];
};

export type PaginatedProductSwatches_Connection = {
  __typename?: 'PaginatedProductSwatches_Connection';
  ID: Scalars['String'];
  edges: Array<PaginatedProductSwatches_ConnectionEdge>;
  nodes: Array<ProductSwatch>;
  pageInfo: ApPageInfo;
};

/** The collections edge */
export type PaginatedProductSwatches_ConnectionEdge = {
  __typename?: 'PaginatedProductSwatches_ConnectionEdge';
  /** The node at the end of the collections edge */
  node: ProductSwatch;
};

export type PaintColour = {
  __typename?: 'PaintColour';
  B: Scalars['Int'];
  Code: Scalars['String'];
  G: Scalars['Int'];
  Hex: Scalars['String'];
  ID: Scalars['Int'];
  Product?: Maybe<Product>;
  ProductID: Scalars['Int'];
  Professional?: Maybe<Professional>;
  R: Scalars['Int'];
  Title: Scalars['String'];
};

export type PaintColoursConnection = {
  __typename?: 'PaintColoursConnection';
  edges: Array<PaintColoursConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type PaintColoursConnectionEdge = {
  __typename?: 'PaintColoursConnectionEdge';
  /** The node at the end of the collections edge */
  node: PaintColour;
};

export type PaintPartner = {
  __typename?: 'PaintPartner';
  PaintColours: PaintColoursConnection;
};


export type PaintPartnerPaintColoursArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type Participant = {
  ID: Scalars['ID'];
  Identity: ParticipantIdentity;
};

export type ParticipantIdentity = {
  ID: Scalars['Int'];
};

export type PaymentIntent = {
  __typename?: 'PaymentIntent';
  Amount?: Maybe<Scalars['Int']>;
  ClientSecret: Scalars['String'];
  Currency?: Maybe<Scalars['String']>;
  Customer?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
};

export type PaymentIntentResponse = NotAuthenticatedError | NotAuthorizedError | NotFoundError | PaymentIntent | ServerError | UserError;

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  ID: Scalars['String'];
  Title: Scalars['String'];
};

export type PaymentOptions = {
  __typename?: 'PaymentOptions';
  Intent: Scalars['String'];
  Methods: Array<PaymentMethod>;
};

export enum PaymentProviderEnum {
  Stripe = 'STRIPE'
}

export type PeopleContact = {
  __typename?: 'PeopleContact';
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
};

export type PeopleContactList = {
  __typename?: 'PeopleContactList';
  contacts: Array<PeopleContact>;
  provider: PeopleContactProviderEnum;
  success?: Maybe<Scalars['Boolean']>;
};

export enum PeopleContactProviderEnum {
  Google = 'google',
  Outlook = 'outlook'
}

export enum PermissionEnum {
  ApBmAccess = 'AP_BM_ACCESS',
  ApMarketplaceSettingsAccess = 'AP_MARKETPLACE_SETTINGS_ACCESS',
  ApProductEdit = 'AP_PRODUCT_EDIT',
  ApProductView = 'AP_PRODUCT_VIEW',
  ApProfessionalAdmin = 'AP_PROFESSIONAL_ADMIN',
  BmAdvertAdminEdit = 'BM_ADVERT_ADMIN_EDIT',
  BmAnalyticsTrackingLinkShare = 'BM_ANALYTICS_TRACKING_LINK_SHARE',
  BmAnalyticsUpdateSetting = 'BM_ANALYTICS_UPDATE_SETTING',
  BmAnalyticsView = 'BM_ANALYTICS_VIEW',
  BmArticleEdit = 'BM_ARTICLE_EDIT',
  BmCategoryPlacementView = 'BM_CATEGORY_PLACEMENT_VIEW',
  BmContentApprove = 'BM_CONTENT_APPROVE',
  BmContentView = 'BM_CONTENT_VIEW',
  BmDirectEnquiryView = 'BM_DIRECT_ENQUIRY_VIEW',
  BmEnhancedConversionsView = 'BM_ENHANCED_CONVERSIONS_VIEW',
  BmImageExport = 'BM_IMAGE_EXPORT',
  BmImageImport = 'BM_IMAGE_IMPORT',
  BmInboxReply = 'BM_INBOX_REPLY',
  BmInboxRevealContact = 'BM_INBOX_REVEAL_CONTACT',
  BmInboxShare = 'BM_INBOX_SHARE',
  BmInboxUpdateStatus = 'BM_INBOX_UPDATE_STATUS',
  BmInboxView = 'BM_INBOX_VIEW',
  BmIntegrationsSettings = 'BM_INTEGRATIONS_SETTINGS',
  BmMarketingView = 'BM_MARKETING_VIEW',
  BmOrdersView = 'BM_ORDERS_VIEW',
  BmPageTemplateApply = 'BM_PAGE_TEMPLATE_APPLY',
  BmPageTemplateCreate = 'BM_PAGE_TEMPLATE_CREATE',
  BmPlatformSync = 'BM_PLATFORM_SYNC',
  BmProductsEdit = 'BM_PRODUCTS_EDIT',
  BmProductTaggingApprove = 'BM_PRODUCT_TAGGING_APPROVE',
  BmProductTaggingCreate = 'BM_PRODUCT_TAGGING_CREATE',
  BmProductTaggingDelete = 'BM_PRODUCT_TAGGING_DELETE',
  BmProfessionalCreate = 'BM_PROFESSIONAL_CREATE',
  BmProfileEdit = 'BM_PROFILE_EDIT',
  BmProfileView = 'BM_PROFILE_VIEW',
  BmProjectEdit = 'BM_PROJECT_EDIT',
  BmSettingUpdate = 'BM_SETTING_UPDATE',
  BmStaffView = 'BM_STAFF_VIEW',
  BmSupportView = 'BM_SUPPORT_VIEW',
  DevCommand = 'DEV_COMMAND',
  DevUnattended = 'DEV_UNATTENDED',
  FcPinEdit = 'FC_PIN_EDIT'
}

export enum PermissionGroupEnum {
  BusinessManagerAccess = 'BusinessManagerAccess',
  MarketplaceSettingsAccess = 'MarketplaceSettingsAccess',
  ProductManagement = 'ProductManagement',
  ProfessionalAdmin = 'ProfessionalAdmin'
}

export type PermissionInterface = {
  ID: Scalars['Int'];
  Permissions: Array<PermissionEnum>;
};

export type PermissionResource = {
  /** ID of the Resource */
  ID: Scalars['Int'];
  /** Type of the Resource */
  Type: ResourceType;
};

export type PhotoCollageModule = ModuleType & {
  __typename?: 'PhotoCollageModule';
  AnchorTag?: Maybe<Scalars['String']>;
  CTA?: Maybe<SiteTreeLink>;
  ExtraClass?: Maybe<Scalars['String']>;
  ID: Scalars['ID'];
  /** Images */
  Images: Images_Connection;
  NavigationLabel?: Maybe<Scalars['String']>;
  SpacingBelow?: Maybe<Scalars['String']>;
  SpacingBelowMobile?: Maybe<Scalars['String']>;
  ThemeColour: ThemedElementColourType;
  Title?: Maybe<Scalars['String']>;
};


export type PhotoCollageModuleImagesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Images_SortFields>;
};

export type PhotoPin = {
  __typename?: 'PhotoPin';
  BoardID: Scalars['Int'];
  BoardURLSegment: Scalars['String'];
  CanDelete: Scalars['Boolean'];
  Comments?: Maybe<Array<Maybe<Comment>>>;
  CommentsCount: Scalars['Int'];
  CreatedBy?: Maybe<Member>;
  HasUnreadComments: Scalars['Boolean'];
  ID: Scalars['Int'];
  LibraryImageID?: Maybe<Scalars['Int']>;
  LibraryThumb?: Maybe<LibraryThumb>;
  Link?: Maybe<Scalars['String']>;
  PageType?: Maybe<Scalars['String']>;
  PageTypeID?: Maybe<Scalars['Int']>;
  Permission: PinPermission;
  PhotoModal?: Maybe<Scalars['String']>;
  PhotoTile?: Maybe<Scalars['String']>;
  ProfessionalID?: Maybe<Scalars['Int']>;
  ProfessionalLink?: Maybe<Scalars['String']>;
  ProfessionalTitle?: Maybe<Scalars['String']>;
  ProfessionalWebsite?: Maybe<Scalars['String']>;
  SubTitle: Scalars['String'];
  Title?: Maybe<Scalars['String']>;
  Type?: Maybe<Scalars['String']>;
};

/** Deprecated. Use DesignBoardPin type instead. */
export type Pin = ArticlePin | MemberUploadPin | PhotoPin | ProductPin | ProfessionalPin | ProjectPin;

export type PinInput = {
  DesignBoardID?: InputMaybe<Scalars['Int']>;
  Type: Scalars['String'];
  TypeID: Scalars['Int'];
  URLSearchParams?: InputMaybe<Scalars['String']>;
};

export type PinPermission = {
  __typename?: 'PinPermission';
  CanAddComments: Scalars['Boolean'];
  CanDelete: Scalars['Boolean'];
  CanViewComments: Scalars['Boolean'];
  ID: Scalars['Int'];
};

export type Pin_CommentsConnection = {
  __typename?: 'Pin_CommentsConnection';
  edges: Array<Pin_CommentsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type Pin_CommentsConnectionEdge = {
  __typename?: 'Pin_CommentsConnectionEdge';
  /** The node at the end of the collections edge */
  node: Comment;
};

export type PinterestBreakdownFilters = {
  CAMPAIGN_ID__EQUAL?: InputMaybe<Scalars['String']>;
};

export type PinterestCampaignsFilters = {
  CAMPAIGN_START_TIME__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type PinterestSummaryFilters = {
  CAMPAIGN_ID__EQUAL?: InputMaybe<Scalars['String']>;
  CAMPAIGN_START_TIME__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type PixelActivityByOrderFilters = {
  EVENT_DATE_HOST__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
  USER_NAME__EQUAL?: InputMaybe<Scalars['String']>;
};

export type PixelActivityBySessionFilters = {
  EVENT_DATE_HOST__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
  SESSION_ORDER__EQUAL?: InputMaybe<Scalars['Int']>;
  USER_NAME__EQUAL?: InputMaybe<Scalars['String']>;
};

export type PixelActivityByUserFilters = {
  EVENT_DATE_HOST__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

/** Pixel Conversion Setting collection. */
export type PixelConversionSettings = {
  __typename?: 'PixelConversionSettings';
  categories: Array<ConversionCategory>;
  conversionTypes: Array<ConversionType>;
  funnels: Array<FunnelStage>;
};


/** Pixel Conversion Setting collection. */
export type PixelConversionSettingsConversionTypesArgs = {
  professionalID: Scalars['Int'];
  searchText?: InputMaybe<Scalars['String']>;
};

export type PixelConversionsFilters = {
  EVENT_DATE_HOST__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type PixelConversionsNonDistinctFilters = {
  EVENT_DATE_HOST__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type PixelIndustryBreakdownFilters = {
  EVENT_DATE_HOST__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type PixelRegionBreakdownFilters = {
  EVENT_DATE_HOST__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type PixelReturningUserBreakdownFilters = {
  EVENT_DATE_HOST__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type PixelRuleConversionsFilters = {
  CONVERSION__EQUAL?: InputMaybe<Scalars['String']>;
  EVENT_DATE_HOST__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
  PIXEL_CONVERSION_RULE__EQUAL?: InputMaybe<Scalars['String']>;
  TRIGGER_TYPE__EQUAL?: InputMaybe<Scalars['String']>;
};

export type PixelSmokeTestFilters = {
  EVENT_DATE_HOST__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type PixelStatsFilters = {
  EVENT_DATE_HOST__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type PixelTopLandingPagesFilters = {
  EVENT_DATE_HOST__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type PixelTopReferralsFilters = {
  EVENT_DATE_HOST__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type PixelTracker = {
  __typename?: 'PixelTracker';
  BucketID: Scalars['String'];
  ConversionList: Array<PixelTrackerConversion>;
  CreatedAt: Scalars['Int'];
  CustomConversionList: Array<PixelTrackerConversionConfig>;
  EventTrackingStatus?: Maybe<PixelTrackerSnowflakeData>;
  HomeownerBreakdown: PixelTrackerHomeownerBreakdown;
  ID: Scalars['ID'];
  MetaData?: Maybe<PixelTrackerMetaData>;
  MetricItemList: Array<PixelTrackerMetricItem>;
  ProfessionalBreakdown: PixelTrackerProfessionalBreakdown;
  ProfessionalID: Scalars['Int'];
  RealtimeSessionList?: Maybe<PixelTrackerRealtimeSessions_Connection>;
  RealtimeUserList?: Maybe<PixelTrackerRealtimeUsers_Connection>;
  Status?: Maybe<Scalars['String']>;
  TopEventList?: Maybe<PixelTrackerTopEventList_Connection>;
  TopPageList: Array<PixelTrackerTopPage>;
  TotalUV: Scalars['Int'];
  UpdatedAt?: Maybe<Scalars['Float']>;
  conversionConfigList?: Maybe<ProfessionalPixelTrackerConversionStatus_Connection>;
};


export type PixelTrackerCustomConversionListArgs = {
  EventType?: InputMaybe<PixelTrackerConversionConfigEventType>;
};


export type PixelTrackerRealtimeSessionListArgs = {
  PID: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type PixelTrackerRealtimeUserListArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type PixelTrackerTopEventListArgs = {
  EventType: PixelTrackerTopEventEnum;
  SearchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type PixelTrackerConversionConfigListArgs = {
  conversionTypes?: InputMaybe<Array<Scalars['String']>>;
  eventCountSortDirection?: InputMaybe<SortDirectionEnum>;
  groupBy?: InputMaybe<ConversionGroupByEnum>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};

/** Conversion aggregated data by Athena. */
export type PixelTrackerConversion = {
  __typename?: 'PixelTrackerConversion';
  BucketID: Scalars['String'];
  EventType: Scalars['String'];
  ExtraInfo: Scalars['String'];
  ID: Scalars['ID'];
  IsArchipro: Scalars['Boolean'];
  IsPending: Scalars['Boolean'];
  ProfessionalID: Scalars['Int'];
  Title: Scalars['String'];
  URL?: Maybe<Scalars['String']>;
  Value: Scalars['Int'];
};

/** Professional customized conversions stored in mysql */
export type PixelTrackerConversionConfig = {
  __typename?: 'PixelTrackerConversionConfig';
  AppearURL?: Maybe<Scalars['String']>;
  Archived: Scalars['Boolean'];
  ConversionCategory?: Maybe<ConversionCategory>;
  ConversionType?: Maybe<ConversionType>;
  Created: Scalars['String'];
  CreatedBy?: Maybe<Member>;
  CreatedByName?: Maybe<Scalars['String']>;
  EventType: PixelTrackerConversionConfigEventType;
  ExtraInfo: Scalars['String'];
  FunnelStage?: Maybe<FunnelStage>;
  ID: Scalars['ID'];
  Professional?: Maybe<Professional>;
  ProfessionalID: Scalars['Int'];
  ProfessionalURLSegment: Scalars['String'];
  Title: Scalars['String'];
};

/** Conversion config eventType enum */
export enum PixelTrackerConversionConfigEventType {
  Custom = 'CUSTOM',
  Formsubmit = 'FORMSUBMIT',
  Pageview = 'PAGEVIEW'
}

export type PixelTrackerHomeownerBreakdown = {
  __typename?: 'PixelTrackerHomeownerBreakdown';
  ID: Scalars['ID'];
  Regions: Array<PixelTrackerPieChart>;
  Users: Array<PixelTrackerPieChart>;
};

export enum PixelTrackerIsTrackingEnumType {
  NotTracking = 'NotTracking',
  Tracking = 'Tracking',
  TrackingError = 'TrackingError',
  Description = 'description'
}

/** ArchiPro Pixel, meta data of each professional. */
export type PixelTrackerMetaData = {
  __typename?: 'PixelTrackerMetaData';
  Aggregation?: Maybe<PixelTrackerMetaDataAggregation>;
  BucketID: Scalars['String'];
  HasRealtimeData: Scalars['Boolean'];
  ID: Scalars['String'];
  IsTracking: PixelTrackerIsTrackingEnumType;
  LastPixelTrackerEventTimestamp?: Maybe<Scalars['Float']>;
  LastPixelTrackerPingEventTimestamp?: Maybe<Scalars['Float']>;
  LastPixelTrackerRealEventTimestamp?: Maybe<Scalars['Float']>;
  ProfessionalID: Scalars['String'];
  QualifiedTimestamp?: Maybe<Scalars['Float']>;
};

/** The aggregation sub-field of ArchiPro Pixel metadata for each professional. */
export type PixelTrackerMetaDataAggregation = {
  __typename?: 'PixelTrackerMetaDataAggregation';
  CreatedAt?: Maybe<Scalars['Float']>;
  ID: Scalars['ID'];
  Status?: Maybe<Scalars['String']>;
  UpdatedAt?: Maybe<Scalars['Float']>;
};

/** overview statistic data of ArchiPro Pixel, contains events like \"total time spent\", \"page views\", \"website referrals\", etc. */
export type PixelTrackerMetricItem = {
  __typename?: 'PixelTrackerMetricItem';
  BucketID: Scalars['String'];
  Description: Scalars['String'];
  ID: Scalars['ID'];
  IsArchipro: Scalars['Boolean'];
  ProfessionalID: Scalars['Int'];
  Title: Scalars['String'];
  Type: Scalars['String'];
  Value: Scalars['Int'];
};

export type PixelTrackerPieChart = {
  __typename?: 'PixelTrackerPieChart';
  Data: Scalars['Int'];
  ID: Scalars['ID'];
  Range: Scalars['String'];
};

export type PixelTrackerProfessionalBreakdown = {
  __typename?: 'PixelTrackerProfessionalBreakdown';
  Categories: Array<PixelTrackerPieChart>;
  ID: Scalars['ID'];
  Regions: Array<PixelTrackerPieChart>;
  Users: Array<PixelTrackerPieChart>;
};

export type PixelTrackerRealTimeEvent = {
  __typename?: 'PixelTrackerRealTimeEvent';
  Event: Scalars['String'];
  EventConversion?: Maybe<Scalars['String']>;
  EventData: Scalars['String'];
  EventDescription: Scalars['String'];
  EventIsArchipro: Scalars['Boolean'];
  EventSource: Scalars['String'];
  EventTimeSpent?: Maybe<Scalars['Float']>;
  ID: Scalars['ID'];
  RawURL: Scalars['String'];
  RecordID: Scalars['String'];
  TargetTitle: Scalars['String'];
  Timestamp: Scalars['Float'];
  WebsiteEventFromOtherPage?: Maybe<Scalars['Boolean']>;
};

export type PixelTrackerRealTimeSession = {
  __typename?: 'PixelTrackerRealTimeSession';
  BucketID: Scalars['String'];
  Events: Array<PixelTrackerRealTimeEvent>;
  ID: Scalars['ID'];
  PrefixID: Scalars['String'];
  ProfessionalID: Scalars['String'];
  SessionEndTime: Scalars['Float'];
  SessionOrder: Scalars['Int'];
  SessionStartTime: Scalars['Float'];
  SessionTotalTimeSpent?: Maybe<Scalars['Float']>;
  Timestamp: Scalars['Float'];
  TotalEvents: Scalars['Int'];
};

export type PixelTrackerRealTimeUser = {
  __typename?: 'PixelTrackerRealTimeUser';
  BucketID: Scalars['String'];
  FirstSessionStart: Scalars['Float'];
  ID: Scalars['ID'];
  IsNewUser: Scalars['Boolean'];
  IsOnline: Scalars['Boolean'];
  LastSessionEnd: Scalars['Float'];
  LastSessionStart: Scalars['Float'];
  PrefixID: Scalars['String'];
  ProfessionalID: Scalars['String'];
  Source: Scalars['String'];
  Timestamp: Scalars['Float'];
  TotalConversions: Scalars['Int'];
  TotalPageViews: Scalars['Int'];
  TotalSessions: Scalars['Int'];
  TotalTimeSpent?: Maybe<Scalars['Float']>;
  UserCategory?: Maybe<Scalars['String']>;
  UserLocation?: Maybe<Scalars['String']>;
};

export type PixelTrackerRealtimeSessions_Connection = {
  __typename?: 'PixelTrackerRealtimeSessions_Connection';
  ID: Scalars['ID'];
  nodes: Array<PixelTrackerRealTimeSession>;
  pageInfo: ApPageInfo;
};

export type PixelTrackerRealtimeUsers_Connection = {
  __typename?: 'PixelTrackerRealtimeUsers_Connection';
  ID: Scalars['ID'];
  nodes: Array<PixelTrackerRealTimeUser>;
  pageInfo: ApPageInfo;
};

/** Snowflake data for pixel tracker, first and last event dates */
export type PixelTrackerSnowflakeData = {
  __typename?: 'PixelTrackerSnowflakeData';
  CreatedAt?: Maybe<Scalars['Int']>;
  Status: Scalars['String'];
  UpdatedAt?: Maybe<Scalars['Int']>;
};

export type PixelTrackerTopEvent = {
  __typename?: 'PixelTrackerTopEvent';
  AppearPages?: Maybe<Scalars['Int']>;
  AppearURL?: Maybe<Scalars['String']>;
  BucketID: Scalars['String'];
  EventName: Scalars['String'];
  EventSource: Scalars['String'];
  ID: Scalars['ID'];
  InDB: Scalars['Boolean'];
  PageViews: Scalars['Int'];
  ProfessionalID: Scalars['Int'];
};

/** ArchiPro Pixel top events, currently support pageview and formsubmit */
export enum PixelTrackerTopEventEnum {
  FormSubmit = 'FormSubmit',
  PageView = 'PageView'
}

export type PixelTrackerTopEventList_Connection = {
  __typename?: 'PixelTrackerTopEventList_Connection';
  ID: Scalars['ID'];
  nodes: Array<PixelTrackerTopEvent>;
  pageInfo: ApPageInfo;
};

/** Top referral pages on ArchiPro and top 5 visited pages on professional website */
export type PixelTrackerTopPage = {
  __typename?: 'PixelTrackerTopPage';
  BucketID: Scalars['String'];
  ID: Scalars['ID'];
  IsArchipro: Scalars['Boolean'];
  Link: Scalars['String'];
  Order: Scalars['Int'];
  ProfessionalID: Scalars['Int'];
  Thumbnail?: Maybe<Scalars['String']>;
  Title: Scalars['String'];
  Value: Scalars['Int'];
};

export type PlaceDetailType = {
  __typename?: 'PlaceDetailType';
  Address1?: Maybe<Scalars['String']>;
  Address2?: Maybe<Scalars['String']>;
  AddressID?: Maybe<Scalars['String']>;
  ChildCount?: Maybe<Scalars['Int']>;
  City?: Maybe<Scalars['String']>;
  Country?: Maybe<Scalars['String']>;
  Depth?: Maybe<Scalars['Int']>;
  District?: Maybe<Scalars['String']>;
  Division?: Maybe<Scalars['String']>;
  FullAddress: Scalars['String'];
  Latitude?: Maybe<Scalars['Float']>;
  Longitude?: Maybe<Scalars['Float']>;
  ParentID?: Maybe<Scalars['Int']>;
  PlaceName?: Maybe<Scalars['String']>;
  PlaceType?: Maybe<FindPlaceTypeEnum>;
  PostCode?: Maybe<Scalars['String']>;
  Region?: Maybe<Scalars['String']>;
  ServiceableAreaID?: Maybe<Scalars['Int']>;
  Slug?: Maybe<Scalars['String']>;
  State?: Maybe<Scalars['String']>;
  Suburb?: Maybe<Scalars['String']>;
};

export type PlaceDetailTypeInput = {
  Address1?: InputMaybe<Scalars['String']>;
  Address2?: InputMaybe<Scalars['String']>;
  AddressID?: InputMaybe<Scalars['String']>;
  City?: InputMaybe<Scalars['String']>;
  Country?: InputMaybe<Scalars['String']>;
  Depth?: InputMaybe<Scalars['Int']>;
  District?: InputMaybe<Scalars['String']>;
  Division?: InputMaybe<Scalars['String']>;
  FullAddress: Scalars['String'];
  Latitude?: InputMaybe<Scalars['Float']>;
  Longitude?: InputMaybe<Scalars['Float']>;
  ParentID?: InputMaybe<Scalars['Int']>;
  PlaceName?: InputMaybe<Scalars['String']>;
  PlaceType?: InputMaybe<FindPlaceTypeEnum>;
  PostCode?: InputMaybe<Scalars['String']>;
  Region?: InputMaybe<Scalars['String']>;
  ServiceableAreaID?: InputMaybe<Scalars['Int']>;
  Slug?: InputMaybe<Scalars['String']>;
  State?: InputMaybe<Scalars['String']>;
  Suburb?: InputMaybe<Scalars['String']>;
};

export type PlaceholderModule = ModuleType & {
  __typename?: 'PlaceholderModule';
  AnchorTag?: Maybe<Scalars['String']>;
  ExtraClass?: Maybe<Scalars['String']>;
  ID: Scalars['ID'];
  NavigationLabel?: Maybe<Scalars['String']>;
  SpacingBelow?: Maybe<Scalars['String']>;
  SpacingBelowMobile?: Maybe<Scalars['String']>;
  ThemeColour: ThemedElementColourType;
};

export type PlacementFeaturedItemsSimpleSortFields = {
  SortOrder?: InputMaybe<SortDirection>;
};

export type PlacementFeaturedItems_Connection = {
  __typename?: 'PlacementFeaturedItems_Connection';
  ID: Scalars['String'];
  edges: Array<PlacementFeaturedItems_ConnectionEdge>;
  nodes: Array<FeaturedItemData>;
  pageInfo: ApPageInfo;
};

/** The collections edge */
export type PlacementFeaturedItems_ConnectionEdge = {
  __typename?: 'PlacementFeaturedItems_ConnectionEdge';
  /** The node at the end of the collections edge */
  node: FeaturedItemData;
};

export type PlacementPotMsSimpleSortFields = {
  SortOrder?: InputMaybe<SortDirection>;
};

export type PlacementPotMs_Connection = {
  __typename?: 'PlacementPOTMs_Connection';
  ID: Scalars['String'];
  edges: Array<PlacementPotMs_ConnectionEdge>;
  nodes: Array<PotmData>;
  pageInfo: ApPageInfo;
};

/** The collections edge */
export type PlacementPotMs_ConnectionEdge = {
  __typename?: 'PlacementPOTMs_ConnectionEdge';
  /** The node at the end of the collections edge */
  node: PotmData;
};

export type PlainTextModule = ModuleType & {
  __typename?: 'PlainTextModule';
  AnchorTag?: Maybe<Scalars['String']>;
  Content?: Maybe<Scalars['String']>;
  ExtraClass?: Maybe<Scalars['String']>;
  ID: Scalars['ID'];
  NavigationLabel?: Maybe<Scalars['String']>;
  SpacingBelow?: Maybe<Scalars['String']>;
  SpacingBelowMobile?: Maybe<Scalars['String']>;
  ThemeColour: ThemedElementColourType;
};

export type PlatformConnection = {
  __typename?: 'PlatformConnection';
  AccessToken?: Maybe<Scalars['String']>;
  ConnectHash?: Maybe<Scalars['String']>;
  Country?: Maybe<Scalars['String']>;
  DataMap?: Maybe<Scalars['String']>;
  DisabledSettings?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  InitiatedOn?: Maybe<Scalars['Int']>;
  OrdersEnabled?: Maybe<Scalars['Boolean']>;
  Platform: IntegratedPlatformEnum;
  Professional: Scalars['String'];
  Shop: Scalars['String'];
  URLSegment: Scalars['String'];
  WebhooksDisabled?: Maybe<Scalars['Boolean']>;
};

export type Postcode = {
  __typename?: 'Postcode';
  Country: Country;
  ID: Scalars['Int'];
  Postcode: Scalars['String'];
  PostcodeGroups: PostcodeGroupsConnection;
};


export type PostcodePostcodeGroupsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type PostcodeGroup = {
  __typename?: 'PostcodeGroup';
  Children: PostcodeGroupsConnection;
  Country: Country;
  ID: Scalars['Int'];
  Postcodes: PostcodesConnection;
  Title: Scalars['String'];
};


export type PostcodeGroupChildrenArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type PostcodeGroupPostcodesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type PostcodeGroupsConnection = {
  __typename?: 'PostcodeGroupsConnection';
  edges: Array<PostcodeGroupsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type PostcodeGroupsConnectionEdge = {
  __typename?: 'PostcodeGroupsConnectionEdge';
  /** The node at the end of the collections edge */
  node: PostcodeGroup;
};

export type PostcodeGroups_Connection = {
  __typename?: 'PostcodeGroups_Connection';
  ID: Scalars['String'];
  edges: Array<PostcodeGroups_ConnectionEdge>;
  nodes: Array<PostcodeGroup>;
  pageInfo: ApPageInfo;
};

/** The collections edge */
export type PostcodeGroups_ConnectionEdge = {
  __typename?: 'PostcodeGroups_ConnectionEdge';
  /** The node at the end of the collections edge */
  node: PostcodeGroup;
};

export type PostcodesConnection = {
  __typename?: 'PostcodesConnection';
  edges: Array<PostcodesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type PostcodesConnectionEdge = {
  __typename?: 'PostcodesConnectionEdge';
  /** The node at the end of the collections edge */
  node: Postcode;
};

export enum PriceUnitEnum {
  Box = 'Box',
  CubicMetre = 'CubicMetre',
  LinearMetre = 'LinearMetre',
  SquareMetre = 'SquareMetre',
  Unit = 'Unit'
}

export type PricingDisplay = {
  __typename?: 'PricingDisplay';
  Amount: Scalars['Int'];
  Currency?: Maybe<Scalars['String']>;
  HighestAmount: Scalars['Int'];
  LowestAmount: Scalars['Int'];
  Prefix?: Maybe<Scalars['String']>;
  ReferenceVariant?: Maybe<Variant>;
  ReplacedAmount?: Maybe<Scalars['Int']>;
  ReplacedText?: Maybe<Scalars['String']>;
  Text: Scalars['String'];
};

/** The primary CTA for a professional. */
export enum PrimaryCtaEnum {
  AskAQuestion = 'AskAQuestion',
  AutoOptimise = 'AutoOptimise',
  BookConsultation = 'BookConsultation',
  GetInTouch = 'GetInTouch',
  MessageSeller = 'MessageSeller',
  RequestBrochure = 'RequestBrochure',
  RequestMeeting = 'RequestMeeting',
  RequestPrice = 'RequestPrice',
  RequestQuote = 'RequestQuote'
}

export type PrimaryCategory_ParentsConnection = {
  __typename?: 'PrimaryCategory_ParentsConnection';
  edges: Array<PrimaryCategory_ParentsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type PrimaryCategory_ParentsConnectionEdge = {
  __typename?: 'PrimaryCategory_ParentsConnectionEdge';
  /** The node at the end of the collections edge */
  node: CategoryPage;
};

export type PrioritySort = {
  Direction?: InputMaybe<SortDirection>;
  Priority?: InputMaybe<Scalars['Int']>;
};

export type Product = DesignBoardPinTarget & DirectoryItem & IApprovable & ICreatable & IFileCategory & IHasProfessional & IHomePinable & IPublishable & IRecentlyViewedTile & Node & SortableItem & TagTarget & {
  __typename?: 'Product';
  ARFileData?: Maybe<ArFileData>;
  /** Has this page been reviewed and approved by the ArchiPro Content Team? */
  Activated?: Maybe<Scalars['Boolean']>;
  AlsoFromProducts: AlsoFromProductsConnection;
  ApprovedByMember?: Maybe<Member>;
  ApprovedDate?: Maybe<Scalars['String']>;
  ArcherCommentCount: Scalars['Int'];
  ArcherCommentError: Scalars['Int'];
  ArcherComments: ArcherCommentsConnection;
  AssociatedPages: Product_AssociatedPagesConnection;
  AttributeOptions: AttributeOptionsConnection;
  AvailabilityZones: Array<Zone>;
  Awards: ProductAwardsConnection;
  BannerImages: Array<LibraryImage>;
  Banners: LibraryItemBannersConnection;
  Brand: Scalars['String'];
  CanPurchase: Scalars['Boolean'];
  Categories: Array<Category>;
  Clones?: Maybe<Array<DirectoryItem>>;
  Colors: Array<AttributeOption>;
  ColorsCount: Scalars['Int'];
  Content?: Maybe<Scalars['String']>;
  ContentComment?: Maybe<Scalars['String']>;
  ContentLocked: Scalars['Boolean'];
  ContentRejectReasons: Array<ContentRejectReasonEnum>;
  ContentStatus?: Maybe<ContentStatusEnum>;
  ContentStatusBy?: Maybe<Member>;
  ContentStatusDate?: Maybe<Scalars['String']>;
  CreatedByMember?: Maybe<Member>;
  CreatedDate?: Maybe<Scalars['String']>;
  CreatedTimestamp: Scalars['Int'];
  DataQualityRating: Scalars['Float'];
  /** The data source of the product. */
  DataSource?: Maybe<IntegratedPlatformEnum>;
  DataSourceLabel: Scalars['String'];
  DefaultImage?: Maybe<LibraryImage>;
  Deleted: Scalars['Boolean'];
  DesignBoardsForCurrentUser?: Maybe<Array<Maybe<DesignBoard>>>;
  Designer: Scalars['String'];
  DiagramImages: Array<DiagramImage>;
  Disable: Scalars['Boolean'];
  EcommerceObstructions: Array<Scalars['String']>;
  EcommerceReady: Scalars['Boolean'];
  EmbeddedData?: Maybe<Scalars['String']>;
  Embeddings?: Maybe<Scalars['String']>;
  ExcludeAdvertising: Scalars['Boolean'];
  ExcludedFromSpecialtyRates: Scalars['Boolean'];
  FacebookPreviewImage?: Maybe<Scalars['String']>;
  FacetOptions: Array<FacetOption>;
  FeaturedProjects: ProjectsUsingProductConnection;
  FileCategories: FileCategoriesConnection;
  FirstPublishedDate?: Maybe<Scalars['String']>;
  HasClones: Scalars['Boolean'];
  HasDownloads: Scalars['Boolean'];
  HasInstallers: Scalars['Boolean'];
  HasPhotos: Scalars['Boolean'];
  HasProducts: Scalars['Boolean'];
  HasProductsInRange: Scalars['Boolean'];
  HasProjects: Scalars['Boolean'];
  HasSwatches: Scalars['Boolean'];
  HasTags: Scalars['Boolean'];
  HasVideos: Scalars['Boolean'];
  HighestPriceVariant?: Maybe<Variant>;
  HighestTradePriceVariant?: Maybe<Variant>;
  /** Get the highest Purchasable variant price */
  HighestVariantPrice?: Maybe<CurrencyAmount>;
  HomePinned: Scalars['Boolean'];
  ID: Scalars['Int'];
  Images: LibraryItemImagesConnection;
  InLibrary?: Maybe<Scalars['Boolean']>;
  Installers?: Maybe<InstallersType>;
  InvalidWebsite: Scalars['Boolean'];
  IsCloned: Scalars['Boolean'];
  /** Has this page been reviewed and approved by the client? */
  IsDraft: Scalars['Boolean'];
  IsFeature: Scalars['Boolean'];
  IsFeatured: Scalars['Boolean'];
  IsInServiceableArea: Scalars['Boolean'];
  /** True if published and activated */
  IsLive: Scalars['Boolean'];
  IsManufacturer: Scalars['Boolean'];
  IsOnSale: Scalars['Boolean'];
  IsTemplate: Scalars['Boolean'];
  KPI?: Maybe<LibraryItemKpi>;
  LastEditedDate?: Maybe<Scalars['String']>;
  LastEditedTimestamp: Scalars['Int'];
  LastExternalUpdate?: Maybe<Scalars['String']>;
  LastExternalUpdateTimestamp: Scalars['Int'];
  LeadTime: Scalars['String'];
  LibraryDownloads: Array<LibraryDownload>;
  LibraryImages: Array<LibraryImage>;
  LibraryLocations: Array<LibraryLocation>;
  LibraryRange?: Maybe<LibraryRange>;
  LibraryTabs: Array<LibraryTab>;
  LibraryThumb?: Maybe<LibraryThumb>;
  LibraryVideos: Array<LibraryVideo>;
  Link: Scalars['String'];
  LiveDateTimestamp?: Maybe<Scalars['Int']>;
  LowestPriceVariant?: Maybe<Variant>;
  LowestTradePriceVariant?: Maybe<Variant>;
  /** Get the lowest Purchasable variant price */
  LowestVariantPrice?: Maybe<CurrencyAmount>;
  MasterVariant?: Maybe<Variant>;
  Materials: AttributeOptions_MaterialsConnection;
  MemberPricing?: Maybe<PricingDisplay>;
  MemberSortOrder: Scalars['Int'];
  Meta?: Maybe<Meta>;
  MostRelevantCategory?: Maybe<ProductCategory>;
  Networks: Product_NetworksConnection;
  OtherRangeProducts: OtherRangeProductsConnection;
  PageMeta?: Maybe<DirectoryPageMeta>;
  PageType: Scalars['String'];
  ParentID: Scalars['Int'];
  PerformanceDescription: Scalars['String'];
  PriceRange: Scalars['String'];
  Pricing: ProductPricing;
  PricingDisplay?: Maybe<PricingDisplay>;
  /** Same as Categories but with a different return type PrimaryCategory */
  PrimaryCategories: Array<CategoryPage>;
  PrimaryCategory?: Maybe<CategoryPage>;
  ProductCategories?: Maybe<Array<ProductCategory>>;
  ProductsUsed: Array<Product>;
  Professional?: Maybe<Professional>;
  PublicKPI?: Maybe<LibraryItemPublicKpi>;
  /** Has this page been reviewed and approved by the client? */
  Publish: Scalars['Boolean'];
  PublishDate?: Maybe<Scalars['String']>;
  PublishedByMember?: Maybe<Member>;
  RawTileImage?: Maybe<Scalars['String']>;
  RecentlyViewedImage?: Maybe<RecentlyViewedImage>;
  Recommendations?: Maybe<Array<Maybe<DirectoryItem>>>;
  /** Actions that need addressing before this page can be approved */
  ReviewActions?: Maybe<Array<Maybe<ReviewAction>>>;
  SampleAddressPlaceholder?: Maybe<Scalars['String']>;
  SampleMessagePlaceholder?: Maybe<Scalars['String']>;
  SampleSubmitText?: Maybe<Scalars['String']>;
  SampleText?: Maybe<Scalars['String']>;
  SampleTitle?: Maybe<Scalars['String']>;
  SamplesAddressRequired: Scalars['Boolean'];
  SamplesAvailable: Scalars['Boolean'];
  ScopeOfUseDescription: Scalars['String'];
  SearchTags?: Maybe<Array<Maybe<SearchTag>>>;
  ShowsInElasticSearch: Scalars['Boolean'];
  Sizes: Array<ProductSize>;
  SortOrder: Scalars['Int'];
  SpecialtyBannerText?: Maybe<Scalars['String']>;
  SpecialtyCustomerPriceText?: Maybe<Scalars['String']>;
  SpecialtyTradePriceText?: Maybe<Scalars['String']>;
  StockInfo?: Maybe<StockInfo>;
  SupplierProductID?: Maybe<Scalars['String']>;
  Swatches: Array<ProductSwatch>;
  Teaser?: Maybe<Scalars['String']>;
  ThumbnailFile?: Maybe<LibraryImageFile>;
  Title: Scalars['String'];
  TopBanner?: Maybe<LibraryItemBanner>;
  TradePricing?: Maybe<PricingDisplay>;
  URLSegment: Scalars['String'];
  VariantSummary: Scalars['String'];
  Variants: Array<Variant>;
  ViewsCount: Scalars['Int'];
  Visibilities?: Maybe<Array<ProductVisibility>>;
  WarrantyDuration: Scalars['String'];
  Website?: Maybe<Scalars['String']>;
  WebsiteShort?: Maybe<Scalars['String']>;
  WebsiteUntracked: Scalars['String'];
  Year: Scalars['String'];
  deprecated_Awards?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};


export type ProductAlsoFromProductsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type ProductApprovedDateArgs = {
  format?: InputMaybe<DateFormatEnum>;
};


export type ProductArcherCommentsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type ProductAssociatedPagesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type ProductAttributeOptionsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type ProductAwardsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type ProductBannersArgs = {
  filter?: InputMaybe<LibraryItemBannersFilters>;
  filters?: InputMaybe<LibraryItemBannersFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<LibraryItemBannersSortFields>;
};


export type ProductColorsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};


export type ProductContentStatusDateArgs = {
  format?: InputMaybe<DateFormatEnum>;
};


export type ProductCreatedDateArgs = {
  format?: InputMaybe<DateFormatEnum>;
};


export type ProductFeaturedProjectsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type ProductFileCategoriesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<FileCategoriesSortFields>;
};


export type ProductFirstPublishedDateArgs = {
  format?: InputMaybe<DateFormatEnum>;
};


export type ProductImagesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type ProductLibraryImagesArgs = {
  Limit?: InputMaybe<Scalars['Int']>;
};


export type ProductLibraryLocationsArgs = {
  showHidden?: InputMaybe<Scalars['Boolean']>;
};


export type ProductMaterialsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type ProductNetworksArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Product_NetworksSortFields>;
};


export type ProductOtherRangeProductsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type ProductPublishDateArgs = {
  format?: InputMaybe<DateFormatEnum>;
};


export type ProductViewsCountArgs = {
  Range: DirectoryItemViewsCountRange;
};

export type ProductAttributeOption = {
  __typename?: 'ProductAttributeOption';
  AttributeOption: AttributeOption;
  ID: Scalars['Int'];
  SortOrder: Scalars['Int'];
};

export type ProductAwardsConnection = {
  __typename?: 'ProductAwardsConnection';
  edges: Array<ProductAwardsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ProductAwardsConnectionEdge = {
  __typename?: 'ProductAwardsConnectionEdge';
  /** The node at the end of the collections edge */
  node: Award;
};

/** The product CTA for a professional. */
export enum ProductCtaEnum {
  AskAQuestion = 'AskAQuestion',
  AutoOptimise = 'AutoOptimise',
  BookConsultation = 'BookConsultation',
  GetInTouch = 'GetInTouch',
  MessageSeller = 'MessageSeller',
  RequestBrochure = 'RequestBrochure',
  RequestMeeting = 'RequestMeeting',
  RequestPrice = 'RequestPrice',
  RequestQuote = 'RequestQuote'
}

export type ProductCategory = ICategory & IHasItems & {
  __typename?: 'ProductCategory';
  Categories: ProductCategory_CategoriesConnection;
  CustomSeoOnFilters?: Maybe<Scalars['Boolean']>;
  ID: Scalars['Int'];
  /** Clear cut Image */
  Image?: Maybe<ResponsiveImage>;
  IsPublished?: Maybe<Scalars['Boolean']>;
  ItemsCount: Scalars['Int'];
  Link: Scalars['String'];
  MenuTitle: Scalars['String'];
  Parent?: Maybe<ProductCategory>;
  Parents: ProductCategory_ParentsConnection;
  PrettyTitle: Scalars['String'];
  Products: ProductCategory_ProductsConnection;
  /** Clear cut Image */
  Thumbnail?: Maybe<ResponsiveImage>;
  Title: Scalars['String'];
  URLSegment?: Maybe<Scalars['String']>;
};


export type ProductCategoryCategoriesArgs = {
  filter?: InputMaybe<ProductCategory_CategoriesFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<ProductCategory_CategoriesSortFields>;
};


export type ProductCategoryImageArgs = {
  Height?: InputMaybe<Scalars['Int']>;
  Width?: InputMaybe<Scalars['Int']>;
};


export type ProductCategoryItemsCountArgs = {
  Zone?: InputMaybe<SupportedCountry>;
};


export type ProductCategoryParentsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type ProductCategoryProductsArgs = {
  filter?: InputMaybe<ProductCategory_ProductsFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<ProductCategory_ProductsSortFields>;
};


export type ProductCategoryThumbnailArgs = {
  Height?: InputMaybe<Scalars['Int']>;
  Width?: InputMaybe<Scalars['Int']>;
};

export type ProductCategory_CategoriesConnection = {
  __typename?: 'ProductCategory_CategoriesConnection';
  edges: Array<ProductCategory_CategoriesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ProductCategory_CategoriesConnectionEdge = {
  __typename?: 'ProductCategory_CategoriesConnectionEdge';
  /** The node at the end of the collections edge */
  node: ProductCategory;
};

export type ProductCategory_CategoriesFilters = {
  /** Filter categories that have or don`t have items */
  HasItems?: InputMaybe<Scalars['Boolean']>;
};

export type ProductCategory_CategoriesSortFields = {
  Title?: InputMaybe<SortDirection>;
};

export type ProductCategory_ParentsConnection = {
  __typename?: 'ProductCategory_ParentsConnection';
  edges: Array<ProductCategory_ParentsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ProductCategory_ParentsConnectionEdge = {
  __typename?: 'ProductCategory_ParentsConnectionEdge';
  /** The node at the end of the collections edge */
  node: ProductCategory;
};

export type ProductCategory_ProductsConnection = {
  __typename?: 'ProductCategory_ProductsConnection';
  edges: Array<ProductCategory_ProductsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ProductCategory_ProductsConnectionEdge = {
  __typename?: 'ProductCategory_ProductsConnectionEdge';
  /** The node at the end of the collections edge */
  node: Product;
};

export type ProductCategory_ProductsFilters = {
  /** Filters this type when CountryCode is in the provided value */
  CountryCode__in?: InputMaybe<Array<SupportedCountry>>;
  /** Filters this type when EcommerceEnabled is eq the provided value */
  EcommerceEnabled__eq?: InputMaybe<Scalars['Boolean']>;
  /** Filter by ID */
  ID__in?: InputMaybe<Array<Scalars['Int']>>;
  /** Filters this type when Visibility is find_in the provided value */
  Visibility__find_in?: InputMaybe<Scalars['String']>;
};

export type ProductCategory_ProductsSortFields = {
  Created?: InputMaybe<SortDirection>;
  ID?: InputMaybe<SortDirection>;
  LastEdited?: InputMaybe<SortDirection>;
  Popularity?: InputMaybe<SortDirection>;
  SortOrder?: InputMaybe<SortDirection>;
};

export type ProductColor = {
  __typename?: 'ProductColor';
  Hex: Scalars['String'];
  ID: Scalars['Int'];
  Name: Scalars['String'];
  Synonyms: SynonymsConnection;
};


export type ProductColorSynonymsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type ProductColorSynonym = {
  __typename?: 'ProductColorSynonym';
  ID: Scalars['Int'];
  Name: Scalars['String'];
};

export type ProductEnrichmentResult = {
  __typename?: 'ProductEnrichmentResult';
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  executionSeconds?: Maybe<Scalars['Float']>;
  facetsProcessed: Scalars['Int'];
  message: Scalars['String'];
  mostRelevantCategoryId?: Maybe<Scalars['Int']>;
  optionsAdded: Scalars['Int'];
  optionsFound: Scalars['Int'];
  optionsRemoved: Scalars['Int'];
  optionsUnchanged: Scalars['Int'];
  success: Scalars['Boolean'];
  warnings?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ProductFeature = ModuleType & {
  __typename?: 'ProductFeature';
  AnchorTag?: Maybe<Scalars['String']>;
  ExtraClass?: Maybe<Scalars['String']>;
  ID: Scalars['ID'];
  Image?: Maybe<ResponsiveVariantImage>;
  NavigationLabel?: Maybe<Scalars['String']>;
  SpacingBelow?: Maybe<Scalars['String']>;
  SpacingBelowMobile?: Maybe<Scalars['String']>;
  ThemeColour: ThemedElementColourType;
  Title?: Maybe<Scalars['String']>;
};

export type ProductImprovementTaskStatus = {
  __typename?: 'ProductImprovementTaskStatus';
  ArcherCommentID: Scalars['Int'];
  InProgress: Scalars['Boolean'];
  Message?: Maybe<Scalars['String']>;
  Success?: Maybe<Scalars['Boolean']>;
};

export type ProductPin = {
  __typename?: 'ProductPin';
  ARFileData?: Maybe<ArFileData>;
  BoardID: Scalars['Int'];
  BoardURLSegment: Scalars['String'];
  CanDelete: Scalars['Boolean'];
  CanPurchase: Scalars['Boolean'];
  Comments?: Maybe<Array<Maybe<Comment>>>;
  CommentsCount: Scalars['Int'];
  CreatedBy?: Maybe<Member>;
  HasUnreadComments: Scalars['Boolean'];
  ID: Scalars['Int'];
  LibraryImageID?: Maybe<Scalars['Int']>;
  LibraryThumb?: Maybe<LibraryThumb>;
  Link?: Maybe<Scalars['String']>;
  PageType?: Maybe<Scalars['String']>;
  PageTypeID?: Maybe<Scalars['Int']>;
  Permission: PinPermission;
  PhotoModal?: Maybe<Scalars['String']>;
  PhotoTile?: Maybe<Scalars['String']>;
  ProfessionalID?: Maybe<Scalars['Int']>;
  ProfessionalLink?: Maybe<Scalars['String']>;
  ProfessionalTitle?: Maybe<Scalars['String']>;
  ProfessionalWebsite?: Maybe<Scalars['String']>;
  SubTitle: Scalars['String'];
  Title?: Maybe<Scalars['String']>;
  Type?: Maybe<Scalars['String']>;
};

export type ProductPricing = {
  __typename?: 'ProductPricing';
  ID: Scalars['Int'];
  Maximum: CurrencyAmount;
  Minimum: CurrencyAmount;
  PricingType: ProductPricingTypeEnum;
  Product: Product;
  Retail: CurrencyAmount;
  Sale: CurrencyAmount;
  Sample: CurrencyAmount;
  SampleEnabled: Scalars['Boolean'];
  SampleShipping?: Maybe<ShippingProfile>;
  Trade: CurrencyAmount;
  Unit?: Maybe<PriceUnitEnum>;
};

export enum ProductPricingTypeEnum {
  EcommercePricing = 'ecommercePricing',
  OnRequest = 'onRequest'
}

export type ProductResultData = {
  ProductID: Scalars['Int'];
  SupplierProductID?: InputMaybe<Scalars['String']>;
  Title: Scalars['String'];
};

export type ProductSize = {
  __typename?: 'ProductSize';
  Depth: Scalars['Int'];
  Diameter: Scalars['Int'];
  /** Formatted without name: D00 x L00 x W00 x H00 - 0kg/0L */
  Formatted: Scalars['String'];
  /** Full version: Name - D00 x L00 x W00 x H00 - 0kg/0L */
  FullTitle: Scalars['String'];
  Height: Scalars['Int'];
  ID: Scalars['Int'];
  Length: Scalars['Int'];
  MeasurementUnit: Scalars['String'];
  MeasurementUnitShort: Scalars['String'];
  Name: Scalars['String'];
  PackageHeight: Scalars['Int'];
  PackageLength: Scalars['Int'];
  PackageWeight: Scalars['Int'];
  PackageWidth: Scalars['Int'];
  Product: Product;
  SortOrder: Scalars['Int'];
  /** Sort version: size name or the formatted label if name is empty */
  Title: Scalars['String'];
  Volume: Scalars['Int'];
  Weight: Scalars['Int'];
  Width: Scalars['Int'];
};

export type ProductSizeInput = {
  Depth: Scalars['Int'];
  Diameter: Scalars['Int'];
  Height: Scalars['Int'];
  Length: Scalars['Int'];
  MeasurementUnit: Scalars['StringInput'];
  Name: Scalars['StringInput'];
  PackageHeight: Scalars['Int'];
  PackageLength: Scalars['Int'];
  PackageWeight: Scalars['Int'];
  PackageWidth: Scalars['Int'];
  Volume: Scalars['Int'];
  Weight: Scalars['Int'];
  Width: Scalars['Int'];
};

/** The result of a product import */
export type ProductSummaryInputType = {
  InternalProductID?: InputMaybe<Scalars['Int']>;
  Link?: InputMaybe<Scalars['String']>;
  ProductID?: InputMaybe<Scalars['String']>;
  SKUs?: InputMaybe<Array<Scalars['String']>>;
  Title?: InputMaybe<Scalars['String']>;
};

export type ProductSwatch = {
  __typename?: 'ProductSwatch';
  AttributeOptions: Array<AttributeOption>;
  ColourImageFileID: Scalars['Int'];
  ID: Scalars['Int'];
  Image: ResponsiveImage;
  MemberSortOrder: Scalars['Int'];
  Title: Scalars['String'];
  /** Deprecated. Can use a proper ResponsiveImage type. See `Image`. */
  URL: Scalars['String'];
};

export type ProductSwatchUpdate = {
  ID: Scalars['Int'];
  MemberSortOrder?: InputMaybe<Scalars['Int']>;
  Title?: InputMaybe<Scalars['StringInput']>;
};

export type ProductTagStatsFilters = {
  INLIBRARY__EQUAL?: InputMaybe<Scalars['Int']>;
  PARENT_NAME__EQUAL?: InputMaybe<Scalars['String']>;
  PARENT_TAG__EQUAL?: InputMaybe<Scalars['String']>;
  PRODUCT_NAME__EQUAL?: InputMaybe<Scalars['String']>;
};

export type ProductTagTemporalStatsFilters = {
  EVENT_DATE_HOST__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
  INLIBRARY__EQUAL?: InputMaybe<Scalars['Int']>;
  PARENT_NAME__EQUAL?: InputMaybe<Scalars['String']>;
  PARENT_TAG__EQUAL?: InputMaybe<Scalars['String']>;
  PRODUCT_NAME__EQUAL?: InputMaybe<Scalars['String']>;
};

export enum ProductVisibility {
  Disabled = 'Disabled',
  Draft = 'Draft',
  InLibrary = 'InLibrary',
  InSearch = 'InSearch',
  NotLive = 'NotLive',
  PendingApproval = 'PendingApproval',
  ProfileOnly = 'ProfileOnly'
}

export type Product_AssociatedPagesConnection = {
  __typename?: 'Product_AssociatedPagesConnection';
  edges: Array<Product_AssociatedPagesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type Product_AssociatedPagesConnectionEdge = {
  __typename?: 'Product_AssociatedPagesConnectionEdge';
  /** The node at the end of the collections edge */
  node: AssociatedPage;
};

export type Product_NetworksConnection = {
  __typename?: 'Product_NetworksConnection';
  edges: Array<Product_NetworksConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type Product_NetworksConnectionEdge = {
  __typename?: 'Product_NetworksConnectionEdge';
  /** The node at the end of the collections edge */
  node: Network;
};

export type Product_NetworksSortFields = {
  ID?: InputMaybe<SortDirection>;
};

export type ProductsUsedInProjectConnection = {
  __typename?: 'ProductsUsedInProjectConnection';
  edges: Array<ProductsUsedInProjectConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ProductsUsedInProjectConnectionEdge = {
  __typename?: 'ProductsUsedInProjectConnectionEdge';
  /** The node at the end of the collections edge */
  node: Product;
};

export type Professional = DesignBoardPinTarget & DirectoryItem & IApprovable & ICreatable & IHomePinable & IPublishable & IRecentlyViewedTile & Node & ParticipantIdentity & PermissionInterface & SortableItem & TagTarget & {
  __typename?: 'Professional';
  /** AI-generated summary for the professional */
  AIServiceSummary?: Maybe<Scalars['String']>;
  APConnect: Scalars['Boolean'];
  /** Has this page been reviewed and approved by the ArchiPro Content Team? */
  Activated?: Maybe<Scalars['Boolean']>;
  AggregatedPublicKPI?: Maybe<ProfessionalAggregatedKpi>;
  AllContacts: Array<Contact>;
  AllowBooking: Scalars['Boolean'];
  AllowCRMIntegration: Scalars['Boolean'];
  AllowEmailBuilder: Scalars['Boolean'];
  AllowInLibraryForRelatedItems: Scalars['Boolean'];
  AllowInvoicing: Scalars['Boolean'];
  AllowsEnquiries: Scalars['Boolean'];
  AnalyticsStatus: AnalyticsStatusEnum;
  AnalyticsSubscription?: Maybe<AnalyticsSubscription>;
  ApprovedByMember?: Maybe<Member>;
  ApprovedDate?: Maybe<Scalars['String']>;
  ArchiproEditorialAccount: Scalars['Boolean'];
  ArticleAuthors: ArticleAuthorsConnection;
  Articles: Array<Article>;
  AssociatedPages: Professional_AssociatedPagesConnection;
  Associations: AssociationsConnection;
  AutoConfirmOrders: Scalars['Boolean'];
  AvailabilityZones: Array<Zone>;
  AvailableForWork: Scalars['Boolean'];
  Awards: ProfessionalAwardsConnection;
  /** Professional business number field */
  BN?: Maybe<Scalars['String']>;
  BannerImages: Array<LibraryImage>;
  Banners: LibraryItemBannersConnection;
  BlockSummary?: Maybe<Scalars['String']>;
  /** The business focus of a professional. */
  BusinessFocus: BusinessFocusEnum;
  /** fetches professional's business terms */
  BusinessTerms: ProfessionalBusinessTermsConnection;
  BusinessTermsCategories: Array<BusinessTermsCategory>;
  BusinessTypes: BusinessTypesConnection;
  CalendarSessions: CalendarSessionsConnection;
  Categories: Array<Category>;
  City?: Maybe<Scalars['String']>;
  CloneTasks: Array<CloneTask>;
  Clones?: Maybe<Array<DirectoryItem>>;
  CloningOptions: Array<Option>;
  Companies: ProfessionalCompaniesConnection;
  CompanyCustomFields: Array<CustomField>;
  CompanyLogo?: Maybe<Scalars['String']>;
  CompanyLogo48Cropped?: Maybe<Scalars['String']>;
  CompanyLogo48Resized?: Maybe<Scalars['String']>;
  CompanyLogo96Resized?: Maybe<Scalars['String']>;
  CompanyLogo200Cropped?: Maybe<Scalars['String']>;
  CompanyLogoAdsThumb?: Maybe<Scalars['String']>;
  CompanyLogoPadded?: Maybe<Scalars['String']>;
  CompanyLogoThumbMini?: Maybe<Scalars['String']>;
  CompanyLogoThumbTiny?: Maybe<Scalars['String']>;
  ContactCustomFields: Array<CustomField>;
  Contacts: ProfessionalContactsConnection;
  Content?: Maybe<Scalars['String']>;
  ContentComment?: Maybe<Scalars['String']>;
  ContentNotificationEmailAddresses: Array<Scalars['String']>;
  ContentRejectReasons: Array<ContentRejectReasonEnum>;
  ContentStatus?: Maybe<ContentStatusEnum>;
  ContentStatusBy?: Maybe<Member>;
  ContentStatusDate?: Maybe<Scalars['String']>;
  Country: Scalars['String'];
  CreatedByMember?: Maybe<Member>;
  CreatedDate?: Maybe<Scalars['String']>;
  CreatedTimestamp: Scalars['Int'];
  CustomEnquiryMessage?: Maybe<Scalars['String']>;
  DesignBoardsForCurrentUser?: Maybe<Array<Maybe<DesignBoard>>>;
  Disable: Scalars['Boolean'];
  EcommerceEmailAddresses: Array<Scalars['String']>;
  EcommerceEnabled: Scalars['Boolean'];
  EligibleShippingProducts: EligibleShippingProducts;
  Email?: Maybe<Scalars['String']>;
  EmailAssets: Array<LibraryImage>;
  /** fetches professional's email templates */
  EmailTemplates: ProfessionalEmailTemplatesConnection;
  EmbeddedData?: Maybe<Scalars['String']>;
  EmbeddedReport?: Maybe<EmbeddedReport>;
  EmbeddedReportsList?: Maybe<Array<Maybe<EmbeddedReport>>>;
  Embeddings?: Maybe<Scalars['String']>;
  EngagementNotificationEmailAddresses: Array<Scalars['String']>;
  EnquiryAvgResponseHours: Scalars['Int'];
  EnquiryEmailAddresses: Array<Scalars['String']>;
  EnquiryResponseRate: Scalars['Int'];
  FacebookPreviewImage?: Maybe<Scalars['String']>;
  FeaturedProductThumbs?: Maybe<Array<Maybe<LibraryThumb>>>;
  FeaturedProjectThumbs?: Maybe<Array<Maybe<LibraryThumb>>>;
  FirstPublishedDate?: Maybe<Scalars['String']>;
  FreeShippingThreshold: CurrencyAmount;
  FreeShippingThresholdEnabled: Scalars['Boolean'];
  FullAddress?: Maybe<Scalars['String']>;
  GoogleAnalytics: GoogleAnalytics;
  HasArticles: Scalars['Boolean'];
  HasClones: Scalars['Boolean'];
  HasDownloads: Scalars['Boolean'];
  HasNativeDriver: Scalars['Boolean'];
  HasOnSitePlacement: Scalars['Boolean'];
  HasPackages: Scalars['Boolean'];
  HasPartners: Scalars['Boolean'];
  HasPhotos: Scalars['Boolean'];
  HasProducts: Scalars['Boolean'];
  HasProjects: Scalars['Boolean'];
  HasProjectsUsingThisProfessional: Scalars['Boolean'];
  HasRunningAds: Scalars['Boolean'];
  HasTags: Scalars['Boolean'];
  HasTeamMembers: Scalars['Boolean'];
  HasVideos: Scalars['Boolean'];
  HomePinned: Scalars['Boolean'];
  HubspotCompany?: Maybe<HubspotCompany>;
  ID: Scalars['Int'];
  Images: LibraryItemImagesConnection;
  InLibrary?: Maybe<Scalars['Boolean']>;
  InvalidWebsite: Scalars['Boolean'];
  IsCloned: Scalars['Boolean'];
  /** Has this page been reviewed and approved by the client? */
  IsDraft: Scalars['Boolean'];
  IsEmailIntegrationEnabled: Scalars['Boolean'];
  IsFeature: Scalars['Boolean'];
  /** True if published and activated */
  IsLive: Scalars['Boolean'];
  IsManufacturer: Scalars['Boolean'];
  IsTemplate: Scalars['Boolean'];
  KPI?: Maybe<LibraryItemKpi>;
  LastEditedDate?: Maybe<Scalars['String']>;
  LastEditedTimestamp: Scalars['Int'];
  LibraryDownloads: Array<LibraryDownload>;
  LibraryImages: Array<LibraryImage>;
  LibraryLocations: Array<LibraryLocation>;
  LibraryRange?: Maybe<LibraryRange>;
  LibraryTabs: Array<LibraryTab>;
  LibraryThumb?: Maybe<LibraryThumb>;
  LibraryVideos: Array<LibraryVideo>;
  Link: Scalars['String'];
  LiveDateTimestamp?: Maybe<Scalars['Int']>;
  LogoBackgroundColor?: Maybe<Scalars['String']>;
  LogoNavbar?: Maybe<Scalars['String']>;
  MemberSortOrder: Scalars['Int'];
  Meta?: Maybe<Meta>;
  MetaData?: Maybe<ProfessionalMetaData>;
  Networks: Professional_NetworksConnection;
  NoticePeriod: Scalars['Int'];
  NoticePeriodUnit: ProfessionalNoticePeriodUnitEnum;
  OrganizationNetworkOwner?: Maybe<OrganizationNetworkOwner>;
  PageMeta?: Maybe<DirectoryPageMeta>;
  PageType: Scalars['String'];
  ParentID: Scalars['Int'];
  Parents: Array<Professional>;
  PartnerCategories?: Maybe<Array<Category>>;
  Partners: Array<Professional>;
  Permissions: Array<PermissionEnum>;
  Phone: Scalars['String'];
  Phone2?: Maybe<Scalars['String']>;
  PhoneTracking?: Maybe<Scalars['String']>;
  PhoneTrackingPlayMessage?: Maybe<Scalars['Boolean']>;
  PickupLocations: Array<LibraryLocation>;
  PixelNotGated: Scalars['Boolean'];
  PixelTracker?: Maybe<PixelTracker>;
  /** Professional postcode field */
  PostCode?: Maybe<Scalars['String']>;
  PriceRanges: Array<ProfessionalPriceRange>;
  PricingDisabled: Scalars['Boolean'];
  PrimaryAddress?: Maybe<Scalars['String']>;
  /** The primary CTA for a professional. */
  PrimaryCTA: PrimaryCtaEnum;
  /** Same as Categories but with a different return type PrimaryCategory */
  PrimaryCategories: Array<CategoryPage>;
  PrimaryCategory?: Maybe<CategoryPage>;
  /** The product CTA for a professional. */
  ProductCTA: ProductCtaEnum;
  ProductCount: Scalars['Int'];
  Products: Array<Product>;
  ProductsAllowed: Scalars['Boolean'];
  ProductsUsed: Array<Product>;
  Professional?: Maybe<Professional>;
  ProfessionalServices: ProfessionalServicesConnection;
  ProfileLiveDate?: Maybe<Scalars['String']>;
  ProjectCount: Scalars['Int'];
  Projects: Array<Project>;
  PublicFacebookLink?: Maybe<Scalars['String']>;
  PublicInstagramLink?: Maybe<Scalars['String']>;
  PublicKPI?: Maybe<LibraryItemPublicKpi>;
  PublicLinkedinLink?: Maybe<Scalars['String']>;
  PublicPinterestLink?: Maybe<Scalars['String']>;
  PublicTikTokLink?: Maybe<Scalars['String']>;
  PublicTwitterLink?: Maybe<Scalars['String']>;
  PublicYoutubeLink?: Maybe<Scalars['String']>;
  /** Has this page been reviewed and approved by the client? */
  Publish: Scalars['Boolean'];
  PublishDate?: Maybe<Scalars['String']>;
  PublishedByMember?: Maybe<Member>;
  /** fetches professional's quarterly business reviews */
  QBRs: ProfessionalQbRsConnection;
  RawTileImage?: Maybe<Scalars['String']>;
  RecentlyViewedImage?: Maybe<RecentlyViewedImage>;
  Recommendations?: Maybe<Array<Maybe<DirectoryItem>>>;
  Regions?: Maybe<Array<Region>>;
  /** Actions that need addressing before this page can be approved */
  ReviewActions?: Maybe<Array<Maybe<ReviewAction>>>;
  SampleAddressPlaceholder?: Maybe<Scalars['String']>;
  SampleEstimatedWeight: Scalars['Int'];
  SampleMessagePlaceholder?: Maybe<Scalars['String']>;
  SampleSubmitText?: Maybe<Scalars['String']>;
  SampleText?: Maybe<Scalars['String']>;
  SampleTitle?: Maybe<Scalars['String']>;
  SamplesAddressRequired: Scalars['Boolean'];
  SamplesAvailable: Scalars['Boolean'];
  /** fetches professional's saved quotes */
  SavedQuotes: ProfessionalSavedQuotesConnection;
  SearchTags?: Maybe<Array<Maybe<SearchTag>>>;
  ServiceAreas?: Maybe<Array<ProfessionalServiceArea>>;
  ServiceOfferings: Array<ServiceOffering>;
  /** Deprecated. Use ProfessionalServices instead. */
  Services?: Maybe<Array<Scalars['String']>>;
  ShippingProfiles: Array<ShippingProfile>;
  ShippingPromotions: Array<ShippingPromotion>;
  ShippingProviders: Array<ShippingProvider>;
  ShippingZones: ShippingZonesConnection;
  ShowCaseStudies: Scalars['Boolean'];
  ShowOwnProjectsOnly: Scalars['Boolean'];
  /** Whether the marketplace supplier systems survey should be displayed. */
  ShowSupplierSurvey: Scalars['Boolean'];
  ShowsInElasticSearch: Scalars['Boolean'];
  SortOrder: Scalars['Int'];
  SpecialityRatesOnSalePrices: Scalars['Boolean'];
  SpecialtyRates?: Maybe<Array<SpecialtyRateCategories>>;
  SpecialtyRatesOnSalePrices: Scalars['Boolean'];
  /** Professional state field */
  State?: Maybe<Scalars['String']>;
  StatsReportEmailAddresses: Array<Scalars['String']>;
  StripeAccount: Scalars['String'];
  StripeAccountEnabled: Scalars['Boolean'];
  /** Professional subtitle field */
  SubTitle?: Maybe<Scalars['String']>;
  SuburbCity?: Maybe<Scalars['String']>;
  TeamMembers: TeamMembersConnection;
  Teaser?: Maybe<Scalars['String']>;
  Testimonials?: Maybe<Array<Testimonial>>;
  ThumbnailFile?: Maybe<LibraryImageFile>;
  Title: Scalars['String'];
  TopBanner?: Maybe<LibraryItemBanner>;
  URLSegment: Scalars['String'];
  UseLegacyPixelReport?: Maybe<Scalars['Boolean']>;
  Videos: VideosConnection;
  ViewsCount: Scalars['Int'];
  Visibilities?: Maybe<Array<ProfessionalVisibility>>;
  Website?: Maybe<Scalars['String']>;
  WebsiteLink?: Maybe<Scalars['String']>;
  WebsiteShort?: Maybe<Scalars['String']>;
  WebsiteUntracked: Scalars['String'];
  /** The year the company was founded. */
  YearFounded: Scalars['String'];
  deprecated_Awards?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};


export type ProfessionalApprovedDateArgs = {
  format?: InputMaybe<DateFormatEnum>;
};


export type ProfessionalArticleAuthorsArgs = {
  filter?: InputMaybe<ArticleAuthorsFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type ProfessionalArticlesArgs = {
  ID?: InputMaybe<Scalars['Int']>;
};


export type ProfessionalAssociatedPagesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type ProfessionalAssociationsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type ProfessionalAwardsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<ProfessionalAwardsSortFields>;
};


export type ProfessionalBannersArgs = {
  filter?: InputMaybe<LibraryItemBannersFilters>;
  filters?: InputMaybe<LibraryItemBannersFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<LibraryItemBannersSortFields>;
};


export type ProfessionalBusinessTermsArgs = {
  filter?: InputMaybe<ProfessionalBusinessTermsFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<ProfessionalBusinessTermsSortFields>;
};


export type ProfessionalBusinessTypesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<BusinessTypesSortFields>;
};


export type ProfessionalCalendarSessionsArgs = {
  filter?: InputMaybe<CalendarSessionsFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<CalendarSessionsSortFields>;
};


export type ProfessionalCloneTasksArgs = {
  Status?: InputMaybe<AsyncTaskStatus>;
  TaskID?: InputMaybe<Scalars['Int']>;
};


export type ProfessionalCompaniesArgs = {
  filter?: InputMaybe<ProfessionalCompaniesFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<ProfessionalCompaniesSortFields>;
};


export type ProfessionalContactsArgs = {
  filter?: InputMaybe<ProfessionalContactsFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<ProfessionalContactsSortFields>;
};


export type ProfessionalContentStatusDateArgs = {
  format?: InputMaybe<DateFormatEnum>;
};


export type ProfessionalCreatedDateArgs = {
  format?: InputMaybe<DateFormatEnum>;
};


export type ProfessionalEmailTemplatesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type ProfessionalEmbeddedReportArgs = {
  reportCategory: ReportCategory;
};


export type ProfessionalFeaturedProductThumbsArgs = {
  Limit?: InputMaybe<Scalars['Int']>;
};


export type ProfessionalFeaturedProjectThumbsArgs = {
  Limit?: InputMaybe<Scalars['Int']>;
};


export type ProfessionalFirstPublishedDateArgs = {
  format?: InputMaybe<DateFormatEnum>;
};


export type ProfessionalGoogleAnalyticsArgs = {
  DateRange: BmDateRange;
};


export type ProfessionalImagesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type ProfessionalLibraryImagesArgs = {
  Limit?: InputMaybe<Scalars['Int']>;
};


export type ProfessionalLibraryLocationsArgs = {
  showHidden?: InputMaybe<Scalars['Boolean']>;
};


export type ProfessionalNetworksArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Professional_NetworksSortFields>;
};


export type ProfessionalPixelTrackerArgs = {
  DateRange?: InputMaybe<BmDateRange>;
};


export type ProfessionalProductsArgs = {
  ID?: InputMaybe<Scalars['Int']>;
};


export type ProfessionalProfessionalServicesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<ProfessionalServicesSortFields>;
};


export type ProfessionalProjectsArgs = {
  ID?: InputMaybe<Scalars['Int']>;
};


export type ProfessionalPublishDateArgs = {
  format?: InputMaybe<DateFormatEnum>;
};


export type ProfessionalQbRsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type ProfessionalSavedQuotesArgs = {
  filter?: InputMaybe<ProfessionalSavedQuotesFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<ProfessionalSavedQuotesSortFields>;
};


export type ProfessionalShippingZonesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type ProfessionalTeamMembersArgs = {
  filter?: InputMaybe<TeamMembersFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<TeamMembersSortFields>;
};


export type ProfessionalVideosArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<VideosSortFields>;
};


export type ProfessionalViewsCountArgs = {
  Range: DirectoryItemViewsCountRange;
};

export type ProfessionalAggregatedKpi = {
  __typename?: 'ProfessionalAggregatedKPI';
  ID: Scalars['Int'];
  LibraryItemsCount: Scalars['Int'];
  ProfessionalID: Scalars['Int'];
  TotalEnquiries: Scalars['Int'];
  TotalImpressions: Scalars['Int'];
  TotalPageViews: Scalars['Int'];
  TotalReferrals: Scalars['Int'];
  TotalSaves: Scalars['Int'];
  TotalTimeSpent: Scalars['Int'];
};

export type ProfessionalAttendee = {
  __typename?: 'ProfessionalAttendee';
  ID: Scalars['ID'];
  Link?: Maybe<Scalars['String']>;
  Logo?: Maybe<LibraryImageFile>;
  Professional?: Maybe<Professional>;
  Title?: Maybe<Scalars['String']>;
};

export type ProfessionalAttendeeModule = ModuleType & {
  __typename?: 'ProfessionalAttendeeModule';
  AnchorTag?: Maybe<Scalars['String']>;
  /** List of professional attendees */
  Attendees: Attendees_Connection;
  ExtraClass?: Maybe<Scalars['String']>;
  HideSponsorText: Scalars['Boolean'];
  ID: Scalars['ID'];
  NavigationLabel?: Maybe<Scalars['String']>;
  SpacingBelow?: Maybe<Scalars['String']>;
  SpacingBelowMobile?: Maybe<Scalars['String']>;
  SponsorImage?: Maybe<LibraryImageFile>;
  ThemeColour: ThemedElementColourType;
  Title?: Maybe<Scalars['String']>;
};


export type ProfessionalAttendeeModuleAttendeesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Attendees_SortFields>;
};

export type ProfessionalAwardBadgeDeleteResultType = Award | NotAuthorizedError | NotFoundError;

export type ProfessionalAwardMutationCreateResultType = Award | NotAuthorizedError | NotFoundError;

export type ProfessionalAwardMutationDeleteResultType = Award | NotAuthorizedError | NotFoundError;

export type ProfessionalAwardMutationUpdateResultType = Award | NotAuthorizedError | NotFoundError;

export type ProfessionalAwardsConnection = {
  __typename?: 'ProfessionalAwardsConnection';
  edges: Array<ProfessionalAwardsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ProfessionalAwardsConnectionEdge = {
  __typename?: 'ProfessionalAwardsConnectionEdge';
  /** The node at the end of the collections edge */
  node: Award;
};

export type ProfessionalAwardsSortFields = {
  Created?: InputMaybe<SortDirection>;
  MemberSortOrder?: InputMaybe<SortDirection>;
  SortOrder?: InputMaybe<SortDirection>;
  YearAwarded?: InputMaybe<SortDirection>;
};

export type ProfessionalBacklink = {
  __typename?: 'ProfessionalBacklink';
  Created?: Maybe<Scalars['String']>;
  ID?: Maybe<Scalars['Int']>;
  LastEdited?: Maybe<Scalars['String']>;
  Links: Array<ProfessionalBacklinks>;
};

export type ProfessionalBacklinks = {
  __typename?: 'ProfessionalBacklinks';
  backlinks_num: Scalars['Int'];
  category: Scalars['String'];
  country: Scalars['String'];
  domain: Scalars['String'];
  domain_ascore: Scalars['Int'];
  first_seen: Scalars['Int'];
  ip: Scalars['String'];
  is_follow: Scalars['Boolean'];
  last_seen: Scalars['Int'];
  lost: Scalars['Boolean'];
  new: Scalars['Boolean'];
};

export type ProfessionalBusinessTermsConnection = {
  __typename?: 'ProfessionalBusinessTermsConnection';
  edges: Array<ProfessionalBusinessTermsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ProfessionalBusinessTermsConnectionEdge = {
  __typename?: 'ProfessionalBusinessTermsConnectionEdge';
  /** The node at the end of the collections edge */
  node: BusinessTerms;
};

export type ProfessionalBusinessTermsFilters = {
  /** filter by category ID */
  CategoryID__eq?: InputMaybe<Scalars['Int']>;
  /** filter by country code(s) */
  CountriesCode__in?: InputMaybe<Array<Scalars['String']>>;
  /** filter by business terms title */
  Title__partial_match?: InputMaybe<Scalars['String']>;
};

export type ProfessionalBusinessTermsSortFields = {
  Created?: InputMaybe<SortDirection>;
  ID?: InputMaybe<SortDirection>;
  Title?: InputMaybe<SortDirection>;
};

export type ProfessionalCategory = ICategory & IHasItems & {
  __typename?: 'ProfessionalCategory';
  Categories: ProfessionalCategory_CategoriesConnection;
  CustomSeoOnFilters?: Maybe<Scalars['Boolean']>;
  ID: Scalars['Int'];
  /** Clear cut Image */
  Image?: Maybe<ResponsiveImage>;
  IsPublished?: Maybe<Scalars['Boolean']>;
  /** Items count for the given zone */
  ItemsCount: Scalars['Int'];
  Link: Scalars['String'];
  Locations: Array<ProfessionalLocation>;
  MenuTitle: Scalars['String'];
  Parent?: Maybe<ProfessionalCategory>;
  Parents: ProfessionalCategory_ParentsConnection;
  PrettyTitle: Scalars['String'];
  Professionals: ProfessionalCategory_ProfessionalsConnection;
  /** Clear cut Image */
  Thumbnail?: Maybe<ResponsiveImage>;
  Title: Scalars['String'];
  URLSegment?: Maybe<Scalars['String']>;
};


export type ProfessionalCategoryCategoriesArgs = {
  filter?: InputMaybe<ProfessionalCategory_CategoriesFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<ProfessionalCategory_CategoriesSortFields>;
};


export type ProfessionalCategoryImageArgs = {
  Height?: InputMaybe<Scalars['Int']>;
  Width?: InputMaybe<Scalars['Int']>;
};


export type ProfessionalCategoryItemsCountArgs = {
  Zone?: InputMaybe<SupportedCountry>;
};


export type ProfessionalCategoryParentsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type ProfessionalCategoryProfessionalsArgs = {
  filter?: InputMaybe<ProfessionalCategory_ProfessionalsFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<ProfessionalCategory_ProfessionalsSortFields>;
};


export type ProfessionalCategoryThumbnailArgs = {
  Height?: InputMaybe<Scalars['Int']>;
  Width?: InputMaybe<Scalars['Int']>;
};

export type ProfessionalCategory_CategoriesConnection = {
  __typename?: 'ProfessionalCategory_CategoriesConnection';
  edges: Array<ProfessionalCategory_CategoriesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ProfessionalCategory_CategoriesConnectionEdge = {
  __typename?: 'ProfessionalCategory_CategoriesConnectionEdge';
  /** The node at the end of the collections edge */
  node: ProfessionalCategory;
};

export type ProfessionalCategory_CategoriesFilters = {
  /** Filter categories that have or don`t have items */
  HasItems?: InputMaybe<Scalars['Boolean']>;
};

export type ProfessionalCategory_CategoriesSortFields = {
  Title?: InputMaybe<SortDirection>;
};

export type ProfessionalCategory_ParentsConnection = {
  __typename?: 'ProfessionalCategory_ParentsConnection';
  edges: Array<ProfessionalCategory_ParentsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ProfessionalCategory_ParentsConnectionEdge = {
  __typename?: 'ProfessionalCategory_ParentsConnectionEdge';
  /** The node at the end of the collections edge */
  node: ProfessionalCategory;
};

export type ProfessionalCategory_ProfessionalsConnection = {
  __typename?: 'ProfessionalCategory_ProfessionalsConnection';
  edges: Array<ProfessionalCategory_ProfessionalsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ProfessionalCategory_ProfessionalsConnectionEdge = {
  __typename?: 'ProfessionalCategory_ProfessionalsConnectionEdge';
  /** The node at the end of the collections edge */
  node: Professional;
};

export type ProfessionalCategory_ProfessionalsFilters = {
  /** Filters this type when CountryCode is in the provided value */
  CountryCode__in?: InputMaybe<Array<SupportedCountry>>;
  /** Filter categories that have or don`t have items */
  HasItems?: InputMaybe<Scalars['Boolean']>;
  /** Filter by ID */
  ID__in?: InputMaybe<Array<Scalars['Int']>>;
  /** Filters this type when Visibility is find_in the provided value */
  Visibility__find_in?: InputMaybe<Scalars['String']>;
};

export type ProfessionalCategory_ProfessionalsSortFields = {
  Created?: InputMaybe<SortDirection>;
  LastEdited?: InputMaybe<SortDirection>;
  Popularity?: InputMaybe<SortDirection>;
  SortOrder?: InputMaybe<SortDirection>;
};

export type ProfessionalCompaniesConnection = {
  __typename?: 'ProfessionalCompaniesConnection';
  edges: Array<ProfessionalCompaniesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ProfessionalCompaniesConnectionEdge = {
  __typename?: 'ProfessionalCompaniesConnectionEdge';
  /** The node at the end of the collections edge */
  node: Company;
};

export type ProfessionalCompaniesFilters = {
  /** Filters this type when Contacts is is_empty the provided value */
  Contacts__is_empty?: InputMaybe<Scalars['Boolean']>;
  NameStartsWith?: InputMaybe<Scalars['String']>;
  /** Filters this type when Name is not_eq the provided value */
  Name__not_eq?: InputMaybe<Scalars['String']>;
  WebsiteContains?: InputMaybe<Scalars['String']>;
};

export type ProfessionalCompaniesSortFields = {
  Created?: InputMaybe<SortDirection>;
  ID?: InputMaybe<SortDirection>;
  Name?: InputMaybe<SortDirection>;
};

export type ProfessionalContactsConnection = {
  __typename?: 'ProfessionalContactsConnection';
  edges: Array<ProfessionalContactsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ProfessionalContactsConnectionEdge = {
  __typename?: 'ProfessionalContactsConnectionEdge';
  /** The node at the end of the collections edge */
  node: Contact;
};

export type ProfessionalContactsFilters = {
  EmailContains?: InputMaybe<Scalars['String']>;
  NameStartsWith?: InputMaybe<Scalars['String']>;
};

export type ProfessionalContactsSortFields = {
  Created?: InputMaybe<SortDirection>;
  FirstName?: InputMaybe<SortDirection>;
  ID?: InputMaybe<SortDirection>;
  Surname?: InputMaybe<SortDirection>;
};

export type ProfessionalEmailAssets = {
  __typename?: 'ProfessionalEmailAssets';
  Items: Array<LibraryImage>;
};

export type ProfessionalEmailTemplatesConnection = {
  __typename?: 'ProfessionalEmailTemplatesConnection';
  edges: Array<ProfessionalEmailTemplatesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ProfessionalEmailTemplatesConnectionEdge = {
  __typename?: 'ProfessionalEmailTemplatesConnectionEdge';
  /** The node at the end of the collections edge */
  node: EmailTemplate;
};

export type ProfessionalLocation = {
  __typename?: 'ProfessionalLocation';
  ID?: Maybe<Scalars['ID']>;
  Link?: Maybe<Scalars['String']>;
  Title?: Maybe<Scalars['String']>;
};

export type ProfessionalMembersModule = ModuleType & {
  __typename?: 'ProfessionalMembersModule';
  AnchorTag?: Maybe<Scalars['String']>;
  ExtraClass?: Maybe<Scalars['String']>;
  ID: Scalars['ID'];
  NavigationLabel?: Maybe<Scalars['String']>;
  Orientation: Scalars['String'];
  SlimImageColumn: Scalars['Boolean'];
  SpacingBelow?: Maybe<Scalars['String']>;
  SpacingBelowMobile?: Maybe<Scalars['String']>;
  TeamMembers: Module_TeamMembersConnection;
  TextContent?: Maybe<TextCarouselItem>;
  ThemeColour: ThemedElementColourType;
};


export type ProfessionalMembersModuleTeamMembersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Module_TeamMembersSortFields>;
};

export type ProfessionalMetaData = {
  __typename?: 'ProfessionalMetaData';
  AverageArticleScore: Scalars['Float'];
  AverageProjectScore: Scalars['Float'];
  AverageScore: Scalars['Float'];
  Draft: Scalars['Int'];
  GetFirstItem?: Maybe<DirectoryItem>;
  GetItemsCount: Scalars['Int'];
  Live: Scalars['Int'];
  Pending: Scalars['Int'];
  RequireAttention: Scalars['Int'];
};


export type ProfessionalMetaDataGetFirstItemArgs = {
  isLowScore?: InputMaybe<Scalars['Boolean']>;
  itemType: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  threshold?: InputMaybe<Scalars['Float']>;
};


export type ProfessionalMetaDataGetItemsCountArgs = {
  isLowScore?: InputMaybe<Scalars['Boolean']>;
  itemType: Scalars['String'];
  status?: InputMaybe<Scalars['String']>;
  threshold?: InputMaybe<Scalars['Float']>;
  withDisableItems?: InputMaybe<Scalars['Boolean']>;
};

export enum ProfessionalNoticePeriodUnitEnum {
  Days = 'Days',
  Months = 'Months',
  Weeks = 'Weeks',
  Years = 'Years'
}

export type ProfessionalPin = {
  __typename?: 'ProfessionalPin';
  BoardID: Scalars['Int'];
  BoardURLSegment: Scalars['String'];
  CanDelete: Scalars['Boolean'];
  Comments?: Maybe<Array<Maybe<Comment>>>;
  CommentsCount: Scalars['Int'];
  CreatedBy?: Maybe<Member>;
  HasUnreadComments: Scalars['Boolean'];
  ID: Scalars['Int'];
  LibraryImageID?: Maybe<Scalars['Int']>;
  LibraryThumb?: Maybe<LibraryThumb>;
  Link?: Maybe<Scalars['String']>;
  LogoBackgroundColor?: Maybe<Scalars['String']>;
  PageType?: Maybe<Scalars['String']>;
  PageTypeID?: Maybe<Scalars['Int']>;
  Permission: PinPermission;
  PhotoModal?: Maybe<Scalars['String']>;
  PhotoTile?: Maybe<Scalars['String']>;
  ProfessionalID?: Maybe<Scalars['Int']>;
  ProfessionalLink?: Maybe<Scalars['String']>;
  ProfessionalTitle?: Maybe<Scalars['String']>;
  ProfessionalWebsite?: Maybe<Scalars['String']>;
  Services?: Maybe<Array<Maybe<Scalars['String']>>>;
  SubTitle: Scalars['String'];
  Title?: Maybe<Scalars['String']>;
  Type?: Maybe<Scalars['String']>;
};

/** Status of a professional's pixel tracker conversion */
export type ProfessionalPixelTrackerConversionStatus = {
  __typename?: 'ProfessionalPixelTrackerConversionStatus';
  Archived: Scalars['Boolean'];
  Created: Scalars['String'];
  Deleted: Scalars['Boolean'];
  EventCount: Scalars['Int'];
  ID: Scalars['ID'];
  PixelTrackerConversionConfig: PixelTrackerConversionConfig;
  Professional: Professional;
};

export type ProfessionalPixelTrackerConversionStatus_Connection = {
  __typename?: 'ProfessionalPixelTrackerConversionStatus_Connection';
  ID: Scalars['ID'];
  nodes: Array<ProfessionalPixelTrackerConversionStatus>;
  pageInfo: ApPageInfo;
};

export type ProfessionalPriceRange = {
  __typename?: 'ProfessionalPriceRange';
  ID: Scalars['Int'];
  SortOrder: Scalars['Int'];
  Title: Scalars['String'];
};

export enum ProfessionalProjectsTypeEnum {
  All = 'ALL',
  OurProjects = 'OUR_PROJECTS',
  TaggedIn = 'TAGGED_IN'
}

export type ProfessionalQbRsConnection = {
  __typename?: 'ProfessionalQBRsConnection';
  edges: Array<ProfessionalQbRsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ProfessionalQbRsConnectionEdge = {
  __typename?: 'ProfessionalQBRsConnectionEdge';
  /** The node at the end of the collections edge */
  node: Qbr;
};

export type ProfessionalSavedQuotesConnection = {
  __typename?: 'ProfessionalSavedQuotesConnection';
  edges: Array<ProfessionalSavedQuotesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ProfessionalSavedQuotesConnectionEdge = {
  __typename?: 'ProfessionalSavedQuotesConnectionEdge';
  /** The node at the end of the collections edge */
  node: QuoteContent;
};

export type ProfessionalSavedQuotesFilters = {
  /** quote content is a template */
  IsTemplate__eq?: InputMaybe<Scalars['Boolean']>;
  /** acceped quotes */
  QuoteAccepted__eq?: InputMaybe<Scalars['Boolean']>;
  /** filter by invoice statuses */
  Status__in?: InputMaybe<Array<InvoiceStatusEnum>>;
  /** filter by quote content title */
  Title__partial_match?: InputMaybe<Scalars['String']>;
};

export type ProfessionalSavedQuotesSortFields = {
  ID?: InputMaybe<SortDirection>;
  IsTemplate?: InputMaybe<SortDirection>;
  LastEdited?: InputMaybe<SortDirection>;
};

export type ProfessionalService = SortableItem & {
  __typename?: 'ProfessionalService';
  CategoryPageID: Scalars['Int'];
  ID: Scalars['Int'];
  MemberSortOrder: Scalars['Int'];
  ProfessionalID: Scalars['Int'];
  ServiceName: Scalars['String'];
};

export type ProfessionalServiceArea = SortableItem & {
  __typename?: 'ProfessionalServiceArea';
  AddressID?: Maybe<Scalars['String']>;
  City?: Maybe<Scalars['String']>;
  Country?: Maybe<Scalars['String']>;
  District?: Maybe<Scalars['String']>;
  Division?: Maybe<Scalars['String']>;
  FullAddress?: Maybe<Scalars['String']>;
  ID: Scalars['Int'];
  Latitude: Scalars['Float'];
  Longitude: Scalars['Float'];
  MemberSortOrder: Scalars['Int'];
  PlaceName?: Maybe<Scalars['String']>;
  PlaceType: FindPlaceTypeEnum;
  PostCode?: Maybe<Scalars['String']>;
  Region?: Maybe<Scalars['String']>;
  RegionType: Region;
  ServiceableAreaID?: Maybe<Scalars['Int']>;
  State?: Maybe<Scalars['String']>;
  Suburb?: Maybe<Scalars['String']>;
  ZoomLevel?: Maybe<Scalars['Int']>;
};

export type ProfessionalServicesConnection = {
  __typename?: 'ProfessionalServicesConnection';
  edges: Array<ProfessionalServicesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ProfessionalServicesConnectionEdge = {
  __typename?: 'ProfessionalServicesConnectionEdge';
  /** The node at the end of the collections edge */
  node: ProfessionalService;
};

export type ProfessionalServicesSortFields = {
  ID?: InputMaybe<SortDirection>;
  MemberSortOrder?: InputMaybe<SortDirection>;
  SortOrder?: InputMaybe<SortDirection>;
};

export enum ProfessionalTargetMarketType {
  Both = 'Both',
  Commercial = 'Commercial',
  Residential = 'Residential'
}

export enum ProfessionalVisibility {
  Disabled = 'Disabled',
  InLibrary = 'InLibrary',
  InSearch = 'InSearch',
  ProfileOnly = 'ProfileOnly'
}

export type Professional_AssociatedPagesConnection = {
  __typename?: 'Professional_AssociatedPagesConnection';
  edges: Array<Professional_AssociatedPagesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type Professional_AssociatedPagesConnectionEdge = {
  __typename?: 'Professional_AssociatedPagesConnectionEdge';
  /** The node at the end of the collections edge */
  node: AssociatedPage;
};

export type Professional_NetworksConnection = {
  __typename?: 'Professional_NetworksConnection';
  edges: Array<Professional_NetworksConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type Professional_NetworksConnectionEdge = {
  __typename?: 'Professional_NetworksConnectionEdge';
  /** The node at the end of the collections edge */
  node: Network;
};

export type Professional_NetworksSortFields = {
  ID?: InputMaybe<SortDirection>;
};

export type ProfessionalsByKeywordOrTeamMemberNameSimpleSortFields = {
  ID?: InputMaybe<SortDirection>;
  Title?: InputMaybe<SortDirection>;
};

export type ProfessionalsLocation = {
  __typename?: 'ProfessionalsLocation';
  City?: Maybe<Scalars['String']>;
  Country?: Maybe<Scalars['String']>;
  District?: Maybe<Scalars['String']>;
  FullAddress?: Maybe<Scalars['String']>;
  ID?: Maybe<Scalars['ID']>;
  Latitude?: Maybe<Scalars['String']>;
  Longitude?: Maybe<Scalars['String']>;
  PlaceName?: Maybe<Scalars['String']>;
  PlaceShortName?: Maybe<Scalars['String']>;
  PlaceType?: Maybe<Scalars['String']>;
  PostCode?: Maybe<Scalars['String']>;
  Region?: Maybe<Scalars['String']>;
  Slug?: Maybe<Scalars['String']>;
  State?: Maybe<Scalars['String']>;
  Suburb?: Maybe<Scalars['String']>;
};

export type ProfileCampaignsOverTimeFilters = {
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type ProfileConversionBreakdownFilters = {
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
  INDUSTRY_CATEGORY__EQUAL?: InputMaybe<Scalars['String']>;
};

export type ProfileConversionTypesFilters = {
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type ProfileImpressionSourcesFilters = {
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
  INDUSTRY_CATEGORY__EQUAL?: InputMaybe<Scalars['String']>;
};

export type ProfileIndustriesFilters = {
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type ProfilePageNamesFilters = {
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type ProfilePageTypeBreakdownFilters = {
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
  INDUSTRY_CATEGORY__EQUAL?: InputMaybe<Scalars['String']>;
};

export type ProfilePageTypesFilters = {
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type ProfilePagesSummary = {
  __typename?: 'ProfilePagesSummary';
  ClickThroughRate: Scalars['Float'];
  Clicks: Scalars['Int'];
  ID: Scalars['String'];
  Impressions: Scalars['Int'];
  TotalEngagements: Scalars['Int'];
  TotalTimeSpent: Scalars['String'];
};

export type ProfileStatsFilters = {
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type ProfileStatsOverTimeFilters = {
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type ProfileTopPagesFilters = {
  CONVERSION_TYPE__IN?: InputMaybe<Array<Scalars['String']>>;
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
  INDUSTRY_CATEGORY__IN?: InputMaybe<Array<Scalars['String']>>;
  LIBRARY_ITEM_TYPE__IN?: InputMaybe<Array<Scalars['String']>>;
  TITLE__IN?: InputMaybe<Array<Scalars['String']>>;
};

export type ProfileTopPagesSort = {
  AVG_TIME_ON_PAGE?: InputMaybe<PrioritySort>;
  CONVERSIONS?: InputMaybe<PrioritySort>;
  CONVERSION_RATE?: InputMaybe<PrioritySort>;
  IMPRESSIONS?: InputMaybe<PrioritySort>;
  PAGE?: InputMaybe<PrioritySort>;
  PAGE_VIEWS?: InputMaybe<PrioritySort>;
  TYPE?: InputMaybe<PrioritySort>;
};

export type ProfileTrafficSourcesFilters = {
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
  INDUSTRY_CATEGORY__EQUAL?: InputMaybe<Scalars['String']>;
};

export type Project = ContentBuilder & DesignBoardPinTarget & DirectoryItem & HasPaintPartner & IApprovable & ICreatable & IFileCategory & IHasProfessional & IHomePinable & IPublishable & IRecentlyViewedTile & Node & SortableItem & {
  __typename?: 'Project';
  /** Has this page been reviewed and approved by the ArchiPro Content Team? */
  Activated?: Maybe<Scalars['Boolean']>;
  ApprovedByMember?: Maybe<Member>;
  ApprovedDate?: Maybe<Scalars['String']>;
  AssociatedPages: Project_AssociatedPagesConnection;
  AvailabilityZones: Array<Zone>;
  Awards: ProjectAwardsConnection;
  BannerImages: Array<LibraryImage>;
  Banners: LibraryItemBannersConnection;
  BuildingStyle?: Maybe<ProjectBuildingStyleEnum>;
  Categories: Array<Category>;
  ClassName: Scalars['String'];
  Client?: Maybe<Scalars['String']>;
  Clones?: Maybe<Array<DirectoryItem>>;
  Content?: Maybe<Scalars['String']>;
  ContentArea: ContentArea;
  ContentBuilderType: ContentBuilderTypeEnum;
  ContentComment?: Maybe<Scalars['String']>;
  ContentRejectReasons: Array<ContentRejectReasonEnum>;
  ContentStatus?: Maybe<ContentStatusEnum>;
  ContentStatusBy?: Maybe<Member>;
  ContentStatusDate?: Maybe<Scalars['String']>;
  CreatedByMember?: Maybe<Member>;
  CreatedDate?: Maybe<Scalars['String']>;
  CreatedTimestamp: Scalars['Int'];
  DataQualityRating: Scalars['Float'];
  DesignBoardsForCurrentUser?: Maybe<Array<Maybe<DesignBoard>>>;
  Disable: Scalars['Boolean'];
  EmbeddedData?: Maybe<Scalars['String']>;
  Embeddings?: Maybe<Scalars['String']>;
  FacebookPreviewImage?: Maybe<Scalars['String']>;
  FeaturedProducts: ProductsUsedInProjectConnection;
  FeaturedProfessionals: FeaturedProfessionalsConnection;
  FeaturedProjects: FeaturedProjectsConnection;
  FileCategories: FileCategoriesConnection;
  FirstPublishedDate?: Maybe<Scalars['String']>;
  HasClones: Scalars['Boolean'];
  HasDownloads: Scalars['Boolean'];
  HasPhotos: Scalars['Boolean'];
  HasProducts: Scalars['Boolean'];
  HasProjects: Scalars['Boolean'];
  HasRelatedProjects: Scalars['Boolean'];
  HasTags: Scalars['Boolean'];
  HasVideos: Scalars['Boolean'];
  HomePinned: Scalars['Boolean'];
  ID: Scalars['Int'];
  Images: LibraryItemImagesConnection;
  InLibrary?: Maybe<Scalars['Boolean']>;
  IsCloned: Scalars['Boolean'];
  /** Has this page been reviewed and approved by the client? */
  IsDraft: Scalars['Boolean'];
  IsFeature: Scalars['Boolean'];
  IsFeatured: Scalars['Boolean'];
  /** True if published and activated */
  IsLive: Scalars['Boolean'];
  IsManufacturer: Scalars['Boolean'];
  IsProjectOfTheMonth: Scalars['Boolean'];
  IsTemplate: Scalars['Boolean'];
  KPI?: Maybe<LibraryItemKpi>;
  LastEdited?: Maybe<Scalars['String']>;
  LastEditedDate?: Maybe<Scalars['String']>;
  LastEditedTimestamp: Scalars['Int'];
  LibraryDownloads: Array<LibraryDownload>;
  LibraryImages: Array<LibraryImage>;
  LibraryLocations: Array<LibraryLocation>;
  LibraryRange?: Maybe<LibraryRange>;
  LibraryTabs: Array<LibraryTab>;
  LibraryThumb?: Maybe<LibraryThumb>;
  LibraryVideos: Array<LibraryVideo>;
  Link: Scalars['String'];
  LiveDateTimestamp?: Maybe<Scalars['Int']>;
  Location?: Maybe<LibraryLocation>;
  MemberSortOrder: Scalars['Int'];
  Meta?: Maybe<Meta>;
  Networks: Project_NetworksConnection;
  PageMeta?: Maybe<DirectoryPageMeta>;
  PageType: Scalars['String'];
  PaintPartner?: Maybe<PaintPartner>;
  ParentID: Scalars['Int'];
  Photographers?: Maybe<Array<Professional>>;
  /** Same as Categories but with a different return type PrimaryCategory */
  PrimaryCategories: Array<CategoryPage>;
  PrimaryCategory?: Maybe<CategoryPage>;
  ProductsUsed: Array<Product>;
  Professional?: Maybe<Professional>;
  ProfessionalsUsed?: Maybe<Array<Professional>>;
  ProjectHeroTitle?: Maybe<Scalars['String']>;
  ProjectPriceRange?: Maybe<ProjectPriceRange>;
  PublicKPI?: Maybe<LibraryItemPublicKpi>;
  /** Has this page been reviewed and approved by the client? */
  Publish: Scalars['Boolean'];
  PublishDate?: Maybe<Scalars['String']>;
  PublishedByMember?: Maybe<Member>;
  RawTileImage?: Maybe<Scalars['String']>;
  RecentlyViewedImage?: Maybe<RecentlyViewedImage>;
  Recommendations?: Maybe<Array<Maybe<DirectoryItem>>>;
  Region?: Maybe<Region>;
  Review?: Maybe<PageReview>;
  /** Actions that need addressing before this page can be approved */
  ReviewActions?: Maybe<Array<Maybe<ReviewAction>>>;
  SampleAddressPlaceholder?: Maybe<Scalars['String']>;
  SampleMessagePlaceholder?: Maybe<Scalars['String']>;
  SampleSubmitText?: Maybe<Scalars['String']>;
  SampleText?: Maybe<Scalars['String']>;
  SampleTitle?: Maybe<Scalars['String']>;
  SamplesAddressRequired: Scalars['Boolean'];
  SamplesAvailable: Scalars['Boolean'];
  SearchTags?: Maybe<Array<Maybe<SearchTag>>>;
  SelfPublished: Scalars['Boolean'];
  ShowsInElasticSearch: Scalars['Boolean'];
  SortOrder: Scalars['Int'];
  Subheading?: Maybe<Scalars['String']>;
  /** JSON array of team member IDs in custom order */
  TeamMemberOrder?: Maybe<Scalars['String']>;
  Teaser?: Maybe<Scalars['String']>;
  ThumbnailFile?: Maybe<LibraryImageFile>;
  Title: Scalars['String'];
  TopBanner?: Maybe<LibraryItemBanner>;
  TotalSavedCount: Scalars['Int'];
  TotalViewedCount: Scalars['Int'];
  URLSegment: Scalars['String'];
  ViewsCount: Scalars['Int'];
  Visibilities?: Maybe<Array<ProjectVisibility>>;
  Website?: Maybe<Scalars['String']>;
  WebsiteShort?: Maybe<Scalars['String']>;
  WebsiteUntracked: Scalars['String'];
  YearOfCompletion?: Maybe<Scalars['Int']>;
  deprecated_Awards?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  libraryImageMarkerCount: LibraryImageMarkerCount;
};


export type ProjectApprovedDateArgs = {
  format?: InputMaybe<DateFormatEnum>;
};


export type ProjectAssociatedPagesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type ProjectAwardsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type ProjectBannersArgs = {
  filter?: InputMaybe<LibraryItemBannersFilters>;
  filters?: InputMaybe<LibraryItemBannersFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<LibraryItemBannersSortFields>;
};


export type ProjectContentStatusDateArgs = {
  format?: InputMaybe<DateFormatEnum>;
};


export type ProjectCreatedDateArgs = {
  format?: InputMaybe<DateFormatEnum>;
};


export type ProjectFeaturedProductsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type ProjectFeaturedProfessionalsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type ProjectFeaturedProjectsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type ProjectFileCategoriesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<FileCategoriesSortFields>;
};


export type ProjectFirstPublishedDateArgs = {
  format?: InputMaybe<DateFormatEnum>;
};


export type ProjectImagesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type ProjectLibraryImagesArgs = {
  Limit?: InputMaybe<Scalars['Int']>;
};


export type ProjectLibraryLocationsArgs = {
  showHidden?: InputMaybe<Scalars['Boolean']>;
};


export type ProjectNetworksArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Project_NetworksSortFields>;
};


export type ProjectProductsUsedArgs = {
  ProfileProduct?: InputMaybe<Scalars['Boolean']>;
};


export type ProjectPublishDateArgs = {
  format?: InputMaybe<DateFormatEnum>;
};


export type ProjectViewsCountArgs = {
  Range: DirectoryItemViewsCountRange;
};

export type ProjectAward = {
  InstitutionTitle: Scalars['String'];
  Title: Scalars['String'];
  YearAwarded: Scalars['String'];
};

export type ProjectAwardsConnection = {
  __typename?: 'ProjectAwardsConnection';
  edges: Array<ProjectAwardsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ProjectAwardsConnectionEdge = {
  __typename?: 'ProjectAwardsConnectionEdge';
  /** The node at the end of the collections edge */
  node: Award;
};

export enum ProjectBuildingStyleEnum {
  ArtDeco = 'Art_Deco',
  Bauhaus = 'Bauhaus',
  Cabin = 'Cabin',
  Classic = 'Classic',
  Colonial = 'Colonial',
  Contemporary = 'Contemporary',
  Cottage = 'Cottage',
  Deconstructive = 'Deconstructive',
  Farmhouse = 'Farmhouse',
  Industrial = 'Industrial',
  Mediterranean = 'Mediterranean',
  Modern = 'Modern',
  Passive = 'Passive',
  Ranch = 'Ranch',
  SmallHome = 'Small_home',
  Terrace = 'Terrace'
}

export type ProjectCategory = ICategory & IHasItems & {
  __typename?: 'ProjectCategory';
  Categories: ProjectCategory_CategoriesConnection;
  CustomSeoOnFilters?: Maybe<Scalars['Boolean']>;
  ID: Scalars['Int'];
  Image?: Maybe<ResponsiveImage>;
  IsPublished?: Maybe<Scalars['Boolean']>;
  ItemsCount: Scalars['Int'];
  Link: Scalars['String'];
  MenuTitle: Scalars['String'];
  Parent?: Maybe<ProjectCategory>;
  Parents: ProjectCategory_ParentsConnection;
  PrettyTitle: Scalars['String'];
  Projects: ProjectCategory_ProjectsConnection;
  Thumbnail?: Maybe<ResponsiveImage>;
  Title: Scalars['String'];
  URLSegment?: Maybe<Scalars['String']>;
};


export type ProjectCategoryCategoriesArgs = {
  filter?: InputMaybe<ProjectCategory_CategoriesFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<ProjectCategory_CategoriesSortFields>;
};


export type ProjectCategoryImageArgs = {
  Height?: InputMaybe<Scalars['Int']>;
  Width?: InputMaybe<Scalars['Int']>;
};


export type ProjectCategoryItemsCountArgs = {
  Zone?: InputMaybe<SupportedCountry>;
};


export type ProjectCategoryParentsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type ProjectCategoryProjectsArgs = {
  filter?: InputMaybe<ProjectCategory_ProjectsFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<ProjectCategory_ProjectsSortFields>;
};


export type ProjectCategoryThumbnailArgs = {
  Height?: InputMaybe<Scalars['Int']>;
  Width?: InputMaybe<Scalars['Int']>;
};

export type ProjectCategory_CategoriesConnection = {
  __typename?: 'ProjectCategory_CategoriesConnection';
  edges: Array<ProjectCategory_CategoriesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ProjectCategory_CategoriesConnectionEdge = {
  __typename?: 'ProjectCategory_CategoriesConnectionEdge';
  /** The node at the end of the collections edge */
  node: ProjectCategory;
};

export type ProjectCategory_CategoriesFilters = {
  /** Filter categories that have or don`t have items */
  HasItems?: InputMaybe<Scalars['Boolean']>;
};

export type ProjectCategory_CategoriesSortFields = {
  Title?: InputMaybe<SortDirection>;
};

export type ProjectCategory_ParentsConnection = {
  __typename?: 'ProjectCategory_ParentsConnection';
  edges: Array<ProjectCategory_ParentsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ProjectCategory_ParentsConnectionEdge = {
  __typename?: 'ProjectCategory_ParentsConnectionEdge';
  /** The node at the end of the collections edge */
  node: ProjectCategory;
};

export type ProjectCategory_ProjectsConnection = {
  __typename?: 'ProjectCategory_ProjectsConnection';
  edges: Array<ProjectCategory_ProjectsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ProjectCategory_ProjectsConnectionEdge = {
  __typename?: 'ProjectCategory_ProjectsConnectionEdge';
  /** The node at the end of the collections edge */
  node: Project;
};

export type ProjectCategory_ProjectsFilters = {
  /** Filters this type when CountryCode is in the provided value */
  CountryCode__in?: InputMaybe<Array<SupportedCountry>>;
  /** Filter categories that have or don`t have items */
  HasItems?: InputMaybe<Scalars['Boolean']>;
  /** Filter by ID */
  ID__in?: InputMaybe<Array<Scalars['Int']>>;
  /** Filters this type when Visibility is find_in the provided value */
  Visibility__find_in?: InputMaybe<Scalars['String']>;
};

export type ProjectCategory_ProjectsSortFields = {
  Created?: InputMaybe<SortDirection>;
  ID?: InputMaybe<SortDirection>;
  LastEdited?: InputMaybe<SortDirection>;
  Popularity?: InputMaybe<SortDirection>;
  SortOrder?: InputMaybe<SortDirection>;
};

export type ProjectFeatureBlock = {
  __typename?: 'ProjectFeatureBlock';
  CTA?: Maybe<SiteTreeLink>;
  ID: Scalars['ID'];
  Image?: Maybe<ResponsiveVariantImage>;
  Summary?: Maybe<Scalars['String']>;
  Title?: Maybe<Scalars['String']>;
};

export type ProjectFeaturesModule = ModuleType & {
  __typename?: 'ProjectFeaturesModule';
  AnchorTag?: Maybe<Scalars['String']>;
  ExtraClass?: Maybe<Scalars['String']>;
  FeatureBlocks: Module_FeatureBlocksConnection;
  ID: Scalars['ID'];
  NavigationLabel?: Maybe<Scalars['String']>;
  SpacingBelow?: Maybe<Scalars['String']>;
  SpacingBelowMobile?: Maybe<Scalars['String']>;
  ThemeColour: ThemedElementColourType;
  Title?: Maybe<Scalars['String']>;
};


export type ProjectFeaturesModuleFeatureBlocksArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Module_FeatureBlocksSortFields>;
};

export type ProjectGroup = {
  __typename?: 'ProjectGroup';
  Category: Scalars['String'];
  TeamMembers: Array<TeamMember>;
};

export type ProjectPin = {
  __typename?: 'ProjectPin';
  BoardID: Scalars['Int'];
  BoardURLSegment: Scalars['String'];
  CanDelete: Scalars['Boolean'];
  Comments?: Maybe<Array<Maybe<Comment>>>;
  CommentsCount: Scalars['Int'];
  CreatedBy?: Maybe<Member>;
  HasUnreadComments: Scalars['Boolean'];
  ID: Scalars['Int'];
  LibraryImageID?: Maybe<Scalars['Int']>;
  LibraryThumb?: Maybe<LibraryThumb>;
  Link?: Maybe<Scalars['String']>;
  PageType?: Maybe<Scalars['String']>;
  PageTypeID?: Maybe<Scalars['Int']>;
  Permission: PinPermission;
  PhotoModal?: Maybe<Scalars['String']>;
  PhotoTile?: Maybe<Scalars['String']>;
  ProfessionalID?: Maybe<Scalars['Int']>;
  ProfessionalLink?: Maybe<Scalars['String']>;
  ProfessionalTitle?: Maybe<Scalars['String']>;
  ProfessionalWebsite?: Maybe<Scalars['String']>;
  SubTitle: Scalars['String'];
  Title?: Maybe<Scalars['String']>;
  Type?: Maybe<Scalars['String']>;
};

export type ProjectPriceRange = {
  __typename?: 'ProjectPriceRange';
  ID: Scalars['Int'];
  SortOrder: Scalars['Int'];
  Title: Scalars['String'];
};

export type ProjectTeamMember = {
  __typename?: 'ProjectTeamMember';
  Category: Scalars['String'];
  ID: Scalars['ID'];
  Project: Project;
  ProjectID: Scalars['ID'];
  TeamMember: TeamMember;
  TeamMemberID: Scalars['ID'];
};

export enum ProjectVisibility {
  Disabled = 'Disabled',
  Draft = 'Draft',
  InLibrary = 'InLibrary',
  InSearch = 'InSearch',
  NotLive = 'NotLive',
  PendingApproval = 'PendingApproval',
  ProfileOnly = 'ProfileOnly'
}

export type Project_AssociatedPagesConnection = {
  __typename?: 'Project_AssociatedPagesConnection';
  edges: Array<Project_AssociatedPagesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type Project_AssociatedPagesConnectionEdge = {
  __typename?: 'Project_AssociatedPagesConnectionEdge';
  /** The node at the end of the collections edge */
  node: AssociatedPage;
};

export type Project_NetworksConnection = {
  __typename?: 'Project_NetworksConnection';
  edges: Array<Project_NetworksConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type Project_NetworksConnectionEdge = {
  __typename?: 'Project_NetworksConnectionEdge';
  /** The node at the end of the collections edge */
  node: Network;
};

export type Project_NetworksSortFields = {
  ID?: InputMaybe<SortDirection>;
};

export type ProjectsSimpleSortFields = {
  Created?: InputMaybe<SortDirection>;
  DataQualityRating?: InputMaybe<SortDirection>;
  ID?: InputMaybe<SortDirection>;
  IsFeatured?: InputMaybe<SortDirection>;
  LastEdited?: InputMaybe<SortDirection>;
  MemberSortOrder?: InputMaybe<SortDirection>;
  Title?: InputMaybe<SortDirection>;
};

export type ProjectsUsingProductConnection = {
  __typename?: 'ProjectsUsingProductConnection';
  edges: Array<ProjectsUsingProductConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ProjectsUsingProductConnectionEdge = {
  __typename?: 'ProjectsUsingProductConnectionEdge';
  /** The node at the end of the collections edge */
  node: Project;
};

export type PromotionConversionSummary = AdConversions & {
  __typename?: 'PromotionConversionSummary';
  Downloads: Scalars['Int'];
  EmailReveals: Scalars['Int'];
  Enquiries: Scalars['Int'];
  ID: Scalars['String'];
  LocationReveals: Scalars['Int'];
  PhoneReveals: Scalars['Int'];
  Referrals: Scalars['Int'];
  Saves: Scalars['Int'];
  Shares: Scalars['Int'];
  TotalPageViews: Scalars['Int'];
  TotalTime: Scalars['Int'];
  VideoPlays: Scalars['Int'];
};

export type PromotionalSpikeDetails = {
  __typename?: 'PromotionalSpikeDetails';
  Clicks: Scalars['Int'];
  DirectoryItem: DirectoryItem;
  ID: Scalars['String'];
  Impressions: Scalars['Int'];
};

export type PromotionalStat = {
  __typename?: 'PromotionalStat';
  AdStartTime?: Maybe<Scalars['String']>;
  AttentionShare?: Maybe<Scalars['Float']>;
  CampaignUTMTitle?: Maybe<Scalars['String']>;
  Clicks?: Maybe<Scalars['String']>;
  Date: Scalars['String'];
  DirectoryItem: DirectoryItem;
  ExternalCampaignID?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  Impressions: Scalars['Int'];
  Picture?: Maybe<Scalars['String']>;
  PromotionID?: Maybe<Scalars['String']>;
  PromotionLink?: Maybe<Scalars['String']>;
  Reach?: Maybe<Scalars['Int']>;
  Thumb?: Maybe<Scalars['String']>;
  Title: Scalars['String'];
  Top10?: Maybe<Scalars['String']>;
  Type: Scalars['String'];
  VideoPicture?: Maybe<Scalars['String']>;
};

export type PromotionalStats = {
  __typename?: 'PromotionalStats';
  ID: Scalars['String'];
  NewsLetter: Array<PromotionalStat>;
  SocialMedia: Array<PromotionalStat>;
};

export type Proof = {
  __typename?: 'Proof';
  FullSizeURL: Scalars['String'];
  ThumbnailURL: Scalars['String'];
};

export type PublicMember = {
  __typename?: 'PublicMember';
  FirstName: Scalars['String'];
  LastName: Scalars['String'];
  LoginOptions: Array<Maybe<Scalars['String']>>;
  ProfileImageLink?: Maybe<Scalars['String']>;
};

export type PublicUser = NotFoundError | PublicMember | UserError;

export type PublicationDetails = {
  __typename?: 'PublicationDetails';
  ConversionSummary: PromotionConversionSummary;
  DeviceTypes?: Maybe<Array<DeviceData>>;
  EmailClients?: Maybe<Array<EmailClient>>;
  HomeownerRegions: Array<GraphSegment>;
  HomeownerUsers: Array<GraphSegment>;
  HomeownerUsersCount: Scalars['Int'];
  ID: Scalars['String'];
  OpenClickRates?: Maybe<OpenClickRates>;
  PerformanceOverview: PublicationPerformanceOverview;
  ProfessionalCategories: Array<GraphSegment>;
  ProfessionalRegions: Array<GraphSegment>;
  ProfessionalUsers: Array<GraphSegment>;
  ProfessionalUsersCount: Scalars['Int'];
  PublicationSummary: PublicationSummary;
  ReaderProfessionalCategories: Array<GraphSegment>;
  ReaderRegions: Array<GraphSegment>;
  RecipientOverview: RecipientOverview;
  TimeSpent?: Maybe<TimeSpent>;
};

export type PublicationPerformanceOverview = {
  __typename?: 'PublicationPerformanceOverview';
  AttentionShare: Scalars['Float'];
  Clicks: Scalars['Int'];
  Conversions: Scalars['Int'];
  ID: Scalars['String'];
  Impressions: Scalars['Int'];
  Reach: Scalars['Int'];
};

export type PublicationRecipient = {
  __typename?: 'PublicationRecipient';
  EDMCategory?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  Opened: Scalars['Boolean'];
  Recipient: Scalars['String'];
};

export type PublicationRecipientEvent = {
  __typename?: 'PublicationRecipientEvent';
  Count: Scalars['Int'];
  EDMCategory?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  Recipient: Scalars['String'];
};

export type PublicationSummary = {
  __typename?: 'PublicationSummary';
  Date: Scalars['String'];
  DirectoryItem: DirectoryItem;
  ID: Scalars['String'];
  PromotionLink: Scalars['String'];
  Title: Scalars['String'];
  Top10: Scalars['Boolean'];
};

export type PublicationsSummary = {
  __typename?: 'PublicationsSummary';
  AttentionShare: Scalars['Float'];
  AttentionShareAvg: Scalars['Float'];
  Clicks: Scalars['Int'];
  ClicksAvg: Scalars['Int'];
  ID: Scalars['String'];
  Impressions: Scalars['Int'];
  ImpressionsAvg: Scalars['Int'];
  Reach: Scalars['Int'];
  ReachAvg: Scalars['Int'];
};

export type PushDeviceInfo = {
  AppVersion?: InputMaybe<Scalars['String']>;
  DeviceID: Scalars['String'];
  ExpoToken: Scalars['String'];
  Platform: PushDeviceType;
};

/** Device type capable of sending us an Expo push token. */
export enum PushDeviceType {
  Android = 'Android',
  Ios = 'IOS',
  Web = 'Web'
}

export type PushNotificationRecipient = {
  Email: Scalars['Email'];
};

export type Qbr = ContentBuilder & {
  __typename?: 'QBR';
  ClassName: Scalars['String'];
  ContentArea: ContentArea;
  ContentBuilderType: ContentBuilderTypeEnum;
  ID: Scalars['Int'];
  Member?: Maybe<Member>;
  Professional?: Maybe<Professional>;
  Title: Scalars['String'];
  URLSegment: Scalars['String'];
};

export type QuadImageModule = FlexibleModule & {
  __typename?: 'QuadImageModule';
  Columns: ColumnsConnection;
  ContentAreaID: Scalars['Int'];
  CreatedFromID?: Maybe<Scalars['Int']>;
  CreatedFromVersion?: Maybe<Scalars['Int']>;
  DetachedFromSavedModule?: Maybe<Scalars['Boolean']>;
  EcommerceEnabled: Scalars['Boolean'];
  ID: Scalars['Int'];
  LibraryItemID: Scalars['Int'];
  MemberSortOrder: Scalars['Int'];
  ModuleGroup?: Maybe<ModuleGroupEnum>;
  PossibleColumnDimensions: Array<ColumnDimension>;
  PresetName: Scalars['String'];
  PresetType: FlexibleModuleEnum;
  SortableColumns: Scalars['Boolean'];
  Swappable: Scalars['Boolean'];
};


export type QuadImageModuleColumnsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<ColumnsSortFields>;
};

export type Query = {
  __typename?: 'Query';
  AiCompanyDescriptionGenerate?: Maybe<Scalars['String']>;
  AiDescriptionGenerate?: Maybe<Scalars['String']>;
  AiProductDescriptionGenerate?: Maybe<Scalars['String']>;
  AiProjectDescriptionGenerate?: Maybe<Scalars['String']>;
  AirtableAdSchedule: AirtableAdScheduleModel;
  ArcherComments: Array<ArcherComment>;
  Articles: ArticlesConnection;
  Attribute: Attribute;
  Attributes: Array<Attribute>;
  BAReportDashboard?: Maybe<BaReports>;
  Countries: Countries_Connection;
  Couriers: Array<Courier>;
  /** This query is just a hack to generate types that aren't directly used in any queries */
  DO_NOT_USE_QUERY?: Maybe<Do_Not_Use_Hack>;
  DigitalPublicationFilters: YearAndMonthsTypeConnection;
  /** Container for DirectoryItems an Categories */
  Directory: Directory;
  EditorialAuthors: EditorialAuthors_Connection;
  ExistingProductCount: Scalars['Int'];
  Facet: Facet;
  Facets: Array<Facet>;
  FeaturedDirectoryItem?: Maybe<FeaturedDirectoryItem>;
  /** Retrieves the content for the homepage marketing guides section */
  HomeContentCampaign?: Maybe<HomeContentCampaign>;
  IntegratedPlatforms: Array<IntegratedPlatform>;
  IntegrationRequestFile: Scalars['String'];
  IntegrationSettings: IntegrationSettingsModelOutput;
  /** Validates a given token from the Bearer header */
  JWTTokenValidate?: Maybe<JwtTokenValidationResponse>;
  LastUpdated?: Maybe<Scalars['String']>;
  ListCombinedUnreadNotifications: CombinedUnreadNotifications;
  ListPinIdsYouOwn: Array<PagePin>;
  ListProfessionalProjects: ListProfessionalProjects_Connection;
  Localities: LocalityConnection;
  Materials: Array<Material>;
  MemberOrders: SupplierOrdersConnection;
  ModulePresets: Array<ModulePreset>;
  MonthlyTotalUsers: Scalars['Int'];
  Order: Order;
  /** Retrieves the payment intent options for the current user */
  PaymentOptions: PaymentOptions;
  PeopleContacts: Array<PeopleContactList>;
  PlaceByCoordinate: Array<PlaceDetailType>;
  PlatformConnection?: Maybe<PlatformConnection>;
  Postcode: Postcode;
  PostcodeGroups: PostcodeGroups_Connection;
  ProductAttributeOptions: Array<ProductAttributeOption>;
  ProductImprovementLatestTask?: Maybe<ProductImprovementTaskStatus>;
  ProfessionalPriceRanges: Array<ProfessionalPriceRange>;
  ProjectBuildingStyles: Array<ProjectBuildingStyleEnum>;
  ProjectPriceRanges: Array<ProjectPriceRange>;
  Projects: ListProfessionalProjects_Connection;
  PublicUser: PublicUser;
  QBRByLink?: Maybe<Qbr>;
  Regions: Array<Region>;
  SalesReportDashboard?: Maybe<SalesReports>;
  SavedModuleVersion?: Maybe<SavedModule>;
  SavedModuleVersions: Array<SavedModuleVersion>;
  SavedModules: Array<SavedModule>;
  /** Retrieves a single shipping profile */
  ShippingProfile: ShippingProfile;
  /** Retrieves a single shipping zone */
  ShippingZone: ShippingZoneResult;
  ShoppingCart: ShoppingCart;
  SupplierOrder: SupplierOrder;
  SupplierOrders: SupplierOrdersConnection;
  SyncEnquiryOAuthEmail?: Maybe<SyncEnquiryOAuthEmailType>;
  SyncStatus?: Maybe<SyncStatus>;
  TopTrendingCategories: Array<Category>;
  TrendingCategories: TrendingCategories_Connection;
  Variant: Variant;
  VariantShipping: VariantShippingsConnection;
  VerifyEmail: Scalars['Boolean'];
  VerifyURLAccessToken?: Maybe<Scalars['Boolean']>;
  WhoAmI: AuthDebugResult;
  WooCommerceLastUpdated?: Maybe<Scalars['String']>;
  WooCommerceSyncCounts?: Maybe<WooCommerceSyncCounts>;
  WooCommerceTags: Array<WooCommerceTag>;
  /** Get all available account deletion request reasons, sorted by SortOrder */
  accountDeletionRequestReasons: Array<AccountDeletionRequestReason>;
  allAvailableConversionSettings: PixelConversionSettings;
  availableInputTypes: Array<InputDataTypeInfo>;
  buildHubByLink: BuildHubResponse;
  /** gets comments targeted at a particular buildhub file. */
  buildHubFileComments: Array<BuildHubComment>;
  /** Get the stage configuration for all project types and scopes */
  buildHubStageConfig: BuildHubStageConfiguration;
  /** Get a list of BuildHub projects that the current user has access to. */
  buildHubs: BuildHubConnection;
  /** List of cards for a given professional */
  cards: ErrorHandlingCardConnection;
  conversionRules: Array<ConversionRule>;
  editableImage: EditableImage;
  emailTemplateByLink: EmailTemplateResponse;
  findAddress: Array<AddressResult>;
  findPlace: Array<PlaceDetailType>;
  /** Given an external url and a professional, make url always resolvable to that professional */
  generateExternalLink: GeneratedExternalLink;
  getAddress: AddressDetailResult;
  getAnalyticsDemoBookingURL: Scalars['String'];
  /** Get booking details by event ID for reschedule/cancel operations */
  getBookingByEventId?: Maybe<BookingByEventId>;
  getBrandImpressionTopPerformers: Array<BrandImpressionTopPerformer>;
  getBuildingGuide: BuildingGuide;
  getBuildingGuideSection: BuildingGuideSection;
  getBuildingGuideSections: Array<BuildingGuideSection>;
  getBuildingGuideSubscriptions: Array<BuildingGuideSubscription>;
  getBusinessTermsByID: BusinessTermsResponse;
  getBusinessTermsByURLSegment: BusinessTermsResponse;
  getCalendarAvailability: CalendarAvailabilityResult;
  /** Get calendar OAuth connection for a member */
  getCalendarConnection?: Maybe<MemberCalendarOAuth>;
  /** Fetch calendar events and data from connected calendar */
  getCalendarData?: Maybe<CalendarDataType>;
  getCalendarSession?: Maybe<CalendarSession>;
  getCalendarSessionByURLSegment?: Maybe<CalendarSession>;
  getCampaignMetaAds: Array<Maybe<SocialAd>>;
  getCategory: Category;
  getClientDocuments?: Maybe<Array<DownloadableFile>>;
  /** Get the contacts for the current user. */
  getContactsList: MemberConnection;
  /** Get a conversation by its ID. */
  getConversation?: Maybe<Conversation>;
  /** Get a conversation by its participants. */
  getConversationByParticipants?: Maybe<DirectConversation>;
  /** Get the available filters to filter conversations by. */
  getConversationFilters: ConversationFilters;
  /** Get a list of conversations that belongs to the current user. */
  getConversations: ConversationConnection;
  getDashboardAudience: DashboardAudienceResult;
  getDashboardOverview: DashboardOverviewResult;
  getDashboardProfilePages: DashboardProfilePagesResult;
  getDashboardPublications: DashboardPublicationsResult;
  getDashboardSocialAds: DashboardSocialAdsResult;
  getDesignBoard?: Maybe<DesignBoard>;
  getDesignBoardSetting: DesignBoardSetting;
  getDigitalPublicationDetails: PublicationDetails;
  /** Returns the list of Professionals available within the provided category Url */
  getDirectoryCompanies?: Maybe<Array<TitleWithUrlSegment>>;
  getDirectoryItems: Array<DirectoryItem>;
  getDirectoryPageMeta?: Maybe<DirectoryPageMeta>;
  getDirectoryProfessions?: Maybe<Array<Category>>;
  getDirectoryRegions?: Maybe<Array<Category>>;
  getEngagementEventsCount: EngagementEventsCount;
  getEngagementEventsSummary: EngagementEventSummary;
  getEngagementTopPerformers: Array<EngagementTopPerformer>;
  getEngagementsOverTime: EngagementsOverTime;
  getEnquiryConversation?: Maybe<EnquiryConversation>;
  getHomePageContent: RecentlyViewedContent;
  getHubspotCompany?: Maybe<HubspotCompany>;
  getImportMap?: Maybe<ImportMap>;
  getInboxState: Inbox;
  getIntegrationRequest?: Maybe<IntegrationRequest>;
  getInviteInfo?: Maybe<InviteInfo>;
  /** Get items to amplify for a given URL segment and item types */
  getItemToAmplify: Array<Professional>;
  getLibraryImages?: Maybe<Array<LibraryImage>>;
  getMember: User;
  getMembershipTerm?: Maybe<Scalars['String']>;
  getModulePage?: Maybe<UnionModulePage>;
  /** Get the latest monthly user count data for AU and NZ */
  getMonthlyUserCount: Array<MonthlyUserCount>;
  getOverwriteBlacklist?: Maybe<BlacklistedFields>;
  getPageBulkCloneJob?: Maybe<PageBulkCloneJob>;
  getPageSEOSchema?: Maybe<PageSeoSchema>;
  getPrivacyPolicyContent: PageContent;
  getProduct: Product;
  getProductInstallers: GetProductInstallers_Connection;
  getProductSwatches: Array<ProductSwatch>;
  getProductsCSV: Scalars['String'];
  getProfessional?: Maybe<Professional>;
  getProfessionalByURLSegment: Professional;
  getProfessionalCategories: Array<ProfessionalCategory>;
  getProfessionalServices?: Maybe<Array<ProfessionalService>>;
  getPromotionalStats: PromotionalStats;
  getPublicationDetails: PublicationDetails;
  getRecentlyViewedContent: RecentlyViewedContent;
  getRecentlyViewedDirectoryItem?: Maybe<Array<DirectoryItem>>;
  getSecuritySetting: SecuritySettings;
  getShareLink?: Maybe<Scalars['String']>;
  getSidePromo?: Maybe<SidePromo>;
  getSignupData: SignupData;
  getSiteConfig: SiteConfig;
  getSocialAdDetails: SocialAd;
  getTermsContent: PageContent;
  getTopLibraryItems: TopLibraryItems;
  getUsersOnPage?: Maybe<Scalars['Int']>;
  /** Retrieves the content for the homepage hero section */
  homeHero?: Maybe<HomeHeroData>;
  /** Retrieves the content for the homepage introduction section */
  homeIntro?: Maybe<HomeIntroData>;
  /** Retrieves the content for the homepage media section */
  homeMedia?: Maybe<HomeMediaData>;
  inspirationByLink: InspirationGroupResponse;
  invoiceByUuid: InvoiceableResponse;
  invoiceHasProcessingPayment: InvoiceHasProcessingPaymentResponse;
  listAllDirectoryCategories?: Maybe<Array<Category>>;
  listClickEngagementEvents: ListClickEngagementEvents_Cursor;
  listDesignBoardCollaborators?: Maybe<Array<Maybe<Collaborator>>>;
  listDesignBoardComments?: Maybe<Array<Comment>>;
  listDesignBoards: ListDesignBoards_Connection;
  listDigitalPublicationRecipientClicks: ListDigitalPublicationRecipientClicksConnection;
  listDirectoryCategories: Array<Category>;
  listDirectoryItems: ListLibraryRangeItems_Connection;
  listDirectoryItemsByCategory: ListLibraryRangeItems_Connection;
  listEngagementEvents: ListEngagementEvents_Cursor;
  listEnquiryConversations?: Maybe<ListEnquiryConversations_Connection>;
  listIntegrationRequests?: Maybe<IntegrationRequestConnection>;
  listLibraryDownloads?: Maybe<Array<Maybe<LibraryDownload>>>;
  listLibraryImages: ListLibraryImages_Connection;
  listLibraryRangeItems: ListLibraryRangeItems_Connection;
  listLibraryRanges: Array<LibraryRange>;
  listLibraryTabs?: Maybe<Array<LibraryTab>>;
  /** Returns moderation requests submitted by the current authenticated user */
  listModerations: Array<Moderation>;
  /** List comments on a pin */
  listPinComments?: Maybe<Array<Comment>>;
  listPins: ListPinsConnection;
  listProductSwatches: PaginatedProductSwatches_Connection;
  /** Fetch a Connection of Professionals who are suggested network partners. */
  listProfessionalNetworkSuggestions: GetProductInstallers_Connection;
  /** Fetch a paginated connection of a professionals network partners */
  listProfessionalPartners: GetProductInstallers_Connection;
  listProjectGroups: Array<ProjectGroup>;
  listPublicationClickedRecipients: ListPublicationOpenedRecipientsConnection;
  listPublicationOpenedRecipients: ListPublicationOpenedRecipientsConnection;
  listPublicationRecipientClicks: ListDigitalPublicationRecipientClicksConnection;
  listPublicationRecipientOpens: ListDigitalPublicationRecipientClicksConnection;
  listPublications: ListPublications_Cursor;
  listRecommendedCategories?: Maybe<Array<Category>>;
  listRegionOptions: Array<RegionOption>;
  listSocialAds: ListSocialAds_Cursor;
  /** [Paginated] Gets the team members of the professional with the given url segment (deprecated, please see TeamMembers on ProfessionalType) */
  listTeamMembersByURLSegment: ListTeamMembersByUrlSegmentConnection;
  listTopLevelCategories: Array<Category>;
  listUploadedFiles?: Maybe<Array<Maybe<LibraryImageFile>>>;
  listWebsiteNotifications: ListWebsiteNotifications_Connection;
  /** Checks if a member has read a specific record */
  memberReadRecordGet: Scalars['Boolean'];
  /** Returns moderation reasons available for the specified entity types */
  moderationReasons: Array<ModerationReason>;
  modules: Array<Module>;
  pageEmbedding?: Maybe<PageEmbedding>;
  placementFeaturedItems: PlacementFeaturedItems_Connection;
  placementPOTMs: PlacementPotMs_Connection;
  previewConversionRule: ConversionRuleResponse;
  professionalBacklinks?: Maybe<ProfessionalBacklink>;
  professionalsByKeywordOrTeamMemberName: GetProductInstallers_Connection;
  professionalsLocation?: Maybe<ProfessionalsLocation>;
  readFeatureBookings?: Maybe<Array<Maybe<FeatureBooking>>>;
  readOneFeatureBookingByPlacement?: Maybe<FeatureBooking>;
  savedQuoteByLink: SavedQuoteResponse;
  /** Classify a search query to generate filters for the search. */
  searchClassify: SearchClassification;
  searchEmbedding?: Maybe<SearchEmbedding>;
  templateTokenBindings: Array<TemplateTokenBinding>;
  templateTokens: Array<TemplateToken>;
  userMoodBoardItems: InspirationItemsConnection;
  /** An object containing separate arrays of page IDs and image IDs saved in moodboards, useful for determining if a page or image can be saved */
  userMoodBoardSavedPageIDs: MoodBoardSavedIDs;
  userMoodBoards: InspirationGroupsConnection;
};


export type QueryAiCompanyDescriptionGenerateArgs = {
  Awards: Array<ProjectAward>;
  Category: Scalars['String'];
  OriginalDescription: Scalars['String'];
  Professional: Scalars['String'];
  ProfessionalTitle: Scalars['String'];
  Prompt: Scalars['String'];
  Services: Array<Scalars['String']>;
  Tone?: InputMaybe<AiTone>;
  YearFounded: Scalars['String'];
};


export type QueryAiDescriptionGenerateArgs = {
  Categories: Array<Scalars['String']>;
  OriginalDescription: Scalars['String'];
  ProductTitle: Scalars['String'];
  Professional: Scalars['String'];
  Prompt: Scalars['String'];
  Tone: Scalars['String'];
};


export type QueryAiProductDescriptionGenerateArgs = {
  Categories: Array<Scalars['String']>;
  OriginalDescription: Scalars['String'];
  ProductTitle: Scalars['String'];
  Professional: Scalars['String'];
  Prompt: Scalars['String'];
  Tone?: InputMaybe<AiTone>;
};


export type QueryAiProjectDescriptionGenerateArgs = {
  Awards: Array<ProjectAward>;
  BuildingStyle: Scalars['String'];
  Categories: Array<Scalars['String']>;
  ClientName: Scalars['String'];
  FeaturedProducts: Array<Scalars['String']>;
  FeaturedProfessionals: Array<Scalars['String']>;
  OriginalDescription: Scalars['String'];
  Professional: Scalars['String'];
  ProfessionalCategory: Scalars['String'];
  ProfessionalTitle: Scalars['String'];
  ProjectTitle: Scalars['String'];
  Prompt: Scalars['String'];
  Tone?: InputMaybe<AiTone>;
  YearOfCompletion: Scalars['Int'];
};


export type QueryAirtableAdScheduleArgs = {
  Professional: Scalars['String'];
  ProfessionalID: Scalars['Int'];
};


export type QueryArcherCommentsArgs = {
  AuthorID?: InputMaybe<Scalars['Int']>;
  ProductID?: InputMaybe<Scalars['Int']>;
};


export type QueryArticlesArgs = {
  Link: Scalars['String'];
  filters?: InputMaybe<Array<ListArticlesFilter>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<ArticlesSimpleSortFields>;
};


export type QueryAttributeArgs = {
  ID: Scalars['Int'];
};


export type QueryAttributesArgs = {
  ProductID?: InputMaybe<Scalars['Int']>;
  ProfessionalURLSegment?: InputMaybe<Scalars['StringInput']>;
};


export type QueryBaReportDashboardArgs = {
  ProfessionalID: Scalars['Int'];
};


export type QueryCountriesArgs = {
  filter?: InputMaybe<Countries_Filters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Countries_SortFields>;
};


export type QueryCouriersArgs = {
  CountryCode?: InputMaybe<Scalars['StringInput']>;
};


export type QueryDigitalPublicationFiltersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryEditorialAuthorsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<EditorialAuthorsSimpleSortFields>;
};


export type QueryExistingProductCountArgs = {
  Products: Array<ProductSummaryInputType>;
  ProfessionalURLSegment: Scalars['String'];
};


export type QueryFacetArgs = {
  ID: Scalars['Int'];
};


export type QueryFacetsArgs = {
  ProductCategoryIDs?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};


export type QueryFeaturedDirectoryItemArgs = {
  Directory: DirectoryItemEnumType;
};


export type QueryIntegratedPlatformsArgs = {
  Limit?: InputMaybe<Scalars['Int']>;
  Offset?: InputMaybe<Scalars['Int']>;
  Professional: Scalars['String'];
};


export type QueryIntegrationRequestFileArgs = {
  Professional: Scalars['String'];
  RequestID: Scalars['String'];
};


export type QueryIntegrationSettingsArgs = {
  Platform: IntegratedPlatformEnum;
  Professional: Scalars['String'];
};


export type QueryLastUpdatedArgs = {
  Platform: IntegratedPlatformEnum;
  Professional: Scalars['String'];
};


export type QueryListCombinedUnreadNotificationsArgs = {
  ProfessionalID?: InputMaybe<Scalars['ID']>;
};


export type QueryListProfessionalProjectsArgs = {
  ListType: ProfessionalProjectsTypeEnum;
  Sort?: InputMaybe<Scalars['String']>;
  URLSegment: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<ListProfessionalProjectsSimpleSortFields>;
};


export type QueryLocalitiesArgs = {
  Coordinates?: InputMaybe<CoordinateInput>;
  CountryCode?: InputMaybe<Scalars['StringInput']>;
  Query?: InputMaybe<Scalars['StringInput']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<LocalitiesSimpleSortFields>;
};


export type QueryMaterialsArgs = {
  SearchTerm: Scalars['String'];
};


export type QueryMemberOrdersArgs = {
  SearchString?: InputMaybe<Scalars['String']>;
  Shipping?: InputMaybe<Array<Scalars['String']>>;
  Sort?: InputMaybe<Scalars['String']>;
  Status?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<MemberOrdersSimpleSortFields>;
};


export type QueryModulePresetsArgs = {
  ContentBuilderType: ContentBuilderTypeEnum;
};


export type QueryMonthlyTotalUsersArgs = {
  CombinedCount: Scalars['Boolean'];
};


export type QueryOrderArgs = {
  ID: Scalars['Int'];
};


export type QueryPaymentOptionsArgs = {
  Provider?: InputMaybe<PaymentProviderEnum>;
};


export type QueryPlaceByCoordinateArgs = {
  Latitude: Scalars['Float'];
  Longitude: Scalars['Float'];
  Type?: InputMaybe<FindPlaceTypeEnum>;
};


export type QueryPlatformConnectionArgs = {
  Platform: IntegratedPlatformEnum;
  URLSegment: Scalars['String'];
};


export type QueryPostcodeArgs = {
  ID?: InputMaybe<Scalars['Int']>;
  Postcode?: InputMaybe<Scalars['StringInput']>;
};


export type QueryPostcodeGroupsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryProductAttributeOptionsArgs = {
  ID: Scalars['Int'];
  SyncOptions?: InputMaybe<Scalars['Boolean']>;
  URLSegment?: InputMaybe<Scalars['StringInput']>;
};


export type QueryProductImprovementLatestTaskArgs = {
  ProductID: Scalars['Int'];
};


export type QueryProjectsArgs = {
  CountryAgnostic?: InputMaybe<Scalars['Boolean']>;
  Filters?: InputMaybe<Array<ListProjectsFilter>>;
  Link: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<ProjectsSimpleSortFields>;
};


export type QueryPublicUserArgs = {
  email: Scalars['Email'];
};


export type QueryQbrByLinkArgs = {
  Link: Scalars['String'];
};


export type QueryRegionsArgs = {
  Country?: InputMaybe<Scalars['String']>;
  ParentID?: InputMaybe<Scalars['Int']>;
  Public?: InputMaybe<Scalars['Boolean']>;
};


export type QuerySavedModuleVersionArgs = {
  ID: Scalars['Int'];
  Version: Scalars['Int'];
};


export type QuerySavedModuleVersionsArgs = {
  ID: Scalars['Int'];
};


export type QuerySavedModulesArgs = {
  ContentBuilderType: ContentBuilderTypeEnum;
  ProfessionalID: Scalars['Int'];
};


export type QueryShippingProfileArgs = {
  ID: Scalars['Int'];
};


export type QueryShippingZoneArgs = {
  ID?: InputMaybe<Scalars['Int']>;
};


export type QueryShoppingCartArgs = {
  UUID?: InputMaybe<Scalars['String']>;
};


export type QuerySupplierOrderArgs = {
  OrderNumber: Scalars['String'];
};


export type QuerySupplierOrdersArgs = {
  Attention?: InputMaybe<Array<Scalars['String']>>;
  LastModifiedAfter?: InputMaybe<Scalars['String']>;
  SearchString?: InputMaybe<Scalars['String']>;
  Shipping?: InputMaybe<Array<Scalars['String']>>;
  Sort?: InputMaybe<Scalars['String']>;
  Status?: InputMaybe<Array<Scalars['String']>>;
  URLSegment: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SupplierOrdersSimpleSortFields>;
};


export type QuerySyncEnquiryOAuthEmailArgs = {
  ProfessionalID: Scalars['Int'];
  SyncGapInSeconds?: InputMaybe<Scalars['Int']>;
};


export type QuerySyncStatusArgs = {
  Platform: IntegratedPlatformEnum;
  Professional: Scalars['String'];
};


export type QueryTopTrendingCategoriesArgs = {
  count: Scalars['Int'];
};


export type QueryTrendingCategoriesArgs = {
  Directory: DirectoryItemEnumType;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryVariantArgs = {
  ID: Scalars['Int'];
};


export type QueryVariantShippingArgs = {
  IsSample: Scalars['Boolean'];
  MethodIDs?: InputMaybe<Array<Scalars['Int']>>;
  Quantity: Scalars['Int'];
  VariantID: Scalars['Int'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryVerifyEmailArgs = {
  email: Scalars['String'];
};


export type QueryVerifyUrlAccessTokenArgs = {
  token?: InputMaybe<Scalars['String']>;
};


export type QueryWhoAmIArgs = {
  Professional: Scalars['String'];
};


export type QueryWooCommerceLastUpdatedArgs = {
  Professional: Scalars['String'];
};


export type QueryWooCommerceSyncCountsArgs = {
  Professional: Scalars['String'];
};


export type QueryWooCommerceTagsArgs = {
  Professional: Scalars['String'];
};


export type QueryBuildHubByLinkArgs = {
  UrlSegment: Scalars['String'];
};


export type QueryBuildHubFileCommentsArgs = {
  CommentTargetID: Scalars['ID'];
};


export type QueryBuildHubsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryCardsArgs = {
  category?: InputMaybe<Array<CardTypeCategory>>;
  limit?: InputMaybe<Scalars['Int']>;
  link: Scalars['String'];
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<CardsSimpleSortFields>;
  state?: InputMaybe<Array<CardState>>;
};


export type QueryConversionRulesArgs = {
  ProfessionalID: Scalars['ID'];
};


export type QueryEditableImageArgs = {
  ID: Scalars['Int'];
};


export type QueryEmailTemplateByLinkArgs = {
  Link: Scalars['String'];
};


export type QueryFindAddressArgs = {
  Limit?: InputMaybe<Scalars['Int']>;
  Query: Scalars['String'];
  Type?: InputMaybe<Scalars['String']>;
};


export type QueryFindPlaceArgs = {
  apiProvider?: InputMaybe<FindPlaceApiProviderEnum>;
  apiVersion?: InputMaybe<Scalars['String']>;
  country: SupportedCountry;
  includeParents?: InputMaybe<Scalars['Boolean']>;
  keyword: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  parentIDs?: InputMaybe<Array<Scalars['Int']>>;
  type?: InputMaybe<FindPlaceTypeEnum>;
};


export type QueryGenerateExternalLinkArgs = {
  Input?: InputMaybe<GeneratedExternalLinkInput>;
};


export type QueryGetAddressArgs = {
  ID: Scalars['String'];
};


export type QueryGetAnalyticsDemoBookingUrlArgs = {
  URLSegment: Scalars['String'];
};


export type QueryGetBookingByEventIdArgs = {
  eventId: Scalars['String'];
};


export type QueryGetBrandImpressionTopPerformersArgs = {
  Months: Scalars['Int'];
  ProfessionalURL: Scalars['String'];
};


export type QueryGetBuildingGuideArgs = {
  URLSegment: Scalars['String'];
};


export type QueryGetBuildingGuideSectionArgs = {
  URLSegment: Scalars['String'];
};


export type QueryGetBusinessTermsByIdArgs = {
  ID: Scalars['ID'];
};


export type QueryGetBusinessTermsByUrlSegmentArgs = {
  ProfessionalURLSegment: Scalars['String'];
  URLSegment: Scalars['String'];
};


export type QueryGetCalendarAvailabilityArgs = {
  originalEventId?: InputMaybe<Scalars['String']>;
  sessionId: Scalars['Int'];
  timezone?: InputMaybe<Scalars['String']>;
};


export type QueryGetCalendarConnectionArgs = {
  provider: Scalars['String'];
};


export type QueryGetCalendarDataArgs = {
  email?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  maxResults?: InputMaybe<Scalars['Int']>;
  provider: Scalars['String'];
  startDate?: InputMaybe<Scalars['String']>;
  timeZone?: InputMaybe<Scalars['String']>;
};


export type QueryGetCalendarSessionArgs = {
  ID: Scalars['Int'];
};


export type QueryGetCalendarSessionByUrlSegmentArgs = {
  URLSegment: Scalars['String'];
};


export type QueryGetCampaignMetaAdsArgs = {
  ProfessionalID: Scalars['Int'];
  UTM: Scalars['String'];
};


export type QueryGetCategoryArgs = {
  Link: Scalars['String'];
};


export type QueryGetContactsListArgs = {
  ExcludeMemberIDs?: InputMaybe<Array<Scalars['Int']>>;
  Search?: InputMaybe<Scalars['StringInput']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryGetConversationArgs = {
  ID: Scalars['Int'];
};


export type QueryGetConversationByParticipantsArgs = {
  MemberIDs: Array<Scalars['Int']>;
};


export type QueryGetConversationsArgs = {
  BuildHubIDs?: InputMaybe<Array<Scalars['ID']>>;
  Search?: InputMaybe<Scalars['StringInput']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryGetDashboardAudienceArgs = {
  Months: Scalars['Int'];
  ProfessionalURL: Scalars['String'];
};


export type QueryGetDashboardOverviewArgs = {
  Months: Scalars['Int'];
  ProfessionalURL: Scalars['String'];
};


export type QueryGetDashboardProfilePagesArgs = {
  Months: Scalars['Int'];
  ProfessionalURL: Scalars['String'];
};


export type QueryGetDashboardPublicationsArgs = {
  Months: Scalars['Int'];
  ProfessionalURL: Scalars['String'];
};


export type QueryGetDashboardSocialAdsArgs = {
  Months: Scalars['Int'];
  ProfessionalURL: Scalars['String'];
  Type?: InputMaybe<SocialAdTypeEnum>;
};


export type QueryGetDesignBoardArgs = {
  URLSegment: Scalars['String'];
};


export type QueryGetDigitalPublicationDetailsArgs = {
  CampaignID: Scalars['Int'];
  ProfessionalURL: Scalars['String'];
};


export type QueryGetDirectoryCompaniesArgs = {
  Category?: InputMaybe<Array<Scalars['String']>>;
  Purchasable?: InputMaybe<Scalars['Boolean']>;
  Region?: InputMaybe<Array<Scalars['String']>>;
  Url: Scalars['String'];
};


export type QueryGetDirectoryItemsArgs = {
  IDs?: InputMaybe<Array<Scalars['Int']>>;
  URLSegments?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryGetDirectoryPageMetaArgs = {
  Url: Scalars['String'];
};


export type QueryGetDirectoryProfessionsArgs = {
  ProfessionalURLs?: InputMaybe<Array<Scalars['String']>>;
  Url: Scalars['String'];
};


export type QueryGetDirectoryRegionsArgs = {
  Country: Scalars['String'];
  ProfessionalURLs?: InputMaybe<Array<Scalars['String']>>;
  Url: Scalars['String'];
};


export type QueryGetEngagementEventsSummaryArgs = {
  Months: Scalars['Int'];
  ProfessionalURL: Scalars['String'];
};


export type QueryGetEngagementTopPerformersArgs = {
  Months: Scalars['Int'];
  ProfessionalURL: Scalars['String'];
};


export type QueryGetEngagementsOverTimeArgs = {
  Days: Scalars['Int'];
  ProfessionalURL: Scalars['String'];
  Title: Scalars['String'];
};


export type QueryGetEnquiryConversationArgs = {
  ID: Scalars['ID'];
};


export type QueryGetHubspotCompanyArgs = {
  HubspotID: Scalars['String'];
};


export type QueryGetImportMapArgs = {
  Professional: Scalars['String'];
};


export type QueryGetInboxStateArgs = {
  ProfessionalID?: InputMaybe<Scalars['ID']>;
};


export type QueryGetIntegrationRequestArgs = {
  RequestID: Scalars['String'];
};


export type QueryGetInviteInfoArgs = {
  InviteHash: Scalars['String'];
};


export type QueryGetItemToAmplifyArgs = {
  Limit?: InputMaybe<Scalars['Int']>;
  Link: Scalars['String'];
};


export type QueryGetLibraryImagesArgs = {
  IDs?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};


export type QueryGetMembershipTermArgs = {
  ProfessionalURL: Scalars['String'];
};


export type QueryGetModulePageArgs = {
  URLSegment: Scalars['String'];
};


export type QueryGetOverwriteBlacklistArgs = {
  URLSegment: Scalars['String'];
};


export type QueryGetPageBulkCloneJobArgs = {
  JobID: Scalars['Int'];
};


export type QueryGetPageSeoSchemaArgs = {
  ID: Scalars['Int'];
};


export type QueryGetProductArgs = {
  URLSegment: Scalars['String'];
};


export type QueryGetProductInstallersArgs = {
  CategoryID?: InputMaybe<Scalars['Int']>;
  URLSegment: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<GetProductInstallersSimpleSortFields>;
};


export type QueryGetProductSwatchesArgs = {
  URLSegment?: InputMaybe<Scalars['String']>;
};


export type QueryGetProductsCsvArgs = {
  input?: InputMaybe<GetProductsCsvInputType>;
};


export type QueryGetProfessionalArgs = {
  ID?: InputMaybe<Scalars['Int']>;
};


export type QueryGetProfessionalByUrlSegmentArgs = {
  URLSegment: Scalars['String'];
};


export type QueryGetProfessionalServicesArgs = {
  CategoryPageIDs?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  ProfessionalID?: InputMaybe<Scalars['Int']>;
};


export type QueryGetPromotionalStatsArgs = {
  ProfessionalURL: Scalars['String'];
};


export type QueryGetPublicationDetailsArgs = {
  ProfessionalURL: Scalars['String'];
  Title: Scalars['String'];
};


export type QueryGetRecentlyViewedDirectoryItemArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  type: DirectoryItemEnumType;
};


export type QueryGetShareLinkArgs = {
  ExtraClaims?: InputMaybe<Array<ShareLinkExtraClaimEnum>>;
  Link: Scalars['String'];
  ProfessionalID?: InputMaybe<Scalars['Int']>;
  ValidDurationSeconds: Scalars['Int'];
};


export type QueryGetSidePromoArgs = {
  URLSegment: Scalars['String'];
};


export type QueryGetSocialAdDetailsArgs = {
  ID: Scalars['String'];
  ProfessionalURLSegment: Scalars['String'];
  Type: SocialAdTypeEnum;
};


export type QueryGetUsersOnPageArgs = {
  URLSegment: Scalars['String'];
};


export type QueryHomeHeroArgs = {
  countryCode?: InputMaybe<Scalars['String']>;
};


export type QueryInspirationByLinkArgs = {
  UrlSegment: Scalars['String'];
};


export type QueryInvoiceByUuidArgs = {
  Uuid: Scalars['String'];
};


export type QueryInvoiceHasProcessingPaymentArgs = {
  InvoiceId: Scalars['Int'];
};


export type QueryListAllDirectoryCategoriesArgs = {
  Directory?: InputMaybe<DirectoryItemEnumType>;
};


export type QueryListClickEngagementEventsArgs = {
  Limit?: InputMaybe<Scalars['Int']>;
  Months: Scalars['Int'];
  Offset?: InputMaybe<Scalars['String']>;
  ProfessionalURL: Scalars['String'];
};


export type QueryListDesignBoardCollaboratorsArgs = {
  DesignBoardID: Scalars['Int'];
};


export type QueryListDesignBoardCommentsArgs = {
  DesignBoardID: Scalars['Int'];
};


export type QueryListDesignBoardsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<ListDesignBoardsSimpleSortFields>;
};


export type QueryListDigitalPublicationRecipientClicksArgs = {
  CampaignID: Scalars['Int'];
  ProfessionalURL: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryListDirectoryCategoriesArgs = {
  Directory?: InputMaybe<DirectoryItemEnumType>;
  IncludeRelatedItems?: InputMaybe<Scalars['Boolean']>;
  IncludeUnlistedItems?: InputMaybe<Scalars['Boolean']>;
  LeafCategoriesOnly?: InputMaybe<Scalars['Boolean']>;
  LibraryItemIDs?: InputMaybe<Array<Scalars['Int']>>;
  NonEmptyCategoriesOnly?: InputMaybe<Scalars['Boolean']>;
  OnlyVisible?: InputMaybe<Scalars['Boolean']>;
  ProfessionalCategories?: InputMaybe<Array<Scalars['String']>>;
  ProfessionalURLs?: InputMaybe<Array<Scalars['String']>>;
  Purchasable?: InputMaybe<Scalars['Boolean']>;
  Regions?: InputMaybe<Array<Scalars['String']>>;
  Sort?: InputMaybe<Scalars['String']>;
  Source?: InputMaybe<Scalars['String']>;
};


export type QueryListDirectoryItemsArgs = {
  Directory: DirectoryItemEnumType;
  Filters?: InputMaybe<Array<ListDirectoryItemsFilter>>;
  IncludeAllCountries?: InputMaybe<Scalars['Boolean']>;
  ProfessionalURLs?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  Regions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ShowUnlistedItems?: InputMaybe<Scalars['Boolean']>;
  Sort?: InputMaybe<Scalars['String']>;
  Title?: InputMaybe<Scalars['String']>;
  URLSegment: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  professionalCategories?: InputMaybe<Array<Scalars['String']>>;
  sort?: InputMaybe<ListDirectoryItemsSimpleSortFields>;
};


export type QueryListDirectoryItemsByCategoryArgs = {
  CategoryID?: InputMaybe<Scalars['Int']>;
  DirectoryItemIDWhitelist?: InputMaybe<Array<Scalars['Int']>>;
  EditMode?: InputMaybe<Scalars['Boolean']>;
  Filter?: InputMaybe<DirectoryItemsFilterEnum>;
  KeyUniquify?: InputMaybe<Scalars['String']>;
  ListType?: InputMaybe<DirectoryItemsByCategoryListTypeEnum>;
  Sort?: InputMaybe<Scalars['String']>;
  Source: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<ListDirectoryItemsByCategorySimpleSortFields>;
};


export type QueryListEngagementEventsArgs = {
  Limit?: InputMaybe<Scalars['Int']>;
  Months: Scalars['Int'];
  Offset?: InputMaybe<Scalars['String']>;
  ProfessionalURL: Scalars['String'];
};


export type QueryListEnquiryConversationsArgs = {
  All?: InputMaybe<Scalars['Boolean']>;
  URLSegment?: InputMaybe<Scalars['StringInput']>;
  filter?: InputMaybe<Array<EnquiryConversationsFilterFieldsType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<ListEnquiryConversationsSimpleSortFields>;
};


export type QueryListIntegrationRequestsArgs = {
  EndTimestamp?: InputMaybe<Scalars['Int']>;
  IntegrationType?: InputMaybe<Scalars['String']>;
  Limit?: InputMaybe<Scalars['Int']>;
  Offset?: InputMaybe<Scalars['Int']>;
  Professional: Scalars['String'];
  Source?: InputMaybe<Scalars['String']>;
  StartTimestamp?: InputMaybe<Scalars['Int']>;
  Status?: InputMaybe<Scalars['String']>;
};


export type QueryListLibraryDownloadsArgs = {
  URLSegment: Scalars['String'];
};


export type QueryListLibraryImagesArgs = {
  ProfessionalURLs?: InputMaybe<Array<Scalars['String']>>;
  Sort?: InputMaybe<Scalars['String']>;
  URLSegment: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<ListLibraryImagesSimpleSortFields>;
};


export type QueryListLibraryRangeItemsArgs = {
  CategoryID?: InputMaybe<Scalars['Int']>;
  EditMode?: InputMaybe<Scalars['Boolean']>;
  ID: Scalars['Int'];
  Sort?: InputMaybe<Scalars['String']>;
  Source?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<ListLibraryRangeItemsSimpleSortFields>;
};


export type QueryListLibraryRangesArgs = {
  IsInUse?: InputMaybe<Scalars['Boolean']>;
  URLSegment: Scalars['String'];
};


export type QueryListLibraryTabsArgs = {
  URLSegment: Scalars['String'];
};


export type QueryListPinCommentsArgs = {
  PinID: Scalars['Int'];
};


export type QueryListPinsArgs = {
  URLSegment?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryListProductSwatchesArgs = {
  URLSegment: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryListProfessionalNetworkSuggestionsArgs = {
  Input?: InputMaybe<ListProfessionalNetworkSuggestionsInputType>;
  URLSegment: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryListProfessionalPartnersArgs = {
  URLSegment: Scalars['String'];
  filter?: InputMaybe<ListProfessionalPartnersFilterType>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryListProjectGroupsArgs = {
  IncludeInvisible?: InputMaybe<Scalars['Boolean']>;
  ProjectID: Scalars['ID'];
};


export type QueryListPublicationClickedRecipientsArgs = {
  ProfessionalURL: Scalars['String'];
  Title: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryListPublicationOpenedRecipientsArgs = {
  Title: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryListPublicationRecipientClicksArgs = {
  ProfessionalURL: Scalars['String'];
  Title: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryListPublicationRecipientOpensArgs = {
  ProfessionalURL: Scalars['String'];
  Title: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryListPublicationsArgs = {
  Limit?: InputMaybe<Scalars['Int']>;
  Months: Scalars['Int'];
  Offset?: InputMaybe<Scalars['String']>;
  ProfessionalURL: Scalars['String'];
};


export type QueryListRecommendedCategoriesArgs = {
  type: DirectoryItemEnumType;
};


export type QueryListSocialAdsArgs = {
  Limit?: InputMaybe<Scalars['Int']>;
  Months: Scalars['Int'];
  Offset?: InputMaybe<Scalars['String']>;
  ProfessionalURL: Scalars['String'];
  Type: SocialAdTypeEnum;
};


export type QueryListTeamMembersByUrlSegmentArgs = {
  URLSegment: Scalars['String'];
  filter?: InputMaybe<ListTeamMembersByUrlSegmentFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<ListTeamMembersByUrlSegmentSimpleSortFields>;
};


export type QueryListWebsiteNotificationsArgs = {
  IsRead?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryMemberReadRecordGetArgs = {
  Name: Scalars['String'];
};


export type QueryModerationReasonsArgs = {
  EntityTypes: Array<ModerationEntityTypeEnum>;
};


export type QueryPageEmbeddingArgs = {
  pageId: Scalars['Int'];
};


export type QueryPlacementFeaturedItemsArgs = {
  content: FeaturedItemContent;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  placement: FeaturedItemPlacement;
  sort?: InputMaybe<PlacementFeaturedItemsSimpleSortFields>;
};


export type QueryPlacementPotMsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  placement: PotmPlacement;
  sort?: InputMaybe<PlacementPotMsSimpleSortFields>;
};


export type QueryPreviewConversionRuleArgs = {
  ID: Scalars['ID'];
  ProfessionalID: Scalars['ID'];
};


export type QueryProfessionalBacklinksArgs = {
  ProfessionalID: Scalars['Int'];
  Refresh?: InputMaybe<Scalars['Boolean']>;
};


export type QueryProfessionalsByKeywordOrTeamMemberNameArgs = {
  Keyword: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<ProfessionalsByKeywordOrTeamMemberNameSimpleSortFields>;
};


export type QueryProfessionalsLocationArgs = {
  location?: InputMaybe<Scalars['String']>;
};


export type QueryReadFeatureBookingsArgs = {
  TitlePrefix?: InputMaybe<Scalars['String']>;
};


export type QueryReadOneFeatureBookingByPlacementArgs = {
  PlacementTitle: Scalars['String'];
};


export type QuerySavedQuoteByLinkArgs = {
  Link: Scalars['String'];
};


export type QuerySearchClassifyArgs = {
  query: Scalars['String'];
};


export type QuerySearchEmbeddingArgs = {
  searchTerm: Scalars['String'];
};


export type QueryTemplateTokenBindingsArgs = {
  TemplateID: Scalars['ID'];
  TemplateType: TokenTemplateType;
};


export type QueryTemplateTokensArgs = {
  TemplateID: Scalars['ID'];
  TemplateType: TokenTemplateType;
};


export type QueryUserMoodBoardItemsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryUserMoodBoardsArgs = {
  canEdit?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** A quote content contains modules, including the invoice module which contains draft or template data representing a quote that can be sent and later transition into an invoice. */
export type QuoteContent = ContentBuilder & {
  __typename?: 'QuoteContent';
  CanCreate: Scalars['Boolean'];
  CanDelete: Scalars['Boolean'];
  CanEdit: Scalars['Boolean'];
  CanSend: Scalars['Boolean'];
  ClassName: Scalars['String'];
  ContentArea: ContentArea;
  ContentBuilderType: ContentBuilderTypeEnum;
  Created: Scalars['String'];
  ID: Scalars['Int'];
  Invoiceable?: Maybe<Invoiceable>;
  IsTemplate: Scalars['Boolean'];
  LastEdited: Scalars['String'];
  Link: Scalars['String'];
  Owner?: Maybe<Member>;
  Professional: Professional;
  QuoteAccepted: Scalars['Boolean'];
  Status: InvoiceStatusEnum;
  Title: Scalars['String'];
  URLSegment: Scalars['String'];
};

export enum QuoteDecisionEnum {
  Accept = 'Accept',
  Decline = 'Decline'
}

export type QuoteModule = FlexibleModule & {
  __typename?: 'QuoteModule';
  Columns: ColumnsConnection;
  ContentAreaID: Scalars['Int'];
  CreatedFromID?: Maybe<Scalars['Int']>;
  CreatedFromVersion?: Maybe<Scalars['Int']>;
  DetachedFromSavedModule?: Maybe<Scalars['Boolean']>;
  EcommerceEnabled: Scalars['Boolean'];
  ID: Scalars['Int'];
  LibraryItemID: Scalars['Int'];
  MemberSortOrder: Scalars['Int'];
  ModuleGroup?: Maybe<ModuleGroupEnum>;
  PossibleColumnDimensions: Array<ColumnDimension>;
  PresetName: Scalars['String'];
  PresetType: FlexibleModuleEnum;
  SortableColumns: Scalars['Boolean'];
  Swappable: Scalars['Boolean'];
};


export type QuoteModuleColumnsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<ColumnsSortFields>;
};

export type QuoteTemplate = Invoiceable & ModuleColumn & SortableItem & {
  __typename?: 'QuoteTemplate';
  AccountDetails?: Maybe<TokenisedField>;
  BankTransferTerms?: Maybe<TokenisedField>;
  BusinessTermsVersions: Array<BusinessTermsVersion>;
  Contact?: Maybe<Contact>;
  Created: Scalars['Date'];
  CreditCardTerms?: Maybe<TokenisedField>;
  Currency: Scalars['String'];
  Description?: Maybe<TokenisedField>;
  Discounts: CurrencyAmount;
  ExpiryDate?: Maybe<Scalars['Date']>;
  ID: Scalars['Int'];
  IsEmpty: Scalars['Boolean'];
  LastEdited: Scalars['Date'];
  MemberSortOrder: Scalars['Int'];
  ModuleID: Scalars['Int'];
  Notes?: Maybe<TokenisedField>;
  PaymentTerms?: Maybe<TokenisedField>;
  Payments: Array<InvoicePayment>;
  Professional?: Maybe<Professional>;
  ReadOnly: Scalars['Boolean'];
  References?: Maybe<TokenisedField>;
  Scope?: Maybe<TokenisedField>;
  SelectedBusinessTermsCategories: Array<BusinessTermsCategory>;
  Services: Array<InvoiceServiceItem>;
  SubTotal: CurrencyAmount;
  Tax: CurrencyAmount;
  Title?: Maybe<TokenisedField>;
  Total: CurrencyAmount;
  WordCount: Scalars['Int'];
};

/** Indicates if a reaction is positive or negative or neutral. */
export enum ReactionPolarityEnum {
  Negative = 'Negative',
  Neutral = 'Neutral',
  Positive = 'Positive'
}

/** Allowed reactions configured in YAML */
export enum ReactionTypeEnum {
  Angry = 'angry',
  Checkmark = 'checkmark',
  DownVote = 'down_vote',
  Eyes = 'eyes',
  Heart = 'heart',
  Laugh = 'laugh',
  RaisedHands = 'raised_hands',
  Sad = 'sad',
  ThumbsUp = 'thumbs_up',
  UpVote = 'up_vote',
  Wave = 'wave'
}

export type ReadStatus = {
  __typename?: 'ReadStatus';
  ID: Scalars['String'];
  ReadBy: Scalars['String'];
  ReadOn: Scalars['String'];
  Source: Scalars['String'];
};

export type RearrangeItems = {
  ID: Scalars['Int'];
  /** This is the current sort order */
  MemberSortOrder: Scalars['Int'];
};

/** Return data associated with recently viewed content */
export type RecentlyViewedContent = {
  __typename?: 'RecentlyViewedContent';
  RecentlyViewedAll: Array<DirectoryItem>;
  RecentlyViewedArticles: Array<Article>;
  RecentlyViewedProducts: Array<Product>;
  RecentlyViewedProfessionals: Array<Professional>;
  RecentlyViewedProjects: Array<Project>;
};

/** Return recently viewed image */
export type RecentlyViewedImage = {
  __typename?: 'RecentlyViewedImage';
  IsMultiplied?: Maybe<Scalars['Boolean']>;
  LibraryImageFile?: Maybe<LibraryImageFile>;
};

export type RecipientOverview = {
  __typename?: 'RecipientOverview';
  Clicked: Scalars['Int'];
  ID: Scalars['String'];
  Opened: Scalars['Int'];
};

export type RecommendationModule = ModuleType & {
  __typename?: 'RecommendationModule';
  AnchorTag?: Maybe<Scalars['String']>;
  BackgroundDesktop?: Maybe<LibraryImageFile>;
  BackgroundMobile?: Maybe<LibraryImageFile>;
  CTA?: Maybe<SiteTreeLink>;
  Content?: Maybe<Scalars['String']>;
  ExtraClass?: Maybe<Scalars['String']>;
  ID: Scalars['ID'];
  Logo?: Maybe<LibraryImageFile>;
  LogoLink?: Maybe<Scalars['String']>;
  MobileBackgroundPosition?: Maybe<Scalars['String']>;
  NavigationLabel?: Maybe<Scalars['String']>;
  SpacingBelow?: Maybe<Scalars['String']>;
  SpacingBelowMobile?: Maybe<Scalars['String']>;
  ThemeColour: ThemedElementColourType;
  Title?: Maybe<Scalars['String']>;
};

export type Redirect = {
  __typename?: 'Redirect';
  Code: Scalars['Int'];
  URL: Scalars['String'];
};

export type Region = {
  __typename?: 'Region';
  Country: Country;
  ID: Scalars['Int'];
  ParentID: Scalars['Int'];
  PrimaryLocality?: Maybe<Locality>;
  Regions: ChildRegionsConnection;
  SortOrder: Scalars['Int'];
  Title: Scalars['String'];
  URLSegment: Scalars['String'];
};


export type RegionRegionsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type RegionOption = {
  __typename?: 'RegionOption';
  ID: Scalars['String'];
  Name: Scalars['String'];
};

export type RemoveFacetOptionInput = {
  /** ID of the facet to add the option too. */
  FacetOptionID: Scalars['Int'];
  URLSegment: Scalars['StringInput'];
};

export type RemoveNetworkParticipantCreateData = {
  network?: InputMaybe<RemoveNetworkParticipantNetworkCreateData>;
  /** ID of the participant to remove */
  participantId: Scalars['ID'];
};

export type RemoveNetworkParticipantNetworkCreateData = {
  /** The type of the network to remove a participant from */
  type?: InputMaybe<NetworkEnum>;
};

export type RepliesConnection = {
  __typename?: 'RepliesConnection';
  edges: Array<RepliesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type RepliesConnectionEdge = {
  __typename?: 'RepliesConnectionEdge';
  /** The node at the end of the collections edge */
  node: ArcherReply;
};

export enum ReportCategory {
  Acquisition = 'Acquisition',
  Benchmarks = 'Benchmarks',
  Campaigns = 'Campaigns',
  CategoryPlacement = 'CategoryPlacement',
  Demographics = 'Demographics',
  EnhancedConversions = 'EnhancedConversions',
  GoogleSeo = 'GoogleSeo',
  LeadFunnel = 'LeadFunnel',
  LeadsPipeline = 'LeadsPipeline',
  Overview = 'Overview',
  PixelConversions = 'PixelConversions',
  ProductTags = 'ProductTags',
  ProfilePages = 'ProfilePages',
  Roi = 'Roi',
  Sales = 'Sales'
}

export type ReportDirectoryItemResponse = ModerationContentReportCreated | NotAuthorizedError | NotFoundError | ServerError | UserError;

export type ReportUserResponse = ModerationUserReportCreated | NotAuthorizedError | NotFoundError | ServerError | UserError;

export enum ResourceType {
  Member = 'Member',
  Professional = 'Professional',
  TeamMember = 'TeamMember'
}

export type ResponsiveImage = {
  __typename?: 'ResponsiveImage';
  Desktop?: Maybe<Scalars['String']>;
  Desktop2x?: Maybe<Scalars['String']>;
  DesktopPreload?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  Mobile?: Maybe<Scalars['String']>;
  Mobile2x?: Maybe<Scalars['String']>;
  MobilePreload?: Maybe<Scalars['String']>;
};

export type ResponsiveSingleImage = {
  __typename?: 'ResponsiveSingleImage';
  Height?: Maybe<Scalars['Int']>;
  URL?: Maybe<Scalars['String']>;
  Width?: Maybe<Scalars['Int']>;
};

export type ResponsiveVariantImage = {
  __typename?: 'ResponsiveVariantImage';
  DesktopOriginalDimension?: Maybe<ImageDimension>;
  DesktopVariant?: Maybe<ResponsiveImage>;
  MobileOriginalDimension?: Maybe<ImageDimension>;
  MobileVariant?: Maybe<ResponsiveImage>;
};

/** Message sent when a professional reveals the enquirer's contact details. */
export type RevealContactDetailsMessage = Message & {
  __typename?: 'RevealContactDetailsMessage';
  Content: Scalars['String'];
  Created: Scalars['String'];
  CreatedBy: Scalars['String'];
  FirstReadBy: FirstReadBy;
  ID: Scalars['ID'];
  MemberEnquiryEmail?: Maybe<MemberEnquiryEmail>;
  Participant: Participant;
};

export type ReviewAction = {
  __typename?: 'ReviewAction';
  ID: Scalars['Int'];
  IsDone: Scalars['Boolean'];
  Task: Scalars['String'];
};

export type RichTextModule = ModuleType & {
  __typename?: 'RichTextModule';
  AnchorTag?: Maybe<Scalars['String']>;
  CTA?: Maybe<SiteTreeLink>;
  Content?: Maybe<Scalars['String']>;
  ExternalLink?: Maybe<Scalars['String']>;
  ExtraClass?: Maybe<Scalars['String']>;
  ID: Scalars['ID'];
  Image?: Maybe<ResponsiveVariantImage>;
  NavigationLabel?: Maybe<Scalars['String']>;
  SpacingBelow?: Maybe<Scalars['String']>;
  SpacingBelowMobile?: Maybe<Scalars['String']>;
  ThemeColour: ThemedElementColourType;
  Title?: Maybe<Scalars['String']>;
};

export type RowData = {
  __typename?: 'RowData';
  ID: Scalars['String'];
  Values: Array<Datum>;
};

export type SalesConversionsFilters = {
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
};

export type SalesReports = {
  __typename?: 'SalesReports';
  ID: Scalars['Int'];
  LibraryPageKPI?: Maybe<RowData>;
  LibraryPagePublicKPI?: Maybe<RowData>;
  MonthlyUserCount?: Maybe<RowData>;
  SalesConversions?: Maybe<TableData>;
};


export type SalesReportsLibraryPageKpiArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type SalesReportsLibraryPagePublicKpiArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type SalesReportsSalesConversionsArgs = {
  filters?: InputMaybe<SalesConversionsFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type SampleEnquiryInput = {
  Address?: InputMaybe<Scalars['StringInput']>;
  Company?: InputMaybe<Scalars['StringInput']>;
  CustomAddressPlaceholder?: InputMaybe<Scalars['StringInput']>;
  CustomMessagePlaceholder?: InputMaybe<Scalars['StringInput']>;
  Email: Scalars['Email'];
  Message: Scalars['StringInput'];
  Name: Scalars['StringInput'];
  Phone?: InputMaybe<Scalars['StringInput']>;
};

export type SavedModule = FlexibleModule & SortableItem & {
  __typename?: 'SavedModule';
  Columns: ColumnsConnection;
  ContentAreaID: Scalars['Int'];
  ContentBuilderType: ContentBuilderTypeEnum;
  CreatedFromID?: Maybe<Scalars['Int']>;
  CreatedFromVersion?: Maybe<Scalars['Int']>;
  DetachedFromSavedModule?: Maybe<Scalars['Boolean']>;
  EcommerceEnabled: Scalars['Boolean'];
  ID: Scalars['Int'];
  LibraryItemID: Scalars['Int'];
  MemberSortOrder: Scalars['Int'];
  ModuleGroup: ModuleGroupEnum;
  PossibleColumnDimensions: Array<ColumnDimension>;
  PresetName: Scalars['String'];
  PresetType: FlexibleModuleEnum;
  PreviewImage?: Maybe<ResponsiveImage>;
  ProfessionalID: Scalars['Int'];
  SortableColumns: Scalars['Boolean'];
  Swappable: Scalars['Boolean'];
  Version?: Maybe<Scalars['Int']>;
};


export type SavedModuleColumnsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<ColumnsSortFields>;
};

export type SavedModuleVersion = {
  __typename?: 'SavedModuleVersion';
  Author?: Maybe<Member>;
  LastEdited?: Maybe<Scalars['String']>;
  Version: Scalars['Int'];
};

export type SavedQuoteResponse = NotAuthorizedError | NotFoundError | QuoteContent | ServerError | UserError;

/** The classification result of a search query. */
export type SearchClassification = {
  __typename?: 'SearchClassification';
  /** The color. Only set if the searchType is \"PRODUCTS\". */
  color?: Maybe<Scalars['String']>;
  /** The modified search query. This is `null` if the query was not modified. */
  modifiedQuery?: Maybe<Scalars['String']>;
  /** The search type. */
  searchType?: Maybe<SearchTypeEnum>;
};

export type SearchEmbedding = {
  __typename?: 'SearchEmbedding';
  Embedding: Scalars['String'];
  SearchTerm: Scalars['String'];
};

export type SearchSuggestion = {
  __typename?: 'SearchSuggestion';
  ID: Scalars['Int'];
  Keyword: Scalars['String'];
};

export type SearchTag = {
  __typename?: 'SearchTag';
  ID: Scalars['Int'];
  SortOrder: Scalars['Int'];
  Text: Scalars['String'];
};

/** The search type for Service Service queries. */
export enum SearchTypeEnum {
  Articles = 'ARTICLES',
  Products = 'PRODUCTS',
  Professionals = 'PROFESSIONALS',
  Projects = 'PROJECTS'
}

export type SecuritySettings = {
  __typename?: 'SecuritySettings';
  MfaEnabled: Scalars['Boolean'];
};

export type SendHubspotMarketingPreferencesEmailInputType = {
  email: Scalars['Email'];
};

export type SendHubspotMarketingPreferencesEmailResultType = {
  __typename?: 'SendHubspotMarketingPreferencesEmailResultType';
  recipient?: Maybe<Scalars['String']>;
};

export type ServerError = ErrorInterface & {
  __typename?: 'ServerError';
  Message: Scalars['String'];
};

export type ServiceAreaInput = {
  AddressID?: InputMaybe<Scalars['StringInput']>;
  City?: InputMaybe<Scalars['StringInput']>;
  Country?: InputMaybe<Scalars['StringInput']>;
  District?: InputMaybe<Scalars['StringInput']>;
  FullAddress?: InputMaybe<Scalars['StringInput']>;
  Latitude?: InputMaybe<Scalars['Float']>;
  Longitude?: InputMaybe<Scalars['Float']>;
  PlaceName?: InputMaybe<Scalars['StringInput']>;
  PlaceType?: InputMaybe<Scalars['StringInput']>;
  PostCode?: InputMaybe<Scalars['StringInput']>;
  Region?: InputMaybe<Scalars['StringInput']>;
  ServiceableAreaID?: InputMaybe<Scalars['Int']>;
  State?: InputMaybe<Scalars['StringInput']>;
  Suburb?: InputMaybe<Scalars['StringInput']>;
};

/** Quantifiable services a professional provides */
export type ServiceOffering = {
  __typename?: 'ServiceOffering';
  Description?: Maybe<Scalars['String']>;
  /** HubSpot URL for the service offering, if linked to HubSpot */
  HubspotURL?: Maybe<Scalars['String']>;
  ID: Scalars['ID'];
  PhotoSrc?: Maybe<Scalars['String']>;
  Quantity?: Maybe<Scalars['Int']>;
  SKU: Scalars['String'];
  ServicePriceAmount?: Maybe<Scalars['Float']>;
  Title: Scalars['String'];
  Unit?: Maybe<Scalars['String']>;
  UnitPriceAmount?: Maybe<Scalars['Float']>;
};

export type ServiceOfferingResponse = NotAuthorizedError | NotFoundError | ServerError | ServiceOffering | UserError;

export type SetParticipantStatusInput = {
  /** The ID of the conversation. */
  ID: Scalars['ID'];
  /** The status(es) to update. */
  Status: SetParticipantStatusStatusField;
};

export type SetParticipantStatusStatusField = {
  Archived?: InputMaybe<Scalars['Boolean']>;
  Important?: InputMaybe<Scalars['Boolean']>;
  MarkAsDone?: InputMaybe<Scalars['Boolean']>;
  Unread?: InputMaybe<Scalars['Boolean']>;
};

export type SetupIntent = {
  __typename?: 'SetupIntent';
  ClientSecret: Scalars['String'];
  ID: Scalars['String'];
};

export type SetupIntentResponse = NotAuthenticatedError | NotAuthorizedError | NotFoundError | ServerError | SetupIntent | UserError;

export type ShareEnquiryConversationInput = {
  Emails: Array<Scalars['Email']>;
  ID: Scalars['ID'];
  Message?: InputMaybe<Scalars['String']>;
  RedirectNotificationEmails?: InputMaybe<Scalars['Boolean']>;
};

export type ShareEnquiryConversationResult = {
  __typename?: 'ShareEnquiryConversationResult';
  Conversation?: Maybe<EnquiryConversation>;
};

export enum ShareItemType {
  Board = 'board',
  Directoryitem = 'directoryitem',
  Pin = 'pin'
}

export enum ShareLinkExtraClaimEnum {
  AutoJoinTeam = 'AutoJoinTeam',
  RequireLogin = 'RequireLogin'
}

export enum ShareType {
  Email = 'email',
  Facebook = 'facebook',
  Instagram = 'instagram',
  Linkedin = 'linkedin',
  Pinterest = 'pinterest',
  Whatsapp = 'whatsapp'
}

export type ShippingMethod = {
  __typename?: 'ShippingMethod';
  DeliveryEstimate: MinMax;
  DeliveryEstimateText: Scalars['String'];
  FreeThresholdEnabled: Scalars['Boolean'];
  /** Whether this shipping method is fulfilled with shipping rates */
  Fulfilled: Scalars['Boolean'];
  ID: Scalars['Int'];
  QuotedSeparately: Scalars['Boolean'];
  ShippingCost?: Maybe<CurrencyAmount>;
  ShippingCostText: Scalars['String'];
  ShippingProfile?: Maybe<ShippingProfile>;
  ShippingProvider?: Maybe<ShippingProviderEnum>;
  ShippingRates: Array<ShippingRate>;
  ShippingZoneRates: ShippingZoneRatesConnection;
  Title: Scalars['String'];
};


export type ShippingMethodShippingZoneRatesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type ShippingMethodInput = {
  DeliveryEstimate?: InputMaybe<MinMaxInput>;
  FreeThresholdEnabled?: InputMaybe<Scalars['Boolean']>;
  ID: Scalars['Int'];
  ShippingRates?: InputMaybe<Array<ShippingRateInput>>;
  ShippingZoneRates?: InputMaybe<Array<ShippingZoneRateInput>>;
  Title?: InputMaybe<Scalars['String']>;
};

export type ShippingPriceBreak = {
  __typename?: 'ShippingPriceBreak';
  Breakpoint: Scalars['Int'];
  ID: Scalars['Int'];
  Rate: CurrencyAmount;
};

export type ShippingPriceBreakInput = {
  Breakpoint: Scalars['Int'];
  Rate: Scalars['Int'];
};

export type ShippingPriceBreaksConnection = {
  __typename?: 'ShippingPriceBreaksConnection';
  edges: Array<ShippingPriceBreaksConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ShippingPriceBreaksConnectionEdge = {
  __typename?: 'ShippingPriceBreaksConnectionEdge';
  /** The node at the end of the collections edge */
  node: ShippingPriceBreak;
};

export type ShippingProfile = {
  __typename?: 'ShippingProfile';
  ApplyRatePerItem: Scalars['Boolean'];
  Default: Scalars['Boolean'];
  ExcludePromotions: Scalars['Boolean'];
  FreeShipping: Scalars['Boolean'];
  ID: Scalars['Int'];
  NoShipping: Scalars['Boolean'];
  ShippingMethods: Array<ShippingMethod>;
  Title: Scalars['String'];
};


export type ShippingProfileShippingMethodsArgs = {
  Deliverable?: InputMaybe<Scalars['Boolean']>;
};

export type ShippingPromotion = {
  __typename?: 'ShippingPromotion';
  ID: Scalars['Int'];
  Title: Scalars['String'];
};

export type ShippingProvider = {
  __typename?: 'ShippingProvider';
  AccountID: Scalars['String'];
  Countries: Array<Scalars['String']>;
  Enabled: Scalars['Boolean'];
  FreeThresholdEnabled: Scalars['Boolean'];
  HasAccountSecret: Scalars['Boolean'];
  HelpText?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  Locations: ShippingProviderLocationsConnection;
  LogoUrl: Scalars['String'];
  Name: Scalars['String'];
  ShippingProvider: ShippingProviderEnum;
  Title: Scalars['String'];
  ValidationRegex: Scalars['String'];
};


export type ShippingProviderLocationsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export enum ShippingProviderEnum {
  Onsend = 'ONSEND'
}

export type ShippingProviderLocation = {
  __typename?: 'ShippingProviderLocation';
  ID: Scalars['Int'];
  Location: LibraryLocation;
  SiteCode: Scalars['String'];
};

export type ShippingProviderLocationInput = {
  /** The LibraryLocation ID */
  LocationID: Scalars['Int'];
  /** The Shipping Provider's site code for the location */
  SiteCode: Scalars['StringInput'];
};

export type ShippingProviderLocationsConnection = {
  __typename?: 'ShippingProviderLocationsConnection';
  edges: Array<ShippingProviderLocationsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ShippingProviderLocationsConnectionEdge = {
  __typename?: 'ShippingProviderLocationsConnectionEdge';
  /** The node at the end of the collections edge */
  node: ShippingProviderLocation;
};

export type ShippingRate = {
  __typename?: 'ShippingRate';
  Available: Scalars['Boolean'];
  ID: Scalars['Int'];
  Rate: CurrencyAmount;
  Region: Region;
  ShippingMethod: ShippingMethod;
};

export type ShippingRateInput = {
  Rate: Scalars['Int'];
  RegionID: Scalars['Int'];
};

export enum ShippingRateTypeEnum {
  Flatrate = 'FLATRATE',
  Quoted = 'QUOTED',
  Weight = 'WEIGHT'
}

export type ShippingZone = {
  __typename?: 'ShippingZone';
  ExcludedPostcodes: ExcludedPostcodesConnection;
  ID: Scalars['Int'];
  Locations: LocationsConnection;
  PostcodeGroups: PostcodeGroupsConnection;
  Radius: Scalars['Int'];
  Title: Scalars['String'];
  Type: ShippingZoneTypeEnum;
};


export type ShippingZoneExcludedPostcodesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type ShippingZoneLocationsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type ShippingZonePostcodeGroupsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type ShippingZoneCreateResult = NotAuthenticatedError | NotAuthorizedError | NotFoundError | ServerError | ShippingZone | UserError;

export type ShippingZoneDeleteResult = NotAuthenticatedError | NotAuthorizedError | NotFoundError | ServerError | ShippingZone | UserError;

export type ShippingZoneInput = {
  ExcludedPostcodes?: InputMaybe<Scalars['StringInput']>;
  /** A list of LibraryLocation (IDs) to link to this shipping zone. */
  Locations?: InputMaybe<Array<Scalars['Int']>>;
  /** A list of postcode groups (IDs) to link to this shipping zone. */
  PostcodeGroups?: InputMaybe<Array<Scalars['Int']>>;
  Radius?: InputMaybe<Scalars['Int']>;
  Title?: InputMaybe<Scalars['StringInput']>;
  Type: ShippingZoneTypeEnum;
};

export type ShippingZoneRate = {
  __typename?: 'ShippingZoneRate';
  ID: Scalars['Int'];
  PriceBreaks: ShippingPriceBreaksConnection;
  Rate: CurrencyAmount;
  ShippingMethod: ShippingMethod;
  ShippingZone: ShippingZone;
  Type: ShippingRateTypeEnum;
};


export type ShippingZoneRatePriceBreaksArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type ShippingZoneRateInput = {
  PriceBreaks?: InputMaybe<Array<ShippingPriceBreakInput>>;
  Rate: Scalars['Int'];
  Type: ShippingRateTypeEnum;
  ZoneID: Scalars['Int'];
};

export type ShippingZoneRatesConnection = {
  __typename?: 'ShippingZoneRatesConnection';
  edges: Array<ShippingZoneRatesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ShippingZoneRatesConnectionEdge = {
  __typename?: 'ShippingZoneRatesConnectionEdge';
  /** The node at the end of the collections edge */
  node: ShippingZoneRate;
};

export type ShippingZoneResult = NotAuthenticatedError | NotAuthorizedError | NotFoundError | ServerError | ShippingZone | UserError;

export enum ShippingZoneTypeEnum {
  Postcode = 'POSTCODE',
  Radius = 'RADIUS'
}

export type ShippingZoneUpdateResult = NotAuthenticatedError | NotAuthorizedError | NotFoundError | ServerError | ShippingZone | UserError;

export type ShippingZonesConnection = {
  __typename?: 'ShippingZonesConnection';
  edges: Array<ShippingZonesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ShippingZonesConnectionEdge = {
  __typename?: 'ShippingZonesConnectionEdge';
  /** The node at the end of the collections edge */
  node: ShippingZone;
};

export type ShopifySyncStatus = SyncStatus & {
  __typename?: 'ShopifySyncStatus';
  /** @deprecated No longer provided */
  BulkImportID?: Maybe<Scalars['String']>;
  ErrorDismissed: Scalars['Boolean'];
  Errors: Array<ImportError>;
  Finished: Scalars['Boolean'];
  RequestID: Scalars['String'];
  StartedTimestamp?: Maybe<Scalars['Int']>;
  SuccessDismissed: Scalars['Boolean'];
  SuccessfullySyncedCount: Scalars['Int'];
  TotalProcessed: Scalars['Int'];
  TotalToSync?: Maybe<Scalars['Int']>;
};

export type ShoppingCart = {
  __typename?: 'ShoppingCart';
  BillingAddress?: Maybe<Address>;
  CartSuppliers: Array<CartSupplier>;
  CartTotal?: Maybe<CurrencyAmount>;
  Currency: Scalars['String'];
  DeliveryAddress?: Maybe<Address>;
  Email: Scalars['String'];
  ID: Scalars['Int'];
  ItemCount: Scalars['Int'];
  ItemTotal?: Maybe<CurrencyAmount>;
  LastAddedItems: Array<CartItem>;
  LastEdited?: Maybe<Scalars['String']>;
  Locality?: Maybe<Locality>;
  LoginRequired: Scalars['Boolean'];
  ModifiedOnRefresh: Scalars['Boolean'];
  ReadOnlyEmail: Scalars['Boolean'];
  Region?: Maybe<Region>;
  ShippingTotal?: Maybe<CurrencyAmount>;
  TaxSystem: Scalars['String'];
  TaxTotal?: Maybe<CurrencyAmount>;
};


export type ShoppingCartLastAddedItemsArgs = {
  Limit?: InputMaybe<Scalars['Int']>;
};

export type SidePromo = {
  __typename?: 'SidePromo';
  Content?: Maybe<Scalars['String']>;
  FirstPromoImage?: Maybe<ResponsiveVariantImage>;
  FirstPromoLink?: Maybe<Scalars['String']>;
  ID: Scalars['ID'];
  SecondPromoImage?: Maybe<ResponsiveVariantImage>;
  SecondPromoLink?: Maybe<Scalars['String']>;
  Title?: Maybe<Scalars['String']>;
};

export type SignupData = {
  __typename?: 'SignupData';
  HomeownerBudget: HomeownerBudgetConnection;
  HomeownerPurpose: HomeownerPurposeConnection;
  HomeownerStage: HomeownerStageConnection;
  SignupCategories: OnboardingProfessionalCategoryConnection;
};


export type SignupDataHomeownerBudgetArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type SignupDataHomeownerPurposeArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type SignupDataHomeownerStageArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type SignupDataSignupCategoriesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type SingleImageModule = FlexibleModule & {
  __typename?: 'SingleImageModule';
  Columns: ColumnsConnection;
  ContentAreaID: Scalars['Int'];
  CreatedFromID?: Maybe<Scalars['Int']>;
  CreatedFromVersion?: Maybe<Scalars['Int']>;
  DetachedFromSavedModule?: Maybe<Scalars['Boolean']>;
  EcommerceEnabled: Scalars['Boolean'];
  ID: Scalars['Int'];
  LibraryItemID: Scalars['Int'];
  MemberSortOrder: Scalars['Int'];
  ModuleGroup?: Maybe<ModuleGroupEnum>;
  PossibleColumnDimensions: Array<ColumnDimension>;
  PresetName: Scalars['String'];
  PresetType: FlexibleModuleEnum;
  SortableColumns: Scalars['Boolean'];
  Swappable: Scalars['Boolean'];
};


export type SingleImageModuleColumnsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<ColumnsSortFields>;
};

export type SingleParagraphModule = FlexibleModule & {
  __typename?: 'SingleParagraphModule';
  Columns: ColumnsConnection;
  ContentAreaID: Scalars['Int'];
  CreatedFromID?: Maybe<Scalars['Int']>;
  CreatedFromVersion?: Maybe<Scalars['Int']>;
  DetachedFromSavedModule?: Maybe<Scalars['Boolean']>;
  EcommerceEnabled: Scalars['Boolean'];
  ID: Scalars['Int'];
  LibraryItemID: Scalars['Int'];
  MemberSortOrder: Scalars['Int'];
  ModuleGroup?: Maybe<ModuleGroupEnum>;
  PossibleColumnDimensions: Array<ColumnDimension>;
  PresetName: Scalars['String'];
  PresetType: FlexibleModuleEnum;
  SortableColumns: Scalars['Boolean'];
  Swappable: Scalars['Boolean'];
};


export type SingleParagraphModuleColumnsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<ColumnsSortFields>;
};

export type SingleVideoModule = FlexibleModule & {
  __typename?: 'SingleVideoModule';
  Columns: ColumnsConnection;
  ContentAreaID: Scalars['Int'];
  CreatedFromID?: Maybe<Scalars['Int']>;
  CreatedFromVersion?: Maybe<Scalars['Int']>;
  DetachedFromSavedModule?: Maybe<Scalars['Boolean']>;
  EcommerceEnabled: Scalars['Boolean'];
  ID: Scalars['Int'];
  LibraryItemID: Scalars['Int'];
  MemberSortOrder: Scalars['Int'];
  ModuleGroup?: Maybe<ModuleGroupEnum>;
  PossibleColumnDimensions: Array<ColumnDimension>;
  PresetName: Scalars['String'];
  PresetType: FlexibleModuleEnum;
  SortableColumns: Scalars['Boolean'];
  Swappable: Scalars['Boolean'];
};


export type SingleVideoModuleColumnsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<ColumnsSortFields>;
};

export type SiteConfig = {
  __typename?: 'SiteConfig';
  SiteOutageAlertForClients?: Maybe<Scalars['String']>;
};

export type SiteTree = {
  __typename?: 'SiteTree';
  ID: Scalars['Int'];
  Link: Scalars['String'];
  Meta?: Maybe<Meta>;
  PageType: Scalars['String'];
  ParentID: Scalars['Int'];
  Title: Scalars['String'];
  URLSegment: Scalars['String'];
  id: Scalars['ID'];
  version?: Maybe<Scalars['Int']>;
  versions?: Maybe<LibraryPageVersionConnection>;
};


export type SiteTreeVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<VersionsSimpleSortFields>;
};

export type SiteTreeLink = {
  __typename?: 'SiteTreeLink';
  Anchor?: Maybe<Scalars['String']>;
  ExternalLink?: Maybe<Scalars['String']>;
  ID: Scalars['ID'];
  LinkToLoginModal?: Maybe<Scalars['Boolean']>;
  Title?: Maybe<Scalars['String']>;
  URL?: Maybe<Scalars['String']>;
};

export type SocialAd = {
  BodyText: Scalars['String'];
  Date: Scalars['String'];
  Engagements: AdEngagements;
  ExternalID: Scalars['String'];
  ID: Scalars['String'];
  Image: Scalars['String'];
  Performance: AdPerformance;
  PreviewImage: Scalars['String'];
  PreviewShareableLink: Scalars['String'];
  Thumbnail?: Maybe<Scalars['String']>;
  Title: Scalars['String'];
  Top10: Scalars['Boolean'];
  Type: Scalars['String'];
};

export enum SocialAdTypeEnum {
  Facebook = 'Facebook',
  FacebookAd = 'FacebookAd',
  FacebookCampaign = 'FacebookCampaign',
  InstagramMedia = 'InstagramMedia',
  Pinterest = 'Pinterest'
}

export type SocialAdUnion = FacebookSocialAd | FacebookSocialCampaign | InstagramMediaSocialAd;

export type SocialAdsSummary = {
  __typename?: 'SocialAdsSummary';
  ClickThroughRate: Scalars['Float'];
  Clicks: Scalars['Int'];
  ConversionRate: Scalars['Float'];
  ID: Scalars['String'];
  Impressions: Scalars['Int'];
  Reach: Scalars['Int'];
};

export type SocialLoginInput = {
  AccessToken?: InputMaybe<Scalars['String']>;
  Email?: InputMaybe<Scalars['Email']>;
  FirstName?: InputMaybe<Scalars['String']>;
  LastName?: InputMaybe<Scalars['String']>;
  Provider: Scalars['String'];
  ProviderUserId: Scalars['String'];
};

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** Enum for sorting direction */
export enum SortDirectionEnum {
  Asc = 'asc',
  Desc = 'desc'
}

export type SortOrderInput = {
  ID: Scalars['Int'];
  SortOrder: Scalars['Int'];
};

export type SortableItem = {
  ID: Scalars['Int'];
  MemberSortOrder: Scalars['Int'];
};

export enum SortableItemEnum {
  Article = 'Article',
  Award = 'Award',
  DiagramImage = 'DiagramImage',
  LibraryDownload = 'LibraryDownload',
  LibraryImage = 'LibraryImage',
  LibraryLocation = 'LibraryLocation',
  LibraryVideo = 'LibraryVideo',
  ModuleColumn = 'ModuleColumn',
  MultiColumnModule = 'MultiColumnModule',
  Product = 'Product',
  ProfessionalService = 'ProfessionalService',
  Project = 'Project',
  TeamMember = 'TeamMember',
  Testimonial = 'Testimonial'
}

export type SpeakerLineupModule = ModuleType & {
  __typename?: 'SpeakerLineupModule';
  AnchorTag?: Maybe<Scalars['String']>;
  Date?: Maybe<Scalars['String']>;
  ExtraClass?: Maybe<Scalars['String']>;
  HideSpeakers?: Maybe<Scalars['Boolean']>;
  ID: Scalars['ID'];
  NavigationLabel?: Maybe<Scalars['String']>;
  SpacingBelow?: Maybe<Scalars['String']>;
  SpacingBelowMobile?: Maybe<Scalars['String']>;
  /** The speaker lineup at an event */
  Speakers: KeynoteSpeakers_Connection;
  ThemeColour: ThemedElementColourType;
  Title?: Maybe<Scalars['String']>;
};


export type SpeakerLineupModuleSpeakersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<KeynoteSpeakers_SortFields>;
};

export type SpeakersSimpleSortFields = {
  SortOrder?: InputMaybe<SortDirection>;
};

export enum SpecialtyPriceTypeEnum {
  Customer = 'CUSTOMER',
  Trade = 'TRADE'
}

export type SpecialtyRateCategories = {
  __typename?: 'SpecialtyRateCategories';
  Category?: Maybe<Array<Category>>;
  CustomerRate: Scalars['Float'];
  ID: Scalars['Int'];
  TradeProductRate: Scalars['Float'];
  TradeSampleRate: Scalars['Float'];
};

export type SpecialtyRateCategoriesInput = {
  CustomerPriceProducts: Scalars['Float'];
  ID: Scalars['Int'];
  TradePriceProducts: Scalars['Float'];
  TradePriceSamples: Scalars['Float'];
};

export type SquarespaceSyncStatus = SyncStatus & {
  __typename?: 'SquarespaceSyncStatus';
  /** @deprecated No longer provided */
  BulkImportID?: Maybe<Scalars['String']>;
  Errors: Array<ImportError>;
  Finished: Scalars['Boolean'];
  RequestID: Scalars['String'];
  StartedTimestamp?: Maybe<Scalars['Int']>;
  SuccessfullySyncedCount: Scalars['Int'];
  TotalProcessed: Scalars['Int'];
  TotalToSync?: Maybe<Scalars['Int']>;
};

export type StaticGalleryModule = ModuleType & {
  __typename?: 'StaticGalleryModule';
  AnchorTag?: Maybe<Scalars['String']>;
  Content?: Maybe<Scalars['String']>;
  ExtraClass?: Maybe<Scalars['String']>;
  FirstDesktopImage?: Maybe<LibraryImageFile>;
  FirstMobileImage?: Maybe<LibraryImageFile>;
  ID: Scalars['ID'];
  NavigationLabel?: Maybe<Scalars['String']>;
  SecondDesktopImage?: Maybe<LibraryImageFile>;
  SecondMobileImage?: Maybe<LibraryImageFile>;
  SpacingBelow?: Maybe<Scalars['String']>;
  SpacingBelowMobile?: Maybe<Scalars['String']>;
  ThemeColour: ThemedElementColourType;
  ThirdDesktopImage?: Maybe<LibraryImageFile>;
  ThirdMobileImage?: Maybe<LibraryImageFile>;
  Title?: Maybe<Scalars['String']>;
};

export type StockInfo = {
  __typename?: 'StockInfo';
  DeliveryAvailable: Scalars['Boolean'];
  InStock: Scalars['Boolean'];
  SampleAvailable: Scalars['Boolean'];
};

export type SupplierOrder = {
  __typename?: 'SupplierOrder';
  Actions: Array<SupplierOrderAction>;
  BillingAddress?: Maybe<Address>;
  Comment: Scalars['String'];
  Consignments: ConsignmentsConnection;
  Created: Scalars['String'];
  DeclinedReturnCount: Scalars['Int'];
  DeliveryAddress?: Maybe<Address>;
  Dispatches: Array<Dispatch>;
  Events: Array<OrderEvent>;
  ExternalOrderReference?: Maybe<Scalars['String']>;
  HasClickAndCollect: Scalars['Boolean'];
  HasDelivery: Scalars['Boolean'];
  HasRefunds: Scalars['Boolean'];
  ID: Scalars['Int'];
  IsNew: Scalars['Boolean'];
  ItemTotal: CurrencyAmount;
  ItemsCount: Scalars['Int'];
  ItemsProcessed: Scalars['Int'];
  NotifyCustomer: Scalars['Boolean'];
  Order: Order;
  OrderCompleted: Scalars['String'];
  OrderGrossTotal: CurrencyAmount;
  OrderItems: Array<OrderItem>;
  OrderNumber: Scalars['String'];
  OrderTotal: CurrencyAmount;
  PaymentExpired: Scalars['Boolean'];
  PendingReturnCount: Scalars['Int'];
  PickupEstimate?: Maybe<Scalars['String']>;
  PickupLocation?: Maybe<LibraryLocation>;
  PickupLocationLabel: Scalars['String'];
  RefundableShipping: CurrencyAmount;
  ShippingCost: CurrencyAmount;
  ShippingRefunded: CurrencyAmount;
  Status: OrderStatusEnum;
  StatusText: Scalars['String'];
  Supplier: Professional;
  TaxRate: Scalars['Float'];
  TaxSystem: Scalars['String'];
  TaxTotal: CurrencyAmount;
  TotalRefunded: CurrencyAmount;
};


export type SupplierOrderConsignmentsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type SupplierOrderAction = {
  __typename?: 'SupplierOrderAction';
  Action: SupplierOrderActionEnum;
  ByMember?: Maybe<Member>;
  Created: Scalars['String'];
  Events: Array<OrderEvent>;
  ID: Scalars['Int'];
  Message: Scalars['String'];
  Reason: Scalars['String'];
  SupplierOrder: SupplierOrder;
};

export enum SupplierOrderActionEnum {
  Cancel = 'CANCEL',
  Confirm = 'CONFIRM',
  Edit = 'EDIT'
}

export type SupplierOrdersConnection = {
  __typename?: 'SupplierOrdersConnection';
  ID: Scalars['String'];
  edges: Array<SupplierOrdersConnectionEdge>;
  nodes: Array<SupplierOrder>;
  pageInfo: ApPageInfo;
};

/** The collections edge */
export type SupplierOrdersConnectionEdge = {
  __typename?: 'SupplierOrdersConnectionEdge';
  /** The node at the end of the collections edge */
  node: SupplierOrder;
};

export type SupplierOrdersSimpleSortFields = {
  Created?: InputMaybe<SortDirection>;
  OrderNumber?: InputMaybe<SortDirection>;
};

export enum SupportedCountry {
  Au = 'AU',
  Nz = 'NZ',
  Us = 'US'
}

export type SyncEnquiryOAuthEmailType = {
  __typename?: 'SyncEnquiryOAuthEmailType';
  /** Whether the sync operation completed successfully */
  success: Scalars['Boolean'];
  /** IDs of the OAuth accounts that were successfully synced */
  syncedOAuthIDs?: Maybe<Array<Scalars['Int']>>;
  /** Number of email replies that were synced */
  syncedReplyCount: Scalars['Int'];
  /** Total duration of the sync operation in seconds */
  totalSyncDuration: Scalars['Float'];
};

export type SyncStatus = {
  /** @deprecated No longer provided */
  BulkImportID?: Maybe<Scalars['String']>;
  Errors: Array<ImportError>;
  Finished: Scalars['Boolean'];
  RequestID: Scalars['String'];
  StartedTimestamp?: Maybe<Scalars['Int']>;
  SuccessfullySyncedCount: Scalars['Int'];
  TotalProcessed: Scalars['Int'];
  TotalToSync?: Maybe<Scalars['Int']>;
};

export type SynonymsConnection = {
  __typename?: 'SynonymsConnection';
  edges: Array<SynonymsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type SynonymsConnectionEdge = {
  __typename?: 'SynonymsConnectionEdge';
  /** The node at the end of the collections edge */
  node: ProductColorSynonym;
};

/** Message representing changes to a conversation (e.g. The settings were updated). */
export type SystemMessage = Message & {
  __typename?: 'SystemMessage';
  Created: Scalars['String'];
  CreatedBy: Scalars['String'];
  FirstReadBy: FirstReadBy;
  ID: Scalars['ID'];
  MemberEnquiryEmail?: Maybe<MemberEnquiryEmail>;
  Participant: Participant;
  /** The type of system message. */
  Type: SystemMessageType;
  /** The value of the system message. Only exists for certain types. */
  Value?: Maybe<Scalars['String']>;
  /** The BuildHub project linked to the system message. Only exists for the `BuildHubChanged` type. */
  ValueBuildHub?: Maybe<BuildHub>;
  /** The value ID of the system message. Only exists for certain types. */
  ValueID: Scalars['Int'];
  /** The participant linked to the system message. Only exists for the `ParticipantAdded` and `ParticipantRemoved` types. */
  ValueParticipant?: Maybe<MemberParticipant>;
};

/** The type of system message. */
export enum SystemMessageType {
  /** The linked BuildHub project was changed. */
  BuildHubChanged = 'BuildHubChanged',
  /** The conversation title was updated. */
  NameChanged = 'NameChanged',
  /** A participant was added to the conversation. */
  ParticipantAdded = 'ParticipantAdded',
  /** A participant was removed from the conversation. */
  ParticipantRemoved = 'ParticipantRemoved'
}

export type TableData = {
  __typename?: 'TableData';
  ID: Scalars['String'];
  Name: Scalars['String'];
  Values: Array<RowData>;
};

export type TagTarget = {
  ID: Scalars['Int'];
};

export type TaggedProductsByRecordFilters = {
  EVENT_DATE_HOST__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
  INLIBRARY__EQUAL?: InputMaybe<Scalars['Int']>;
  PARENT_ID__EQUAL?: InputMaybe<Scalars['Int']>;
  PARENT_NAME__EQUAL?: InputMaybe<Scalars['String']>;
  PARENT_TAG__EQUAL?: InputMaybe<Scalars['String']>;
  PRODUCT_NAME__EQUAL?: InputMaybe<Scalars['String']>;
};

export type TaggedRecordsFilters = {
  EVENT_DATE_HOST__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
  INLIBRARY__EQUAL?: InputMaybe<Scalars['Int']>;
  PARENT_NAME__EQUAL?: InputMaybe<Scalars['String']>;
  PARENT_TAG__EQUAL?: InputMaybe<Scalars['String']>;
  PRODUCT_NAME__EQUAL?: InputMaybe<Scalars['String']>;
};

export type TaggedRecordsSort = {
  CLICK_THROUGH_RATE?: InputMaybe<PrioritySort>;
  CONVERSIONS?: InputMaybe<PrioritySort>;
  CONVERSION_RATE?: InputMaybe<PrioritySort>;
  IMPRESSIONS?: InputMaybe<PrioritySort>;
  OWNER?: InputMaybe<PrioritySort>;
  PAGE_NAME?: InputMaybe<PrioritySort>;
  PRODUCT_TAGS?: InputMaybe<PrioritySort>;
  PRODUCT_VIEWS?: InputMaybe<PrioritySort>;
  SESSIONS?: InputMaybe<PrioritySort>;
  TOTAL_TIME_ON_PAGES?: InputMaybe<PrioritySort>;
  USERS?: InputMaybe<PrioritySort>;
};

export type TeamMember = PermissionInterface & SortableItem & {
  __typename?: 'TeamMember';
  Approved: Scalars['Int'];
  CalendarConnection?: Maybe<Array<CalendarConnectionSummary>>;
  Email: Scalars['String'];
  HasInboxAccess: Scalars['Int'];
  HideEmail: Scalars['Boolean'];
  HideJobTitle: Scalars['Boolean'];
  HideLinkedInLink: Scalars['Boolean'];
  HidePhone: Scalars['Boolean'];
  ID: Scalars['Int'];
  IsOwner: Scalars['Int'];
  IsPublic: Scalars['Boolean'];
  JobTitle?: Maybe<Scalars['String']>;
  LicenseNumber?: Maybe<Scalars['String']>;
  LinkedInLink?: Maybe<Scalars['String']>;
  MemberID: Scalars['Int'];
  MemberImage?: Maybe<MemberImage>;
  MemberOAuths?: Maybe<Array<MemberOAuth>>;
  MemberSortOrder: Scalars['Int'];
  Name: Scalars['String'];
  Permissions: Array<PermissionEnum>;
  Phone?: Maybe<Scalars['String']>;
  Professional: Professional;
  SortOrder: Scalars['Int'];
  Summary?: Maybe<Scalars['String']>;
};

export type TeamMemberInput = {
  Email?: InputMaybe<Scalars['StringInput']>;
  HideEmail?: InputMaybe<Scalars['Boolean']>;
  HideJobTitle?: InputMaybe<Scalars['Boolean']>;
  HideLinkedInLink?: InputMaybe<Scalars['Boolean']>;
  HidePhone?: InputMaybe<Scalars['Boolean']>;
  ID?: InputMaybe<Scalars['Int']>;
  Image?: InputMaybe<Scalars['Upload']>;
  IsPublic?: InputMaybe<Scalars['Boolean']>;
  JobTitle?: InputMaybe<Scalars['StringInput']>;
  LicenseNumber?: InputMaybe<Scalars['StringInput']>;
  LinkedInLink?: InputMaybe<Scalars['StringInput']>;
  Message?: InputMaybe<Scalars['StringInput']>;
  Name?: InputMaybe<Scalars['StringInput']>;
  Phone?: InputMaybe<Scalars['StringInput']>;
  Summary?: InputMaybe<Scalars['StringInput']>;
};

export type TeamMemberNotification = WebsiteNotificationInterface & {
  __typename?: 'TeamMemberNotification';
  Action: WebsiteNotificationAction;
  CreatedAt: Scalars['String'];
  CreatedBy: Member;
  ID: Scalars['ID'];
  IsRead: Scalars['Boolean'];
  LastEdited: Scalars['String'];
  PhotoTileURL?: Maybe<Scalars['String']>;
  Professional: Professional;
  TeamMember: TeamMember;
};

export type TeamMembersConnection = {
  __typename?: 'TeamMembersConnection';
  edges: Array<TeamMembersConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type TeamMembersConnectionEdge = {
  __typename?: 'TeamMembersConnectionEdge';
  /** The node at the end of the collections edge */
  node: TeamMember;
};

export type TeamMembersFilters = {
  /** Filter team members that are approved */
  Approved__in?: InputMaybe<Scalars['Boolean']>;
  /** Filter team members that are publicy visible */
  Ispublic__in?: InputMaybe<Scalars['Boolean']>;
  /** Filter team members partial matched by Name */
  Name__partial_match?: InputMaybe<Scalars['String']>;
};

export type TeamMembersSortFields = {
  MemberSortOrder?: InputMaybe<SortDirection>;
  Name?: InputMaybe<SortDirection>;
};

export type TemplateToken = {
  __typename?: 'TemplateToken';
  class: Scalars['String'];
  resolveAt: TokenResolveAt;
  root: Scalars['String'];
  token: Scalars['String'];
};

export type TemplateTokenBinding = {
  __typename?: 'TemplateTokenBinding';
  class: Scalars['String'];
  id: Scalars['ID'];
  label: Scalars['String'];
};

export type Testimonial = SortableItem & {
  __typename?: 'Testimonial';
  Content: Scalars['String'];
  ID: Scalars['Int'];
  Location: Scalars['String'];
  MemberSortOrder: Scalars['Int'];
  Rating: Scalars['Int'];
  SortOrder: Scalars['Int'];
  Source?: Maybe<Scalars['String']>;
};

export type TestimonialModule = ModuleType & {
  __typename?: 'TestimonialModule';
  AnchorTag?: Maybe<Scalars['String']>;
  ExtraClass?: Maybe<Scalars['String']>;
  ID: Scalars['ID'];
  NavigationLabel?: Maybe<Scalars['String']>;
  SpacingBelow?: Maybe<Scalars['String']>;
  SpacingBelowMobile?: Maybe<Scalars['String']>;
  /** List of testimonials */
  Testimonials: Testimonials_Connection;
  ThemeColour: ThemedElementColourType;
};


export type TestimonialModuleTestimonialsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Testimonials_SortFields>;
};

export type TestimonialsList = {
  Content?: InputMaybe<Scalars['StringInput']>;
  ID: Scalars['Int'];
  Location?: InputMaybe<Scalars['StringInput']>;
  MemberSortOrder?: InputMaybe<Scalars['Int']>;
  Rating?: InputMaybe<Scalars['Int']>;
  SortOrder?: InputMaybe<Scalars['Int']>;
  Source?: InputMaybe<Scalars['StringInput']>;
};

export type Testimonials_Connection = {
  __typename?: 'Testimonials_Connection';
  edges: Array<Testimonials_ConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type Testimonials_ConnectionEdge = {
  __typename?: 'Testimonials_ConnectionEdge';
  /** The node at the end of the collections edge */
  node: EventTestimonial;
};

export type Testimonials_SortFields = {
  SortOrder?: InputMaybe<SortDirection>;
};

export type TextCarouselItem = {
  __typename?: 'TextCarouselItem';
  CTA?: Maybe<SiteTreeLink>;
  Content?: Maybe<Scalars['String']>;
  ID: Scalars['ID'];
  Links: TextCarouselItem_LinksConnection;
  LinksTitle?: Maybe<Scalars['String']>;
  Subtitle?: Maybe<Scalars['String']>;
  Title?: Maybe<Scalars['String']>;
};


export type TextCarouselItemLinksArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<TextCarouselItem_LinksSortFields>;
};

export type TextCarouselItem_LinksConnection = {
  __typename?: 'TextCarouselItem_LinksConnection';
  edges: Array<TextCarouselItem_LinksConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type TextCarouselItem_LinksConnectionEdge = {
  __typename?: 'TextCarouselItem_LinksConnectionEdge';
  /** The node at the end of the collections edge */
  node: ExternalLink;
};

export type TextCarouselItem_LinksSortFields = {
  SortOrder?: InputMaybe<SortDirection>;
};

export type TextColumn = ModuleColumn & SortableItem & {
  __typename?: 'TextColumn';
  Content?: Maybe<Scalars['String']>;
  ID: Scalars['Int'];
  IsEmpty: Scalars['Boolean'];
  MemberSortOrder: Scalars['Int'];
  ModuleID: Scalars['Int'];
  ProductID?: Maybe<Scalars['Int']>;
  ReadOnly: Scalars['Boolean'];
  TextType: TextTypeEnum;
  WordCount: Scalars['Int'];
};

/** A generic message with text content. */
export type TextMessage = Message & {
  __typename?: 'TextMessage';
  Content: Scalars['String'];
  Created: Scalars['String'];
  CreatedBy: Scalars['String'];
  FirstReadBy: FirstReadBy;
  ID: Scalars['ID'];
  IsHTML: Scalars['Boolean'];
  MemberEnquiryEmail?: Maybe<MemberEnquiryEmail>;
  Participant: Participant;
};

export enum TextTypeEnum {
  H3 = 'h3',
  Paragraph = 'paragraph',
  Quote = 'quote'
}

export enum ThemedElementColourType {
  Dark = 'dark',
  Grey = 'grey',
  Light = 'light',
  Sage = 'sage',
  Transparent = 'transparent'
}

export type Thumbnails_Connection = {
  __typename?: 'Thumbnails_Connection';
  edges: Array<Thumbnails_ConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type Thumbnails_ConnectionEdge = {
  __typename?: 'Thumbnails_ConnectionEdge';
  /** The node at the end of the collections edge */
  node: LibraryImageFile;
};

export type Thumbnails_SortFields = {
  SortOrder?: InputMaybe<SortDirection>;
};

export type TimeSpent = {
  __typename?: 'TimeSpent';
  Glanced: Scalars['Int'];
  ID: Scalars['String'];
  Read: Scalars['Int'];
  Skimmed: Scalars['Int'];
};

export type TimezoneFreeDaysType = {
  __typename?: 'TimezoneFreeDaysType';
  days: Array<FreeDayType>;
  timezone: Scalars['String'];
};

export type TitleWithUrlSegment = {
  __typename?: 'TitleWithURLSegment';
  ID: Scalars['Int'];
  Title: Scalars['String'];
  URLSegment: Scalars['String'];
};

export enum TokenResolveAt {
  Authoring = 'Authoring',
  Sending = 'Sending'
}

export enum TokenTemplateType {
  BusinessTerms = 'BusinessTerms',
  Email = 'Email',
  Invoice = 'Invoice'
}

/** A tokenised field is an editable field that contains tokens which renders out with different content than the input */
export type TokenisedField = {
  __typename?: 'TokenisedField';
  Raw: Scalars['String'];
  Render: Scalars['String'];
};

export type TopClickedTagsFilters = {
  EVENT_DATE_HOST__BETWEEN?: InputMaybe<Array<Scalars['String']>>;
  INLIBRARY__EQUAL?: InputMaybe<Scalars['Int']>;
  PARENT_NAME__EQUAL?: InputMaybe<Scalars['String']>;
  PARENT_TAG__EQUAL?: InputMaybe<Scalars['String']>;
  PRODUCT_NAME__EQUAL?: InputMaybe<Scalars['String']>;
};

/** Return most recently created items */
export type TopLibraryItems = {
  __typename?: 'TopLibraryItems';
  Articles?: Maybe<Array<DirectoryItem>>;
  Products?: Maybe<Array<DirectoryItem>>;
  Professionals?: Maybe<Array<DirectoryItem>>;
  Projects?: Maybe<Array<DirectoryItem>>;
};

export type TopPerformer = {
  __typename?: 'TopPerformer';
  Count: Scalars['Int'];
  DirectoryItem: DirectoryItem;
  ID: Scalars['String'];
};

export type TrendingCategories_Connection = {
  __typename?: 'TrendingCategories_Connection';
  ID: Scalars['String'];
  edges: Array<TrendingCategories_ConnectionEdge>;
  nodes: Array<Category>;
  pageInfo: ApPageInfo;
};

/** The collections edge */
export type TrendingCategories_ConnectionEdge = {
  __typename?: 'TrendingCategories_ConnectionEdge';
  /** The node at the end of the collections edge */
  node: Category;
};

export type TrioImageModule = FlexibleModule & {
  __typename?: 'TrioImageModule';
  Columns: ColumnsConnection;
  ContentAreaID: Scalars['Int'];
  CreatedFromID?: Maybe<Scalars['Int']>;
  CreatedFromVersion?: Maybe<Scalars['Int']>;
  DetachedFromSavedModule?: Maybe<Scalars['Boolean']>;
  EcommerceEnabled: Scalars['Boolean'];
  ID: Scalars['Int'];
  LibraryItemID: Scalars['Int'];
  MemberSortOrder: Scalars['Int'];
  ModuleGroup?: Maybe<ModuleGroupEnum>;
  PossibleColumnDimensions: Array<ColumnDimension>;
  PresetName: Scalars['String'];
  PresetType: FlexibleModuleEnum;
  SortableColumns: Scalars['Boolean'];
  Swappable: Scalars['Boolean'];
};


export type TrioImageModuleColumnsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<ColumnsSortFields>;
};

export type UnionModulePage = GuestHomePage | ModulePage;

export type UnlinkAwardFromEntityMutationType = Award | NotAuthorizedError | NotFoundError;

export type UpdateCalendarSessionInput = {
  availability?: InputMaybe<Array<CalendarSessionAvailabilityInput>>;
  customMessage?: InputMaybe<Scalars['String']>;
  durations?: InputMaybe<Array<CalendarSessionDurationInput>>;
  emailReminders?: InputMaybe<Array<CalendarSessionEmailReminderInput>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  locationString?: InputMaybe<Scalars['String']>;
  locationType?: InputMaybe<Scalars['String']>;
  meetingCover?: InputMaybe<Scalars['String']>;
  meetingType?: InputMaybe<Scalars['String']>;
  oneOnOneTeamMemberId?: InputMaybe<Scalars['Int']>;
  sessionName?: InputMaybe<Scalars['String']>;
  teamMembers?: InputMaybe<Array<Scalars['Int']>>;
  timezone?: InputMaybe<Scalars['String']>;
  unavailableDateRanges?: InputMaybe<Array<CalendarSessionUnavailableDateRangeInput>>;
};

/** The result of the `updateConversation` and `updateConversationParticipants` mutations. */
export type UpdateConversationPayload = {
  __typename?: 'UpdateConversationPayload';
  /** The updated conversation. */
  Conversation: DirectConversation;
  /** The system messages created as a result of the update. */
  SystemMessages: Array<SystemMessage>;
};

export type UpdateEnquiryParticipantStatusResult = {
  __typename?: 'UpdateEnquiryParticipantStatusResult';
  Conversation: EnquiryConversation;
  Participant?: Maybe<EnquiryParticipant>;
};

export type UpdateLibraryImageInput = {
  /** Full screen width (no padding) */
  FullScreen?: InputMaybe<Scalars['Boolean']>;
  /** ID of the LibrayImage you are updating */
  ID: Scalars['Int'];
  /** Show overlay on banner image */
  Overlay?: InputMaybe<Scalars['Boolean']>;
  /** Professional ID for photo credit */
  PhotoCreditID?: InputMaybe<Scalars['Int']>;
  /** custom string photo credit not associated with Professional */
  PhotoCreditName?: InputMaybe<Scalars['StringInput']>;
  /** Regenerate the image with watermark reflective of photo credit */
  Regenerate?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateMeInput = {
  AgeGroup?: InputMaybe<Scalars['StringInput']>;
  Budget?: InputMaybe<Scalars['StringInput']>;
  BuildStatus?: InputMaybe<Scalars['StringInput']>;
  Company?: InputMaybe<Scalars['StringInput']>;
  Email?: InputMaybe<Scalars['Email']>;
  FirstName?: InputMaybe<Scalars['StringInput']>;
  HomeownerBudgetID?: InputMaybe<Scalars['Int']>;
  HomeownerPurposeID?: InputMaybe<Scalars['Int']>;
  HomeownerStageID?: InputMaybe<Scalars['Int']>;
  Industry?: InputMaybe<Scalars['Int']>;
  JobTitle?: InputMaybe<Scalars['StringInput']>;
  Phone?: InputMaybe<Scalars['StringInput']>;
  PostSignupQuestionnaireSeen?: InputMaybe<Scalars['Boolean']>;
  ProfessionalCategoryID?: InputMaybe<Scalars['Int']>;
  ProfessionalListingInterest?: InputMaybe<Scalars['Boolean']>;
  ProfessionalTargetMarket?: InputMaybe<ProfessionalTargetMarketType>;
  ProfilePicture?: InputMaybe<Scalars['Upload']>;
  Region?: InputMaybe<Scalars['StringInput']>;
  Section?: InputMaybe<Scalars['Boolean']>;
  Style?: InputMaybe<Scalars['StringInput']>;
  Surname?: InputMaybe<Scalars['StringInput']>;
  UserClassification?: InputMaybe<UserClassificationType>;
  Website?: InputMaybe<Scalars['StringInput']>;
  When?: InputMaybe<Scalars['StringInput']>;
  Where?: InputMaybe<Scalars['StringInput']>;
};

export type UpdateMetaInput = {
  MetaDescription?: InputMaybe<Scalars['StringInput']>;
  Title?: InputMaybe<Scalars['StringInput']>;
};

export type UpdateOrganizationNetworkParticipantData = {
  /** ID of the participant that is being updated */
  participantId: Scalars['ID'];
  updates: OrganizationNetworkParticipantUpdateData;
};

export type UpdatePasswordInput = {
  Current: Scalars['String'];
  New: Scalars['String'];
};

export type UpdateProductPricingInput = {
  ID: Scalars['Int'];
  Maximum?: InputMaybe<Scalars['Int']>;
  Minimum?: InputMaybe<Scalars['Int']>;
  PricingType?: InputMaybe<ProductPricingTypeEnum>;
  Retail?: InputMaybe<Scalars['Int']>;
  Sale?: InputMaybe<Scalars['Int']>;
  Sample?: InputMaybe<Scalars['Int']>;
  SampleEnabled?: InputMaybe<Scalars['Boolean']>;
  SampleShippingID?: InputMaybe<Scalars['Int']>;
  Trade?: InputMaybe<Scalars['Int']>;
  Unit?: InputMaybe<PriceUnitEnum>;
};

export type UpdateProfessionalAwardInput = {
  AwardingInstitutionTitle?: InputMaybe<Scalars['StringInput']>;
  File?: InputMaybe<Scalars['Upload']>;
  MemberSortOrder?: InputMaybe<Scalars['Int']>;
  Title?: InputMaybe<Scalars['StringInput']>;
  YearAwarded?: InputMaybe<Scalars['StringInput']>;
};

export enum UploadErrorCodeEnum {
  CorruptedFile = 'CorruptedFile',
  EmptyFile = 'EmptyFile',
  FileTypeMismatch = 'FileTypeMismatch',
  InvalidLandscapeImageDimension = 'InvalidLandscapeImageDimension',
  InvalidPortraitImageDimension = 'InvalidPortraitImageDimension',
  ModuleExceedLimit = 'ModuleExceedLimit',
  NoPermission = 'NoPermission',
  UnknownError = 'UnknownError',
  UnsupportedFileType = 'UnsupportedFileType'
}

export type User = {
  APID: Scalars['String'];
  DesignBoard: DesignBoardResult;
  DesignBoardsPins: DesignBoardPinsConnection;
  EcommerceBookingURL: Scalars['String'];
  Enrichment?: Maybe<Scalars['String']>;
  FeatureFlags?: Maybe<Array<FeatureFlag>>;
  ID: Scalars['Int'];
  ShoppingCart?: Maybe<ShoppingCart>;
};


export type UserDesignBoardArgs = {
  Link: Scalars['String'];
};


export type UserDesignBoardsPinsArgs = {
  filter?: InputMaybe<DesignBoardsPinsFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<DesignBoardsPinsSimpleSortFields>;
};

export enum UserClassificationType {
  Homeowner = 'Homeowner',
  Professional = 'Professional'
}

export type UserError = ErrorInterface & {
  __typename?: 'UserError';
  Message: Scalars['String'];
};

/** registered device info on the current user, Expo token is omitted intentionally to avoid leaking. */
export type UserPushDevice = {
  __typename?: 'UserPushDevice';
  AppVersion?: Maybe<Scalars['String']>;
  DeviceID: Scalars['String'];
  Enabled: Scalars['Boolean'];
};

export type UserPushDevicesResponse = MyPushDevices | NotAuthorizedError | NotFoundError | ServerError | UserError;

export type UsersSummary = {
  __typename?: 'UsersSummary';
  AvgDailyUsers: Scalars['Int'];
  AvgSessionDuration: Scalars['String'];
  ID: Scalars['String'];
  NewUsers: Scalars['Int'];
  Sessions: Scalars['Int'];
  TotalUsers: Scalars['Int'];
};

export type Variant = {
  __typename?: 'Variant';
  AllowsBackOrder: Scalars['Boolean'];
  AvailableSampleStock: Scalars['Int'];
  AvailableStock: Scalars['Int'];
  Barcode: Scalars['String'];
  CanPurchase: Scalars['Boolean'];
  CoverageArea: Scalars['Int'];
  HasUnlimitedSample: Scalars['Boolean'];
  HasUnlimitedStock: Scalars['Boolean'];
  ID: Scalars['Int'];
  Image?: Maybe<LibraryImage>;
  IsHidden: Scalars['Boolean'];
  IsOnSale: Scalars['Boolean'];
  IsPublished?: Maybe<Scalars['Boolean']>;
  IsTradeOnly: Scalars['Boolean'];
  LeadTime: Scalars['Int'];
  LeadTimeUnit?: Maybe<LeadTimeUnitEnum>;
  MaxPrice: CurrencyAmount;
  MemberPrice?: Maybe<CurrencyAmount>;
  /** Deprecated. */
  Name?: Maybe<Scalars['String']>;
  Options: Array<AttributeOption>;
  Price: CurrencyAmount;
  PriceType: Scalars['String'];
  PriceUnit?: Maybe<PriceUnitEnum>;
  Product: Product;
  ProjectedSamplePrice: CurrencyAmount;
  QuantityPerUnit: Scalars['Int'];
  RetailPrice: CurrencyAmount;
  SKU?: Maybe<Scalars['String']>;
  SaleFinish?: Maybe<Scalars['String']>;
  SalePrice: CurrencyAmount;
  SaleStart?: Maybe<Scalars['String']>;
  SampleEnabled: Scalars['Boolean'];
  SamplePrice: CurrencyAmount;
  SampleShippingProfile?: Maybe<ShippingProfile>;
  ShippingProfile?: Maybe<ShippingProfile>;
  Size?: Maybe<ProductSize>;
  SortOrder?: Maybe<Scalars['Int']>;
  SpecialtyPricingApplied?: Maybe<AppliedSpecialtyDiscountEnum>;
  StockLevels: Array<VariantStock>;
  StockType?: Maybe<VariantStockTypeEnum>;
  SupplierSKU?: Maybe<Scalars['String']>;
  SupplierVariantID?: Maybe<Scalars['String']>;
  Thumbnail?: Maybe<ResponsiveImage>;
  TradeOnlyEnabled: Scalars['Boolean'];
  TradePrice?: Maybe<CurrencyAmount>;
  TradeSamplePrice?: Maybe<CurrencyAmount>;
};


export type VariantAvailableSampleStockArgs = {
  ValidOnly?: InputMaybe<Scalars['Boolean']>;
};


export type VariantAvailableStockArgs = {
  ValidOnly?: InputMaybe<Scalars['Boolean']>;
};


export type VariantPriceArgs = {
  raw?: InputMaybe<Scalars['Boolean']>;
};


export type VariantPriceTypeArgs = {
  ValidOnly?: InputMaybe<Scalars['Boolean']>;
};


export type VariantSampleShippingProfileArgs = {
  ValidOnly?: InputMaybe<Scalars['Boolean']>;
};


export type VariantShippingProfileArgs = {
  ValidOnly?: InputMaybe<Scalars['Boolean']>;
};


export type VariantSpecialtyPricingAppliedArgs = {
  ValidOnly?: InputMaybe<Scalars['Boolean']>;
};


export type VariantStockLevelsArgs = {
  ValidOnly?: InputMaybe<Scalars['Boolean']>;
};


export type VariantTradePriceArgs = {
  Raw?: InputMaybe<Scalars['Boolean']>;
};

export type VariantInput = {
  AllowsBackOrder?: InputMaybe<Scalars['Boolean']>;
  Barcode?: InputMaybe<Scalars['StringInput']>;
  CoverageArea?: InputMaybe<Scalars['Int']>;
  ID: Scalars['Int'];
  IsHidden?: InputMaybe<Scalars['Boolean']>;
  IsOnSale?: InputMaybe<Scalars['Boolean']>;
  LeadTime?: InputMaybe<Scalars['Int']>;
  LeadTimeUnit?: InputMaybe<LeadTimeUnitEnum>;
  LowStockThreshold?: InputMaybe<Scalars['Int']>;
  MaxPrice?: InputMaybe<Scalars['Int']>;
  Name?: InputMaybe<Scalars['StringInput']>;
  Price?: InputMaybe<Scalars['Int']>;
  PriceUnit?: InputMaybe<PriceUnitEnum>;
  QuantityPerUnit?: InputMaybe<Scalars['Int']>;
  SKU?: InputMaybe<Scalars['StringInput']>;
  SaleFinish?: InputMaybe<Scalars['StringInput']>;
  SalePrice?: InputMaybe<Scalars['Int']>;
  SaleStart?: InputMaybe<Scalars['StringInput']>;
  SampleEnabled?: InputMaybe<Scalars['Boolean']>;
  SamplePrice?: InputMaybe<Scalars['Int']>;
  SampleShippingProfile?: InputMaybe<Scalars['Int']>;
  SampleStock?: InputMaybe<Scalars['Int']>;
  ShippingProfile?: InputMaybe<Scalars['Int']>;
  SortOrder?: InputMaybe<Scalars['Int']>;
  Stock?: InputMaybe<Scalars['Int']>;
  StockType?: InputMaybe<VariantStockTypeEnum>;
  SupplierSKU?: InputMaybe<Scalars['StringInput']>;
  TradeOnlyEnabled?: InputMaybe<Scalars['Boolean']>;
  TradePrice?: InputMaybe<Scalars['Int']>;
};

export type VariantOptionGroupInput = {
  Attribute: Scalars['Int'];
  Options: Array<Scalars['Int']>;
};

export type VariantShipping = {
  __typename?: 'VariantShipping';
  ID: Scalars['String'];
  Quantity: Scalars['Int'];
  ShippingCost: CurrencyAmount;
  ShippingCostText: Scalars['String'];
  ShippingMethod: ShippingMethod;
};

export type VariantShippingsConnection = {
  __typename?: 'VariantShippingsConnection';
  ID: Scalars['String'];
  edges: Array<VariantShippingsConnectionEdge>;
  nodes: Array<VariantShipping>;
  pageInfo: ApPageInfo;
};

/** The collections edge */
export type VariantShippingsConnectionEdge = {
  __typename?: 'VariantShippingsConnectionEdge';
  /** The node at the end of the collections edge */
  node: VariantShipping;
};

export type VariantStock = {
  __typename?: 'VariantStock';
  AllowPickup?: Maybe<Scalars['Boolean']>;
  AllowPostal?: Maybe<Scalars['Boolean']>;
  ID: Scalars['Int'];
  LastChecked?: Maybe<Scalars['String']>;
  LowStockThreshold: Scalars['Int'];
  SampleStock: Scalars['Int'];
  Stock: Scalars['Int'];
  Variant?: Maybe<Variant>;
};

export enum VariantStockTypeEnum {
  InStock = 'InStock',
  Indent = 'Indent',
  MadeToOrder = 'MadeToOrder'
}

export type VersionsSimpleSortFields = {
  version?: InputMaybe<SortDirection>;
};

export type VideoColumn = ModuleColumn & SortableItem & {
  __typename?: 'VideoColumn';
  ColumnDimension?: Maybe<ColumnDimension>;
  ID: Scalars['Int'];
  IsEmpty: Scalars['Boolean'];
  MemberSortOrder: Scalars['Int'];
  ModuleID: Scalars['Int'];
  ProductID?: Maybe<Scalars['Int']>;
  ReadOnly: Scalars['Boolean'];
  Video?: Maybe<LibraryVideo>;
  WordCount: Scalars['Int'];
};

export type VideoModule = ModuleType & {
  __typename?: 'VideoModule';
  AnchorTag?: Maybe<Scalars['String']>;
  AutoPlay?: Maybe<Scalars['Boolean']>;
  AutoPlayRedirect?: Maybe<Scalars['String']>;
  AutoPlayRedirectRequireLogin?: Maybe<Scalars['Boolean']>;
  ExternalVideoLink?: Maybe<Scalars['String']>;
  ExtraClass?: Maybe<Scalars['String']>;
  ID: Scalars['ID'];
  NavigationLabel?: Maybe<Scalars['String']>;
  PlaysInline?: Maybe<Scalars['Boolean']>;
  SpacingBelow?: Maybe<Scalars['String']>;
  SpacingBelowMobile?: Maybe<Scalars['String']>;
  ThemeColour: ThemedElementColourType;
  Title?: Maybe<Scalars['String']>;
  VideoCover?: Maybe<ResponsiveVariantImage>;
  VideoID?: Maybe<Scalars['String']>;
  VideoPlatform?: Maybe<Scalars['String']>;
};

export type VideoParagraphModule = FlexibleModule & {
  __typename?: 'VideoParagraphModule';
  Columns: ColumnsConnection;
  ContentAreaID: Scalars['Int'];
  CreatedFromID?: Maybe<Scalars['Int']>;
  CreatedFromVersion?: Maybe<Scalars['Int']>;
  DetachedFromSavedModule?: Maybe<Scalars['Boolean']>;
  EcommerceEnabled: Scalars['Boolean'];
  ID: Scalars['Int'];
  LibraryItemID: Scalars['Int'];
  MemberSortOrder: Scalars['Int'];
  ModuleGroup?: Maybe<ModuleGroupEnum>;
  PossibleColumnDimensions: Array<ColumnDimension>;
  PresetName: Scalars['String'];
  PresetType: FlexibleModuleEnum;
  SortableColumns: Scalars['Boolean'];
  Swappable: Scalars['Boolean'];
};


export type VideoParagraphModuleColumnsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<ColumnsSortFields>;
};

export type VideosConnection = {
  __typename?: 'VideosConnection';
  edges: Array<VideosConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type VideosConnectionEdge = {
  __typename?: 'VideosConnectionEdge';
  /** The node at the end of the collections edge */
  node: LibraryVideo;
};

export type VideosSortFields = {
  Created?: InputMaybe<SortDirection>;
  Featured?: InputMaybe<SortDirection>;
  MemberSortOrder?: InputMaybe<SortDirection>;
  SortOrder?: InputMaybe<SortDirection>;
  Title?: InputMaybe<SortDirection>;
  Type?: InputMaybe<SortDirection>;
};

export type WebsiteEvent = {
  Action: Scalars['String'];
  Created: Scalars['Int'];
  EventID: Scalars['String'];
  MemberID: Scalars['Int'];
  Professional: Scalars['String'];
  Resource: Scalars['String'];
  ResourceID: Scalars['String'];
};

export type WebsiteNotification = DesignBoardNotification | EnquiryNotification | GenericNotification | TeamMemberNotification;

export enum WebsiteNotificationAction {
  ContactDetailsRevealed = 'ContactDetailsRevealed',
  DesignBoardShared = 'DesignBoardShared',
  EnquiryConversationInviteAccepted = 'EnquiryConversationInviteAccepted',
  EnquiryConversationMemberInvited = 'EnquiryConversationMemberInvited',
  GenericNotification = 'GenericNotification',
  InviteAccepted = 'InviteAccepted',
  MemberInvited = 'MemberInvited',
  NewDesignBoardComment = 'NewDesignBoardComment',
  NewEnquiry = 'NewEnquiry',
  NewEnquiryComment = 'NewEnquiryComment',
  NewFollower = 'NewFollower',
  NewMemberUpload = 'NewMemberUpload',
  NewPin = 'NewPin',
  NewPinComment = 'NewPinComment',
  PinShared = 'PinShared',
  TeamMemberInvitationSent = 'TeamMemberInvitationSent'
}

export type WebsiteNotificationInterface = {
  Action: WebsiteNotificationAction;
  CreatedAt: Scalars['String'];
  CreatedBy: Member;
  ID: Scalars['ID'];
  IsRead: Scalars['Boolean'];
  LastEdited: Scalars['String'];
  PhotoTileURL?: Maybe<Scalars['String']>;
};

export type WelcomeEvents_Connection = {
  __typename?: 'WelcomeEvents_Connection';
  edges: Array<WelcomeEvents_ConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type WelcomeEvents_ConnectionEdge = {
  __typename?: 'WelcomeEvents_ConnectionEdge';
  /** The node at the end of the collections edge */
  node: EventDetails;
};

export type WelcomeEvents_SortFields = {
  SortOrder?: InputMaybe<SortDirection>;
};

export type WelcomeModule = ModuleType & {
  __typename?: 'WelcomeModule';
  AnchorTag?: Maybe<Scalars['String']>;
  BackgroundImages: BackgroundImages_Connection;
  /** URL of the background video */
  BackgroundVideo?: Maybe<Scalars['String']>;
  CTA?: Maybe<SiteTreeLink>;
  /** Events for registration */
  Events: WelcomeEvents_Connection;
  ExtraCTAText?: Maybe<Scalars['String']>;
  ExtraClass?: Maybe<Scalars['String']>;
  ID: Scalars['ID'];
  /** URL of the mobile background video (portrait mode) */
  MobileBackgroundVideo?: Maybe<Scalars['String']>;
  NavigationLabel?: Maybe<Scalars['String']>;
  PhotographyCredits?: Maybe<Scalars['String']>;
  Slogan?: Maybe<Scalars['String']>;
  SpacingBelow?: Maybe<Scalars['String']>;
  SpacingBelowMobile?: Maybe<Scalars['String']>;
  SponsorLogo?: Maybe<LibraryImageFile>;
  ThemeColour: ThemedElementColourType;
  Title?: Maybe<Scalars['String']>;
  TitleImageDesktop?: Maybe<LibraryImageFile>;
  TitleImageMobile?: Maybe<LibraryImageFile>;
};


export type WelcomeModuleBackgroundImagesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<BackgroundImages_SortFields>;
};


export type WelcomeModuleEventsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<WelcomeEvents_SortFields>;
};

export type WooCommerceSyncCounts = {
  __typename?: 'WooCommerceSyncCounts';
  Imported: Scalars['Int'];
  Total: Scalars['Int'];
};

export type WooCommerceSyncStatus = SyncStatus & {
  __typename?: 'WooCommerceSyncStatus';
  /** @deprecated No longer provided */
  BulkImportID?: Maybe<Scalars['String']>;
  Errors: Array<ImportError>;
  Finished: Scalars['Boolean'];
  RequestID: Scalars['String'];
  StartedTimestamp?: Maybe<Scalars['Int']>;
  SuccessfullySyncedCount: Scalars['Int'];
  TotalProcessed: Scalars['Int'];
  TotalToSync?: Maybe<Scalars['Int']>;
};

export type WooCommerceTag = {
  __typename?: 'WooCommerceTag';
  ID: Scalars['Int'];
  Name: Scalars['String'];
  Slug: Scalars['String'];
};

export type YearAndMonthsType = {
  __typename?: 'YearAndMonthsType';
  Months: Array<Scalars['Int']>;
  Year: Scalars['Int'];
};

export type YearAndMonthsTypeConnection = {
  __typename?: 'YearAndMonthsTypeConnection';
  ID: Scalars['String'];
  edges: Array<YearAndMonthsTypeConnectionEdge>;
  nodes: Array<YearAndMonthsType>;
  pageInfo: ApPageInfo;
};

/** The collections edge */
export type YearAndMonthsTypeConnectionEdge = {
  __typename?: 'YearAndMonthsTypeConnectionEdge';
  /** The node at the end of the collections edge */
  node: YearAndMonthsType;
};

export type Zone = {
  __typename?: 'Zone';
  Country: Country;
};

export type CurrentMemberFragment = { __typename?: 'Me', ID: number, APID: string, ArchiproProfilePage: string, Company: string, Email: string, FirstName: string, HashedEmail: string, IsActive: boolean, LastName: string, Initials?: string | null, IsArchiproStaff: boolean, IsLeadershipTeam: boolean, Name: string, Phone: string, ProfileImage: string, ProfileImageComments: string, Region: string, TempPassword: boolean, Website: string, ProfessionalType: string, UserType: string, EcommerceBookingURL: string, ProfileImageLink?: string | null, JobTitle?: string | null, AgeGroup?: string | null, BuildStatus?: string | null, When?: string | null, Where?: string | null, Budget?: string | null, Style?: string | null, Section?: boolean | null, Permissions: Array<PermissionEnum>, PostSignupQuestionnaireSeen: boolean, MfaType?: MfaConfigEnumType | null, IntercomHash: string, OrderNotificationCount: number, Professionals: Array<{ __typename?: 'MemberProfessional', ID: number, Title: string, URLSegment: string, Link: string, CanEdit: boolean, HasInboxAccess: boolean, CompanyLogo: string, CompanyLogo48Resized?: string | null, CompanyLogo96Resized?: string | null, LogoBackgroundColor?: string | null, AnalyticsEnabled: boolean, EcommerceEnabled: boolean, Website: string, Country: string, IsCloned: boolean, HasClones: boolean, IsCollaborator: boolean, IsTeamMember: boolean, IsManufacturer: boolean, BusinessFocus: string, ServiceableAreasCount: number, AnalyticsStatus: AnalyticsStatusEnum, StripeAccountEnabled: boolean, LibraryLocationsCount: number, HasEcommerceEmail: boolean, PrimaryDomain: string, MetaData: { __typename?: 'ProfessionalMetaData', AverageScore: number }, TradePricing: Array<{ __typename?: 'SpecialtyRateCategories', ID: number, TradeProductRate: number, TradeSampleRate: number }> }>, MemberImage?: { __typename?: 'MemberImage', ID: number, FileName?: string | null, LargeAvatar?: string | null } | null, TeamMembers: Array<{ __typename?: 'TeamMember', ID: number, Permissions: Array<PermissionEnum>, Professional: { __typename?: 'Professional', ID: number, Permissions: Array<PermissionEnum>, AnalyticsStatus: AnalyticsStatusEnum, Country: string, ProductsAllowed: boolean, URLSegment: string, Title: string, Link: string, CompanyLogo?: string | null, CompanyLogo48Resized?: string | null, CompanyLogo96Resized?: string | null, LogoBackgroundColor?: string | null, HasRunningAds: boolean, EcommerceEnabled: boolean, Categories: Array<{ __typename?: 'Category', ID: number }> } }>, ProfessionalCategory?: { __typename?: 'ProfessionalCategory', ID: number, Title: string } | null, FeatureFlags: Array<{ __typename?: 'FeatureFlag', Name: string, Enabled: boolean, Title: string, CanToggle: boolean, ToggleArgs: string }>, TrackedGuest?: { __typename?: 'Guest', ID: number } | null, OwnedBuildHubs: Array<{ __typename: 'BuildHub', ID: string, Title: string, URLSegment: string }> };

export type GuestUserFragment = { __typename?: 'Guest', ID: number, APID: string, EcommerceBookingURL: string, FeatureFlags: Array<{ __typename?: 'FeatureFlag', Name: string, Enabled: boolean }> };

export type GetMemberQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMemberQuery = { __typename?: 'Query', getMember: { __typename?: 'Guest', ID: number, APID: string, EcommerceBookingURL: string, FeatureFlags: Array<{ __typename?: 'FeatureFlag', Name: string, Enabled: boolean }> } | { __typename?: 'Me', ID: number, APID: string, ArchiproProfilePage: string, Company: string, Email: string, FirstName: string, HashedEmail: string, IsActive: boolean, LastName: string, Initials?: string | null, IsArchiproStaff: boolean, IsLeadershipTeam: boolean, Name: string, Phone: string, ProfileImage: string, ProfileImageComments: string, Region: string, TempPassword: boolean, Website: string, ProfessionalType: string, UserType: string, EcommerceBookingURL: string, ProfileImageLink?: string | null, JobTitle?: string | null, AgeGroup?: string | null, BuildStatus?: string | null, When?: string | null, Where?: string | null, Budget?: string | null, Style?: string | null, Section?: boolean | null, Permissions: Array<PermissionEnum>, PostSignupQuestionnaireSeen: boolean, MfaType?: MfaConfigEnumType | null, IntercomHash: string, OrderNotificationCount: number, Professionals: Array<{ __typename?: 'MemberProfessional', ID: number, Title: string, URLSegment: string, Link: string, CanEdit: boolean, HasInboxAccess: boolean, CompanyLogo: string, CompanyLogo48Resized?: string | null, CompanyLogo96Resized?: string | null, LogoBackgroundColor?: string | null, AnalyticsEnabled: boolean, EcommerceEnabled: boolean, Website: string, Country: string, IsCloned: boolean, HasClones: boolean, IsCollaborator: boolean, IsTeamMember: boolean, IsManufacturer: boolean, BusinessFocus: string, ServiceableAreasCount: number, AnalyticsStatus: AnalyticsStatusEnum, StripeAccountEnabled: boolean, LibraryLocationsCount: number, HasEcommerceEmail: boolean, PrimaryDomain: string, MetaData: { __typename?: 'ProfessionalMetaData', AverageScore: number }, TradePricing: Array<{ __typename?: 'SpecialtyRateCategories', ID: number, TradeProductRate: number, TradeSampleRate: number }> }>, MemberImage?: { __typename?: 'MemberImage', ID: number, FileName?: string | null, LargeAvatar?: string | null } | null, TeamMembers: Array<{ __typename?: 'TeamMember', ID: number, Permissions: Array<PermissionEnum>, Professional: { __typename?: 'Professional', ID: number, Permissions: Array<PermissionEnum>, AnalyticsStatus: AnalyticsStatusEnum, Country: string, ProductsAllowed: boolean, URLSegment: string, Title: string, Link: string, CompanyLogo?: string | null, CompanyLogo48Resized?: string | null, CompanyLogo96Resized?: string | null, LogoBackgroundColor?: string | null, HasRunningAds: boolean, EcommerceEnabled: boolean, Categories: Array<{ __typename?: 'Category', ID: number }> } }>, ProfessionalCategory?: { __typename?: 'ProfessionalCategory', ID: number, Title: string } | null, FeatureFlags: Array<{ __typename?: 'FeatureFlag', Name: string, Enabled: boolean, Title: string, CanToggle: boolean, ToggleArgs: string }>, TrackedGuest?: { __typename?: 'Guest', ID: number } | null, OwnedBuildHubs: Array<{ __typename: 'BuildHub', ID: string, Title: string, URLSegment: string }> } };
